import * as React from 'react';
import React__default, { useRef, useState, useEffect, useCallback, useContext, cloneElement, Component, useLayoutEffect, useReducer, useMemo, Children, isValidElement, createContext } from 'react';
import ReactDOM from 'react-dom';
import { useFormContext, useForm, FormProvider } from 'react-hook-form';

var undefined$1 = undefined;

const defaultProps$i = {
    className: '',
    fill: 'currentColor',
    size: '1.5rem',
    testId: 'icon',
};
const HuiIcon = (props) => {
    props = { ...defaultProps$i, ...props };
    const { className, icon, label, size, testId, ...otherProps } = props;
    const isDecoration = !label;
    const Icon = icon.default;
    return (React__default.createElement("span", { "aria-hidden": isDecoration, "aria-label": label, className: `hui-icon ${className}`, "data-testid": testId, role: "img", style: { height: size, minHeight: size, minWidth: size, width: size }, title: label },
        React__default.createElement(Icon, { className: "hui-vertical-align-top", height: "100%", width: "100%", ...otherProps })));
};

var HuiBadgeType;
(function (HuiBadgeType) {
    HuiBadgeType["Information"] = "hui-background-information hui-text-white";
    HuiBadgeType["Success"] = "hui-background-success hui-text-white";
    HuiBadgeType["Caution"] = "hui-background-caution";
    HuiBadgeType["Error"] = "hui-background-error hui-text-white";
    HuiBadgeType["Status"] = "hui-background-status hui-text-white";
    HuiBadgeType["BadgePink"] = "hui-background-badge-pink hui-text-badge-red";
    HuiBadgeType["BadgeTeal"] = "hui-background-teal-90 hui-text-teal-20";
    HuiBadgeType["LabelTeal"] = "hui-background-teal-60 hui-text-teal-10";
})(HuiBadgeType || (HuiBadgeType = {}));
const HuiBadge = ({ className = '', icon, label, testId = 'badge', type, ...otherProps }) => {
    return (React__default.createElement("div", { className: `hui-badge hui-padding-vertical-4 hui-padding-horizontal-8 hui-text-sm hui-font-weight-bold hui-text-transform-uppercase hui-border-radius-full hui-width-fit-content hui-flex hui-flex-align-center ${type} ${className}`, "data-testid": testId, ...otherProps },
        icon && React__default.createElement(HuiIcon, { className: "hui-badge-icon hui-margin-right-4", icon: icon, size: "1.25rem" }),
        React__default.createElement("div", { className: "hui-badge-label", role: "status" }, label)));
};

// Would be nice to import these from the breakpoints.less file, but that's a headache for another day
var HuiBreakpointProps;
(function (HuiBreakpointProps) {
    HuiBreakpointProps[HuiBreakpointProps["Sm"] = 0] = "Sm";
    HuiBreakpointProps[HuiBreakpointProps["Md"] = 600] = "Md";
    HuiBreakpointProps[HuiBreakpointProps["Lg"] = 900] = "Lg";
    HuiBreakpointProps[HuiBreakpointProps["Xl"] = 1200] = "Xl";
})(HuiBreakpointProps || (HuiBreakpointProps = {}));

var HuiLoaderLayout;
(function (HuiLoaderLayout) {
    HuiLoaderLayout[HuiLoaderLayout["Default"] = 0] = "Default";
    HuiLoaderLayout[HuiLoaderLayout["Page"] = 1] = "Page";
    HuiLoaderLayout[HuiLoaderLayout["Component"] = 2] = "Component";
})(HuiLoaderLayout || (HuiLoaderLayout = {}));
var HuiLoaderSize;
(function (HuiLoaderSize) {
    HuiLoaderSize[HuiLoaderSize["Default"] = 0] = "Default";
    HuiLoaderSize[HuiLoaderSize["Small"] = 1] = "Small";
})(HuiLoaderSize || (HuiLoaderSize = {}));
const defaultProps$h = {
    label: 'Loading...',
    layout: HuiLoaderLayout.Default,
    size: HuiLoaderSize.Default,
};
const HuiLoader = function (props) {
    props = { ...defaultProps$h, ...props };
    const { className, label, layout, size, testId, ...otherProps } = props;
    const huiLoaderModifier = size === HuiLoaderSize.Default ? 'hui-loader-default' : 'hui-loader-small';
    const huiLoaderDotModifier = size === HuiLoaderSize.Default ? 'hui-loader-dot-default' : 'hui-loader-dot-small';
    let layoutClass = '';
    switch (layout) {
        case HuiLoaderLayout.Default:
            layoutClass = 'hui-loader-default-layout';
            break;
        case HuiLoaderLayout.Page:
            layoutClass = 'hui-loader-page-layout';
            break;
        case HuiLoaderLayout.Component:
            layoutClass = 'hui-loader-component-layout';
            break;
    }
    return (React__default.createElement("div", { "aria-label": label, className: `hui-loader ${huiLoaderModifier} ${layoutClass} ${className}`, "data-testid": testId || 'cmp-loader', role: "progressbar", ...otherProps },
        React__default.createElement("div", { className: `hui-loader-dot ${huiLoaderDotModifier}` }),
        React__default.createElement("div", { className: `hui-loader-dot ${huiLoaderDotModifier}` }),
        React__default.createElement("div", { className: `hui-loader-dot ${huiLoaderDotModifier}` })));
};

var HuiButtonLayoutProps;
(function (HuiButtonLayoutProps) {
    HuiButtonLayoutProps[HuiButtonLayoutProps["Default"] = 0] = "Default";
    HuiButtonLayoutProps[HuiButtonLayoutProps["Secondary"] = 1] = "Secondary";
    HuiButtonLayoutProps[HuiButtonLayoutProps["SecondaryDark"] = 2] = "SecondaryDark";
    HuiButtonLayoutProps[HuiButtonLayoutProps["Outline"] = 3] = "Outline";
    HuiButtonLayoutProps[HuiButtonLayoutProps["Text"] = 4] = "Text";
})(HuiButtonLayoutProps || (HuiButtonLayoutProps = {}));
var HuiButtonSizeProps;
(function (HuiButtonSizeProps) {
    HuiButtonSizeProps[HuiButtonSizeProps["Default"] = 0] = "Default";
    HuiButtonSizeProps[HuiButtonSizeProps["Small"] = 1] = "Small";
    HuiButtonSizeProps[HuiButtonSizeProps["Large"] = 2] = "Large";
    HuiButtonSizeProps[HuiButtonSizeProps["Xlarge"] = 3] = "Xlarge";
})(HuiButtonSizeProps || (HuiButtonSizeProps = {}));
var HuiButtonWidthProps;
(function (HuiButtonWidthProps) {
    HuiButtonWidthProps[HuiButtonWidthProps["Default"] = 0] = "Default";
    HuiButtonWidthProps[HuiButtonWidthProps["Full"] = 1] = "Full";
})(HuiButtonWidthProps || (HuiButtonWidthProps = {}));
const defaultProps$g = {
    className: '',
    disabled: false,
    fullSizeOnMobile: true,
    layout: HuiButtonLayoutProps.Default,
    size: HuiButtonSizeProps.Default,
    testId: 'cmp-button',
    type: 'button',
    width: HuiButtonWidthProps.Default,
};
const HuiButton = (props) => {
    const isHuiButtonComponentMounted = useRef();
    props = { ...defaultProps$g, ...props };
    const { children, className, fullSizeOnMobile, isLoading, layout, onClick, size, testId, width, ...otherProps } = props;
    const [isButtonLoading, setButtonLoading] = useState(false);
    useEffect(() => {
        isHuiButtonComponentMounted.current = true;
        return () => {
            isHuiButtonComponentMounted.current = false;
        };
    }, []);
    useEffect(() => {
        if (isLoading) {
            showLoader();
        }
        else {
            hideLoader();
        }
    }, [isLoading]);
    const showLoader = () => {
        if (isHuiButtonComponentMounted.current) {
            setButtonLoading(true);
        }
    };
    const hideLoader = () => {
        if (isHuiButtonComponentMounted.current) {
            setButtonLoading(false);
        }
    };
    let layoutClass = '';
    switch (layout) {
        case HuiButtonLayoutProps.Default:
            layoutClass = 'hui-button-default';
            break;
        case HuiButtonLayoutProps.Secondary:
            layoutClass = 'hui-button-secondary';
            break;
        case HuiButtonLayoutProps['SecondaryDark']:
            layoutClass = 'hui-button-secondary-dark';
            break;
        case HuiButtonLayoutProps.Outline:
            layoutClass = 'hui-button-outline';
            break;
        case HuiButtonLayoutProps.Text:
            layoutClass = 'hui-button-text';
            break;
    }
    let sizeClass = '';
    let loaderSizeClass = '';
    switch (size) {
        case HuiButtonSizeProps.Default:
            sizeClass = 'hui-button-size-default';
            loaderSizeClass = '';
            break;
        case HuiButtonSizeProps.Small:
            sizeClass = 'hui-button-size-small';
            loaderSizeClass = '';
            break;
        case HuiButtonSizeProps.Large:
            sizeClass = 'hui-button-size-large';
            loaderSizeClass = '';
            break;
        case HuiButtonSizeProps.Xlarge:
            sizeClass = 'hui-button-size-xlarge';
            loaderSizeClass = '';
            break;
    }
    let widthClass = '';
    switch (width) {
        case HuiButtonWidthProps.Default:
            widthClass = 'hui-button-width-default';
            break;
        case HuiButtonWidthProps.Full:
            widthClass = 'hui-button-width-full';
            break;
    }
    const mobileClass = fullSizeOnMobile ? 'hui-button-full-size-on-mobile' : '';
    return (React__default.createElement("button", { className: `hui-button ${layoutClass} ${sizeClass} ${mobileClass} ${widthClass} ${className} ${isButtonLoading ? 'hui-button-active-disabled' : ''}`, "data-testid": testId, onClick: async (evt) => {
            if (isButtonLoading) {
                return null;
            }
            try {
                if (!onClick) {
                    return null;
                }
                showLoader();
                const result = await onClick(evt);
                hideLoader();
                return result;
            }
            catch (e) {
                hideLoader();
                // eslint-disable-next-line no-console
                console.error(e);
                throw e;
            }
        }, ...otherProps },
        React__default.createElement("div", { className: "hui-button-content" }, children),
        React__default.createElement("div", { "aria-hidden": !isButtonLoading, className: `hui-button-loader ${loaderSizeClass}` },
            React__default.createElement(HuiLoader, { size: [HuiButtonSizeProps.Xlarge].includes(size) && window.matchMedia('(min-width: 600px)').matches
                    ? HuiLoaderSize.Default
                    : HuiLoaderSize.Small })),
        React__default.createElement("div", { "aria-hidden": "true", className: "hui-button-ripple-container" })));
};

/**
   * @license MIT
   * author: Roy Pearce <rhdp@roypearce.us> (github.com/roypearce)
   * rhdp.js v3.0.2
   * Released under the MIT license.
   */
var r$1;!function(e){e[e.Day=0]="Day",e[e.Month=1]="Month",e[e.Week=2]="Week",e[e.Year=3]="Year";}(r$1||(r$1={}));const n$1=class{date;constructor(e){if(this.date=e&&e instanceof Date?new Date(e):new Date,e&&!(e instanceof Date)){let t;"string"==typeof e&&10===e.length&&(t=e.split("-"),3===t.length&&(this.setFullDate(+t[0],+t[1],+t[2]),this.date.setHours(0,0,0,0),this.regenDate()));}}add=(e,t,a=!1)=>{switch(t){case r$1.Year:this.setYear(this.date.getFullYear()+e,a);break;case r$1.Month:this.setMonth(this.date.getMonth()+1+e,a);break;case r$1.Week:this.date.setDate(this.date.getDate()+7*e);break;case r$1.Day:this.date.setDate(this.date.getDate()+e);}return this.regenDate(),this};clone=()=>new n$1(this.date);endOfMonth=()=>(this.date.setFullYear(this.date.getFullYear(),this.date.getMonth()+1,0),this.regenDate(),this);endOfYear=()=>(this.date.setFullYear(this.date.getFullYear(),12,0),this.regenDate(),this);format=()=>{const e=this.date.getMonth()+1,t=this.date.getDate();return [this.date.getFullYear(),e<10?"0"+e:e,t<10?"0"+t:t].join("-")};getDate=()=>this.date.getDate();getDay=()=>this.date.getDay();getFullYear=()=>this.date.getFullYear();getMonth=()=>this.date.getMonth()+1;regenDate=()=>{this.date=new Date(this.date);};setDay=e=>(this.date.setDate(e),this.regenDate(),this);setFullDate=(e,t,a)=>(this.date.setFullYear.apply(this.date,[e,t-1,a]),this.regenDate(),this);setMonth=(e,t=!1)=>{let a;return t&&this.getDate()>28&&(a=this.clone().setFullDate(this.getFullYear(),e+1,0)),this.date.setMonth(e-1),this.regenDate(),t&&a&&this.getMonth()!==e&&(this.date=a.date),this};setYear=(e,t=!1)=>{let a;return t&&this.getDate()>28&&(a=this.clone().setFullDate(e,this.getMonth()+1,0)),this.date.setFullYear(e),this.regenDate(),t&&a&&this.getMonth()!==a.getMonth()&&(this.date=a.date),this};startOfMonth=()=>(this.date.setFullYear(this.getFullYear(),this.date.getMonth(),1),this.regenDate(),this);startOfYear=()=>(this.date.setFullYear(this.getFullYear(),0,1),this.regenDate(),this)};var o$1,s;!function(e){e[e.Down=0]="Down",e[e.Left=1]="Left",e[e.Right=2]="Right",e[e.Up=3]="Up";}(o$1||(o$1={})),function(e){e[e.Initial=0]="Initial",e[e.Programmatic=1]="Programmatic",e[e.User=2]="User";}(s||(s={}));const d=[[0,1,2,3,4,5,6],[0,-1,1,2,3,4,5],[0,-1,1,-2,2,3,4],[0,-1,1,-2,2,-3,3],[0,-1,1,-2,2,-3,-4],[0,-1,1,-2,-3,-4,-5],[0,-1,-2,-3,-4,-5,-6]],l$1=e=>e[0].toUpperCase()+e.slice(1),c=e=>Array.isArray(e)?e:e?[e]:[],i=(e,t,a)=>l$1(new Intl.DateTimeFormat(e,{weekday:a}).format(t)),u=(e,t)=>{const a=new n$1,o=a.getDay(),s=a.add(-1*(o-t),r$1.Day);return [h(e,s.date),h(e,s.add(1,r$1.Day).date),h(e,s.add(1,r$1.Day).date),h(e,s.add(1,r$1.Day).date),h(e,s.add(1,r$1.Day).date),h(e,s.add(1,r$1.Day).date),h(e,s.add(1,r$1.Day).date)]},h=(e,t)=>({long:i(e,t,"long"),narrow:i(e,t,"narrow"),short:i(e,t,"short")}),D=(e,t)=>l$1(new Intl.DateTimeFormat(t,{month:"long"}).format(e.date)),f=e=>e.getFullYear();let g=0;const y=e=>{try{if(!e)return !1;const[t,a,r]=e.match(/\d+/g)||["","",""],n=/^\d{4}-\d{2}-\d{2}$/u,o=new Date(`${m(a,2)}/${m(r,2)}/${t}`);return !isNaN(o.getTime())&&n.test(e)&&+a===o.getMonth()+1&&+r===o.getDate()&&+t===o.getFullYear()}catch(e){return !1}},m=(e,t)=>{const a=t-e.length;if(a<1)return e;for(let t=1;t<=a;t+=1)e=`0${e}`;return e},M=new n$1,p=({blockedDates:s=[],focusOnInit:l=!1,hasFocusTrap:i=!1,labels:h,locale:m="en-US",maxDate:p,minDate:b,mode:w="single",onChange:k,onClose:Y,selectDates:F,weekStart:v=0})=>{const[E,O]=useState([[]]),[P,T]=useState(!1),[x,S]=useState(!1),[C,$]=useState(!1),[B,I]=useState(""),W=useRef({closeButton:"close",dateSelected:"date selected",disabled:"disabled",nextMonth:"next month",nextYear:"next year",previousMonth:"previous month",previousYear:"previous year",today:"today",...h}),R=useRef({blockedDatesMap:{},calendarDisplayMonth:M,calendarMonthEndDate:M.clone().endOfMonth().format(),calendarMonthStartDate:M.clone().startOfMonth().format(),dateClicked:"",displayDaysOfTheWeek:u(m,v),focusedDate:"",id:"",isInitialRender:!0,lastActiveElement:document.activeElement,lastFocusedDate:"",locale:m,newSelectedDate:"",newRemovedDate:"",newTimePeriod:"",now:M,oneYearAfterMinDate:"",oneYearAfterStartOfMonth:"",oneYearBeforeEndOfMonth:"",oneYearBeforeMaxDate:"",selectDates:[],selectedDates:[],selectedDatesMap:{},today:(new n$1).format(),weekStart:v});R.current.id||(R.current.id=function(e="rhdp-id-"){return `${e}${g+=1}`}());const[A,U]=useState({displayMonth:D(M,m),displayYear:f(M),selectedDates:[""]}),L=()=>{R.current.oneYearBeforeEndOfMonth=new n$1(R.current.calendarMonthEndDate).add(-1,r$1.Year).format();},K=()=>{R.current.oneYearAfterStartOfMonth=new n$1(R.current.calendarMonthStartDate).add(1,r$1.Year).format();},N=()=>{let{blockedDatesMap:e,calendarDisplayMonth:t,calendarMonthEndDate:a,calendarMonthStartDate:r,dateClicked:o,displayDaysOfTheWeek:d,focusedDate:i,isInitialRender:h,lastFocusedDate:g,newSelectedDate:M,newRemovedDate:k,newTimePeriod:E,selectedDates:O,selectedDatesMap:P,today:T}=R.current,x=!1,S=!1,C=[],$=[...M&&[M],...O],B=!1,I=!1;switch(`${F}`!=`${R.current.selectDates}`&&(F?.length?(B=!0,I=!0,$=c(F)):$=[]),m===R.current.locale&&v===R.current.weekStart||(d=u(m,v)),e={},s&&c(s).forEach((t=>{e[t]=null;})),(s||b||p||k||I)&&($=$.filter((t=>!!y(t)&&(!(b&&t<b)&&(!(p&&t>p)&&(t!==k&&!(t in e))))))),w){case"single":$.length>1&&($.length=1),1===$.length&&(C=[$[0]],S=!0);break;case"range":$.length>2&&M&&($=[M]),C=[...$],C.length>=2&&(C.length=2,S=!0);break;case"multiple":C.push(...$);break;default:"number"==typeof w&&(C.push(...$),C.length>=w&&(C.length=w,S=!0));}$.length||(B=!1),P={},C&&C.forEach((e=>{P[e]=null;})),(h&&C.length||B||E)&&({calendarDisplayMonth:t,calendarMonthEndDate:a,calendarMonthStartDate:r}=(e=>{const t=new n$1(e).startOfMonth();return {calendarDisplayMonth:t,calendarMonthEndDate:t.clone().endOfMonth().format(),calendarMonthStartDate:t.format()}})(E||C[0])),h&&(g=C.length?C[0]:T,`${C}`!=`${F}`&&(x=!0),l&&setTimeout((()=>{document.getElementById(g)?.focus();}),0)),C.sort(),h||`${R.current.selectedDates}`!=`${C}`&&(x=!0),(M||k||x)&&X(C),i&&M&&E&&setTimeout((()=>{document.getElementById(i)?.focus();}),0),Y&&o&&S&&Y(),U({displayMonth:D(t,m),displayYear:f(t),selectedDates:C}),R.current={...R.current,blockedDatesMap:e,calendarDisplayMonth:t,calendarMonthEndDate:a,calendarMonthStartDate:r,dateClicked:"",displayDaysOfTheWeek:d,isInitialRender:!1,...h&&{lastFocusedDate:g},newSelectedDate:"",newRemovedDate:"",newTimePeriod:"",selectDates:F,selectedDates:C,selectedDatesMap:P};};useEffect((()=>{const{focusedDate:e,lastFocusedDate:t}=R.current;P?t&&(R.current.focusedDate=t):(R.current.lastFocusedDate=e,R.current.focusedDate="");}),[P]),useEffect((()=>{document.getElementById(R.current.focusedDate)?.focus();}),[R.current.focusedDate]),useEffect((()=>(L(),K(),N(),()=>{R.current.lastActiveElement.focus?.();})),[]),useEffect((()=>{N();}),[`${s}`,h,m,p,b,w,`${F}`,v]),useEffect((()=>{R.current.oneYearBeforeMaxDate=p?new n$1(p).add(-1,r$1.Year).format():"";}),[p]),useEffect((()=>{R.current.oneYearAfterMinDate=b?new n$1(b).add(1,r$1.Year).format():"";}),[b]),useEffect(L,[R.current.calendarMonthStartDate]),useEffect(K,[R.current.calendarMonthEndDate]),useEffect((()=>{te();}),[A]);const H=(e,t)=>{V(new KeyboardEvent("keydown",{ctrlKey:e===r$1.Year,key:1===t?"PageDown":"PageUp"}));},j=(e,t,a=!1,s=!1)=>{let l=p?new n$1(p).add(1,r$1.Week).format():new n$1(e).add(6,r$1.Week).format(),c=b?new n$1(b).add(-1,r$1.Week).format():new n$1(e).add(-6,r$1.Week).format(),i="";if(R.current.selectedDates.forEach((e=>{e<c?c=e:e>l&&(l=e);})),a&&Z(e,c,l))return e;e<c?e=c:e>l&&(e=l);let u,h,D,f,g=new n$1(e),y=1,m=1;switch(t){case o$1.Left:y=-1;case o$1.Right:for(h=g.add(y,r$1.Day).format();h>c&&h<l&&(G(h)||J(h));)h=g.add(y,r$1.Day).format();if(Z(h,c,l))i=h;else if(s)return j(e,t===o$1.Left?o$1.Right:o$1.Left,a,!1);break;case o$1.Up:m=-1;case o$1.Down:for(g.add(m,r$1.Week),u=g.getDay(),D=d[u],h=g.format();!i&&h>=c&&h<=l;)f=D.find((e=>Z(g.clone().add(e,r$1.Day).format(),c,l))),"number"==typeof f&&(i=g.clone().add(f,r$1.Day).format()),g.add(m,r$1.Week),h=g.format();}return i},q=e=>{const t=e.format();x||!C?(R.current.focusedDate="",R.current.lastFocusedDate=t):R.current.focusedDate=t,R.current.newTimePeriod=t,N();},z=e=>R.current.focusedDate?e.formatted===R.current.focusedDate?0:-1:R.current.lastFocusedDate?e.formatted===R.current.lastFocusedDate?0:-1:e.formatted===R.current.today?0:-1,G=e=>e in R.current.blockedDatesMap,J=e=>!!(b&&e<b)||(!!(p&&e>p)||!(!ee()||e in R.current.selectedDatesMap)),Q=e=>e===B,V=e=>{if("Tab"===e.key&&!i||x&&"PageDown"!==e.key&&"PageUp"!==e.key)return;const{calendarMonthEndDate:t,calendarMonthStartDate:a,focusedDate:s,lastFocusedDate:d}=R.current;let l=x?d:s;(!l||l<a||l>t)&&(l=a);let c="";switch(e.key){case"ArrowLeft":c=j(l,o$1.Left);break;case"ArrowRight":c=j(l,o$1.Right);break;case"ArrowUp":c=j(l,o$1.Up);break;case"ArrowDown":c=j(l,o$1.Down);break;case"Home":c=j(new n$1(l).startOfMonth().format(),o$1.Right,!0);break;case"End":c=j(new n$1(l).endOfMonth().format(),o$1.Left,!0);break;case"PageUp":let t=r$1.Month;e.ctrlKey&&(t=r$1.Year),c=new n$1(l).add(-1,t,!0).format(),b&&c.substring(0,7)===b.substring(0,7)&&b>c&&(c=j(new n$1(l).add(-1,t,!0).format(),o$1.Left,!0,!0));break;case"PageDown":let a=r$1.Month;e.ctrlKey&&(a=r$1.Year),c=new n$1(l).add(1,a,!0).format(),p&&c.substring(0,7)===p.substring(0,7)&&p<c&&(c=j(new n$1(l).add(1,a,!0).format(),o$1.Right,!0,!0));break;case"Tab":const s=(u=document.getElementById(R.current.id),[...u?.querySelectorAll('a:not([disabled]):not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([disabled]):not([tabindex="-1"]), [tabindex]:not([disabled]):not([tabindex="-1"])')||[]]);if(s.length){const t=s.findIndex((e=>e===document.activeElement));0===t&&e.shiftKey?(e.preventDefault(),s[s.length-1].focus()):t!==s.length-1||e.shiftKey||(e.preventDefault(),s[0].focus());}break;case" ":case"Enter":return;case"Esc":case"Escape":return Y&&Y(),void e.preventDefault()}var u;return c&&(e.preventDefault(),b&&c<b||p&&c>p?c="":(c>t||c<a)&&(R.current.newTimePeriod=c,N())),c&&(x?R.current.lastFocusedDate=c:R.current.focusedDate=c,te()),!1},X=e=>{if(k){let t=e;"single"===w&&(t=e?.length?e[0]:""),k(t);}},Z=(e,t,a)=>e>=t&&e<=a&&!G(e)&&!J(e),_=e=>e.inRange||e.rangeStart||e.rangeEnd||e.selected,ee=()=>"number"==typeof w&&A.selectedDates.length>=w,te=()=>{const{calendarDisplayMonth:e}=R.current,t=(e=>{const t=e.getMonth(),a=[],n=e.clone().startOfMonth(),o=n.add(-1*(n.getDay()-v),r$1.Day);let s=0;for(;!(s>=4&&o.getMonth()!==t);){a.push([]);for(let e=0;e<=6;e+=1){const n=o.format();a[s].push({blocked:G(n),disabled:J(n),displayText:String(o.getDate()),formatted:n,hovered:Q(n),index:e,inMonth:o.getMonth()===t,inRange:"range"===w&&n>=A.selectedDates[0]&&n<=A.selectedDates[1],rangeEnd:"range"===w&&n===A.selectedDates[1],rangeStart:"range"===w&&n===A.selectedDates[0],selected:(d=o,d.format()in R.current.selectedDatesMap),today:R.current.today===n}),o.add(1,r$1.Day);}s+=1;}var d;return a})(e);O(t);};return {calendar:E,displayDaysOfTheWeek:R.current.displayDaysOfTheWeek,displayMonth:A.displayMonth,displayYear:A.displayYear,focusedDate:R.current.focusedDate,getCalendarContainerProps:()=>({"aria-labelledby":`${R.current.id}-month-year-label`,onBlur:e=>{e.currentTarget?.contains(e.relatedTarget)||T(!1);},onFocus:()=>{T(!0),S(!1);},role:"grid"}),getCalendarDayContainerProps:()=>({role:"gridcell"}),getCalendarWeekContainerProps:()=>({role:"row"}),getDayOfTheWeekProps:e=>{const t=R.current.displayDaysOfTheWeek[e];return {abbr:t.long,"aria-label":t.long,id:`day-of-the-week-${e}`,role:"columnheader",scope:"col"}},getDaysOfTheWeekContainerProps:()=>({role:"row"}),getOnCloseButtonProps:()=>({"aria-label":W.current.closeButton,onClick:()=>{Y&&(T(!1),S(!1),$(!1),Y());},tabIndex:C?0:-1,title:W.current.closeButton,type:"button"}),getControlsContainerProps:()=>({onBlur:e=>{e.currentTarget?.contains(e.relatedTarget)||S(!1);},onFocus:()=>{S(!0);}}),getDatepickerContainerProps:()=>({"aria-activedescendant":R.current.focusedDate,id:R.current.id,onBlur:e=>{e.currentTarget?.contains(e.relatedTarget)||$(!1);},onFocus:()=>$(!0),onKeyDown:V}),getDayButtonProps:e=>{const{focusedDate:t,id:a,lastFocusedDate:r}=R.current,o=e.blocked||e.disabled;return {...o&&{"aria-disabled":!0},"aria-label":`${e.displayText} ${o?W.current.disabled:""} ${e.today?W.current.today:""} ${_(e)?W.current.dateSelected:""}`,"aria-describedby":`${a}-month-year-label`,"aria-pressed":_(e),...!(e.formatted===t||e.formatted===r)&&o&&{disabled:!0},id:e.formatted,key:e.formatted,onClick:()=>{e.blocked||e.disabled||(!e.selected||"multiple"!==w&&"number"!=typeof w?e.selected||(R.current.newSelectedDate=e.formatted):R.current.newRemovedDate=e.formatted,R.current.dateClicked=e.formatted,q(new n$1(e.formatted)));},onMouseOut:()=>{I("");},onMouseOver:()=>{I(e.formatted);},tabIndex:z(e),type:"button"}},getMonthYearContainerProps:()=>({"aria-atomic":"true","aria-live":"assertive",id:`${R.current.id}-month-year-label`}),getNextMonthButtonProps:()=>{const{calendarMonthEndDate:e,selectedDates:t}=R.current,{nextMonth:a}=W.current;return {"aria-label":a,disabled:p&&e>p||ee()&&t[t.length-1]<=e,onClick:()=>{H(r$1.Month,1);},tabIndex:C?0:-1,title:a,type:"button"}},getNextYearButtonProps:()=>{const{calendarMonthEndDate:e,oneYearBeforeMaxDate:t,oneYearAfterStartOfMonth:a,selectedDates:n}=R.current,{nextYear:o}=W.current;return {"aria-label":o,disabled:p&&e>t||ee()&&n[n.length-1]<a,onClick:()=>{H(r$1.Year,1);},tabIndex:C?0:-1,title:o,type:"button"}},getPreviousMonthButtonProps:()=>{const{calendarMonthStartDate:e,selectedDates:t}=R.current,{previousMonth:a}=W.current;return {"aria-label":a,disabled:b&&e<b||ee()&&t[0]>=e,onClick:()=>{H(r$1.Month,-1);},tabIndex:C?0:-1,title:a,type:"button"}},getPreviousYearButtonProps:()=>{const{calendarMonthStartDate:e,oneYearAfterMinDate:t,oneYearBeforeEndOfMonth:a,selectedDates:n}=R.current,{previousYear:o}=W.current;return {"aria-label":o,disabled:b&&e<t||ee()&&n[0]>a,onClick:()=>{H(r$1.Year,-1);},tabIndex:C?0:-1,title:o,type:"button"}},hoveredDate:B,id:R.current.id,selectedDates:A.selectedDates,setMonth:e=>{const t=new n$1(R.current.focusedDate||R.current.lastFocusedDate).setMonth(e,!0);q(t);},setYear:e=>{const t=new n$1(R.current.focusedDate||R.current.lastFocusedDate).setYear(e);q(t);},today:R.current.today}};

var _path$T;
function _extends$Y() { _extends$Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }
const SvgAddUser = props => /*#__PURE__*/React.createElement("svg", _extends$Y({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$T || (_path$T = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.897 15.056a4 4 0 0 1 1.908-.478h.002c.07 0 .104-.084.052-.131a8.7 8.7 0 0 0-2.43-1.542q-.015-.006-.029-.012a5.81 5.81 0 0 0 2.403-4.713 5.806 5.806 0 0 0-5.801-5.813c-3.204 0-5.799 2.602-5.799 5.813a5.81 5.81 0 0 0 2.405 4.713q-.015.006-.028.012a8.7 8.7 0 0 0-2.796 1.889 8.8 8.8 0 0 0-1.884 2.8 8.8 8.8 0 0 0-.69 3.237.187.187 0 0 0 .188.192h1.404c.1 0 .185-.082.187-.182a7 7 0 0 1 2.054-4.789 6.96 6.96 0 0 1 4.961-2.06c1.33 0 2.604.368 3.703 1.057a.19.19 0 0 0 .19.007m-3.893-2.845A4 4 0 0 1 9.16 11.03a4.01 4.01 0 0 1-1.18-2.85c0-1.076.42-2.089 1.179-2.85a4 4 0 0 1 2.845-1.182c1.076 0 2.084.42 2.846 1.182a4.01 4.01 0 0 1 1.179 2.85c0 1.075-.42 2.088-1.18 2.85a4 4 0 0 1-2.845 1.18Zm8.62 5.578h-1.968V15.82a.19.19 0 0 0-.188-.187h-1.312a.19.19 0 0 0-.188.187v1.97H15a.19.19 0 0 0-.188.187v1.312c0 .103.084.188.188.188h1.968v1.968a.19.19 0 0 0 .188.188h1.312a.19.19 0 0 0 .188-.188v-1.968h1.969a.19.19 0 0 0 .187-.188v-1.312a.19.19 0 0 0-.187-.188Z"
})));

var SVGAddUser = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgAddUser
});

var _path$S;
function _extends$X() { _extends$X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends$X({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$S || (_path$S = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.605 12c0 .44-.36.8-.8.8H7.125l3.62 3.64c.32.32.32.82 0 1.14a.8.8 0 0 1-.56.24c-.2 0-.42-.08-.56-.24l-4.98-5c-.32-.32-.32-.82 0-1.12l4.98-5c.32-.32.82-.32 1.14 0s.32.82 0 1.14l-3.64 3.6h11.68c.44 0 .8.36.8.8"
})));

var SVGArrowLeft = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgArrowLeft
});

var _path$R;
function _extends$W() { _extends$W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends$W({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$R || (_path$R = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m19.365 12.56-4.98 5a.8.8 0 0 1-.56.24c-.2 0-.4-.08-.56-.24a.797.797 0 0 1 0-1.14l3.62-3.64H5.205c-.44 0-.8-.36-.8-.8s.36-.8.8-.8h11.68l-3.62-3.64a.797.797 0 0 1 0-1.14c.32-.32.82-.32 1.14 0l4.98 5c.3.34.3.86-.02 1.16"
})));

var SVGArrowRight = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgArrowRight
});

var _path$Q;
function _extends$V() { _extends$V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }
const SvgArrowUpRight = props => /*#__PURE__*/React.createElement("svg", _extends$V({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$Q || (_path$Q = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  d: "M20.8 7.135a.6.6 0 0 1 .144.182.54.54 0 0 1 .056.239V12a.565.565 0 0 1-.575.556.565.565 0 0 1-.574-.556V8.897l-6.296 6.088a.584.584 0 0 1-.812 0l-3.424-3.31-5.338 5.162a.59.59 0 0 1-.813 0 .543.543 0 0 1 0-.785l5.745-5.556a.585.585 0 0 1 .812 0l3.424 3.31 5.89-5.695h-3.21a.565.565 0 0 1-.574-.555c0-.307.257-.556.575-.556h4.595a.6.6 0 0 1 .375.135z"
})));

var SVGArrowUpRight = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgArrowUpRight
});

var _path$P;
function _extends$U() { _extends$U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }
const SvgBriefcase = props => /*#__PURE__*/React.createElement("svg", _extends$U({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$P || (_path$P = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.965 7.38c-.16-.16-.36-.18-.56-.18h-4.2V4.8c0-.44-.4-.8-.84-.8h-6.72c-.44 0-.84.36-.84.8v2.4h-4.2c-.44 0-.8.26-.8.7v11.3c0 .44.36.8.8.8h16.8c.44 0 .8-.36.8-.8V7.94c0-.22-.08-.4-.24-.56M9.405 5.6h5.2v1.6h-5.2zm10.2 3.2V13h-5.6v-.3c0-.34-.32-.5-.66-.5h-2.7c-.34 0-.66.18-.66.5v.3h-5.6V8.8zm-6.8 4.6v.4h-1.6v-.4zm-8.4 5v-4.2h5.6v.2c0 .34.32.6.66.6h2.7c.34 0 .66-.28.66-.6v-.2h5.6v4.2z"
})));

var SVGBriefcase = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgBriefcase
});

var _path$O;
function _extends$T() { _extends$T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends$T({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$O || (_path$O = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.2 7.26V4.7c0-.56.44-1 1-1s1 .44 1 1v2.56c0 .56-.44 1-1 1s-1-.44-1-1m8.6 1c.56 0 1-.44 1-1V4.7c0-.56-.44-1-1-1s-1 .44-1 1v2.56c0 .56.44 1 1 1m5.4-2.28V19.5c0 .44-.36.8-.8.8H3.6c-.44 0-.8-.36-.8-.8V5.98c0-.44.36-.88.8-.88h1.86c.44 0 .8.36.8.8s-.36.8-.8.8H4.38v3.4h15.2V6.7h-1.06c-.44 0-.8-.36-.8-.8s.36-.8.8-.8h1.86c.46 0 .82.44.82.88M19.6 18.7v-7.2H4.4v7.2zm-8.86-12h2.52c.44 0 .8-.36.8-.8s-.36-.8-.8-.8h-2.52c-.44 0-.8.36-.8.8s.36.8.8.8"
})));

var SVGCalendar = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCalendar
});

var _path$N;
function _extends$S() { _extends$S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }
const SvgCaretDown = props => /*#__PURE__*/React.createElement("svg", _extends$S({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$N || (_path$N = /*#__PURE__*/React.createElement("path", {
  d: "M5.293 8.293a1 1 0 0 1 1.414 0L12 13.586l5.293-5.293a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414"
})));

var SVGCaretDown = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCaretDown
});

var _path$M;
function _extends$R() { _extends$R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }
const SvgCaretLeft = props => /*#__PURE__*/React.createElement("svg", _extends$R({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$M || (_path$M = /*#__PURE__*/React.createElement("path", {
  d: "M15.707 5.28a1 1 0 0 1 0 1.414l-5.293 5.293 5.293 5.294a1 1 0 1 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0z"
})));

var SVGCaretLeft = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCaretLeft
});

var _path$L;
function _extends$Q() { _extends$Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }
const SvgCaretRight = props => /*#__PURE__*/React.createElement("svg", _extends$Q({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$L || (_path$L = /*#__PURE__*/React.createElement("path", {
  d: "M8.306 18.707a1 1 0 0 1 0-1.414L13.599 12 8.306 6.707A1 1 0 1 1 9.72 5.293l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414 0"
})));

var SVGCaretRight = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCaretRight
});

var _path$K;
function _extends$P() { _extends$P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }
const SvgCaretUp = props => /*#__PURE__*/React.createElement("svg", _extends$P({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$K || (_path$K = /*#__PURE__*/React.createElement("path", {
  d: "M5.293 15.707a1 1 0 0 0 1.414 0L12 10.414l5.293 5.293a1 1 0 0 0 1.414-1.414l-6-6a1 1 0 0 0-1.414 0l-6 6a1 1 0 0 0 0 1.414"
})));

var SVGCaretUp = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCaretUp
});

var _path$J;
function _extends$O() { _extends$O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }
const SvgChat = props => /*#__PURE__*/React.createElement("svg", _extends$O({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$J || (_path$J = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.405 4h-16.8c-.44 0-.8.36-.8.8v10.22c0 .44.36.78.8.78h9.4v3.4c0 .34.26.64.56.76.1.04.2.04.3.04.24 0 .46-.1.62-.28l3.32-3.92h2.6c.44 0 .8-.34.8-.78V4.8c0-.44-.36-.8-.8-.8m-.8 10.2h-2.16c-.24 0-.5.12-.66.28L14.605 17v-2c0-.44-.28-.82-.72-.82h-9.48v-8.6h15.2zM6.525 8.4c0-.44.36-.8.8-.8h5.8c.44 0 .8.36.8.8s-.36.8-.8.8h-5.8c-.44 0-.8-.36-.8-.8m8.78.62a.84.84 0 0 1-.24-.56c0-.22.08-.42.24-.56a.8.8 0 0 1 .56-.24c.22 0 .42.08.56.24.14.14.24.36.24.56 0 .22-.08.42-.24.56a.8.8 0 0 1-.56.24c-.2-.02-.4-.1-.56-.24"
})));

var SVGChat = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgChat
});

var _path$I, _path2$c;
function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }
const SvgCheckCircleSolid = props => /*#__PURE__*/React.createElement("svg", _extends$N({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$I || (_path$I = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 19.38a7.38 7.38 0 1 0 0-14.76 7.38 7.38 0 0 0 0 14.76M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18",
  clipRule: "evenodd"
})), _path2$c || (_path2$c = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m4.983-10.497a.81.81 0 0 0-1.146-1.146l-4.701 4.703-2.854-2.33a.81.81 0 0 0-1.024 1.256l3.288 2.683a1 1 0 0 0 1.34-.068z",
  clipRule: "evenodd"
})));

var SVGCheckCircleSolid = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCheckCircleSolid
});

var _path$H, _path2$b;
function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }
const SvgCheckCircle = props => /*#__PURE__*/React.createElement("svg", _extends$M({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$H || (_path$H = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 19.38a7.38 7.38 0 1 0 0-14.76 7.38 7.38 0 0 0 0 14.76M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18",
  clipRule: "evenodd"
})), _path2$b || (_path2$b = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.983 9.357a.81.81 0 0 1 0 1.146L11.885 15.6a1 1 0 0 1-1.34.068l-3.287-2.683a.81.81 0 0 1 1.024-1.255l2.854 2.329 4.701-4.703a.81.81 0 0 1 1.146 0Z",
  clipRule: "evenodd"
})));

var SVGCheckCircle = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCheckCircle
});

var _path$G;
function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends$L({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}, props), _path$G || (_path$G = /*#__PURE__*/React.createElement("path", {
  d: "M9.685 17.2c-.24 0-.46-.08-.64-.26l-3.98-3.98a.894.894 0 0 1 0-1.28c.36-.36.92-.36 1.28 0l3.36 3.34 7.98-7.96c.36-.37.92-.36 1.28 0s.36.92 0 1.28l-8.62 8.6c-.2.18-.42.26-.66.26"
})));

var SVGCheck = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCheck
});

var _rect$1, _path$F;
function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }
const SvgCheckboxChecked = props => /*#__PURE__*/React.createElement("svg", _extends$K({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _rect$1 || (_rect$1 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "currentColor",
  rx: 4
})), _path$F || (_path$F = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "m7 12.071 3.536 3.536 7.07-7.071"
})));

var SVGCheckboxChecked = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCheckboxChecked
});

var _rect, _rect2;
function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }
const SvgCheckboxUnchecked = props => /*#__PURE__*/React.createElement("svg", _extends$J({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 21,
  x: 1.5,
  y: 1.5,
  stroke: "currentColor",
  strokeWidth: 3,
  rx: 2.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 3,
  fill: "#fff",
  rx: 2.5
})));

var SVGCheckboxUnchecked = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCheckboxUnchecked
});

var _circle$5;
function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }
const SvgCircle = props => /*#__PURE__*/React.createElement("svg", _extends$I({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _circle$5 || (_circle$5 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 9,
  fill: "currentColor"
})));

var SVGCircle = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCircle
});

var _path$E, _path2$a;
function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }
const SvgClock = props => /*#__PURE__*/React.createElement("svg", _extends$H({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$E || (_path$E = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 1.5C6.202 1.5 1.5 6.202 1.5 12S6.202 22.5 12 22.5 22.5 17.798 22.5 12 17.798 1.5 12 1.5m0 19.219A8.72 8.72 0 0 1 3.281 12 8.72 8.72 0 0 1 12 3.281 8.72 8.72 0 0 1 20.719 12 8.72 8.72 0 0 1 12 20.719"
})), _path2$a || (_path2$a = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m16.095 14.967-3.343-2.416V6.75a.19.19 0 0 0-.187-.188h-1.127a.19.19 0 0 0-.188.188v6.455c0 .06.028.117.077.152l3.877 2.827a.19.19 0 0 0 .262-.04l.67-.914a.187.187 0 0 0-.041-.263"
})));

var SVGClock = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgClock
});

var _path$D, _path2$9;
function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }
const SvgCrossCircleSolid = props => /*#__PURE__*/React.createElement("svg", _extends$G({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$D || (_path$D = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 19.38a7.38 7.38 0 1 0 0-14.76 7.38 7.38 0 0 0 0 14.76M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18",
  clipRule: "evenodd"
})), _path2$9 || (_path2$9 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-5.22-3.792a.81.81 0 0 1 0 1.145l-2.64 2.641 2.641 2.641a.81.81 0 0 1-1.145 1.146l-2.642-2.641-2.64 2.64a.81.81 0 0 1-1.146-1.145l2.64-2.64-2.64-2.642a.81.81 0 1 1 1.146-1.145l2.64 2.64 2.641-2.64a.81.81 0 0 1 1.146 0Z",
  clipRule: "evenodd"
})));

var SVGCrossCircleSolid = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCrossCircleSolid
});

var _path$C, _path2$8, _path3$3;
function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }
const SvgCrossCircle = props => /*#__PURE__*/React.createElement("svg", _extends$F({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$C || (_path$C = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 19.38a7.38 7.38 0 1 0 0-14.76 7.38 7.38 0 0 0 0 14.76M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18",
  clipRule: "evenodd"
})), _path2$8 || (_path2$8 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.78 8.208a.81.81 0 0 1 0 1.145l-6.427 6.428a.81.81 0 0 1-1.145-1.146l6.427-6.427a.81.81 0 0 1 1.146 0Z",
  clipRule: "evenodd"
})), _path3$3 || (_path3$3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.208 8.208a.81.81 0 0 1 1.146 0l6.427 6.427a.81.81 0 0 1-1.145 1.146L8.208 9.353a.81.81 0 0 1 0-1.145",
  clipRule: "evenodd"
})));

var SVGCrossCircle = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCrossCircle
});

var _path$B;
function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }
const SvgCross = props => /*#__PURE__*/React.createElement("svg", _extends$E({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$B || (_path$B = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.945 15.66c.36.36.36.92 0 1.28-.18.18-.4.26-.64.26s-.46-.08-.64-.26l-3.66-3.66-3.66 3.66c-.18.18-.4.26-.64.26s-.46-.08-.64-.26a.894.894 0 0 1 0-1.28l3.66-3.66-3.66-3.66a.894.894 0 0 1 0-1.28c.36-.36.92-.36 1.28 0l3.66 3.66 3.66-3.66c.36-.36.92-.36 1.28 0s.36.92 0 1.28L13.285 12z"
})));

var SVGCross = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgCross
});

var _path$A;
function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }
const SvgDollar = props => /*#__PURE__*/React.createElement("svg", _extends$D({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$A || (_path$A = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.472 14.52q0 .896-.48 1.648t-1.424 1.2q-.945.448-2.272.448v1.28h-.688v-1.312q-1.744-.144-2.848-1.056-1.088-.912-1.2-2.432h2.912q.048.512.336.864.305.352.8.48v-2.544a5 5 0 0 1-.352-.112q-1.168-.336-1.92-.672a3.7 3.7 0 0 1-1.28-1.024q-.528-.688-.528-1.808 0-.975.528-1.712.544-.735 1.472-1.12.928-.4 2.08-.432V4.904h.688v1.328q1.76.112 2.8 1.008 1.04.88 1.168 2.336h-2.96q-.065-.48-.32-.784t-.688-.416v2.496l.496.16q1.168.367 1.888.72.736.336 1.264 1.008t.528 1.76m-6.016-5.152q0 .432.288.736.304.288.864.528v-2.32q-.544.032-.848.304t-.304.752m1.84 6.352q.576-.015.912-.32.336-.32.336-.816a.95.95 0 0 0-.32-.736q-.32-.304-.928-.528z"
})));

var SVGDollar = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgDollar
});

var _path$z;
function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }
const SvgDotsGrid = props => /*#__PURE__*/React.createElement("svg", _extends$C({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$z || (_path$z = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.025 7.03a1.98 1.98 0 0 1-1.353-.568 1.9 1.9 0 0 1-.542-1.328c0-.487.217-.975.542-1.354a1.9 1.9 0 0 1 1.353-.542c.487 0 .975.216 1.326.542.352.352.57.84.57 1.354 0 .488-.218.976-.57 1.328a1.86 1.86 0 0 1-1.326.569zm8.391-.568c.352-.352.57-.84.57-1.328 0-.487-.218-.975-.57-1.354a1.89 1.89 0 0 0-1.326-.542c-.487 0-1.002.216-1.353.542-.352.352-.542.84-.542 1.354 0 .488.217.976.542 1.328.351.352.84.569 1.353.569.46 0 .974-.217 1.326-.57zm7.038 0c.352-.352.57-.84.57-1.328 0-.487-.218-.975-.57-1.354a1.89 1.89 0 0 0-1.326-.542c-.487 0-1.002.216-1.353.542-.352.352-.542.84-.542 1.354 0 .488.217.976.542 1.328.351.352.84.569 1.353.569.46 0 .974-.217 1.326-.57zM6.378 13.236c.352-.352.57-.84.57-1.328 0-.487-.218-.975-.57-1.355a1.89 1.89 0 0 0-1.326-.541c-.487 0-1 .216-1.353.54a1.9 1.9 0 0 0-.542 1.356c0 .488.217.976.542 1.328.352.352.84.569 1.353.569.46 0 .975-.217 1.326-.57zm7.038 0c.352-.352.57-.84.57-1.328 0-.487-.218-.975-.57-1.355a1.89 1.89 0 0 0-1.326-.541 2.08 2.08 0 0 0-1.353.54 1.9 1.9 0 0 0-.542 1.356c0 .488.217.976.542 1.328.351.352.84.569 1.353.569.46 0 .974-.217 1.326-.57zm7.038 0c.352-.352.57-.84.57-1.328 0-.487-.218-.975-.57-1.355a1.89 1.89 0 0 0-1.326-.541 2.08 2.08 0 0 0-1.353.54 1.9 1.9 0 0 0-.542 1.356c0 .488.217.976.542 1.328.351.352.84.569 1.353.569.46 0 .974-.217 1.326-.57zM6.378 20.01c.352-.352.57-.84.57-1.328s-.218-.975-.57-1.355a1.89 1.89 0 0 0-1.326-.542c-.487 0-1 .217-1.353.542-.352.353-.542.84-.542 1.355 0 .488.217.976.542 1.328.352.352.84.569 1.353.569.46 0 .975-.217 1.326-.57zm7.038 0c.352-.352.57-.84.57-1.328s-.218-.975-.57-1.355a1.89 1.89 0 0 0-1.326-.542c-.487 0-1.002.217-1.353.542-.352.353-.542.84-.542 1.355 0 .488.217.976.542 1.328.351.352.84.569 1.353.569.46 0 .974-.217 1.326-.57zm7.038 0c.352-.352.57-.84.57-1.328s-.218-.975-.57-1.355a1.89 1.89 0 0 0-1.326-.542c-.487 0-1.002.217-1.353.542-.352.353-.542.84-.542 1.355 0 .488.217.976.542 1.328.351.352.84.569 1.353.569.46 0 .974-.217 1.326-.57z"
})));

var SVGDotsGrid = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgDotsGrid
});

var _path$y;
function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends$B({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$y || (_path$y = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21 14.56V20c0 .56-.46 1-1.047 1H4.047C3.46 21 3 20.56 3 20v-5.44c0-.56.46-1 1.047-1 .586 0 1.046.44 1.046 1V19h13.814v-4.44c0-.56.46-1 1.046-1S21 14 21 14.56m-9.754 1.24c.189.2.461.3.754.3s.544-.1.753-.3l4.166-4.08a.977.977 0 0 0-.021-1.42 1.09 1.09 0 0 0-1.486.02l-2.386 2.32V4c0-.56-.46-1-1.047-1-.586 0-1.046.44-1.046 1v8.66l-2.387-2.32c-.397-.4-1.067-.4-1.486-.02a.976.976 0 0 0-.02 1.42z"
})));

var SVGDownload = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgDownload
});

var _path$x, _path2$7;
function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }
const SvgExclamationCircleSolid = props => /*#__PURE__*/React.createElement("svg", _extends$A({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$x || (_path$x = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 19.38a7.38 7.38 0 1 0 0-14.76 7.38 7.38 0 0 0 0 14.76M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18",
  clipRule: "evenodd"
})), _path2$7 || (_path2$7 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-9-5.04a.81.81 0 0 1 .81.81v5.76a.81.81 0 0 1-1.62 0V7.77a.81.81 0 0 1 .81-.81m0 10.08a.81.81 0 1 0 0-1.62.81.81 0 0 0 0 1.62",
  clipRule: "evenodd"
})));

var SVGExclamationCircleSolid = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgExclamationCircleSolid
});

var _path$w, _path2$6, _path3$2;
function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }
const SvgExclamationCircle = props => /*#__PURE__*/React.createElement("svg", _extends$z({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$w || (_path$w = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 19.38a7.38 7.38 0 1 0 0-14.76 7.38 7.38 0 0 0 0 14.76M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18",
  clipRule: "evenodd"
})), _path2$6 || (_path2$6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 6.96a.81.81 0 0 1 .81.81v5.76a.81.81 0 0 1-1.62 0V7.77a.81.81 0 0 1 .81-.81",
  clipRule: "evenodd"
})), _path3$2 || (_path3$2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.81 16.23a.81.81 0 1 1-1.62 0 .81.81 0 0 1 1.62 0"
})));

var SVGExclamationCircle = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgExclamationCircle
});

var _path$v;
function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }
const SvgExternalLink = props => /*#__PURE__*/React.createElement("svg", _extends$y({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$v || (_path$v = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.805 14.94v3.66c0 .44-.32.8-.76.8H3.605c-.44 0-.8-.36-.8-.8V5.4c0-.44.36-.8.8-.8h10.44c.44 0 .76.36.76.8v3.66c0 .44-.36.8-.8.8s-.8-.36-.8-.8V6.2h-8.8v11.6h8.8v-2.86c0-.44.36-.8.8-.8s.8.36.8.8m6.16-3.54-3.14-3.16a.797.797 0 0 0-1.14 0c-.32.32-.32.82 0 1.14l1.78 1.8-9.7.02c-.44 0-.8.36-.8.8s.36.8.8.8l9.7-.02-1.78 1.8c-.32.32-.3.82 0 1.14.16.16.36.24.56.24s.42-.08.56-.24l3.14-3.16c.34-.34.34-.84.02-1.16"
})));

var SVGExternalLink = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgExternalLink
});

var _path$u;
function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends$x({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$u || (_path$u = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.725 3.62a.81.81 0 0 0-.7-.42H4.005c-.3 0-.56.16-.7.42s-.08.58.08.82l6.24 9.16v6.06c0 .62.42 1.14 1.06 1.14h2.68c.62 0 1.06-.5 1.06-1.14V13.6l6.24-9.16c.14-.24.2-.56.06-.82m-7.74 9.3c-.08.14-.18.28-.18.44v5.84h-1.6v-5.84a.72.72 0 0 0-.18-.44l-1.9-2.78c.4-.12.88-.24 1.4-.22.62 0 1.04.12 1.5.24.48.12.96.24 1.64.26q.6 0 1.08-.06zm2.92-4.28c-.02 0-.86.38-2.24.36-.5 0-.88-.1-1.3-.22-.48-.12-1.04-.26-1.84-.28-.9 0-1.7.22-2.24.42l-2.8-4.14h13.02zm-1.64-1.32a.84.84 0 0 1-.24-.56c0-.22.08-.42.24-.56a.84.84 0 0 1 .56-.24c.22 0 .42.08.56.24s.24.36.24.56c0 .22-.08.42-.24.56s-.36.24-.56.24-.42-.1-.56-.24"
})));

var SVGFilter = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgFilter
});

var _circle$4, _path$t;
function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }
const SvgFlagCircle = props => /*#__PURE__*/React.createElement("svg", _extends$w({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}, props), _circle$4 || (_circle$4 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 9.5
})), _path$t || (_path$t = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.618 7.476c.7-.255 2.321-.57 4.016.172.477.209.84.512 1.153.813.13.125.243.24.351.352.173.176.333.339.529.508.293.253.614.468 1.03.61.419.143.959.223 1.697.17a.497.497 0 0 1 .465.746c-.088.15-.553.878-1.383 1.465-.847.598-2.085 1.052-3.649.581-1.202-.362-1.916-.292-2.394-.074-.393.18-.692.485-.993.896l-.009 2.753a.568.568 0 0 1-1.135-.004l.008-2.685v-.014L8.29 7.944c0-.21.13-.397.327-.468z"
})));

var SVGFlagCircle = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgFlagCircle
});

var _path$s;
function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }
const SvgGraduationCap = props => /*#__PURE__*/React.createElement("svg", _extends$v({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$s || (_path$s = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m20.725 9.1-8.4-3.78c-.22-.1-.46-.1-.66 0l-8.4 3.78c-.28.12-.46.4-.46.7s.2.58.48.72l.72.34v2.8c0 .28.22.5.5.5s.5-.22.5-.5V11.4l1.2.64v3.4c0 .14.04.26.12.38s1.9 2.84 5.58 2.84c3.78 0 5.52-2.74 5.6-2.84.06-.1.12-.24.12-.36v-3.28l3.18-1.62c.28-.14.44-.42.44-.72a.93.93 0 0 0-.52-.74m-4.52 6.12c-.4.48-1.76 2.04-4.3 2.04-2.48 0-3.9-1.54-4.3-2.04v-2.46l4.04 2.06c.12.06.24.08.36.08s.26-.02.38-.08l3.82-1.94zm-4.2-2.02-6.56-3.32 6.56-2.96 6.56 2.96zm-7 1.66c.14.14.24.36.24.56s-.08.42-.24.56a.84.84 0 0 1-.56.24c-.2 0-.42-.08-.56-.24a.84.84 0 0 1-.24-.56c0-.2.08-.42.24-.56a.84.84 0 0 1 .56-.24c.2 0 .4.08.56.24"
})));

var SVGGraduationCap = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgGraduationCap
});

var _path$r;
function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }
const SvgHeart = props => /*#__PURE__*/React.createElement("svg", _extends$u({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$r || (_path$r = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.145 7.2c-.82-1.82-2.54-3-4.4-3s-3.06.82-3.76 1.7c-.7-.88-1.9-1.7-3.76-1.7s-3.58 1.18-4.4 3c-.84 1.9-.48 4 .98 5.64 3.5 3.94 6.6 6.72 6.64 6.74.16.14.34.2.54.2s.38-.06.54-.2c.04-.02 3.12-2.82 6.64-6.74 1.48-1.64 1.84-3.74.98-5.64m-2.16 4.58c-2.6 2.9-4.96 5.18-5.98 6.12-1.02-.96-3.38-3.22-5.98-6.14-1.04-1.18-1.3-2.6-.72-3.94.54-1.22 1.72-2.06 2.94-2.06 2.38 0 2.92 1.78 2.98 2 .08.36.4.6.76.6s.68-.26.78-.6c.06-.2.6-2 2.98-2 1.2 0 2.38.82 2.94 2.06.6 1.36.34 2.78-.7 3.96m-.2-2.32c.02.38-.26.72-.66.74h-.04a.7.7 0 0 1-.7-.66c-.08-1.14-.82-1.32-.96-1.34a.71.71 0 0 1-.6-.78.73.73 0 0 1 .8-.6c.7.1 2.04.78 2.16 2.64m-.96 1.16c.16.16.24.36.24.56 0 .22-.08.42-.24.56-.14.16-.36.24-.56.24s-.42-.08-.56-.24a.76.76 0 0 1-.24-.56c0-.2.08-.42.24-.56a.84.84 0 0 1 .56-.24c.2.02.4.1.56.24"
})));

var SVGHeart = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgHeart
});

var _path$q;
function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends$t({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$q || (_path$q = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.405 12.6c-.2 0-.4-.08-.56-.22l-7.84-7.66-7.84 7.66c-.32.3-.82.3-1.14-.02-.3-.32-.3-.82.02-1.14l8.4-8.2c.32-.3.8-.3 1.12 0l8.4 8.2c.32.3.32.82.02 1.14-.16.16-.38.24-.58.24m-1.76 7.8v-7.82c0-.44-.36-.8-.8-.8s-.8.36-.8.8v7.02h-2.5v-4.28c0-.58-.48-1.06-1.06-1.06h-2.98c-.58 0-1.06.48-1.06 1.06v4.28h-2.5v-7.02c0-.44-.36-.8-.8-.8s-.8.36-.8.8v7.82c0 .44.36.8.8.8h4.1c.44 0 .8-.36.8-.8v-4.54h1.9v4.54c0 .44.36.8.8.8h4.1c.46 0 .8-.36.8-.8"
})));

var SVGHome = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgHome
});

var _path$p, _path2$5;
function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }
const SvgInfoCircleSolid = props => /*#__PURE__*/React.createElement("svg", _extends$s({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$p || (_path$p = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 4.62a7.38 7.38 0 1 0 0 14.76 7.38 7.38 0 0 0 0-14.76M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18",
  clipRule: "evenodd"
})), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-9 5.04a.81.81 0 0 1-.81-.81v-5.76a.81.81 0 0 1 1.62 0v5.76a.81.81 0 0 1-.81.81m0-10.08a.81.81 0 1 0 0 1.62.81.81 0 0 0 0-1.62",
  clipRule: "evenodd"
})));

var SVGInfoCircleSolid = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgInfoCircleSolid
});

var _path$o, _path2$4, _path3$1;
function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }
const SvgInfoCircle = props => /*#__PURE__*/React.createElement("svg", _extends$r({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$o || (_path$o = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 4.62a7.38 7.38 0 1 0 0 14.76 7.38 7.38 0 0 0 0-14.76M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18",
  clipRule: "evenodd"
})), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 17.04a.81.81 0 0 1-.81-.81v-5.76a.81.81 0 0 1 1.62 0v5.76a.81.81 0 0 1-.81.81",
  clipRule: "evenodd"
})), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.19 7.77a.81.81 0 1 1 1.62 0 .81.81 0 0 1-1.62 0"
})));

var SVGInfoCircle = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgInfoCircle
});

var _path$n, _path2$3, _path3;
function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
const SvgMask = props => /*#__PURE__*/React.createElement("svg", _extends$q({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$n || (_path$n = /*#__PURE__*/React.createElement("path", {
  d: "m15.99 16.977-1.535-1.123a8 8 0 0 1-2.455.383c-3.778 0-6.362-2.673-7.243-3.735.407-.5 1.174-1.336 2.257-2.09l-1.33-.973c-1.562 1.202-2.439 2.467-2.545 2.621l-.007.01a.81.81 0 0 0 0 .884l.007.01c.209.301 3.37 4.866 8.861 4.866 1.51 0 2.845-.346 3.99-.853"
})), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m4.814 7.197.751-1.027 2.52 1.843A9.8 9.8 0 0 1 12 7.193c5.491 0 8.652 4.565 8.861 4.867l.007.01a.81.81 0 0 1 0 .884l-.007.01c-.105.152-.96 1.386-2.485 2.574l1.645 1.203-.752 1.028zm14.43 5.305a11.4 11.4 0 0 1-2.212 2.053l-1.883-1.377a3.25 3.25 0 0 0-.585-2.603 3 3 0 0 0-2.114-1.297c-.73-.1-1.446.04-2.076.408l-.765-.558A8.1 8.1 0 0 1 12 8.767c3.778 0 6.362 2.673 7.243 3.735zm-5.6-1.258c.254.342.39.738.413 1.136l-2.597-1.9a2.1 2.1 0 0 1 .814-.043 2.1 2.1 0 0 1 1.37.806z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.839 11.746a3.25 3.25 0 0 0 .557 2.722 3.25 3.25 0 0 0 2.134 1.278c.157.02.313.04.45.04.611 0 1.193-.178 1.707-.494l-1.084-.793c-.285.088-.59.111-.897.067a2.1 2.1 0 0 1-1.37-.806 2.1 2.1 0 0 1-.416-1.223z"
})));

var SVGMask = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgMask
});

var _path$m;
function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }
const SvgMedicBox = props => /*#__PURE__*/React.createElement("svg", _extends$p({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$m || (_path$m = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.965 7.38c-.16-.16-.36-.18-.56-.18h-4.2V4.8c0-.44-.4-.8-.84-.8h-6.72c-.44 0-.84.36-.84.8v2.4h-4.2c-.44 0-.8.26-.8.7v11.3c0 .44.36.8.8.8h16.8c.44 0 .8-.36.8-.8V7.94c0-.22-.08-.4-.24-.56M9.405 5.6h5.2v1.6h-5.2zm10.2 12.8h-15.2V8.8h15.2zm-10.86-4.9c0-.38.32-.7.7-.7h1.76v-1.78c0-.38.32-.7.7-.7s.7.32.7.7v1.78h1.96c.38 0 .7.32.7.7s-.32.7-.7.7h-1.96v1.88c0 .38-.32.7-.7.7s-.7-.32-.7-.7V14.2h-1.76c-.38 0-.7-.32-.7-.7"
})));

var SVGMedicBox = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgMedicBox
});

var _path$l;
function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }
const SvgPadlockOpen = props => /*#__PURE__*/React.createElement("svg", _extends$o({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$l || (_path$l = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.405 9.4h-8.6V8.02c0-2.04 1.3-3.42 3.16-3.42 1.36 0 2.44.7 2.9 1.94.16.42.62.62 1.04.46s.62-.62.46-1.04c-.7-1.86-2.38-2.98-4.42-2.98-2.8 0-4.76 2.06-4.76 5.02v1.38h-.6c-.44 0-.8.36-.8.8v10c0 .44.36.8.8.8h10.8c.44 0 .8-.36.8-.8v-10c.02-.42-.34-.78-.78-.78m-.8 10h-9.2V11h9.2z"
})));

var SVGPadlockOpen = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgPadlockOpen
});

var _path$k;
function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
const SvgPaperStamp = props => /*#__PURE__*/React.createElement("svg", _extends$n({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.938 5.86a.19.19 0 0 0-.188.187v1.125c0 .103.084.187.188.187h9a.19.19 0 0 0 .187-.187V6.047a.19.19 0 0 0-.188-.188h-9Zm4.312 3.374H6.937a.19.19 0 0 0-.187.188v1.125c0 .103.084.187.188.187h4.312a.19.19 0 0 0 .188-.187V9.422a.19.19 0 0 0-.188-.188M10.125 19.97h-5.25V3.47H18v7.5c0 .103.084.187.188.187H19.5a.19.19 0 0 0 .188-.187V2.53a.75.75 0 0 0-.75-.75h-15a.75.75 0 0 0-.75.75v18.375c0 .415.335.75.75.75h6.187a.19.19 0 0 0 .188-.187v-1.313a.19.19 0 0 0-.188-.187Zm10.313-2.063h-3.375v-.858a2.625 2.625 0 1 0-1.5 0v.858h-3.376a.376.376 0 0 0-.374.375v3.563c0 .206.168.375.374.375h8.25a.376.376 0 0 0 .375-.375V18.28a.376.376 0 0 0-.375-.375Zm-5.297-3.375a1.172 1.172 0 1 1 2.344.001 1.172 1.172 0 0 1-2.344 0Zm4.218 6.235h-6.093V19.36h6.093z"
})));

var SVGPaperStamp = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgPaperStamp
});

var _path$j;
function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }
const SvgPercent = props => /*#__PURE__*/React.createElement("svg", _extends$m({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.656 6.168q1.168 0 1.904.704.752.704.752 1.984t-.752 1.984q-.735.705-1.904.704-1.2 0-1.952-.704-.735-.704-.736-1.984 0-1.28.736-1.984.752-.704 1.952-.704m7.76.16L10.24 17.672H7.6l6.176-11.344zM7.792 8.856q0 .495.224.784.224.272.608.272.4 0 .64-.272.24-.288.24-.784t-.24-.768a.79.79 0 0 0-.64-.288.73.73 0 0 0-.608.288q-.225.271-.224.768m7.584 3.584q1.185 0 1.92.704.736.704.736 1.984t-.736 2q-.735.704-1.92.704-1.168 0-1.92-.704-.736-.72-.736-2c0-1.28.245-1.515.736-1.984q.752-.704 1.92-.704m-.848 2.688q0 .512.224.8.224.272.624.272.384 0 .608-.272.24-.288.24-.8 0-.496-.24-.768a.73.73 0 0 0-.608-.288q-.4 0-.624.288-.224.271-.224.768"
})));

var SVGPercent = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgPercent
});

var _path$i;
function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
const SvgPieChart = props => /*#__PURE__*/React.createElement("svg", _extends$l({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.545 10.24h-6.02c-.38 0-.7-.32-.7-.7 0-3.72 3.02-6.72 6.72-6.72.38 0 .7.32.7.7v6.02c0 .38-.32.7-.7.7m-5.28-1.42h4.58V4.24c-2.38.32-4.28 2.22-4.58 4.58m8.36 12.38c-4.74 0-8.58-3.68-8.58-8.22 0-.44.36-.8.8-.8h7.34V4.84c0-.44.36-.8.8-.8 4.46 0 8.22 3.94 8.22 8.58 0 4.72-3.86 8.58-8.58 8.58m-6.92-7.42c.42 3.26 3.36 5.82 6.92 5.82 3.84 0 6.98-3.12 6.98-6.98 0-3.5-2.58-6.48-5.82-6.92v7.28c0 .44-.36.8-.8.8z"
})));

var SVGPieChart = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgPieChart
});

var _path$h;
function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends$k({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20 12.15c0 .756-.604 1.36-1.358 1.36h-5.435v5.132c0 .754-.604 1.358-1.359 1.358a1.353 1.353 0 0 1-1.358-1.358v-5.133H5.358A1.353 1.353 0 0 1 4 12.151c0-.755.604-1.359 1.358-1.359h5.133V5.358A1.35 1.35 0 0 1 11.849 4c.755 0 1.359.604 1.359 1.358v5.434h5.434c.754 0 1.358.604 1.358 1.359z"
})));

var SVGPlus = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgPlus
});

var _path$g, _path2$2;
function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
const SvgQuestionCircleSolid = props => /*#__PURE__*/React.createElement("svg", _extends$j({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 19.38a7.38 7.38 0 1 0 0-14.76 7.38 7.38 0 0 0 0 14.76M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18",
  clipRule: "evenodd"
})), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-8.276 2.375H10.94a6 6 0 0 1 .112-1.16q.111-.484.366-.871a4.4 4.4 0 0 1 .686-.804q.344-.32.613-.602a2.6 2.6 0 0 0 .433-.603q.156-.32.156-.722 0-.453-.149-.758a1 1 0 0 0-.425-.462q-.277-.163-.695-.163a1.5 1.5 0 0 0-.65.141q-.305.14-.492.439-.187.29-.202.759H8.715q.023-.974.463-1.622a2.66 2.66 0 0 1 1.187-.975 4.1 4.1 0 0 1 1.672-.327q1.023 0 1.747.342.732.334 1.113.982.387.648.388 1.563 0 .654-.254 1.175-.254.513-.672.96t-.903.9q-.426.38-.575.81-.15.431-.157.998m-.904 2.98a1.035 1.035 0 1 0 0-2.07 1.035 1.035 0 0 0 0 2.07",
  clipRule: "evenodd"
})));

var SVGQuestionCircleSolid = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgQuestionCircleSolid
});

var _path$f, _path2$1, _circle$3;
function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
const SvgQuestionCircle = props => /*#__PURE__*/React.createElement("svg", _extends$i({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 19.38a7.38 7.38 0 1 0 0-14.76 7.38 7.38 0 0 0 0 14.76M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18",
  clipRule: "evenodd"
})), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.724 14.375H10.94a6 6 0 0 1 .112-1.16q.111-.484.366-.871a4.4 4.4 0 0 1 .686-.804q.344-.32.613-.602a2.6 2.6 0 0 0 .433-.603q.156-.32.156-.722 0-.453-.149-.758a1 1 0 0 0-.425-.462q-.277-.163-.695-.163a1.5 1.5 0 0 0-.65.141q-.305.14-.492.439-.187.29-.202.759H8.715q.023-.974.463-1.622a2.66 2.66 0 0 1 1.187-.975 4.1 4.1 0 0 1 1.672-.327q1.023 0 1.747.342.732.334 1.113.982.387.648.388 1.563 0 .654-.254 1.175-.254.513-.672.96t-.903.9q-.426.38-.575.81-.15.431-.157.998"
})), _circle$3 || (_circle$3 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.82,
  cy: 16.32,
  r: 1.035,
  fill: "currentColor"
})));

var SVGQuestionCircle = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgQuestionCircle
});

var _circle$2, _circle2;
function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
const SvgRadioChecked = props => /*#__PURE__*/React.createElement("svg", _extends$h({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _circle$2 || (_circle$2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 10.5,
  fill: "#fff",
  stroke: "currentColor",
  strokeWidth: 3
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 6,
  fill: "currentColor"
})));

var SVGRadioChecked = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgRadioChecked
});

var _circle$1;
function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
const SvgRadioUnchecked = props => /*#__PURE__*/React.createElement("svg", _extends$g({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _circle$1 || (_circle$1 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 10.5,
  fill: "#fff",
  stroke: "currentColor",
  strokeWidth: 3
})));

var SVGRadioUnchecked = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgRadioUnchecked
});

var _path$e;
function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
const SvgReveal = props => /*#__PURE__*/React.createElement("svg", _extends$f({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
  d: "M20.868 12.125C20.73 11.928 17.56 7.25 12 7.25s-8.73 4.68-8.868 4.876a.81.81 0 0 0 0 .885c.137.196 3.308 4.876 8.868 4.876s8.73-4.68 8.868-4.876a.81.81 0 0 0 0-.885zM12 16.293c-3.778 0-6.362-2.674-7.243-3.735.88-1.082 3.445-3.736 7.243-3.736 3.778 0 6.362 2.674 7.243 3.736-.88 1.081-3.465 3.735-7.243 3.735m.45-6.96a3.22 3.22 0 0 0-2.408.63 3.27 3.27 0 0 0 1.488 5.839c.157.02.313.039.45.039.705 0 1.37-.236 1.938-.649a3.27 3.27 0 0 0 .646-4.561 3 3 0 0 0-2.114-1.298m.783 4.896a2 2 0 0 1-1.527.393 2.1 2.1 0 0 1-1.37-.806 2.104 2.104 0 0 1 .411-2.93c.43-.334.979-.471 1.527-.393a2.1 2.1 0 0 1 1.37.806c.685.925.51 2.242-.41 2.93z"
})));

var SVGReveal = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgReveal
});

var _path$d;
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends$e({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.18 3c3.42 0 6.2 2.82 6.2 6.26 0 1.46-.5 2.78-1.32 3.86l5.88 5.94c.34.36.34.92 0 1.26-.18.18-.4.26-.62.26-.24 0-.46-.08-.64-.26l-5.88-5.96a6.1 6.1 0 0 1-3.6 1.16C5.78 15.52 3 12.7 3 9.26 2.98 5.8 5.76 3 9.18 3m0 10.94c2.54 0 4.6-2.1 4.6-4.68s-2.06-4.68-4.6-4.68-4.6 2.1-4.6 4.68 2.06 4.68 4.6 4.68"
})));

var SVGSearch = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgSearch
});

var _path$c, _path2;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
const SvgShieldCheckMark = props => /*#__PURE__*/React.createElement("svg", _extends$d({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m12 1.5-9 3v9a9 9 0 0 0 9 9 9 9 0 0 0 9-9v-9zm7.313 12a7.313 7.313 0 0 1-14.625 0V5.766L12 3.187l7.313 2.579z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.87 11.135a.842.842 0 0 0-1.377.274.84.84 0 0 0 .183.92l3.082 3.081a.795.795 0 0 0 1.128 0l5.238-5.238a.795.795 0 0 0 0-1.128l-.066-.065a.796.796 0 0 0-1.127 0l-4.61 4.608-2.452-2.452Z"
})));

var SVGShieldCheckMark = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgShieldCheckMark
});

var _path$b;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
const SvgSort = props => /*#__PURE__*/React.createElement("svg", _extends$c({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m12 1 6.062 10.147H5.938zm0 23L5.938 13.853h12.124z"
})));

var SVGSort = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgSort
});

var _circle, _path$a;
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
const SvgStarCircle = props => /*#__PURE__*/React.createElement("svg", _extends$b({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 9
})), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.429 6.44c.18-.553.963-.553 1.142 0l1.122 3.451h3.628c.582 0 .824.745.353 1.087L14.74 13.11l1.12 3.45c.18.554-.453 1.014-.924.672L12 15.1l-2.935 2.133c-.471.342-1.105-.118-.925-.672l1.121-3.45-2.935-2.133c-.47-.342-.229-1.087.353-1.087h3.628l1.122-3.45z"
})));

var SVGStarCircle = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgStarCircle
});

var _path$9;
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends$a({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.066 4.088c.295-.904 1.573-.904 1.867 0l1.675 5.136h5.408c.952 0 1.347 1.219.576 1.777L16.22 14.17l1.672 5.13c.295.904-.74 1.658-1.51 1.1L12 17.225l-4.382 3.174c-.77.558-1.804-.196-1.509-1.1l1.672-5.13L3.408 11c-.771-.558-.376-1.777.576-1.777h5.409z"
})));

var SVGStar = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgStar
});

var _path$8;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
const SvgSwitch = props => /*#__PURE__*/React.createElement("svg", _extends$9({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m21.74 14.24-2.737 2.714a.86.86 0 0 1-.608.26.82.82 0 0 1-.608-.26l-2.736-2.715a.86.86 0 0 1-.022-1.216c.347-.347.869-.347 1.194 0l1.195 1.238V8.528H9.795a.87.87 0 0 1-.868-.869.87.87 0 0 1 .868-.868h8.578c.478 0 .782.369.782.847v6.601l1.303-1.237c.347-.348.933-.326 1.28 0a.865.865 0 0 1 0 1.237zm-7.536 1.237H6.582V9.722l1.194 1.238a.8.8 0 0 0 .586.26.86.86 0 0 0 .608-.26.86.86 0 0 0 0-1.216L6.234 7.03a.906.906 0 0 0-1.238 0L2.26 9.744c-.347.348-.347.89 0 1.216a.92.92 0 0 0 1.282 0l1.302-1.238v6.602c0 .478.283.89.782.89h8.578a.87.87 0 0 0 .868-.868.87.87 0 0 0-.868-.869"
})));

var SVGSwitch = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgSwitch
});

var _path$7;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
const SvgTags = props => /*#__PURE__*/React.createElement("svg", _extends$8({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.845 13.12c0-.22-.08-.42-.24-.56l-7.46-7.36a.73.73 0 0 0-.52-.22l-5.96-.38a.79.79 0 0 0-.62.24.86.86 0 0 0-.24.62l.38 5.86c.02.2.1.38.24.52l7.48 7.34c.16.16.36.24.56.24s.4-.08.56-.24l5.58-5.48c.16-.16.24-.36.24-.58m-6.38 4.36-6.7-6.58-.3-4.64 4.76.3 6.68 6.56zm-3.46-9.44c.22.22.36.54.36.84 0 .32-.12.62-.36.84-.22.22-.54.36-.86.36s-.62-.12-.86-.36c-.22-.22-.36-.54-.36-.84 0-.32.12-.62.36-.84.22-.22.54-.36.86-.36s.64.14.86.36m13.2 5.08c0 .18-.08.36-.2.5l-5.58 5.48c-.14.14-.32.2-.5.2s-.36-.06-.5-.2a.677.677 0 0 1 0-.98l5.08-4.98-6.96-6.84a.677.677 0 0 1 0-.98.7.7 0 0 1 1 0l7.48 7.34c.1.1.18.28.18.46"
})));

var SVGTags = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgTags
});

var _path$6;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
const SvgTextFileWithImageDoc = props => /*#__PURE__*/React.createElement("svg", _extends$7({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.805 4c0-.44-.36-.8-.8-.8h-12c-.44 0-.8.36-.8.8v16c0 .44.36.8.8.8h12c.44 0 .8-.36.8-.8zm-1.6 15.2h-10.4V4.8h10.4zm-8.4-2.9c0-.38.32-.7.7-.7h4.76c.38 0 .7.32.7.7s-.32.7-.7.7h-4.76c-.38 0-.7-.32-.7-.7m0-2.8c0-.38.32-.7.7-.7h4.76c.38 0 .7.32.7.7s-.32.7-.7.7h-4.76c-.38 0-.7-.32-.7-.7m6.2-5.8c0-.38-.32-.7-.7-.7h-4.8c-.38 0-.7.32-.7.7v2.8c0 .38.32.7.7.7h4.8c.38 0 .7-.32.7-.7zm-4.8.7h3.4v1.4h-3.4z"
})));

var SVGTextFileWithImageDoc = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgTextFileWithImageDoc
});

var _path$5;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
const SvgThumbsUp = props => /*#__PURE__*/React.createElement("svg", _extends$6({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.765 21.2c-2.48 0-6.38-.82-7.34-1.5a.8.8 0 0 1-.34-.66v-7.82c0-.24.12-.48.3-.62.06-.04 1.46-1.14 2.92-1.96 1.82-1 3.08-2.4 3.38-3.28.36-1.08.88-2.56 2.52-2.56.78 0 1.42.44 1.76 1.2.68 1.56-.04 3.72-1.24 5.42.8.18 1.8.44 2.4.62 1.1.34 1.82 1.14 1.98 2.12.14 1-.36 2.02-1.42 2.8-.78 2.1-2.12 5.42-3.1 5.96-.38.2-1.04.28-1.82.28m-6.08-2.64c1.52.64 6.2 1.3 7.08.96.46-.42 1.64-3.1 2.46-5.36.06-.16.16-.3.3-.4.66-.44 1-.96.94-1.4-.06-.36-.38-.66-.86-.82-1-.32-3.48-.86-3.52-.86a.82.82 0 0 1-.6-.54c-.1-.28-.02-.58.18-.78 1.8-1.94 2.12-3.92 1.78-4.72-.1-.24-.22-.24-.28-.24-.4 0-.58.28-1 1.48-.48 1.4-2.14 3.08-4.12 4.16-.96.52-1.92 1.22-2.4 1.58v6.94zm-3.16.56v-7.98c0-.72-.58-1.3-1.3-1.3s-1.3.58-1.3 1.3v7.98c0 .72.58 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3"
})));

var SVGThumbsUp = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgThumbsUp
});

var _path$4;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
const SvgTicket = props => /*#__PURE__*/React.createElement("svg", _extends$5({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m8.245 11.24 4.52 4.52c.18.18.42.28.66.28s.48-.1.66-.28l1.68-1.68c.18-.18.28-.4.28-.66 0-.24-.1-.48-.28-.66l-4.52-4.52a.9.9 0 0 0-.66-.28c-.24 0-.48.1-.66.28l-1.68 1.68c-.36.36-.36.96 0 1.32m2.34-1.96 4.14 4.14-1.3 1.3-4.14-4.14zm10.38 4.62L10.105 3.04a.797.797 0 0 0-1.14 0l-1.52 1.52c-.22.22-.3.56-.18.86.22.54.08 1.14-.32 1.54s-1 .52-1.54.32a.8.8 0 0 0-.86.18l-1.52 1.52a.8.8 0 0 0-.24.56c0 .2.08.42.24.56l10.86 10.86c.16.16.36.24.56.24s.42-.08.56-.24l1.52-1.52c.22-.22.3-.56.18-.86-.22-.54-.08-1.14.32-1.54s1-.52 1.54-.32c.3.12.64.04.86-.18l1.52-1.52c.34-.32.34-.82.02-1.12m-2.32 1.18c-.98-.2-2.02.1-2.74.84-.72.72-1.02 1.76-.84 2.74l-.62.62-9.72-9.72.62-.62c.98.2 2.02-.1 2.74-.84.72-.72 1.02-1.76.84-2.74l.62-.62 9.72 9.72z"
})));

var SVGTicket = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgTicket
});

var _path$3;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
const SvgTwoArrowsCircle = props => /*#__PURE__*/React.createElement("svg", _extends$4({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.937 11.817A8.05 8.05 0 0 1 6.295 6.3a8.02 8.02 0 0 1 5.702-2.362A8 8 0 0 1 17.695 6.3q.349.349.651.736l-1.41 1.101a.187.187 0 0 0 .07.331l4.118 1.008a.188.188 0 0 0 .232-.18l.019-4.24a.186.186 0 0 0-.303-.148L19.75 5.94a9.82 9.82 0 0 0-7.755-3.785c-5.37 0-9.738 4.303-9.84 9.652a.19.19 0 0 0 .188.192H3.75a.187.187 0 0 0 .187-.183ZM21.656 12H20.25a.187.187 0 0 0-.188.183 8 8 0 0 1-.63 2.953 8 8 0 0 1-1.728 2.564 8.03 8.03 0 0 1-5.702 2.363 8.02 8.02 0 0 1-6.352-3.099l1.411-1.101a.187.187 0 0 0-.07-.331l-4.118-1.008a.188.188 0 0 0-.232.18l-.016 4.243c0 .157.18.246.302.148l1.322-1.034a9.82 9.82 0 0 0 7.755 3.783c5.372 0 9.739-4.306 9.84-9.652a.187.187 0 0 0-.188-.192"
})));

var SVGTwoArrowsCircle = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgTwoArrowsCircle
});

var _path$2;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
const SvgUpload = props => /*#__PURE__*/React.createElement("svg", _extends$3({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M54.947 38.827v14.506A2.64 2.64 0 0 1 52.28 56H11.747a2.64 2.64 0 0 1-2.667-2.667V38.827a2.64 2.64 0 0 1 2.667-2.667 2.64 2.64 0 0 1 2.666 2.667v11.84h35.2v-11.84a2.64 2.64 0 0 1 2.667-2.667 2.64 2.64 0 0 1 2.667 2.667m-31.68-15.414 6.08-6.186V40.32a2.64 2.64 0 0 0 2.666 2.667 2.64 2.64 0 0 0 2.667-2.667V17.227l6.08 6.186c.533.534 1.227.8 1.92.8s1.333-.266 1.867-.746c1.066-1.014 1.066-2.72.053-3.787L33.987 8.8c-.48-.533-1.174-.8-1.92-.8-.694 0-1.387.267-1.92.8L19.533 19.68a2.69 2.69 0 0 0 .054 3.787c.96 1.013 2.666.96 3.68-.054"
})));

var SVGUpload = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgUpload
});

var _path$1;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
const SvgUserProfile = props => /*#__PURE__*/React.createElement("svg", _extends$2({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.005 14.22c2.96 0 5.38-2.42 5.38-5.4s-2.42-5.4-5.38-5.4-5.38 2.42-5.38 5.4 2.42 5.4 5.38 5.4m0-9.22c2.08 0 3.78 1.7 3.78 3.8s-1.7 3.8-3.78 3.8-3.78-1.7-3.78-3.8 1.7-3.8 3.78-3.8m2.5 9.74a.8.8 0 0 0-.76.16l-1.74 1.48-1.74-1.48a.82.82 0 0 0-.76-.16c-1.12.36-6.7 2.28-6.7 5.06 0 .44.36.8.8.8h16.8c.44 0 .8-.36.8-.8 0-2.78-5.58-4.7-6.7-5.06M4.825 19c.88-.94 3-1.98 4.76-2.58l1.9 1.62c.3.26.74.26 1.04 0l1.9-1.62c1.76.62 3.88 1.66 4.76 2.58z"
})));

var SVGUserProfile = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgUserProfile
});

var _path;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
const SvgUsersGroup = props => /*#__PURE__*/React.createElement("svg", _extends$1({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.885 13.66c2.34 0 4.24-1.9 4.24-4.22 0-2.34-1.9-4.22-4.24-4.22s-4.24 1.9-4.24 4.22c.02 2.32 1.92 4.22 4.24 4.22m0-6.86c1.46 0 2.64 1.18 2.64 2.62s-1.18 2.62-2.64 2.62-2.64-1.18-2.64-2.62c.02-1.44 1.2-2.62 2.64-2.62m1.92 7.24a.85.85 0 0 0-.66.08l-1.26.76-1.26-.76a.85.85 0 0 0-.66-.08c-1.22.38-5.16 1.8-5.16 3.96 0 .44.36.8.8.8h12.56c.44 0 .8-.36.8-.8 0-2.14-3.94-3.56-5.16-3.96m-6.74 3.16c.68-.52 1.82-1.08 3.06-1.52l1.36.82c.26.16.58.16.82 0l1.36-.82c1.24.42 2.38 1 3.06 1.52zm15.94-.6c0 .34-.26.6-.6.6h-2.68a.59.59 0 0 1-.6-.6c0-.34.26-.6.6-.6h1.78c-.3-.4-.78-.72-1.38-1.04-.3-.16-.4-.52-.24-.8.16-.3.52-.4.82-.24.86.46 2.3 1.44 2.3 2.68m-3.36-5.28c0-.88-.72-1.58-1.58-1.58-.22 0-.42.04-.62.12-.3.12-.66-.02-.78-.32s.02-.66.32-.78a2.774 2.774 0 0 1 3.86 2.56c0 1.54-1.26 2.78-2.78 2.78-.8 0-1.56-.34-2.08-.94-.22-.24-.2-.62.06-.84.24-.22.62-.2.84.06.3.34.74.54 1.2.54.84-.02 1.56-.74 1.56-1.6"
})));

var SVGUsersGroup = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SvgUsersGroup
});

const HuiIconAddUser = SVGAddUser;
const HuiIconArrowLeft = SVGArrowLeft;
const HuiIconArrowRight = SVGArrowRight;
const HuiIconArrowUpRight = SVGArrowUpRight;
const HuiIconBriefcase = SVGBriefcase;
const HuiIconCalendar = SVGCalendar;
const HuiIconCaretDown = SVGCaretDown;
const HuiIconCaretLeft = SVGCaretLeft;
const HuiIconCaretRight = SVGCaretRight;
const HuiIconCaretUp = SVGCaretUp;
const HuiIconChat = SVGChat;
const HuiIconCheckCircleSolid = SVGCheckCircleSolid;
const HuiIconCheckboxChecked = SVGCheckboxChecked;
const HuiIconCheckboxUnchecked = SVGCheckboxUnchecked;
const HuiIconCheck = SVGCheck;
const HuiIconCheckCircle = SVGCheckCircle;
const HuiIconCircle = SVGCircle;
const HuiIconClock = SVGClock;
const HuiIconCross = SVGCross;
const HuiIconCrossCircle = SVGCrossCircle;
const HuiIconCrossCircleSolid = SVGCrossCircleSolid;
const HuiIconDotsGrid = SVGDotsGrid;
const HuiIconDownload = SVGDownload;
const HuiIconExclamationCircle = SVGExclamationCircle;
const HuiIconExclamationCircleSolid = SVGExclamationCircleSolid;
const HuiIconExternalLink = SVGExternalLink;
const HuiIconFilter = SVGFilter;
const HuiIconFlagCircle = SVGFlagCircle;
const HuiIconGraduationCap = SVGGraduationCap;
const HuiIconHeart = SVGHeart;
const HuiIconHome = SVGHome;
const HuiIconInfoCircle = SVGInfoCircle;
const HuiIconInfoCircleSolid = SVGInfoCircleSolid;
const HuiIconMask = SVGMask;
const HuiIconMedicBox = SVGMedicBox;
const HuiIconPaperStamp = SVGPaperStamp;
const HuiIconReveal = SVGReveal;
const HuiIconPadlockOpen = SVGPadlockOpen;
const HuiIconPercent = SVGPercent;
const HuiIconPieChart = SVGPieChart;
const HuiIconPlus = SVGPlus;
const HuiIconQuestionCircle = SVGQuestionCircle;
const HuiIconQuestionCircleSolid = SVGQuestionCircleSolid;
const HuiIconRadioChecked = SVGRadioChecked;
const HuiIconRadioUnchecked = SVGRadioUnchecked;
const HuiIconShieldCheckMark = SVGShieldCheckMark;
const HuiIconSort = SVGSort;
const HuiIconStar = SVGStar;
const HuiIconStarCircle = SVGStarCircle;
const HuiIconSearch = SVGSearch;
const HuiIconDollar = SVGDollar;
const HuiIconSwitch = SVGSwitch;
const HuiIconTags = SVGTags;
const HuiIconThumbsUp = SVGThumbsUp;
const HuiIconTicket = SVGTicket;
const HuiIconTwoArrowsCircle = SVGTwoArrowsCircle;
const HuiIconUpload = SVGUpload;
const HuiIconUsersGroup = SVGUsersGroup;
const HuiIconUserProfile = SVGUserProfile;
const HuiIconTextFileWithImageDoc = SVGTextFileWithImageDoc;

/**
 * Shows a datepicker
 * See {@link DatepickerProps} and {@link UseDatepickerProps} for examples for usage
 */
const HuiDatepicker = ({ clickOutsideToClose = false, datepickerMethods, focusOnInit, hasFocusTrap, labels, locale, maxDate, minDate, mode, onChange, onClose, selectDates, showCloseButton = false, weekStart, }) => {
    const { calendar, displayDaysOfTheWeek, displayMonth, displayYear, getCalendarContainerProps, getCalendarDayContainerProps, getCalendarWeekContainerProps, getDayOfTheWeekProps, getDaysOfTheWeekContainerProps, getControlsContainerProps, getDatepickerContainerProps, getDayButtonProps, getMonthYearContainerProps, getNextMonthButtonProps, getOnCloseButtonProps, getPreviousMonthButtonProps, id, setMonth, setYear, today, } = p({
        focusOnInit,
        hasFocusTrap,
        labels,
        locale,
        maxDate,
        minDate,
        mode,
        onChange,
        onClose,
        selectDates,
        weekStart,
    });
    const handleCloseClick = (evt) => {
        // if (!(evt.currentTarget as HTMLInputElement)?.contains(evt.relatedTarget as HTMLInputElement)) {
        if (!evt.target.closest(`#${id}`)) {
            onClose();
        }
    };
    useEffect(() => {
        if (clickOutsideToClose) {
            setTimeout(() => {
                document.addEventListener('click', handleCloseClick);
            }, 0);
            return () => {
                document.removeEventListener('click', handleCloseClick);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (datepickerMethods) {
        datepickerMethods.current = { setMonth, setYear };
    }
    if (calendar.length <= 1) {
        return null;
    }
    const renderedControls = () => {
        return (React__default.createElement("div", { className: "hui-flex hui-flex-align-center hui-flex-space-between hui-padding-32 hui-padding-bottom-24", "data-testid": "div-controls", ...getControlsContainerProps() },
            React__default.createElement("div", { className: "hui-flex-1 hui-subheader hui-letter-spacing-narrow hui-text-teal-40 hui-font-weight-normal", "data-testid": "div-month-year-title", ...getMonthYearContainerProps() },
                React__default.createElement("span", { className: "hui-font-weight-semi-bold" }, displayMonth),
                " ",
                displayYear),
            React__default.createElement("div", { className: "hui-flex hui-flex-space-between", style: { position: 'relative', right: '-0.5rem', width: '6rem' } },
                React__default.createElement("button", { className: "hui-flex-align-center hui-button-reset hui-datepicker-control-button", "data-testid": "btn-previous-month", ...getPreviousMonthButtonProps() },
                    React__default.createElement(HuiIcon, { "aria-hidden": true, className: "hui-text-gray-50", icon: HuiIconCaretLeft, size: "2.5rem" })),
                React__default.createElement("button", { className: "hui-flex-align-center hui-button-reset hui-datepicker-control-button", "data-testid": "btn-next-month", ...getNextMonthButtonProps() },
                    React__default.createElement(HuiIcon, { "aria-hidden": true, className: "hui-text-gray-50", icon: HuiIconCaretRight, size: "2.5rem" })))));
    };
    const renderedCalendar = () => {
        return (React__default.createElement("div", { className: "hui-padding-horizontal-12 hui-padding-bottom-12", ...getCalendarContainerProps() },
            renderedDaysOfTheWeek(),
            React__default.createElement("div", { "data-testid": "div-calendar-dates" }, calendar.map((week, weekIndex) => {
                return (React__default.createElement("div", { className: "hui-flex", "data-testid": `div-week-${weekIndex}`, key: `week-${weekIndex}`, ...getCalendarWeekContainerProps() }, week.map((day, index) => {
                    return (React__default.createElement("div", { key: `day-cell-${index}`, ...getCalendarDayContainerProps() },
                        day.inMonth && (React__default.createElement("button", { className: `hui-text-sm hui-font-weight-bold hui-border-radius-round 
                        hui-flex hui-flex-justify-center hui-flex-align-center
                        hui-button-reset hui-datepicker-day-container 
                        ${today === day.formatted ? 'hui-datepicker-day-today' : ''}
                        ${day.inMonth ? 'hui-datepicker-day-in-month' : ''}
                        ${day.disabled ? 'hui-datepicker-day-disabled' : ''}  
                        ${day.selected ? 'hui-datepicker-day-selected' : ''}
                        ${day.inRange ? 'hui-datepicker-day-in-range' : ''} 
                        ${day.rangeEnd ? 'hui-datepicker-day-in-range-end' : ''}   
                        ${day.rangeStart ? 'hui-datepicker-day-in-range-start' : ''}   
                      `, "data-testid": `btn-day-${day.formatted}`, type: "button", ...getDayButtonProps(day) },
                            React__default.createElement("div", { className: "day-content" }, day.displayText))),
                        !day.inMonth && React__default.createElement("div", { className: "hui-datepicker-day-container-out-of-month" })));
                })));
            }))));
    };
    const renderedDaysOfTheWeek = () => {
        return (React__default.createElement("div", { className: "hui-flex", "data-testid": "div-days-of-the-week", ...getDaysOfTheWeekContainerProps() }, displayDaysOfTheWeek.map((dayOfTheWeek, index) => {
            return (React__default.createElement("div", { className: "hui-text-xs hui-font-weight-medium hui-flex hui-flex-1 hui-flex-align-center hui-flex-justify-center", "data-testid": `btn-day-of-the-week-${index}`, key: `dotw-${index}`, ...getDayOfTheWeekProps(index) }, dayOfTheWeek.narrow));
        })));
    };
    return (React__default.createElement("div", { className: `hui-datepicker-container hui-border-radius-10 ${onClose ? 'hui-datepicker-popover' : ''}`, "data-testid": "div-datepicker", role: "group", ...getDatepickerContainerProps() },
        onClose && showCloseButton && (React__default.createElement("div", { className: "hui-datepicker-close-container" },
            React__default.createElement("button", { className: "hui-button-reset hui-datepicker-control-button hui-datepicker-close-button", "data-testid": "btn-close", type: "button", ...getOnCloseButtonProps() },
                React__default.createElement(HuiIcon, { icon: HuiIconCross })))),
        renderedControls(),
        renderedCalendar()));
};

/**
 * When applying layouts that should be 100vh, we can't use 100vh thanks to
 * Safari Mobile making their own rules to support their use case rather than
 * the developer's. This hook fills the need to always return the correct
 * number in pixels for the desired vh even with screen resizing.
 *
 * @example
 * ```
 * JS:
 * const oneHundredVH = useVH(100);
 *
 * JSX:
 * <div style={{ '--one-hundred-vh': `${oneHundredVH}px` }}>
 *   <div className="oneHundredVH">...</div>
 * </div>
 *
 * CSS:
 * .oneHundredVH {
 *   height: var(--one-hundred-vh, 100vh);
 * }
 * ```
 *
 * @param howManyVH - number, an integer based percentage
 * @returns number, pixels that represent the current screen height in vh
 */
const useVH = (howManyVH = 1) => {
    const calcVH = () => {
        return (window.innerHeight || 0) * 0.01 * howManyVH;
    };
    const [vh, setVH] = useState(calcVH());
    useEffect(() => {
        const vhEvent = () => {
            setVH(calcVH());
        };
        window.addEventListener('load', vhEvent);
        window.addEventListener('resize', vhEvent);
        vhEvent();
        return () => {
            window.removeEventListener('load', vhEvent);
            window.removeEventListener('resize', vhEvent);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return vh;
};

let lastUniqueId = 0;
const uniqueId = (prefix = 'gen-id') => {
    lastUniqueId += 1;
    return `${prefix}-${lastUniqueId}`;
};
const setNoScrollOnBody = (noScroll) => {
    if (noScroll) {
        document.body.classList.add('hui-overflow-hidden');
    }
    else {
        document.body.classList.remove('hui-overflow-hidden');
    }
};
const setNoScrollOnDialog = (noScroll) => {
    const dialog = document.querySelector('[data-dialog]');
    if (dialog) {
        if (noScroll) {
            dialog.scrollTo(0, 0);
            dialog.classList.add('hui-overflow-hidden');
        }
        else {
            dialog.classList.remove('hui-overflow-hidden');
        }
    }
};
const scrollSmoothlyTo = (id, buffer = 20) => {
    setTimeout(() => {
        var _a;
        const bounds = (_a = document.getElementById(id)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        const elementTop = bounds ? bounds.y + window.scrollY - buffer : window.scrollY;
        window.scrollTo({ behavior: 'smooth', left: 0, top: elementTop });
    }, 0);
};

/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */
var tabbableNode = /input|select|textarea|button|object/;
var focusSelector = 'a, input, select, textarea, button, object, [tabindex]';

function hidden(el) {
  if (process.env.NODE_ENV === 'test') return false;
  return el.offsetWidth <= 0 && el.offsetHeight <= 0 || el.style.display === 'none';
}

function visible(element) {
  var parentElement = element;

  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidden(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }

  return true;
}

function getElementTabIndex(element) {
  var tabIndex = element.getAttribute('tabindex');
  if (tabIndex === null) tabIndex = undefined;
  return parseInt(tabIndex, 10);
}

function focusable(element) {
  var nodeName = element.nodeName.toLowerCase();
  var isTabIndexNotNaN = !isNaN(getElementTabIndex(element));
  var res = // @ts-ignore
  tabbableNode.test(nodeName) && !element.disabled || (element instanceof HTMLAnchorElement ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}
function tabbable(element) {
  var tabIndex = getElementTabIndex(element);
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
}
/**
 * Tabbable elements are elements the user can tab between. This excludes elements with tabIndex=-1
 * */

function findTabbableDescendants(element) {
  return Array.from(element.querySelectorAll(focusSelector)).filter(tabbable);
}

var focusLaterElements = [];
var focusElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;

    if (!focusElement) {
      return;
    }

    if (!focusElement) return;

    if (focusElement.contains(document.activeElement)) {
      return;
    }

    var el = findTabbableDescendants(focusElement)[0] || focusElement;
    el.focus();
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}
function returnFocus() {
  var toFocus = null;

  try {
    toFocus = focusLaterElements.pop();
    if (toFocus) toFocus.focus();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(['You tried to return focus to', toFocus, 'but it is not in the DOM anymore'].join(' '));
  }
}
function setupScopedFocus(element) {
  focusElement = element;
  document.addEventListener('focusout', handleBlur, false);
  document.addEventListener('focusin', handleFocus, true);
}
function teardownScopedFocus() {
  focusElement = null;
  document.removeEventListener('focusout', handleBlur);
  document.removeEventListener('focusin', handleFocus);
}

/**
 * Controls tabbing, so it stays inside the node element
 * @param node
 * @param event
 */

function scopeTab(node, event) {
  var tabbable = findTabbableDescendants(node);

  if (!tabbable.length) {
    event.preventDefault();
    return;
  }

  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
  var leavingFinalTabbable = finalTabbable === document.activeElement || // handle immediate shift+tab after opening with mouse
  node === document.activeElement;
  if (!leavingFinalTabbable) return;
  event.preventDefault();
  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
  if (target) target.focus();
}

/**
 * Sets `aria-hidden` on all elements on the body, except for the active node.
 **/
function createAriaHider(containerNode, selector) {
  if (selector === void 0) {
    selector = 'body > :not(script)';
  }

  var rootNodes = Array.from(document.querySelectorAll(selector)).map(function (node) {
    if (node.contains(containerNode)) {
      return undefined;
    }

    var ariaHidden = node.getAttribute('aria-hidden');

    if (ariaHidden === null || ariaHidden === 'false') {
      node.setAttribute('aria-hidden', 'true');
    }

    return {
      node: node,
      ariaHidden: ariaHidden
    };
  });
  return function () {
    rootNodes.forEach(function (item) {
      if (!item) return;

      if (item.ariaHidden === null) {
        item.node.removeAttribute('aria-hidden');
      } else {
        item.node.setAttribute('aria-hidden', item.ariaHidden);
      }
    });
  };
}

/**
 *  Traps focus to DOM node. Use this with a modal to ensure the user focus doesn't leave.
 * */
function useFocusTrap(active, options) {
  if (active === void 0) {
    active = true;
  }

  if (options === void 0) {
    options = {};
  }

  var ref = useRef();
  var restoreAria = useRef(null);
  var setRef = useCallback(function (node) {
    if (restoreAria.current) {
      restoreAria.current();
    }

    if (ref.current) {
      returnFocus();
      teardownScopedFocus();
    }

    if (active && node) {
      setupScopedFocus(node);
      markForFocusLater();

      var processNode = function processNode(node) {
        // See if we should disable aria
        restoreAria.current = !options.disableAriaHider ? createAriaHider(node) : null; // Find the initial focus element

        var focusElement = null;

        if (options.focusSelector) {
          focusElement = typeof options.focusSelector === 'string' ? node.querySelector(options.focusSelector) : options.focusSelector;
        }

        if (!focusElement) {
          var children = Array.from(node.querySelectorAll(focusSelector));
          focusElement = // Prefer tabbable elements, But fallback to any focusable element
          children.find(tabbable) || // But fallback to any focusable element
          children.find(focusable) || // Nothing found
          null; // If everything else fails, see if the node itself can handle focus

          if (!focusElement && focusable(node)) focusElement = node;
        }

        if (focusElement) {
          // Set the initial focus inside the traps
          focusElement.focus();
        } else {
          if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.warn('[useFocusTrap]: Failed to find a focusable element after activating the focus trap. Make sure to include at an element that can recieve focus. As a fallback, you can also set "tabIndex={-1}" on the focus trap node.', node);
          }
        }
      }; // Delay processing the HTML node by a frame. This ensures focus is assigned correctly.


      setTimeout(function () {
        if (node.ownerDocument) {
          processNode(node);
        } else if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.warn('[useFocusTrap]: The focus trap is not part of the DOM yet, so it is unable to correctly set focus. Make sure to render the ref node.', node);
        }
      });
      ref.current = node;
    } else {
      ref.current = null;
    }
  }, [active, options.focusSelector, options.disableAriaHider]);
  useEffect(function () {
    if (!active) return undefined;

    var handleKeyDown = function handleKeyDown(event) {
      if (event.key === 'Tab' && ref.current) {
        scopeTab(ref.current, event);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [active]);
  return setRef;
}

var HuiDialogSizeProps;
(function (HuiDialogSizeProps) {
    HuiDialogSizeProps["Small"] = "small";
    HuiDialogSizeProps["Medium"] = "medium";
    HuiDialogSizeProps["Large"] = "large";
})(HuiDialogSizeProps || (HuiDialogSizeProps = {}));
var HuiDialogLayoutProps;
(function (HuiDialogLayoutProps) {
    /**
     * Will cause a `Sm` dialog to not scroll all of its contents, but rather be a
     * fixed height for the entire dialog. The header and footer will take up the space
     * required for themselves and the remainder of the dialog height will be given to
     * the body of the dialog to scroll.
     */
    HuiDialogLayoutProps["MenuDialog"] = "no-scroll-on-sm";
    /**
     * Will present a dialog centered in the screen for `Md`, `Lg`, and `Xl` layouts.
     * For `Sm` it will open in a full-width dialog anchored to the bottom of the screen,
     * it will show a downward facing caret if the content goes off screen and requires
     * scroll.
     */
    HuiDialogLayoutProps["Standard"] = "standard";
})(HuiDialogLayoutProps || (HuiDialogLayoutProps = {}));
const SIZE_PROP_TO_CLASSNAME_MAP = {
    [HuiDialogSizeProps.Small]: 'hui-dialog-small',
    [HuiDialogSizeProps.Medium]: 'hui-dialog-medium',
    [HuiDialogSizeProps.Large]: 'hui-dialog-large',
};
const ModalContext = React__default.createContext({});
/**
 * Use to display a dialog, also referred to as a modal.
 *
 * Each dialog should be comprised of an outer `HuiDialog` and contain `HuiDialogHeader`
 * `HuiDialogBody` and `HuiDialogFooter`. The `HuiDialogFooter` should only contain `HuiButton`'s,
 * no additional markup in `HuiDialogFooter` is required.
 *
 * If a form is used, refer to the Forms in Dialog example at the API/Demo link.
 *
 * @remarks
 * [API/Demos](https://hui.inside.humaninterest.com/?path=/story/components-huidialog--standard--documentation)
 *
 * {@link HuiDialogProps}
 *
 * @returns HuiDialog component
 *
 * @example
 * See the API/Demo links for example usage
 */
const HuiDialog = ({ autoFocus = true, backgroundClose, children, className = '', focusEl, hasCloseButton = false, id, layout = HuiDialogLayoutProps.Standard, onClose, size = HuiDialogSizeProps.Medium, testId = 'modal', visible = true, ...otherProps }) => {
    if (!id) {
        id = uniqueId();
    }
    const previousFocusedElement = useRef();
    const [isScrollable, setScrollable] = useState(false);
    const oneHundredVH = useVH(100);
    const style = { '--one-hundred-vh': `${oneHundredVH}px` };
    const context = {
        bodyTestId: `${testId}-body`,
        containerId: `${id}-container`,
        footerTestId: `${testId}-footer`,
        headerId: `${id}-header`,
        headerTestId: `${testId}-header`,
        id: id,
        isScrollable,
        testId: testId,
    };
    const isBackgroundCloseEnabled = (hasCloseButton && backgroundClose === undefined) || backgroundClose === true;
    const overlayId = `${id}-overlay`;
    const sizeClass = SIZE_PROP_TO_CLASSNAME_MAP[size];
    const handleEscapeKeypress = (evt) => {
        if (evt.code === 'Escape') {
            onClose();
        }
    };
    const handleOverlayClick = (evt) => {
        if (isBackgroundCloseEnabled && (evt.target.id === overlayId || evt.target.id === context.containerId)) {
            onClose();
        }
    };
    const cleanup = () => {
        setNoScrollOnBody(false);
        setTimeout(() => {
            previousFocusedElement.current && previousFocusedElement.current.focus();
            previousFocusedElement.current = null;
        }, 0);
        if (isBackgroundCloseEnabled) {
            document.removeEventListener('keydown', handleEscapeKeypress);
        }
    };
    useEffect(() => {
        if (visible) {
            previousFocusedElement.current = document.activeElement;
            setNoScrollOnBody(true);
            if (isBackgroundCloseEnabled) {
                document.addEventListener('keydown', handleEscapeKeypress);
            }
            const dialogContainer = document.getElementById(context.containerId);
            if (layout === HuiDialogLayoutProps.Standard) {
                setScrollable(dialogContainer.scrollHeight > dialogContainer.offsetHeight);
            }
        }
        else {
            cleanup();
        }
        return cleanup;
    }, [visible]);
    useEffect(() => {
        if (isScrollable) {
            // at certain heights in chrome on mobile the scrolling container can jump down slightly,
            // this resets it so it appears normal
            setTimeout(() => {
                var _a;
                (_a = document.getElementById(context.containerId)) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
            }, 0);
        }
    }, [isScrollable]);
    let hasHeader = false;
    React__default.Children.forEach(children, (child) => {
        var _a;
        if (((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.__TYPE) === 'HuiDialogHeader') {
            hasHeader = true;
        }
    });
    // need to focus the list item when MenuDialog
    const focusTrapOptions = autoFocus && !isScrollable && !focusEl
        ? undefined
        : { focusSelector: CSS.escape(`#${focusEl ? focusEl : hasHeader ? context.headerId : id}`) };
    const focusTrap = useFocusTrap(visible, focusTrapOptions);
    return ReactDOM.createPortal(React__default.createElement(ModalContext.Provider, { value: context },
        React__default.createElement("div", { ...(visible ? {} : { 'aria-hidden': true }), className: `hui-dialog-overlay ${visible ? '' : 'hui-visually-hidden'}`, "data-testid": `${testId}-overlay`, id: overlayId, onClick: handleOverlayClick, ref: focusTrap, style: style },
            React__default.createElement("div", { className: `hui-dialog-container`, "data-dialog": true, id: context.containerId, ...otherProps },
                React__default.createElement("div", { "aria-labelledby": context.headerId, "aria-modal": true, className: `hui-dialog ${sizeClass} ${className}`, "data-testid": testId, id: id, role: "dialog" },
                    children,
                    isScrollable && (React__default.createElement("div", { className: "hui-flex-all-centered hui-dialog-scrollable-overlay" },
                        React__default.createElement(HuiIcon, { icon: HuiIconCaretDown }))),
                    hasCloseButton && (React__default.createElement("button", { "aria-label": "Close modal", className: "hui-dialog-close hui-icon-button", "data-testid": `${testId}-close`, onClick: onClose, type: "button" },
                        React__default.createElement(HuiIcon, { icon: HuiIconCross }))))))), document.body);
};

const HuiDialogBody = ({ children, className = '', ...otherProps }) => {
    const context = useContext(ModalContext);
    return (React__default.createElement("div", { className: `hui-dialog-body hui-text-compact hui-text-gray-20 ${className}`, "data-testid": context.bodyTestId, ...otherProps }, children));
};

const defaultProps$f = {
    className: '',
};
const HuiDialogFooter = (props) => {
    props = { ...defaultProps$f, ...props };
    const context = useContext(ModalContext);
    return (React__default.createElement("div", { className: `hui-dialog-footer ${props.className} ${context.isScrollable ? 'hui-dialog-footer-with-scrollable-overlay' : ''}`, "data-testid": context.footerTestId }, React__default.Children.map(props.children, (child, index) => {
        return (React__default.createElement("div", { className: "hui-dialog-footer-child hui-padding-top-16", key: `hui-footer-child-${index}` }, child));
    })));
};

const defaultProps$e = {
    className: '',
};
const HuiDialogHeader = (props) => {
    props = { ...defaultProps$e, ...props };
    const context = useContext(ModalContext);
    return (React__default.createElement("div", { className: `hui-dialog-header ${props.className}`, "data-testid": context.headerTestId, id: context.headerId, tabIndex: -1 }, props.children));
};
HuiDialogHeader.__TYPE = 'HuiDialogHeader';

const HuiDivider = ({ className = '', testId = 'divider', ...otherProps }) => {
    return React__default.createElement("hr", { className: `hui-divider ${className}`, "data-testid": testId, ...otherProps });
};

var HuiExpandablePanelCaretPosition;
(function (HuiExpandablePanelCaretPosition) {
    HuiExpandablePanelCaretPosition[HuiExpandablePanelCaretPosition["Bottom"] = 0] = "Bottom";
    HuiExpandablePanelCaretPosition[HuiExpandablePanelCaretPosition["Right"] = 1] = "Right";
})(HuiExpandablePanelCaretPosition || (HuiExpandablePanelCaretPosition = {}));
const ExpandablePanelContext = React__default.createContext({});
const HuiExpandablePanel = ({ children, className = '', isOpen = false, onOpenChange, testId = 'panel', ...otherProps }) => {
    const [isPanelOpen, setIsPanelOpen] = useState(isOpen);
    const isPanelOpenRef = useRef(isPanelOpen);
    const panelId = useRef(uniqueId()).current;
    useEffect(() => {
        if (onOpenChange) {
            onOpenChange(isPanelOpen);
        }
        isPanelOpenRef.current = isPanelOpen;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPanelOpen]);
    const context = {
        isPanelOpen,
        isPanelOpenRef,
        panelId,
        setIsPanelOpen,
        testId,
    };
    return (React__default.createElement(ExpandablePanelContext.Provider, { value: context },
        React__default.createElement("div", { className: className, "data-testid": testId, ...otherProps }, children)));
};

const HuiExpandablePanelBottomClose = ({ children, className = '', label, onClick, ...otherProps }) => {
    const { isPanelOpen, panelId, setIsPanelOpen, testId } = useContext(ExpandablePanelContext);
    if (!isPanelOpen) {
        return null;
    }
    return (React__default.createElement("button", { "aria-controls": `${panelId}-summary`, "aria-label": label, className: `hui-expandable-panel-button hui-flex hui-flex-justify-center hui-flex-align-center ${className}`, "data-testid": `${testId}-bottom-close`, onClick: (evt) => {
            setIsPanelOpen(!isPanelOpen);
            if (onClick) {
                setTimeout(() => {
                    onClick(evt);
                }, 0);
            }
        }, type: "button", ...otherProps }, children ? children : React__default.createElement(HuiIcon, { icon: HuiIconCaretUp })));
};

const HuiExpandablePanelContent = ({ className = '', children }) => {
    const { isPanelOpen, panelId, testId } = useContext(ExpandablePanelContext);
    return (React__default.createElement("div", { className: `${isPanelOpen ? 'hui-display-block' : 'hui-display-none'} ${className}`, "data-testid": `${testId}-content`, id: `${panelId}-content` }, children));
};

const HuiExpandablePanelContext = ({ children }) => {
    return children({ ...useContext(ExpandablePanelContext) });
};

const HuiExpandablePanelSummary = ({ caretPosition = HuiExpandablePanelCaretPosition.Right, children, className = '', onClick, panelClosedClassName = '', panelOpenClassName = '', ...otherProps }) => {
    const { isPanelOpen, panelId, setIsPanelOpen, testId } = useContext(ExpandablePanelContext);
    const buttonClassName = `${className} ${isPanelOpen ? panelOpenClassName : panelClosedClassName}`;
    return (React__default.createElement("button", { "aria-describedby": isPanelOpen ? `${panelId}-content` : null, "aria-expanded": isPanelOpen, className: `hui-expandable-panel-button hui-flex hui-flex-space-between hui-flex-align-center ${caretPosition === HuiExpandablePanelCaretPosition.Bottom ? 'hui-flex-column' : ''} ${buttonClassName}`, "data-testid": `${testId}-summary`, id: `${panelId}-summary`, onClick: (evt) => {
            setIsPanelOpen(!isPanelOpen);
            if (onClick) {
                setTimeout(() => {
                    onClick(evt);
                }, 0);
            }
        }, type: "button", ...otherProps },
        children,
        React__default.createElement(HuiIcon, { className: "hui-flex-align-self-center hui-text-gray-40 hui-margin-right-8", icon: isPanelOpen ? HuiIconCaretUp : HuiIconCaretDown })));
};

var HuiFlagType;
(function (HuiFlagType) {
    HuiFlagType["Empty"] = "hui-text-empty";
    HuiFlagType["Error"] = "hui-text-error";
    HuiFlagType["Information"] = "hui-text-information";
    HuiFlagType["Success"] = "hui-text-success";
})(HuiFlagType || (HuiFlagType = {}));
const defaultProps$d = {
    className: '',
    icon: HuiIconFlagCircle,
    testId: 'flag',
};
const HuiFlag = (props) => {
    props = { ...defaultProps$d, ...props };
    const { className, icon, label, testId, type } = props;
    return (React__default.createElement("div", { className: `hui-flag hui-padding-vertical-4 hui-padding-right-12 hui-text-compact hui-font-weight-semi-bold hui-text-gray-10 hui-width-fit-content hui-flex ${className}`, "data-testid": testId },
        React__default.createElement(HuiIcon, { className: `hui-flag-icon hui-margin-right-8 ${type}`, icon: icon, size: "1.8rem" }),
        React__default.createElement("div", { className: "hui-flex hui-flex-align-center min-height-1-8-rem" },
            React__default.createElement("div", { className: "hui-flag-label" }, label))));
};

/**
 * Returns the current viewport's window width and height, and updates as it is changed
 *
 * @example
 * ```
 * const windowSize = useWindowSize();
 * ```
 *
 * @returns An object containing the width & height
 */
const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({
        height: window.innerHeight,
        width: window.innerWidth,
    });
    useEffect(() => {
        function handleResize() {
            setWindowSize({
                height: window.innerHeight,
                width: window.innerWidth,
            });
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return windowSize;
};

/**
 * This hook will return the current matching breakpoint and update whenever the screen is resized.
 *
 * @example
 * const matchingBreakpoint = useMatchingBreakpoint();
 * console.log(matchingBreakpoint === HuiBreakpointProps.Sm)
 *
 * @returns HuiBreakpointProps
 */
const useMatchingBreakpoint = () => {
    const windowSize = useWindowSize();
    const matchingBreakpoint = [
        HuiBreakpointProps.Xl,
        HuiBreakpointProps.Lg,
        HuiBreakpointProps.Md,
        HuiBreakpointProps.Sm,
    ].find((breakpoint) => {
        return windowSize.width >= breakpoint;
    });
    return matchingBreakpoint;
};

/**
 * This hook will find the closest matching layout at a breakpoint given the users current browser width and the HuiBreakpointLayout config
 * If a layout is not found for a specific breakpoint in the config, it will look for the next narrower breakpoint, until it finds a match or if no match is found, it will return the defaultLayout
 *
 * @param layoutConfig - A HuiBreakpointLayout type, this defines the matching layouts to use for various components, T is the type for the layout definition used by the component using this {@link HuiBreakpointLayout}
 * @param defaultLayout - If no match is found in the HuiBreakpointLayout, this is the value returned instead
 * @returns T a chosen layout
 */
const useLayoutFromMatchingBreakpoint = (layoutConfig, defaultLayout) => {
    const matchingBreakpoint = useMatchingBreakpoint();
    if (typeof matchingBreakpoint !== 'number') {
        return defaultLayout;
    }
    let unmatchedDefinedLayout;
    const closestMatchingBreakpoint = [
        HuiBreakpointProps.Xl,
        HuiBreakpointProps.Lg,
        HuiBreakpointProps.Md,
        HuiBreakpointProps.Sm,
    ].find((breakpoint) => {
        if (layoutConfig && breakpoint === matchingBreakpoint && layoutConfig[breakpoint] === undefined) {
            unmatchedDefinedLayout = breakpoint;
            return false;
        }
        else if (layoutConfig && layoutConfig[breakpoint] !== undefined) {
            if (unmatchedDefinedLayout) {
                unmatchedDefinedLayout = null;
                return true;
            }
        }
        return breakpoint === matchingBreakpoint;
    });
    let matchedLayout = defaultLayout;
    if (layoutConfig && layoutConfig[closestMatchingBreakpoint] !== undefined) {
        matchedLayout = layoutConfig[closestMatchingBreakpoint];
    }
    return matchedLayout;
};

var HuiFieldErrorLayoutProps;
(function (HuiFieldErrorLayoutProps) {
    HuiFieldErrorLayoutProps["Center"] = "hui-text-align-center";
    HuiFieldErrorLayoutProps["Left"] = "hui-text-align-left";
})(HuiFieldErrorLayoutProps || (HuiFieldErrorLayoutProps = {}));
const defaultProps$c = {
    className: '',
    layout: HuiFieldErrorLayoutProps.Left,
    testId: 'field-error',
};
const HuiFieldError = (props) => {
    props = { ...defaultProps$c, ...props };
    if (!(props.hasError && props.errorMessage)) {
        return null;
    }
    return (React__default.createElement("div", { "aria-hidden": !props.errorMessage, className: `hui-field-error ${props.layout} ${props.className}`, "data-testid": props.testId, id: props.id, role: "alert" }, props.errorMessage));
};

const defaultProps$b = {
    className: '',
    testId: 'helper-text',
};
const HuiFieldHelperText = (props) => {
    props = { ...defaultProps$b, ...props };
    const { children, className, id, testId, ...otherProps } = props;
    if (!children) {
        return null;
    }
    let helperTextClassName = '';
    let helperTextContent = children;
    let helperTextProps = otherProps;
    if (typeof children !== 'string' && React__default.isValidElement(children)) {
        const { children: childChildren, className: childClassName, ...otherChildProps } = children.props;
        helperTextClassName = childClassName;
        helperTextContent = childChildren;
        helperTextProps = { ...otherProps, ...otherChildProps };
    }
    helperTextClassName = `hui-field-helper-text hui-subheader-xs hui-font-weight-normal ${className} ${helperTextClassName}`;
    return (React__default.createElement("div", { className: helperTextClassName, "data-testid": testId, id: id, ...helperTextProps }, helperTextContent));
};

var HuiLabelTypeProps;
(function (HuiLabelTypeProps) {
    HuiLabelTypeProps["Label"] = "label";
    HuiLabelTypeProps["Legend"] = "legend";
})(HuiLabelTypeProps || (HuiLabelTypeProps = {}));
const defaultProps$a = {
    className: '',
    labelType: HuiLabelTypeProps.Label,
    testId: 'label',
};
const HuiLabel = (props) => {
    props = { ...defaultProps$a, ...props };
    const { children, className, htmlFor, id, isHidden, labelType, readOnly, testId, ...otherProps } = props;
    let labelClassName = '';
    let labelContent = children;
    let labelProps = otherProps;
    if (typeof children !== 'string' && React__default.isValidElement(children)) {
        const { children: childChildren, className: childClassName, ...otherChildProps } = children.props;
        labelClassName = childClassName;
        labelContent = childChildren;
        labelProps = { ...otherProps, ...otherChildProps };
    }
    labelClassName = `hui-label ${isHidden ? 'hui-visually-hidden' : ''} ${readOnly ? 'hui-label-read-only' : ''} ${className} ${labelClassName} `;
    return React__default.createElement(labelType, { className: labelClassName, 'data-testid': testId, htmlFor: htmlFor, id, ...labelProps }, labelContent);
};

var HuiCheckedLayoutProps;
(function (HuiCheckedLayoutProps) {
    HuiCheckedLayoutProps[HuiCheckedLayoutProps["ButtonSmall"] = 0] = "ButtonSmall";
    HuiCheckedLayoutProps[HuiCheckedLayoutProps["ButtonMedium"] = 1] = "ButtonMedium";
    HuiCheckedLayoutProps[HuiCheckedLayoutProps["ButtonLarge"] = 2] = "ButtonLarge";
    HuiCheckedLayoutProps[HuiCheckedLayoutProps["ButtonVertical"] = 3] = "ButtonVertical";
    HuiCheckedLayoutProps[HuiCheckedLayoutProps["ButtonXlarge"] = 4] = "ButtonXlarge";
    HuiCheckedLayoutProps[HuiCheckedLayoutProps["Card"] = 5] = "Card";
    HuiCheckedLayoutProps[HuiCheckedLayoutProps["CardHorizontal"] = 6] = "CardHorizontal";
    HuiCheckedLayoutProps[HuiCheckedLayoutProps["CardHorizontalWrap"] = 7] = "CardHorizontalWrap";
    HuiCheckedLayoutProps[HuiCheckedLayoutProps["Checkbox"] = 8] = "Checkbox";
    HuiCheckedLayoutProps[HuiCheckedLayoutProps["RadioHorizontal"] = 9] = "RadioHorizontal";
    HuiCheckedLayoutProps[HuiCheckedLayoutProps["Radio"] = 10] = "Radio";
    HuiCheckedLayoutProps[HuiCheckedLayoutProps["Switch"] = 11] = "Switch";
    HuiCheckedLayoutProps[HuiCheckedLayoutProps["ToggleVertical"] = 12] = "ToggleVertical";
    HuiCheckedLayoutProps[HuiCheckedLayoutProps["Toggle"] = 13] = "Toggle";
    HuiCheckedLayoutProps[HuiCheckedLayoutProps["ToggleSwitchSmall"] = 14] = "ToggleSwitchSmall";
    HuiCheckedLayoutProps[HuiCheckedLayoutProps["ToggleSwitchLarge"] = 15] = "ToggleSwitchLarge";
})(HuiCheckedLayoutProps || (HuiCheckedLayoutProps = {}));
var HuiCheckedSelectionTypeProps;
(function (HuiCheckedSelectionTypeProps) {
    HuiCheckedSelectionTypeProps[HuiCheckedSelectionTypeProps["Multiple"] = 0] = "Multiple";
    HuiCheckedSelectionTypeProps[HuiCheckedSelectionTypeProps["Single"] = 1] = "Single";
})(HuiCheckedSelectionTypeProps || (HuiCheckedSelectionTypeProps = {}));
var HuiCheckedButtonLayoutProps;
(function (HuiCheckedButtonLayoutProps) {
    HuiCheckedButtonLayoutProps[HuiCheckedButtonLayoutProps["Flex"] = 0] = "Flex";
    HuiCheckedButtonLayoutProps[HuiCheckedButtonLayoutProps["Table"] = 1] = "Table";
})(HuiCheckedButtonLayoutProps || (HuiCheckedButtonLayoutProps = {}));

const defaultProps$9 = {
    buttonLayout: HuiCheckedButtonLayoutProps.Table,
    className: '',
    isAlwaysChecked: false,
    selectionType: HuiCheckedSelectionTypeProps.Single,
    testId: 'checked-element',
};
const HuiCheckedContext = React__default.createContext({});
const HuiChecked = (props) => {
    var _a;
    props = { ...defaultProps$9, ...props };
    const componentId = useRef(props.id || uniqueId());
    const labelId = useRef(uniqueId());
    const flexRow = 'hui-flex hui-flex-row';
    const flexColumn = 'hui-flex hui-flex-column';
    const buttonLayoutClasses = {
        [HuiCheckedButtonLayoutProps.Flex]: flexRow,
        [HuiCheckedButtonLayoutProps.Table]: 'hui-display-table hui-toggle-button-table-container',
    };
    const layoutClasses = {
        [HuiCheckedLayoutProps.ButtonSmall]: buttonLayoutClasses[props.buttonLayout],
        [HuiCheckedLayoutProps.ButtonMedium]: buttonLayoutClasses[props.buttonLayout],
        [HuiCheckedLayoutProps.ButtonLarge]: buttonLayoutClasses[props.buttonLayout],
        [HuiCheckedLayoutProps.ButtonXlarge]: buttonLayoutClasses[props.buttonLayout],
        [HuiCheckedLayoutProps.ButtonVertical]: flexColumn,
        [HuiCheckedLayoutProps.Card]: flexColumn,
        [HuiCheckedLayoutProps.CardHorizontal]: `${flexRow} hui-flex-auto-children hui-checked-card-horizontal-layout-container`,
        [HuiCheckedLayoutProps.CardHorizontalWrap]: `${flexRow} hui-flex-wrap hui-flex-auto-children hui-checked-card-horizontal-layout-container`,
        [HuiCheckedLayoutProps.Checkbox]: flexColumn,
        [HuiCheckedLayoutProps.Radio]: flexColumn,
        [HuiCheckedLayoutProps.RadioHorizontal]: flexRow,
        [HuiCheckedLayoutProps.Switch]: '',
        [HuiCheckedLayoutProps.ToggleVertical]: flexColumn,
        [HuiCheckedLayoutProps.Toggle]: 'hui-flex hui-flex-auto-children hui-checked-connected-container',
        [HuiCheckedLayoutProps.ToggleSwitchSmall]: 'hui-display-table hui-checked-connected-container',
        [HuiCheckedLayoutProps.ToggleSwitchLarge]: 'hui-display-table hui-checked-connected-container',
    };
    const checkedElementGroupId = componentId.current;
    let { errors, register } = props;
    const { errors: contextErrors, register: contextRegister } = useFormContext() || {};
    if (!register && contextRegister) {
        register = contextRegister;
    }
    if (!errors && contextErrors) {
        errors = contextErrors;
    }
    const hasError = Boolean(errors === null || errors === void 0 ? void 0 : errors[props.name]);
    const errorMessage = (_a = errors === null || errors === void 0 ? void 0 : errors[props.name]) === null || _a === void 0 ? void 0 : _a.message;
    const layout = useLayoutFromMatchingBreakpoint(props.layout, typeof props.layout === 'number' ? props.layout : null);
    const isRadio = props.selectionType === HuiCheckedSelectionTypeProps.Single;
    const helperTextId = props.helperText ? `${componentId.current}-helper-text` : '';
    const errorTextId = hasError ? `${componentId.current}-error-text` : '';
    const context = {
        buttonLayout: props.buttonLayout,
        count: React__default.Children.count(props.children),
        disabled: props.disabled,
        errorTextId,
        hasError,
        helperTextId,
        isAlwaysChecked: props.isAlwaysChecked,
        labelId: labelId.current,
        layout,
        name: props.name,
        onChange: props.onChange,
        register,
        required: props.required,
        selectionType: props.selectionType,
        type: isRadio ? 'radio' : 'checkbox',
        value: props.value,
    };
    const children = React__default.Children.toArray(props.children);
    children[0] = React__default.cloneElement(children[0], {
        isFirstChild: true,
    });
    let radioGroupProps = null;
    if (isRadio) {
        radioGroupProps = {
            'aria-describedby': `${helperTextId} ${errorTextId}`,
            'aria-invalid': hasError,
            'aria-labelledby': labelId.current,
            'aria-required': Boolean(props.required),
            role: 'radiogroup',
        };
    }
    return (React__default.createElement(HuiCheckedContext.Provider, { value: context },
        React__default.createElement("fieldset", { className: `hui-checked-container ${props.className}`, "data-testid": props.testId, id: checkedElementGroupId },
            React__default.createElement(HuiLabel, { id: labelId.current, isHidden: props.labelIsHidden, labelType: HuiLabelTypeProps.Legend }, props.label),
            React__default.createElement(HuiFieldHelperText, { id: helperTextId, testId: `${props.testId}-helper-text` }, props.helperText),
            React__default.createElement("div", { "aria-invalid": hasError, className: `${layoutClasses[layout]} hui-checked-option-container`, ...radioGroupProps }, children),
            React__default.createElement(HuiFieldError, { className: isErrorAlignedWithTextLabel(layout) ? 'hui-margin-left-40' : '', errorMessage: errorMessage, hasError: hasError, id: errorTextId, layout: isErrorLeftAligned(layout, props.buttonLayout)
                    ? HuiFieldErrorLayoutProps.Left
                    : HuiFieldErrorLayoutProps.Center, testId: `${props.testId}-error-message` }))));
};
function isErrorLeftAligned(layout, buttonLayout) {
    if (layout === HuiCheckedLayoutProps.ButtonSmall ||
        layout === HuiCheckedLayoutProps.ButtonMedium ||
        layout === HuiCheckedLayoutProps.ButtonLarge ||
        layout === HuiCheckedLayoutProps.ButtonXlarge) {
        return buttonLayout === HuiCheckedButtonLayoutProps.Table;
    }
    return (layout === HuiCheckedLayoutProps.Checkbox ||
        layout === HuiCheckedLayoutProps.Radio ||
        layout === HuiCheckedLayoutProps.ToggleSwitchSmall ||
        layout === HuiCheckedLayoutProps.ToggleSwitchLarge);
}
function isErrorAlignedWithTextLabel(layout) {
    return layout === HuiCheckedLayoutProps.Checkbox || layout === HuiCheckedLayoutProps.Radio;
}

const CheckedOptionInput = ({ defaultChecked, disabled, internalClassName, internalLayout: layout, optionId, testId = 'checked-option', value, }) => {
    const { disabled: parentDisabled, errorTextId, hasError, helperTextId, labelId, name, onChange, register, required, type, } = useContext(HuiCheckedContext);
    let inputClassName = 'hui-visually-hidden';
    if (isStandardFormField(layout)) {
        inputClassName = '';
    }
    else if (isCardFormField(layout)) {
        inputClassName = 'hui-checked-input-full-card';
    }
    return (React__default.createElement("input", { className: `
        hui-checked-input
        ${internalClassName || ''}
        ${inputClassName}
      `, "data-testid": `${testId}-input`, defaultChecked: defaultChecked, disabled: disabled || parentDisabled, id: optionId, name: name, onChange: onChange, ref: register && register({ required }), type: type, value: `${value}`, ...getCheckboxProps({ errorTextId, hasError, helperTextId, labelId, optionId, required, type }) }));
};
const CheckedOptionLabel = ({ children, disabled, internalLayout: layout, labelRef, optionId, testId, }) => {
    const { buttonLayout, count, disabled: parentDisabled } = useContext(HuiCheckedContext);
    const style = { '--children-count': count };
    const childButtonLayoutClasses = {
        [HuiCheckedButtonLayoutProps.Flex]: '',
        [HuiCheckedButtonLayoutProps.Table]: 'hui-display-table-cell',
    };
    const optionLayoutClasses = {
        [HuiCheckedLayoutProps.ButtonSmall]: `${childButtonLayoutClasses[buttonLayout]} hui-toggle-button-option hui-toggle-button-option-horizontal hui-ellipsis hui-checked-button-small`,
        [HuiCheckedLayoutProps.ButtonMedium]: `${childButtonLayoutClasses[buttonLayout]} hui-toggle-button-option hui-toggle-button-option-horizontal hui-ellipsis hui-checked-button-medium`,
        [HuiCheckedLayoutProps.ButtonLarge]: `${childButtonLayoutClasses[buttonLayout]} hui-toggle-button-option hui-toggle-button-option-horizontal hui-ellipsis hui-checked-button-large`,
        [HuiCheckedLayoutProps.ButtonXlarge]: `${childButtonLayoutClasses[buttonLayout]} hui-toggle-button-option hui-toggle-button-option-horizontal hui-ellipsis hui-checked-button-xlarge`,
        [HuiCheckedLayoutProps.ButtonVertical]: `hui-toggle-button-option hui-toggle-button-label hui-ellipsis hui-checked-button-medium`,
        [HuiCheckedLayoutProps.Card]: 'hui-checked-card-label hui-flex-1',
        [HuiCheckedLayoutProps.CardHorizontal]: 'hui-checked-card-label hui-display-block hui-text-align-center',
        [HuiCheckedLayoutProps.CardHorizontalWrap]: 'hui-checked-card-label hui-display-block hui-text-align-center',
        [HuiCheckedLayoutProps.Checkbox]: 'hui-styled-input-label hui-checked-checkbox-label',
        [HuiCheckedLayoutProps.Radio]: 'hui-styled-input-label hui-checked-radio-label',
        [HuiCheckedLayoutProps.RadioHorizontal]: 'hui-padding-horizontal-16 hui-checked-radio-label',
        [HuiCheckedLayoutProps.Switch]: '',
        [HuiCheckedLayoutProps.ToggleVertical]: 'hui-toggle-option hui-toggle-option-variable-size hui-toggle-vertical-label hui-ellipsis',
        [HuiCheckedLayoutProps.Toggle]: 'hui-toggle-option hui-toggle-option-variable-size  hui-ellipsis',
        [HuiCheckedLayoutProps.ToggleSwitchSmall]: 'hui-toggle-option hui-display-table-cell hui-toggle-switch-option hui-checked-button-small',
        [HuiCheckedLayoutProps.ToggleSwitchLarge]: 'hui-toggle-option hui-display-table-cell hui-toggle-switch-option hui-checked-button-large',
    };
    return (React__default.createElement("label", { className: `
          ${optionLayoutClasses[layout]}
          ${disabled || parentDisabled ? 'hui-checked-option-label-is-disabled' : ''}
        `, "data-testid": testId, htmlFor: optionId, id: `${optionId}-label`, ref: labelRef, style: style }, children));
};
const CheckedOptionContainer = (props) => {
    const { disabled: parentDisabled } = useContext(HuiCheckedContext);
    const { internalLayout: layout } = props;
    return (React__default.createElement("div", { className: "hui-checked-styled-container" },
        React__default.createElement("div", { className: "hui-flex" },
            React__default.createElement("div", { className: "hui-checked-styled-input-container hui-position-relative hui-flex hui-flex-align-center" },
                React__default.createElement(CheckedOptionInput, { internalClassName: "hui-checked-styled-input", ...props }),
                isCheckboxFormField(layout) && (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(HuiIcon, { className: "hui-checked-option-checkbox hui-checked-option-checked", icon: HuiIconCheckboxChecked, testId: `${props.testId}-checked` }),
                    React__default.createElement(HuiIcon, { className: "hui-checked-option-checkbox hui-checked-option-unchecked", icon: HuiIconCheckboxUnchecked, testId: `${props.testId}-unchecked` }))),
                isRadioFormField(layout) && (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(HuiIcon, { className: "hui-checked-option-radio hui-checked-option-checked", icon: HuiIconRadioChecked, testId: `${props.testId}-checked` }),
                    React__default.createElement(HuiIcon, { className: "hui-checked-option-radio hui-checked-option-unchecked", icon: HuiIconRadioUnchecked, testId: `${props.testId}-unchecked` })))),
            React__default.createElement(CheckedOptionLabel, { ...props })),
        props.helperText && (React__default.createElement("div", { className: `
          hui-text-compact hui-font-weight-normal hui-margin-left-40
          ${props.disabled || parentDisabled ? 'hui-checked-option-label-is-disabled' : ''}
        ` }, props.helperText))));
};
const CheckedOptionCardContainer = ({ checkedContainerClassName = '', ...otherProps }) => {
    const { isAlwaysChecked, disabled: parentDisabled, errorTextId, hasError, helperTextId, labelId, required, selectionType, type, value: parentValue, } = useContext(HuiCheckedContext);
    const { internalLayout: layout } = otherProps;
    const labelRef = useRef();
    const containerLayoutClasses = {
        [HuiCheckedLayoutProps.Card]: 'hui-checked-styled-container-vertical hui-flex-1 hui-flex-basis-100',
        [HuiCheckedLayoutProps.CardHorizontal]: 'hui-checked-styled-container-horizontal',
        [HuiCheckedLayoutProps.CardHorizontalWrap]: 'hui-checked-styled-container-horizontal hui-flex-basis-100 hui-flex-basis-0:md',
    };
    const cardLayoutClasses = {
        [HuiCheckedLayoutProps.Card]: '',
        [HuiCheckedLayoutProps.CardHorizontal]: 'hui-checked-card-horizontal',
        [HuiCheckedLayoutProps.CardHorizontalWrap]: 'hui-checked-card-horizontal',
    };
    const contentLayoutClasses = {
        [HuiCheckedLayoutProps.Card]: 'hui-flex-row hui-padding-16 hui-padding-24:md hui-padding-32:lg',
        [HuiCheckedLayoutProps.CardHorizontal]: 'hui-flex-column hui-padding-16 hui-padding-32:md hui-padding-40:lg',
        [HuiCheckedLayoutProps.CardHorizontalWrap]: 'hui-flex-column hui-padding-16 hui-padding-32:md hui-padding-40:lg',
    };
    const checkedElementLayoutClasses = {
        [HuiCheckedLayoutProps.Card]: 'hui-margin-right-16 hui-margin-right-24:md hui-margin-right-32:lg',
        [HuiCheckedLayoutProps.CardHorizontal]: 'hui-margin-bottom-16 hui-margin-bottom-24:md hui-margin-bottom-32:lg hui-margin-top-0 hui-margin-top-8:lg hui-flex-align-self-center',
        [HuiCheckedLayoutProps.CardHorizontalWrap]: 'hui-margin-bottom-16 hui-margin-bottom-24:md hui-margin-bottom-32:lg hui-margin-top-0 hui-margin-top-8:lg hui-flex-align-self-center',
    };
    return (React__default.createElement("div", { className: `hui-position-relative ${containerLayoutClasses[layout]}`, 
        // the cards are comprised of labels and helper text inside of the entire container, this lets the entire card be clickable
        onClick: (evt) => {
            if (evt.target !== labelRef.current) {
                labelRef.current.click();
            }
        } },
        React__default.createElement(CheckedOptionInput, { ...otherProps }),
        React__default.createElement("div", { ...getCheckboxProps({
                errorTextId,
                hasError,
                helperTextId,
                labelId,
                optionId: otherProps.optionId,
                required,
                type,
            }), "aria-checked": isChecked({
                isAlwaysChecked,
                isFirstChild: otherProps.isFirstChild,
                optionValue: otherProps.value,
                parentValue,
            }) || false, "aria-labelledby": `${otherProps.optionId}-label`, className: `hui-checked-card hui-border-radius-8 ${cardLayoutClasses[layout]} ${checkedContainerClassName}`, "data-testid": `${otherProps.testId}-card-container`, role: selectionType === HuiCheckedSelectionTypeProps.Single ? 'radio' : 'checkbox' },
            React__default.createElement("div", { className: `hui-checked-card-contents hui-flex ${contentLayoutClasses[layout]}` },
                React__default.createElement("div", { className: `hui-checked-styled-input-container hui-position-relative hui-flex hui-flex-align-center ${checkedElementLayoutClasses[layout]}` },
                    selectionType === HuiCheckedSelectionTypeProps.Multiple && (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(HuiIcon, { className: "hui-checked-option-checked", icon: HuiIconCheckboxChecked, size: "2rem", testId: `${otherProps.testId}-checked` }),
                        React__default.createElement(HuiIcon, { className: "hui-checked-option-unchecked", icon: HuiIconCheckboxUnchecked, size: "2rem", testId: `${otherProps.testId}-unchecked` }))),
                    selectionType === HuiCheckedSelectionTypeProps.Single && (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(HuiIcon, { className: "hui-checked-option-checked", icon: HuiIconRadioChecked, size: "2rem", testId: `${otherProps.testId}-checked` }),
                        React__default.createElement(HuiIcon, { className: "hui-checked-option-unchecked", icon: HuiIconRadioUnchecked, size: "2rem", testId: `${otherProps.testId}-unchecked` })))),
                React__default.createElement("div", { className: "hui-flex-1" },
                    React__default.createElement(CheckedOptionLabel, { labelRef: labelRef, ...otherProps }),
                    otherProps.helperText && (React__default.createElement("div", { className: `hui-text-compact hui-font-weight-normal hui-margin-top-16
                  ${otherProps.disabled || parentDisabled ? 'hui-checked-option-label-is-disabled' : ''}
                `, "data-testid": `${otherProps.testId}-helper-text` }, otherProps.helperText)))))));
};
const getCheckboxProps = ({ errorTextId, hasError, helperTextId, labelId, optionId, required, type }) => {
    let checkboxProps = null;
    if (type === 'checkbox') {
        checkboxProps = {
            'aria-describedby': `${helperTextId} ${errorTextId}`,
            'aria-invalid': hasError,
            'aria-labelledby': `${labelId} ${optionId}-label`,
            'aria-required': Boolean(required),
        };
    }
    return checkboxProps;
};
const isChecked = ({ isAlwaysChecked, isFirstChild, optionValue, parentValue }) => {
    let checked = undefined;
    if (isFirstChild && isAlwaysChecked && !parentValue) {
        checked = true;
    }
    else if (Array.isArray(parentValue)) {
        checked = parentValue.includes(optionValue);
    }
    else if (optionValue === parentValue) {
        checked = true;
    }
    return checked;
};
const HuiCheckedOption = (props) => {
    const { isAlwaysChecked, layout, value: parentValue } = useContext(HuiCheckedContext);
    let internalLayout = useLayoutFromMatchingBreakpoint(props.layout, typeof props.layout === 'number' ? props.layout : null);
    if (!props.layout) {
        internalLayout = layout;
    }
    const optionId = useRef(uniqueId()).current;
    const defaultChecked = isChecked({
        isAlwaysChecked,
        isFirstChild: props.isFirstChild,
        optionValue: props.value,
        parentValue,
    });
    if (isStandardFormField(internalLayout)) {
        return (React__default.createElement(CheckedOptionContainer, { defaultChecked: defaultChecked, optionId: optionId, ...props, internalLayout: internalLayout }));
    }
    else if (isCardFormField(internalLayout)) {
        return (React__default.createElement(CheckedOptionCardContainer, { defaultChecked: defaultChecked, optionId: optionId, ...props, internalLayout: internalLayout }));
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(CheckedOptionInput, { defaultChecked: defaultChecked, optionId: optionId, ...props, internalLayout: internalLayout }),
        React__default.createElement(CheckedOptionLabel, { defaultChecked: defaultChecked, optionId: optionId, ...props, internalLayout: internalLayout })));
};
function isStandardFormField(layout) {
    return isCheckboxFormField(layout) || isRadioFormField(layout);
}
function isCheckboxFormField(layout) {
    return layout === HuiCheckedLayoutProps.Checkbox;
}
function isRadioFormField(layout) {
    return layout === HuiCheckedLayoutProps.Radio || layout === HuiCheckedLayoutProps.RadioHorizontal;
}
function isCardFormField(layout) {
    return (layout === HuiCheckedLayoutProps.Card ||
        layout === HuiCheckedLayoutProps.CardHorizontal ||
        layout === HuiCheckedLayoutProps.CardHorizontalWrap);
}

var HuiFormValidationProps;
(function (HuiFormValidationProps) {
    HuiFormValidationProps["OnBlur"] = "onBlur";
    HuiFormValidationProps["OnChange"] = "onChange";
    HuiFormValidationProps["OnSubmit"] = "onSubmit";
    HuiFormValidationProps["OnTouched"] = "onTouched";
    HuiFormValidationProps["All"] = "all";
})(HuiFormValidationProps || (HuiFormValidationProps = {}));
const defaultProps$8 = {
    className: '',
    validationMode: HuiFormValidationProps.OnTouched,
};
var HuiFormSizeProps;
(function (HuiFormSizeProps) {
    HuiFormSizeProps["Compact"] = "compact";
    HuiFormSizeProps["Normal"] = "normal";
})(HuiFormSizeProps || (HuiFormSizeProps = {}));
const InternalFormContext = React__default.createContext({});
const HuiForm = (props) => {
    props = { ...defaultProps$8, ...props };
    const { children, className, defaultValues, onSubmit, size, validationMode, ...otherProps } = props;
    const methods = useForm({ defaultValues, mode: validationMode });
    const context = {
        size,
    };
    return (React__default.createElement(InternalFormContext.Provider, { value: context },
        React__default.createElement(FormProvider, { ...methods },
            React__default.createElement("form", { className: className, onSubmit: onSubmit ? methods.handleSubmit(onSubmit) : null, ...otherProps }, children))));
};

const HuiFormContext = ({ children }) => {
    const methods = useFormContext();
    return children({ ...methods });
};

var HuiInputIconPlacementProps;
(function (HuiInputIconPlacementProps) {
    HuiInputIconPlacementProps["End"] = "End";
    HuiInputIconPlacementProps["Start"] = "Start";
})(HuiInputIconPlacementProps || (HuiInputIconPlacementProps = {}));
const defaultProps$7 = {
    className: '',
    iconClassName: '',
    iconSize: '2rem',
    inputSize: HuiFormSizeProps.Normal,
    testId: 'input-icon',
};
const HuiInputIcon = (props) => {
    props = { ...defaultProps$7, ...props };
    const placementClass = props.placement === HuiInputIconPlacementProps.Start ? 'hui-input-icon-start' : 'hui-input-icon-end';
    const icon = (React__default.createElement(HuiIcon, { className: `hui-text-gray-10 ${props.iconClassName}`, icon: props.icon, label: props.label, size: props.iconSize }));
    return (React__default.createElement("div", { className: `hui-position-absolute hui-top-0 hui-flex hui-flex-align-center hui-input-icon ${props.inputSize === HuiFormSizeProps.Compact ? 'hui-input-compact-icon' : ''} ${placementClass} ${props.className}`, "data-testid": props.testId }, props.onClick ? (React__default.createElement(HuiInputIconButton, { "data-testid": `btn-${props.testId}`, onClick: props.onClick }, icon)) : (icon)));
};
const HuiInputIconButton = (props) => {
    return (React__default.createElement("button", { className: "hui-icon-button", ...props, type: "button" }, props.children));
};

var HuiInputTextAlignProps;
(function (HuiInputTextAlignProps) {
    HuiInputTextAlignProps["Center"] = "hui-text-align-center";
    HuiInputTextAlignProps["Left"] = "hui-text-align-left";
    HuiInputTextAlignProps["Right"] = "hui-text-align-right";
})(HuiInputTextAlignProps || (HuiInputTextAlignProps = {}));
const defaultProps$6 = {
    ariaDescribedBy: '',
    className: '',
    format: (v) => v,
    labelIsHidden: false,
    testId: 'input',
    textAlign: HuiInputTextAlignProps.Left,
    type: 'text',
};
const HuiInput = (props) => {
    var _a;
    props = { ...defaultProps$6, ...props };
    const { size: contextSize } = useContext(InternalFormContext);
    if (!props.id) {
        props.id = uniqueId();
    }
    const { ariaDescribedBy, className, disabled, errors, format, helperText, iconEnd, iconStart, label, labelIsHidden, max, min, onChange, pattern, placeholder, readOnly, readOnlyClassName, register, required, size, testId, textAlign, validate, value, ...otherProps } = props;
    let inputErrors = errors;
    let inputRegister = register;
    let inputValue = value;
    const inputSize = size || contextSize || HuiFormSizeProps.Normal;
    if (inputValue) {
        const initialValue = format(inputValue);
        if (!(initialValue instanceof RangeError)) {
            inputValue = `${initialValue}`;
        }
    }
    const { clearErrors, errors: contextErrors, register: contextRegister, setError, setValue } = useFormContext() || {};
    if (!inputRegister && contextRegister) {
        inputRegister = contextRegister;
    }
    if (!errors && contextErrors) {
        inputErrors = contextErrors;
    }
    const internalOnChange = (evt) => {
        if (onChange) {
            onChange(evt);
        }
        const formattedValue = format(evt.target.value);
        if (formattedValue instanceof RangeError) {
            setError === null || setError === void 0 ? void 0 : setError(props.name, {
                message: formattedValue.message,
                type: 'manual',
            });
            return;
        }
        setValue === null || setValue === void 0 ? void 0 : setValue(props.name, formattedValue);
        clearErrors === null || clearErrors === void 0 ? void 0 : clearErrors(props.name);
    };
    const hasError = Boolean(inputErrors === null || inputErrors === void 0 ? void 0 : inputErrors[props.name]);
    const errorMessage = (_a = inputErrors === null || inputErrors === void 0 ? void 0 : inputErrors[props.name]) === null || _a === void 0 ? void 0 : _a.message;
    const iconSize = inputSize === HuiFormSizeProps.Normal ? '2rem' : '1.75rem';
    const icons = {
        end: null,
        error: (React__default.createElement(HuiInputIcon, { icon: (iconEnd && iconEnd.icon) || HuiIconExclamationCircleSolid, iconClassName: `hui-text-error ${iconEnd && iconEnd.className ? iconEnd.className : ''}`, iconSize: iconSize, inputSize: inputSize, label: iconEnd && iconEnd.label, onClick: iconEnd && iconEnd.onClick, placement: HuiInputIconPlacementProps.End, testId: iconEnd && iconEnd.testId })),
        start: null,
    };
    if (iconStart) {
        icons.start = (React__default.createElement(HuiInputIcon, { iconSize: iconSize, inputSize: inputSize, ...iconStart, placement: HuiInputIconPlacementProps.Start }));
    }
    if (iconEnd) {
        icons.end = (React__default.createElement(HuiInputIcon, { iconSize: iconSize, inputSize: inputSize, ...iconEnd, placement: HuiInputIconPlacementProps.End }));
    }
    const helperTextId = props.helperText ? `${props.id}-helper-text` : '';
    const errorTextId = hasError ? `${props.id}-error-text` : '';
    return (React__default.createElement("div", { className: className },
        React__default.createElement(HuiLabel, { htmlFor: props.id, isHidden: labelIsHidden, readOnly: props.readOnly, testId: `${testId}-label` }, label),
        React__default.createElement(HuiFieldHelperText, { id: helperTextId, testId: `${testId}-helper-text` }, helperText),
        React__default.createElement("div", { className: "hui-position-relative hui-input-container" },
            !readOnly && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("input", { "aria-describedby": `${helperTextId} ${errorTextId} ${ariaDescribedBy}`, "aria-invalid": hasError, "aria-required": Boolean(required), className: `
                hui-input
                ${inputSize === HuiFormSizeProps.Compact ? 'hui-input-compact' : ''}
                hui-ellipsis
                ${hasError ? 'hui-field-has-error' : ''}
                ${iconStart ? 'hui-padding-left-40' : ''}
                ${iconEnd || hasError ? 'hui-padding-right-40' : ''}
                ${textAlign}
              `, "data-testid": testId, defaultValue: inputValue, disabled: disabled, onChange: internalOnChange, ...otherProps, placeholder: disabled ? null : placeholder, ref: inputRegister && inputRegister({ max, min, pattern, required, validate }) }),
                icons.start,
                hasError ? icons.error : icons.end)),
            readOnly && (React__default.createElement("div", { className: `hui-input hui-input-read-only hui-flex hui-flex-align-center ${readOnlyClassName}`, "data-testid": testId, ...otherProps },
                iconStart && iconStart.icon && React__default.createElement(HuiIcon, { icon: iconStart.icon }),
                React__default.createElement("div", { className: `
              ${iconStart && iconStart.icon ? 'hui-margin-left-8' : ''}
              ${iconEnd && iconEnd.icon ? 'hui-margin-right-8' : ''}
            ` }, inputValue),
                iconEnd && iconEnd.icon && React__default.createElement(HuiIcon, { icon: iconEnd.icon })))),
        React__default.createElement(HuiFieldError, { errorMessage: errorMessage, hasError: hasError, id: errorTextId, testId: `${testId}-error-message` })));
};

const defaultProps$5 = {
    className: '',
    testId: 'password-input',
};
const HuiPassword = (props) => {
    props = { ...defaultProps$5, ...props };
    if (!props.id) {
        props.id = uniqueId();
    }
    const { className, hidePasswordLabel, onChange: onChangePasswordInput, rules, showPasswordLabel, ...otherProps } = props;
    const validations = [];
    const setValidationsMap = {};
    rules.forEach((rule, index) => {
        const validation = { ...rule, isValid: null };
        validation.required = rule.required !== false;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [value, setValue] = useState(validation);
        validations.push(value);
        setValidationsMap[index] = setValue;
    });
    const [isPasswordHidden, setIsPasswordHidden] = useState(true);
    const [isValid, setIsValid] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [numberValidationChecks, setValidationChecks] = useState(0);
    const { trigger } = useFormContext() || {};
    const onChange = async (evt) => {
        const { value } = evt.target;
        validations.forEach(async (validation, index) => {
            validation.isValid = null;
            const result = await validation.validate(value);
            setValidationsMap[index]({ ...validation, isValid: result });
        });
        if (onChangePasswordInput) {
            onChangePasswordInput(evt);
        }
    };
    useEffect(() => {
        if (trigger) {
            // this is dumb, but we don't want to trigger until after the initial render when something has changed
            // otherwise it renders as an invalid input when required={true}
            if (numberValidationChecks > 0) {
                trigger(props.name);
            }
            setValidationChecks(numberValidationChecks + 1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isValid]);
    useEffect(() => {
        // the initial state should show all requirements as the neutral circle and validation should not
        // be triggered on the password until tests on a value have passed/failed
        if (validations.some((validation) => validation.isValid !== null)) {
            setIsValid(validations.every((validation) => {
                return validation.isValid === true || validation.required === false;
            }));
            setHasError(validations.some((validation) => {
                return validation.isValid === false;
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...validations]);
    const passwordRequirementsId = `${props.id}-password-requirements`;
    return (React__default.createElement("div", { className: className },
        React__default.createElement(HuiInput, { ariaDescribedBy: passwordRequirementsId, errors: hasError ? { [props.name]: { message: null } } : null, iconEnd: {
                icon: isPasswordHidden ? HuiIconMask : HuiIconReveal,
                label: isPasswordHidden ? showPasswordLabel : hidePasswordLabel,
                onClick: () => setIsPasswordHidden(!isPasswordHidden),
            }, onChange: onChange, type: isPasswordHidden ? 'password' : 'text', validate: () => {
                return isValid;
            }, ...otherProps }),
        validations.length > 0 && (React__default.createElement("div", { "aria-hidden": true, className: "hui-margin-top-16", id: passwordRequirementsId }, validations.map((validation, index) => {
            const isRuleValid = validation.isValid;
            let icon = HuiIconCircle;
            let iconClass = 'hui-text-gray-50';
            let ruleClass = 'hui-text-gray-50';
            if (typeof isRuleValid === 'boolean') {
                icon = isRuleValid ? HuiIconCheckCircleSolid : HuiIconExclamationCircleSolid;
                iconClass = isRuleValid ? 'hui-text-success' : 'hui-text-error';
                if (!isRuleValid) {
                    ruleClass = 'hui-text-error hui-font-weight-semi-bold';
                }
            }
            return (React__default.createElement("div", { className: "hui-flex hui-flex-align-center hui-margin-top-8", key: `password-rule-${index}` },
                React__default.createElement(HuiIcon, { "aria-hidden": true, className: iconClass, icon: icon, size: "0.75em" }),
                React__default.createElement("div", { "aria-atomic": true, "aria-hidden": isRuleValid, "aria-invalid": !isRuleValid, "aria-live": "polite", className: `hui-password-rule ${ruleClass}` }, validation.label)));
        })))));
};

const HuiRowCheckbox = ({ className = '', disabled, id, isAlwaysChecked, label, name, 
// eslint-disable-next-line @typescript-eslint/no-empty-function
onChange = () => { }, required = false, size = '1.5rem', style = {}, testId = 'row-checkbox', value, ...remainingProps }) => {
    const elementId = useRef(id || uniqueId()).current;
    // eslint-disable-next-line prefer-const
    let { register, ...otherProps } = remainingProps;
    const { register: contextRegister } = useFormContext() || {};
    if (!register && contextRegister) {
        register = contextRegister;
    }
    return (React__default.createElement("div", { className: `hui-checked-styled-input-container hui-row-checkbox hui-position-relative hui-flex hui-flex-all-centered ${className}`, style: style },
        React__default.createElement("label", { className: "hui-visually-hidden", "data-testid": testId, htmlFor: elementId, id: `${elementId}-label` }, label),
        React__default.createElement("input", { "aria-required": Boolean(required), className: "hui-checked-input hui-checked-styled-input", "data-testid": `${testId}-input`, defaultChecked: isAlwaysChecked, disabled: disabled, id: elementId, name: name, onChange: onChange, ref: register && register({ required }), type: "checkbox", value: `${value}`, ...otherProps }),
        React__default.createElement(HuiIcon, { className: "hui-checked-option-checkbox hui-checked-option-checked", icon: HuiIconCheckboxChecked, size: size, testId: `${testId}-checked` }),
        React__default.createElement(HuiIcon, { className: "hui-checked-option-checkbox hui-checked-option-unchecked", icon: HuiIconCheckboxUnchecked, size: size, testId: `${testId}-unchecked` })));
};

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.indexOf(n) >= 0) continue;
    t[n] = r[n];
  }
  return t;
}

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getDefaultExportFromNamespaceIfPresent (n) {
	return n && Object.prototype.hasOwnProperty.call(n, 'default') ? n['default'] : n;
}

function getDefaultExportFromNamespaceIfNotNamed (n) {
	return n && Object.prototype.hasOwnProperty.call(n, 'default') && Object.keys(n).length === 1 ? n['default'] : n;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var propTypes$4 = {exports: {}};

var reactIs$3 = {exports: {}};

var reactIs_production_min$1 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$1;

function requireReactIs_production_min$1 () {
	if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
	hasRequiredReactIs_production_min$1 = 1;
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min$1.AsyncMode=l;reactIs_production_min$1.ConcurrentMode=m;reactIs_production_min$1.ContextConsumer=k;reactIs_production_min$1.ContextProvider=h;reactIs_production_min$1.Element=c;reactIs_production_min$1.ForwardRef=n;reactIs_production_min$1.Fragment=e;reactIs_production_min$1.Lazy=t;reactIs_production_min$1.Memo=r;reactIs_production_min$1.Portal=d;
	reactIs_production_min$1.Profiler=g;reactIs_production_min$1.StrictMode=f;reactIs_production_min$1.Suspense=p;reactIs_production_min$1.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min$1.isConcurrentMode=A;reactIs_production_min$1.isContextConsumer=function(a){return z(a)===k};reactIs_production_min$1.isContextProvider=function(a){return z(a)===h};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min$1.isForwardRef=function(a){return z(a)===n};reactIs_production_min$1.isFragment=function(a){return z(a)===e};reactIs_production_min$1.isLazy=function(a){return z(a)===t};
	reactIs_production_min$1.isMemo=function(a){return z(a)===r};reactIs_production_min$1.isPortal=function(a){return z(a)===d};reactIs_production_min$1.isProfiler=function(a){return z(a)===g};reactIs_production_min$1.isStrictMode=function(a){return z(a)===f};reactIs_production_min$1.isSuspense=function(a){return z(a)===p};
	reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min$1.typeOf=z;
	return reactIs_production_min$1;
}

var reactIs_development$1 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$1;

function requireReactIs_development$1 () {
	if (hasRequiredReactIs_development$1) return reactIs_development$1;
	hasRequiredReactIs_development$1 = 1;
	'use strict';



	if (process.env.NODE_ENV !== "production") {
	  (function() {
	'use strict';

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development$1.AsyncMode = AsyncMode;
	reactIs_development$1.ConcurrentMode = ConcurrentMode;
	reactIs_development$1.ContextConsumer = ContextConsumer;
	reactIs_development$1.ContextProvider = ContextProvider;
	reactIs_development$1.Element = Element;
	reactIs_development$1.ForwardRef = ForwardRef;
	reactIs_development$1.Fragment = Fragment;
	reactIs_development$1.Lazy = Lazy;
	reactIs_development$1.Memo = Memo;
	reactIs_development$1.Portal = Portal;
	reactIs_development$1.Profiler = Profiler;
	reactIs_development$1.StrictMode = StrictMode;
	reactIs_development$1.Suspense = Suspense;
	reactIs_development$1.isAsyncMode = isAsyncMode;
	reactIs_development$1.isConcurrentMode = isConcurrentMode;
	reactIs_development$1.isContextConsumer = isContextConsumer;
	reactIs_development$1.isContextProvider = isContextProvider;
	reactIs_development$1.isElement = isElement;
	reactIs_development$1.isForwardRef = isForwardRef;
	reactIs_development$1.isFragment = isFragment;
	reactIs_development$1.isLazy = isLazy;
	reactIs_development$1.isMemo = isMemo;
	reactIs_development$1.isPortal = isPortal;
	reactIs_development$1.isProfiler = isProfiler;
	reactIs_development$1.isStrictMode = isStrictMode;
	reactIs_development$1.isSuspense = isSuspense;
	reactIs_development$1.isValidElementType = isValidElementType;
	reactIs_development$1.typeOf = typeOf;
	  })();
	}
	return reactIs_development$1;
}

var reactIs$2 = reactIs$3.exports;

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs$3.exports;
	hasRequiredReactIs = 1;
	'use strict';

	if (process.env.NODE_ENV === 'production') {
	  reactIs$3.exports = requireReactIs_production_min$1();
	} else {
	  reactIs$3.exports = requireReactIs_development$1();
	}
	return reactIs$3.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;
	'use strict';

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;
	'use strict';

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;
	'use strict';

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;
	'use strict';

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var propTypes$3 = propTypes$4.exports;

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes$4.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes$4.exports = requireFactoryWithThrowingShims()();
}

var propTypesExports = propTypes$4.exports;
var PropTypes = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
	'use strict';var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
	function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}reactIs_production_min.ContextConsumer=h;reactIs_production_min.ContextProvider=g;reactIs_production_min.Element=b;reactIs_production_min.ForwardRef=l;reactIs_production_min.Fragment=d;reactIs_production_min.Lazy=q;reactIs_production_min.Memo=p;reactIs_production_min.Portal=c;reactIs_production_min.Profiler=f;reactIs_production_min.StrictMode=e;reactIs_production_min.Suspense=m;
	reactIs_production_min.SuspenseList=n;reactIs_production_min.isAsyncMode=function(){return !1};reactIs_production_min.isConcurrentMode=function(){return !1};reactIs_production_min.isContextConsumer=function(a){return v(a)===h};reactIs_production_min.isContextProvider=function(a){return v(a)===g};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};reactIs_production_min.isForwardRef=function(a){return v(a)===l};reactIs_production_min.isFragment=function(a){return v(a)===d};reactIs_production_min.isLazy=function(a){return v(a)===q};reactIs_production_min.isMemo=function(a){return v(a)===p};
	reactIs_production_min.isPortal=function(a){return v(a)===c};reactIs_production_min.isProfiler=function(a){return v(a)===f};reactIs_production_min.isStrictMode=function(a){return v(a)===e};reactIs_production_min.isSuspense=function(a){return v(a)===m};reactIs_production_min.isSuspenseList=function(a){return v(a)===n};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};reactIs_production_min.typeOf=v;
	return reactIs_production_min;
}

var reactIs_development = {};

/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;
	'use strict';

	if (process.env.NODE_ENV !== "production") {
	  (function() {
	'use strict';

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types.
	var REACT_ELEMENT_TYPE = Symbol.for('react.element');
	var REACT_PORTAL_TYPE = Symbol.for('react.portal');
	var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
	var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
	var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
	var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
	var REACT_CONTEXT_TYPE = Symbol.for('react.context');
	var REACT_SERVER_CONTEXT_TYPE = Symbol.for('react.server_context');
	var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
	var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
	var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
	var REACT_MEMO_TYPE = Symbol.for('react.memo');
	var REACT_LAZY_TYPE = Symbol.for('react.lazy');
	var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');

	// -----------------------------------------------------------------------------

	var enableScopeAPI = false; // Experimental Create Event Handle API.
	var enableCacheElement = false;
	var enableTransitionTracing = false; // No known bugs, but needs performance testing

	var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
	// stuff. Intended to enable React core members to more easily debug scheduling
	// issues in DEV builds.

	var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

	var REACT_MODULE_REFERENCE;

	{
	  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
	}

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
	    // types supported by any Flight configuration anywhere since
	    // we don't know which Flight build this will end up being used
	    // with.
	    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
	      return true;
	    }
	  }

	  return false;
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	          case REACT_SUSPENSE_LIST_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_SERVER_CONTEXT_TYPE:
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	}
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false;
	var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isConcurrentMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
	      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}
	function isSuspenseList(object) {
	  return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
	}

	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.SuspenseList = SuspenseList;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isSuspenseList = isSuspenseList;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var reactIs = reactIs$1.exports;

'use strict';

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = requireReactIs_production_min();
} else {
  reactIs$1.exports = requireReactIs_development();
}

var reactIsExports = reactIs$1.exports;
var index = /*@__PURE__*/getDefaultExportFromCjs(reactIsExports);

const t=t=>"object"==typeof t&&null!=t&&1===t.nodeType,e=(t,e)=>(!e||"hidden"!==t)&&("visible"!==t&&"clip"!==t),n=(t,n)=>{if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){const o=getComputedStyle(t,null);return e(o.overflowY,n)||e(o.overflowX,n)||(t=>{const e=(t=>{if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}})(t);return !!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)})(t)}return !1},o=(t,e,n,o,l,r,i,s)=>r<t&&i>e||r>t&&i<e?0:r<=t&&s<=n||i>=e&&s>=n?r-t-o:i>e&&s<n||r<t&&s>n?i-e+l:0,l=t=>{const e=t.parentElement;return null==e?t.getRootNode().host||null:e},r=(e,r)=>{var i,s,d,h;if("undefined"==typeof document)return [];const{scrollMode:c,block:f,inline:u,boundary:a,skipOverflowHiddenElements:g}=r,p="function"==typeof a?a:t=>t!==a;if(!t(e))throw new TypeError("Invalid target");const m=document.scrollingElement||document.documentElement,w=[];let W=e;for(;t(W)&&p(W);){if(W=l(W),W===m){w.push(W);break}null!=W&&W===document.body&&n(W)&&!n(document.documentElement)||null!=W&&n(W,g)&&w.push(W);}const b=null!=(s=null==(i=window.visualViewport)?void 0:i.width)?s:innerWidth,H=null!=(h=null==(d=window.visualViewport)?void 0:d.height)?h:innerHeight,{scrollX:y,scrollY:M}=window,{height:v,width:E,top:x,right:C,bottom:I,left:R}=e.getBoundingClientRect(),{top:T,right:B,bottom:F,left:V}=(t=>{const e=window.getComputedStyle(t);return {top:parseFloat(e.scrollMarginTop)||0,right:parseFloat(e.scrollMarginRight)||0,bottom:parseFloat(e.scrollMarginBottom)||0,left:parseFloat(e.scrollMarginLeft)||0}})(e);let k="start"===f||"nearest"===f?x-T:"end"===f?I+F:x+v/2-T+F,D="center"===u?R+E/2-V+B:"end"===u?C+B:R-V;const L=[];for(let t=0;t<w.length;t++){const e=w[t],{height:n,width:l,top:r,right:i,bottom:s,left:d}=e.getBoundingClientRect();if("if-needed"===c&&x>=0&&R>=0&&I<=H&&C<=b&&x>=r&&I<=s&&R>=d&&C<=i)return L;const h=getComputedStyle(e),a=parseInt(h.borderLeftWidth,10),g=parseInt(h.borderTopWidth,10),p=parseInt(h.borderRightWidth,10),W=parseInt(h.borderBottomWidth,10);let T=0,B=0;const F="offsetWidth"in e?e.offsetWidth-e.clientWidth-a-p:0,V="offsetHeight"in e?e.offsetHeight-e.clientHeight-g-W:0,S="offsetWidth"in e?0===e.offsetWidth?0:l/e.offsetWidth:0,X="offsetHeight"in e?0===e.offsetHeight?0:n/e.offsetHeight:0;if(m===e)T="start"===f?k:"end"===f?k-H:"nearest"===f?o(M,M+H,H,g,W,M+k,M+k+v,v):k-H/2,B="start"===u?D:"center"===u?D-b/2:"end"===u?D-b:o(y,y+b,b,a,p,y+D,y+D+E,E),T=Math.max(0,T+M),B=Math.max(0,B+y);else {T="start"===f?k-r-g:"end"===f?k-s+W+V:"nearest"===f?o(r,s,n,g,W+V,k,k+v,v):k-(r+n/2)+V/2,B="start"===u?D-d-a:"center"===u?D-(d+l/2)+F/2:"end"===u?D-i+p+F:o(d,i,l,a,p+F,D,D+E,E);const{scrollLeft:t,scrollTop:h}=e;T=0===X?0:Math.max(0,Math.min(h+T/X,e.scrollHeight-n/X+V)),B=0===S?0:Math.max(0,Math.min(t+B/S,e.scrollWidth-l/S+F)),k+=h-T,D+=t-B;}L.push({el:e,top:T,left:B});}return L};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
  function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose;
    if (async) {
        if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
        dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
        if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
        dispose = value[Symbol.dispose];
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  function next() {
    while (env.stack.length) {
      var rec = env.stack.pop();
      try {
        var result = rec.dispose && rec.dispose.call(rec.value);
        if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
      }
      catch (e) {
          fail(e);
      }
    }
    if (env.hasError) throw env.error;
  }
  return next();
}

var tslib_es6 = {
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
};

var idCounter = 0;

/**
 * Accepts a parameter and returns it if it's a function
 * or a noop function if it's not. This allows us to
 * accept a callback, but not worry about it if it's not
 * passed.
 * @param {Function} cb the callback
 * @return {Function} a function
 */
function cbToCb(cb) {
  return typeof cb === 'function' ? cb : noop;
}
function noop() {}

/**
 * Scroll node into view if necessary
 * @param {HTMLElement} node the element that should scroll into view
 * @param {HTMLElement} menuNode the menu element of the component
 */
function scrollIntoView(node, menuNode) {
  if (!node) {
    return;
  }
  var actions = r(node, {
    boundary: menuNode,
    block: 'nearest',
    scrollMode: 'if-needed'
  });
  actions.forEach(function (_ref) {
    var el = _ref.el,
      top = _ref.top,
      left = _ref.left;
    el.scrollTop = top;
    el.scrollLeft = left;
  });
}

/**
 * @param {HTMLElement} parent the parent node
 * @param {HTMLElement} child the child node
 * @param {Window} environment The window context where downshift renders.
 * @return {Boolean} whether the parent is the child or the child is in the parent
 */
function isOrContainsNode(parent, child, environment) {
  var result = parent === child || child instanceof environment.Node && parent.contains && parent.contains(child);
  return result;
}

/**
 * Simple debounce implementation. Will call the given
 * function once after the time given has passed since
 * it was last called.
 * @param {Function} fn the function to call after the time
 * @param {Number} time the time to wait
 * @return {Function} the debounced function
 */
function debounce$1(fn, time) {
  var timeoutId;
  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }
  function wrapper() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    cancel();
    timeoutId = setTimeout(function () {
      timeoutId = null;
      fn.apply(void 0, args);
    }, time);
  }
  wrapper.cancel = cancel;
  return wrapper;
}

/**
 * This is intended to be used to compose event handlers.
 * They are executed in order until one of them sets
 * `event.preventDownshiftDefault = true`.
 * @param {...Function} fns the event handler functions
 * @return {Function} the event handler to add to an element
 */
function callAllEventHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }
  return function (event) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }
    return fns.some(function (fn) {
      if (fn) {
        fn.apply(void 0, [event].concat(args));
      }
      return event.preventDownshiftDefault || event.hasOwnProperty('nativeEvent') && event.nativeEvent.preventDownshiftDefault;
    });
  };
}
function handleRefs() {
  for (var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    refs[_key4] = arguments[_key4];
  }
  return function (node) {
    refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    });
  };
}

/**
 * This generates a unique ID for an instance of Downshift
 * @return {String} the unique ID
 */
function generateId() {
  return String(idCounter++);
}

/**
 * Resets idCounter to 0. Used for SSR.
 */
function resetIdCounter() {
  // istanbul ignore next
  if ('useId' in React__default) {
    console.warn("It is not necessary to call resetIdCounter when using React 18+");
    return;
  }
  idCounter = 0;
}

/**
 * Default implementation for status message. Only added when menu is open.
 * Will specify if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */
function getA11yStatusMessage(_ref2) {
  var isOpen = _ref2.isOpen,
    resultCount = _ref2.resultCount,
    previousResultCount = _ref2.previousResultCount;
  if (!isOpen) {
    return '';
  }
  if (!resultCount) {
    return 'No results are available.';
  }
  if (resultCount !== previousResultCount) {
    return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter key to select.";
  }
  return '';
}

/**
 * Takes an argument and if it's an array, returns the first item in the array
 * otherwise returns the argument
 * @param {*} arg the maybe-array
 * @param {*} defaultValue the value if arg is falsey not defined
 * @return {*} the arg or it's first item
 */
function unwrapArray$1(arg, defaultValue) {
  arg = Array.isArray(arg) ? /* istanbul ignore next (preact) */arg[0] : arg;
  if (!arg && defaultValue) {
    return defaultValue;
  } else {
    return arg;
  }
}

/**
 * @param {Object} element (P)react element
 * @return {Boolean} whether it's a DOM element
 */
function isDOMElement(element) {

  // then we assume this is react
  return typeof element.type === 'string';
}

/**
 * @param {Object} element (P)react element
 * @return {Object} the props
 */
function getElementProps(element) {
  return element.props;
}

/**
 * Throws a helpful error message for required properties. Useful
 * to be used as a default in destructuring or object params.
 * @param {String} fnName the function name
 * @param {String} propName the prop name
 */
function requiredProp(fnName, propName) {
  // eslint-disable-next-line no-console
  console.error("The property \"" + propName + "\" is required in \"" + fnName + "\"");
}
var stateKeys = ['highlightedIndex', 'inputValue', 'isOpen', 'selectedItem', 'type'];
/**
 * @param {Object} state the state object
 * @return {Object} state that is relevant to downshift
 */
function pickState(state) {
  if (state === void 0) {
    state = {};
  }
  var result = {};
  stateKeys.forEach(function (k) {
    if (state.hasOwnProperty(k)) {
      result[k] = state[k];
    }
  });
  return result;
}

/**
 * This will perform a shallow merge of the given state object
 * with the state coming from props
 * (for the controlled component scenario)
 * This is used in state updater functions so they're referencing
 * the right state regardless of where it comes from.
 *
 * @param {Object} state The state of the component/hook.
 * @param {Object} props The props that may contain controlled values.
 * @returns {Object} The merged controlled state.
 */
function getState(state, props) {
  if (!state || !props) {
    return state;
  }
  return Object.keys(state).reduce(function (prevState, key) {
    prevState[key] = isControlledProp(props, key) ? props[key] : state[key];
    return prevState;
  }, {});
}

/**
 * This determines whether a prop is a "controlled prop" meaning it is
 * state which is controlled by the outside of this component rather
 * than within this component.
 *
 * @param {Object} props The props that may contain controlled values.
 * @param {String} key the key to check
 * @return {Boolean} whether it is a controlled controlled prop
 */
function isControlledProp(props, key) {
  return props[key] !== undefined;
}

/**
 * Normalizes the 'key' property of a KeyboardEvent in IE/Edge
 * @param {Object} event a keyboardEvent object
 * @return {String} keyboard key
 */
function normalizeArrowKey(event) {
  var key = event.key,
    keyCode = event.keyCode;
  /* istanbul ignore next (ie) */
  if (keyCode >= 37 && keyCode <= 40 && key.indexOf('Arrow') !== 0) {
    return "Arrow" + key;
  }
  return key;
}

/**
 * Simple check if the value passed is object literal
 * @param {*} obj any things
 * @return {Boolean} whether it's object literal
 */
function isPlainObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

/**
 * Returns the next non-disabled highlightedIndex value.
 *
 * @param {number} start The current highlightedIndex.
 * @param {number} offset The offset from the current highlightedIndex to start searching.
 * @param {unknown[]} items The items array.
 * @param {(item: unknown, index: number) => boolean} isItemDisabled Function that tells if an item is disabled or not.
 * @param {boolean?} circular If the search reaches the end, if it can search again starting from the other end.
 * @returns {number} The next highlightedIndex.
 */
function getHighlightedIndex(start, offset, items, isItemDisabled, circular) {
  if (circular === void 0) {
    circular = false;
  }
  var count = items.length;
  if (count === 0) {
    return -1;
  }
  var itemsLastIndex = count - 1;
  if (typeof start !== 'number' || start < 0 || start > itemsLastIndex) {
    start = offset > 0 ? -1 : itemsLastIndex + 1;
  }
  var current = start + offset;
  if (current < 0) {
    current = circular ? itemsLastIndex : 0;
  } else if (current > itemsLastIndex) {
    current = circular ? 0 : itemsLastIndex;
  }
  var highlightedIndex = getNonDisabledIndex(current, offset < 0, items, isItemDisabled, circular);
  if (highlightedIndex === -1) {
    return start >= count ? -1 : start;
  }
  return highlightedIndex;
}

/**
 * Returns the next non-disabled highlightedIndex value.
 *
 * @param {number} start The current highlightedIndex.
 * @param {boolean} backwards If true, it will search backwards from the start.
 * @param {unknown[]} items The items array.
 * @param {(item: unknown, index: number) => boolean} isItemDisabled Function that tells if an item is disabled or not.
 * @param {boolean} circular If the search reaches the end, if it can search again starting from the other end.
 * @returns {number} The next non-disabled index.
 */
function getNonDisabledIndex(start, backwards, items, isItemDisabled, circular) {
  if (circular === void 0) {
    circular = false;
  }
  var count = items.length;
  if (backwards) {
    for (var index = start; index >= 0; index--) {
      if (!isItemDisabled(items[index], index)) {
        return index;
      }
    }
  } else {
    for (var _index = start; _index < count; _index++) {
      if (!isItemDisabled(items[_index], _index)) {
        return _index;
      }
    }
  }
  if (circular) {
    return getNonDisabledIndex(backwards ? count - 1 : 0, backwards, items, isItemDisabled);
  }
  return -1;
}

/**
 * Checks if event target is within the downshift elements.
 *
 * @param {EventTarget} target Target to check.
 * @param {HTMLElement[]} downshiftElements The elements that form downshift (list, toggle button etc).
 * @param {Window} environment The window context where downshift renders.
 * @param {boolean} checkActiveElement Whether to also check activeElement.
 *
 * @returns {boolean} Whether or not the target is within downshift elements.
 */
function targetWithinDownshift(target, downshiftElements, environment, checkActiveElement) {
  if (checkActiveElement === void 0) {
    checkActiveElement = true;
  }
  return environment && downshiftElements.some(function (contextNode) {
    return contextNode && (isOrContainsNode(contextNode, target, environment) || checkActiveElement && isOrContainsNode(contextNode, environment.document.activeElement, environment));
  });
}

// eslint-disable-next-line import/no-mutable-exports
var validateControlledUnchanged = noop;
/* istanbul ignore next */
if (process.env.NODE_ENV !== 'production') {
  validateControlledUnchanged = function validateControlledUnchanged(state, prevProps, nextProps) {
    var warningDescription = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
    Object.keys(state).forEach(function (propKey) {
      if (prevProps[propKey] !== undefined && nextProps[propKey] === undefined) {
        // eslint-disable-next-line no-console
        console.error("downshift: A component has changed the controlled prop \"" + propKey + "\" to be uncontrolled. " + warningDescription);
      } else if (prevProps[propKey] === undefined && nextProps[propKey] !== undefined) {
        // eslint-disable-next-line no-console
        console.error("downshift: A component has changed the uncontrolled prop \"" + propKey + "\" to be controlled. " + warningDescription);
      }
    });
  };
}

var cleanupStatus = debounce$1(function (documentProp) {
  getStatusDiv(documentProp).textContent = '';
}, 500);

/**
 * Get the status node or create it if it does not already exist.
 * @param {Object} documentProp document passed by the user.
 * @return {HTMLElement} the status node.
 */
function getStatusDiv(documentProp) {
  var statusDiv = documentProp.getElementById('a11y-status-message');
  if (statusDiv) {
    return statusDiv;
  }
  statusDiv = documentProp.createElement('div');
  statusDiv.setAttribute('id', 'a11y-status-message');
  statusDiv.setAttribute('role', 'status');
  statusDiv.setAttribute('aria-live', 'polite');
  statusDiv.setAttribute('aria-relevant', 'additions text');
  Object.assign(statusDiv.style, {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    width: '1px'
  });
  documentProp.body.appendChild(statusDiv);
  return statusDiv;
}

/**
 * @param {String} status the status message
 * @param {Object} documentProp document passed by the user.
 */
function setStatus(status, documentProp) {
  if (!status || !documentProp) {
    return;
  }
  var div = getStatusDiv(documentProp);
  div.textContent = status;
  cleanupStatus(documentProp);
}

/**
 * Removes the status element from the DOM
 * @param {Document} documentProp 
 */
function cleanupStatusDiv(documentProp) {
  var statusDiv = documentProp == null ? void 0 : documentProp.getElementById('a11y-status-message');
  if (statusDiv) {
    statusDiv.remove();
  }
}

var unknown = process.env.NODE_ENV !== "production" ? '__autocomplete_unknown__' : 0;
var mouseUp = process.env.NODE_ENV !== "production" ? '__autocomplete_mouseup__' : 1;
var itemMouseEnter = process.env.NODE_ENV !== "production" ? '__autocomplete_item_mouseenter__' : 2;
var keyDownArrowUp = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_arrow_up__' : 3;
var keyDownArrowDown = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_arrow_down__' : 4;
var keyDownEscape = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_escape__' : 5;
var keyDownEnter = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_enter__' : 6;
var keyDownHome = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_home__' : 7;
var keyDownEnd = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_end__' : 8;
var clickItem = process.env.NODE_ENV !== "production" ? '__autocomplete_click_item__' : 9;
var blurInput = process.env.NODE_ENV !== "production" ? '__autocomplete_blur_input__' : 10;
var changeInput = process.env.NODE_ENV !== "production" ? '__autocomplete_change_input__' : 11;
var keyDownSpaceButton = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_space_button__' : 12;
var clickButton = process.env.NODE_ENV !== "production" ? '__autocomplete_click_button__' : 13;
var blurButton = process.env.NODE_ENV !== "production" ? '__autocomplete_blur_button__' : 14;
var controlledPropUpdatedSelectedItem = process.env.NODE_ENV !== "production" ? '__autocomplete_controlled_prop_updated_selected_item__' : 15;
var touchEnd = process.env.NODE_ENV !== "production" ? '__autocomplete_touchend__' : 16;

var stateChangeTypes$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  blurButton: blurButton,
  blurInput: blurInput,
  changeInput: changeInput,
  clickButton: clickButton,
  clickItem: clickItem,
  controlledPropUpdatedSelectedItem: controlledPropUpdatedSelectedItem,
  itemMouseEnter: itemMouseEnter,
  keyDownArrowDown: keyDownArrowDown,
  keyDownArrowUp: keyDownArrowUp,
  keyDownEnd: keyDownEnd,
  keyDownEnter: keyDownEnter,
  keyDownEscape: keyDownEscape,
  keyDownHome: keyDownHome,
  keyDownSpaceButton: keyDownSpaceButton,
  mouseUp: mouseUp,
  touchEnd: touchEnd,
  unknown: unknown
});

var _excluded$3 = ["refKey", "ref"],
  _excluded2$3 = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"],
  _excluded3$2 = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"],
  _excluded4$2 = ["refKey", "ref"],
  _excluded5 = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"];
var Downshift = /*#__PURE__*/function () {
  var Downshift = /*#__PURE__*/function (_Component) {
    function Downshift(_props) {
      var _this;
      _this = _Component.call(this, _props) || this;
      // fancy destructuring + defaults + aliases
      // this basically says each value of state should either be set to
      // the initial value or the default value if the initial value is not provided
      _this.id = _this.props.id || "downshift-" + generateId();
      _this.menuId = _this.props.menuId || _this.id + "-menu";
      _this.labelId = _this.props.labelId || _this.id + "-label";
      _this.inputId = _this.props.inputId || _this.id + "-input";
      _this.getItemId = _this.props.getItemId || function (index) {
        return _this.id + "-item-" + index;
      };
      _this.items = [];
      // itemCount can be changed asynchronously
      // from within downshift (so it can't come from a prop)
      // this is why we store it as an instance and use
      // getItemCount rather than just use items.length
      // (to support windowing + async)
      _this.itemCount = null;
      _this.previousResultCount = 0;
      _this.timeoutIds = [];
      /**
       * @param {Function} fn the function to call after the time
       * @param {Number} time the time to wait
       */
      _this.internalSetTimeout = function (fn, time) {
        var id = setTimeout(function () {
          _this.timeoutIds = _this.timeoutIds.filter(function (i) {
            return i !== id;
          });
          fn();
        }, time);
        _this.timeoutIds.push(id);
      };
      _this.setItemCount = function (count) {
        _this.itemCount = count;
      };
      _this.unsetItemCount = function () {
        _this.itemCount = null;
      };
      _this.isItemDisabled = function (_item, index) {
        var currentElementNode = _this.getItemNodeFromIndex(index);
        return currentElementNode && currentElementNode.hasAttribute('disabled');
      };
      _this.setHighlightedIndex = function (highlightedIndex, otherStateToSet) {
        if (highlightedIndex === void 0) {
          highlightedIndex = _this.props.defaultHighlightedIndex;
        }
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }
        otherStateToSet = pickState(otherStateToSet);
        _this.internalSetState(_extends({
          highlightedIndex: highlightedIndex
        }, otherStateToSet));
      };
      _this.clearSelection = function (cb) {
        _this.internalSetState({
          selectedItem: null,
          inputValue: '',
          highlightedIndex: _this.props.defaultHighlightedIndex,
          isOpen: _this.props.defaultIsOpen
        }, cb);
      };
      _this.selectItem = function (item, otherStateToSet, cb) {
        otherStateToSet = pickState(otherStateToSet);
        _this.internalSetState(_extends({
          isOpen: _this.props.defaultIsOpen,
          highlightedIndex: _this.props.defaultHighlightedIndex,
          selectedItem: item,
          inputValue: _this.props.itemToString(item)
        }, otherStateToSet), cb);
      };
      _this.selectItemAtIndex = function (itemIndex, otherStateToSet, cb) {
        var item = _this.items[itemIndex];
        if (item == null) {
          return;
        }
        _this.selectItem(item, otherStateToSet, cb);
      };
      _this.selectHighlightedItem = function (otherStateToSet, cb) {
        return _this.selectItemAtIndex(_this.getState().highlightedIndex, otherStateToSet, cb);
      };
      // any piece of our state can live in two places:
      // 1. Uncontrolled: it's internal (this.state)
      //    We will call this.setState to update that state
      // 2. Controlled: it's external (this.props)
      //    We will call this.props.onStateChange to update that state
      //
      // In addition, we'll call this.props.onChange if the
      // selectedItem is changed.
      _this.internalSetState = function (stateToSet, cb) {
        var isItemSelected, onChangeArg;
        var onStateChangeArg = {};
        var isStateToSetFunction = typeof stateToSet === 'function';

        // we want to call `onInputValueChange` before the `setState` call
        // so someone controlling the `inputValue` state gets notified of
        // the input change as soon as possible. This avoids issues with
        // preserving the cursor position.
        // See https://github.com/downshift-js/downshift/issues/217 for more info.
        if (!isStateToSetFunction && stateToSet.hasOwnProperty('inputValue')) {
          _this.props.onInputValueChange(stateToSet.inputValue, _extends({}, _this.getStateAndHelpers(), stateToSet));
        }
        return _this.setState(function (state) {
          var _newStateToSet;
          state = _this.getState(state);
          var newStateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet;

          // Your own function that could modify the state that will be set.
          newStateToSet = _this.props.stateReducer(state, newStateToSet);

          // checks if an item is selected, regardless of if it's different from
          // what was selected before
          // used to determine if onSelect and onChange callbacks should be called
          isItemSelected = newStateToSet.hasOwnProperty('selectedItem');
          // this keeps track of the object we want to call with setState
          var nextState = {};
          // we need to call on change if the outside world is controlling any of our state
          // and we're trying to update that state. OR if the selection has changed and we're
          // trying to update the selection
          if (isItemSelected && newStateToSet.selectedItem !== state.selectedItem) {
            onChangeArg = newStateToSet.selectedItem;
          }
          (_newStateToSet = newStateToSet).type || (_newStateToSet.type = unknown);
          Object.keys(newStateToSet).forEach(function (key) {
            // onStateChangeArg should only have the state that is
            // actually changing
            if (state[key] !== newStateToSet[key]) {
              onStateChangeArg[key] = newStateToSet[key];
            }
            // the type is useful for the onStateChangeArg
            // but we don't actually want to set it in internal state.
            // this is an undocumented feature for now... Not all internalSetState
            // calls support it and I'm not certain we want them to yet.
            // But it enables users controlling the isOpen state to know when
            // the isOpen state changes due to mouseup events which is quite handy.
            if (key === 'type') {
              return;
            }
            newStateToSet[key];
            // if it's coming from props, then we don't care to set it internally
            if (!isControlledProp(_this.props, key)) {
              nextState[key] = newStateToSet[key];
            }
          });

          // if stateToSet is a function, then we weren't able to call onInputValueChange
          // earlier, so we'll call it now that we know what the inputValue state will be.
          if (isStateToSetFunction && newStateToSet.hasOwnProperty('inputValue')) {
            _this.props.onInputValueChange(newStateToSet.inputValue, _extends({}, _this.getStateAndHelpers(), newStateToSet));
          }
          return nextState;
        }, function () {
          // call the provided callback if it's a function
          cbToCb(cb)();

          // only call the onStateChange and onChange callbacks if
          // we have relevant information to pass them.
          var hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;
          if (hasMoreStateThanType) {
            _this.props.onStateChange(onStateChangeArg, _this.getStateAndHelpers());
          }
          if (isItemSelected) {
            _this.props.onSelect(stateToSet.selectedItem, _this.getStateAndHelpers());
          }
          if (onChangeArg !== undefined) {
            _this.props.onChange(onChangeArg, _this.getStateAndHelpers());
          }
          // this is currently undocumented and therefore subject to change
          // We'll try to not break it, but just be warned.
          _this.props.onUserAction(onStateChangeArg, _this.getStateAndHelpers());
        });
      };
      //////////////////////////// ROOT
      _this.rootRef = function (node) {
        return _this._rootNode = node;
      };
      _this.getRootProps = function (_temp, _temp2) {
        var _extends2;
        var _ref = _temp === void 0 ? {} : _temp,
          _ref$refKey = _ref.refKey,
          refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
          ref = _ref.ref,
          rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);
        var _ref2 = _temp2 === void 0 ? {} : _temp2,
          _ref2$suppressRefErro = _ref2.suppressRefError,
          suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;
        // this is used in the render to know whether the user has called getRootProps.
        // It uses that to know whether to apply the props automatically
        _this.getRootProps.called = true;
        _this.getRootProps.refKey = refKey;
        _this.getRootProps.suppressRefError = suppressRefError;
        var _this$getState = _this.getState(),
          isOpen = _this$getState.isOpen;
        return _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, _this.rootRef), _extends2.role = 'combobox', _extends2['aria-expanded'] = isOpen, _extends2['aria-haspopup'] = 'listbox', _extends2['aria-owns'] = isOpen ? _this.menuId : undefined, _extends2['aria-labelledby'] = _this.labelId, _extends2), rest);
      };
      //\\\\\\\\\\\\\\\\\\\\\\\\\\ ROOT
      _this.keyDownHandlers = {
        ArrowDown: function ArrowDown(event) {
          var _this2 = this;
          event.preventDefault();
          if (this.getState().isOpen) {
            var amount = event.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowDown
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowDown
            }, function () {
              var itemCount = _this2.getItemCount();
              if (itemCount > 0) {
                var _this2$getState = _this2.getState(),
                  highlightedIndex = _this2$getState.highlightedIndex;
                var nextHighlightedIndex = getHighlightedIndex(highlightedIndex, 1, {
                  length: itemCount
                }, _this2.isItemDisabled, true);
                _this2.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowDown
                });
              }
            });
          }
        },
        ArrowUp: function ArrowUp(event) {
          var _this3 = this;
          event.preventDefault();
          if (this.getState().isOpen) {
            var amount = event.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowUp
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowUp
            }, function () {
              var itemCount = _this3.getItemCount();
              if (itemCount > 0) {
                var _this3$getState = _this3.getState(),
                  highlightedIndex = _this3$getState.highlightedIndex;
                var nextHighlightedIndex = getHighlightedIndex(highlightedIndex, -1, {
                  length: itemCount
                }, _this3.isItemDisabled, true);
                _this3.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowUp
                });
              }
            });
          }
        },
        Enter: function Enter(event) {
          if (event.which === 229) {
            return;
          }
          var _this$getState2 = this.getState(),
            isOpen = _this$getState2.isOpen,
            highlightedIndex = _this$getState2.highlightedIndex;
          if (isOpen && highlightedIndex != null) {
            event.preventDefault();
            var item = this.items[highlightedIndex];
            var itemNode = this.getItemNodeFromIndex(highlightedIndex);
            if (item == null || itemNode && itemNode.hasAttribute('disabled')) {
              return;
            }
            this.selectHighlightedItem({
              type: keyDownEnter
            });
          }
        },
        Escape: function Escape(event) {
          event.preventDefault();
          this.reset(_extends({
            type: keyDownEscape
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ''
          }));
        }
      };
      //////////////////////////// BUTTON
      _this.buttonKeyDownHandlers = _extends({}, _this.keyDownHandlers, {
        ' ': function _(event) {
          event.preventDefault();
          this.toggleMenu({
            type: keyDownSpaceButton
          });
        }
      });
      _this.inputKeyDownHandlers = _extends({}, _this.keyDownHandlers, {
        Home: function Home(event) {
          var _this$getState3 = this.getState(),
            isOpen = _this$getState3.isOpen;
          if (!isOpen) {
            return;
          }
          event.preventDefault();
          var itemCount = this.getItemCount();
          if (itemCount <= 0 || !isOpen) {
            return;
          }

          // get next non-disabled starting downwards from 0 if that's disabled.
          var newHighlightedIndex = getNonDisabledIndex(0, false, {
            length: itemCount
          }, this.isItemDisabled);
          this.setHighlightedIndex(newHighlightedIndex, {
            type: keyDownHome
          });
        },
        End: function End(event) {
          var _this$getState4 = this.getState(),
            isOpen = _this$getState4.isOpen;
          if (!isOpen) {
            return;
          }
          event.preventDefault();
          var itemCount = this.getItemCount();
          if (itemCount <= 0 || !isOpen) {
            return;
          }

          // get next non-disabled starting upwards from last index if that's disabled.
          var newHighlightedIndex = getNonDisabledIndex(itemCount - 1, true, {
            length: itemCount
          }, this.isItemDisabled);
          this.setHighlightedIndex(newHighlightedIndex, {
            type: keyDownEnd
          });
        }
      });
      _this.getToggleButtonProps = function (_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3,
          onClick = _ref3.onClick;
          _ref3.onPress;
          var onKeyDown = _ref3.onKeyDown,
          onKeyUp = _ref3.onKeyUp,
          onBlur = _ref3.onBlur,
          rest = _objectWithoutPropertiesLoose(_ref3, _excluded2$3);
        var _this$getState5 = _this.getState(),
          isOpen = _this$getState5.isOpen;
        var enabledEventHandlers = {
          onClick: callAllEventHandlers(onClick, _this.buttonHandleClick),
          onKeyDown: callAllEventHandlers(onKeyDown, _this.buttonHandleKeyDown),
          onKeyUp: callAllEventHandlers(onKeyUp, _this.buttonHandleKeyUp),
          onBlur: callAllEventHandlers(onBlur, _this.buttonHandleBlur)
        };
        var eventHandlers = rest.disabled ? {} : enabledEventHandlers;
        return _extends({
          type: 'button',
          role: 'button',
          'aria-label': isOpen ? 'close menu' : 'open menu',
          'aria-haspopup': true,
          'data-toggle': true
        }, eventHandlers, rest);
      };
      _this.buttonHandleKeyUp = function (event) {
        // Prevent click event from emitting in Firefox
        event.preventDefault();
      };
      _this.buttonHandleKeyDown = function (event) {
        var key = normalizeArrowKey(event);
        if (_this.buttonKeyDownHandlers[key]) {
          _this.buttonKeyDownHandlers[key].call(_this, event);
        }
      };
      _this.buttonHandleClick = function (event) {
        event.preventDefault();
        // handle odd case for Safari and Firefox which
        // don't give the button the focus properly.
        /* istanbul ignore if (can't reasonably test this) */
        if (_this.props.environment) {
          var _this$props$environme = _this.props.environment.document,
            body = _this$props$environme.body,
            activeElement = _this$props$environme.activeElement;
          if (body && body === activeElement) {
            event.target.focus();
          }
        }
        // to simplify testing components that use downshift, we'll not wrap this in a setTimeout
        // if the NODE_ENV is test. With the proper build system, this should be dead code eliminated
        // when building for production and should therefore have no impact on production code.
        if (process.env.NODE_ENV === 'test') {
          _this.toggleMenu({
            type: clickButton
          });
        } else {
          // Ensure that toggle of menu occurs after the potential blur event in iOS
          _this.internalSetTimeout(function () {
            return _this.toggleMenu({
              type: clickButton
            });
          });
        }
      };
      _this.buttonHandleBlur = function (event) {
        var blurTarget = event.target; // Save blur target for comparison with activeElement later
        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not body element
        _this.internalSetTimeout(function () {
          if (_this.isMouseDown || !_this.props.environment) {
            return;
          }
          var activeElement = _this.props.environment.document.activeElement;
          if ((activeElement == null || activeElement.id !== _this.inputId) && activeElement !== blurTarget // Do nothing if we refocus the same element again (to solve issue in Safari on iOS)
          ) {
            _this.reset({
              type: blurButton
            });
          }
        });
      };
      //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ BUTTON
      /////////////////////////////// LABEL
      _this.getLabelProps = function (props) {
        return _extends({
          htmlFor: _this.inputId,
          id: _this.labelId
        }, props);
      };
      //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ LABEL
      /////////////////////////////// INPUT
      _this.getInputProps = function (_temp4) {
        var _ref4 = _temp4 === void 0 ? {} : _temp4,
          onKeyDown = _ref4.onKeyDown,
          onBlur = _ref4.onBlur,
          onChange = _ref4.onChange,
          onInput = _ref4.onInput;
          _ref4.onChangeText;
          var rest = _objectWithoutPropertiesLoose(_ref4, _excluded3$2);
        var onChangeKey;
        var eventHandlers = {};

        /* istanbul ignore next (preact) */
        {
          onChangeKey = 'onChange';
        }
        var _this$getState6 = _this.getState(),
          inputValue = _this$getState6.inputValue,
          isOpen = _this$getState6.isOpen,
          highlightedIndex = _this$getState6.highlightedIndex;
        if (!rest.disabled) {
          var _eventHandlers;
          eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, _this.inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, _this.inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, _this.inputHandleBlur), _eventHandlers);
        }
        return _extends({
          'aria-autocomplete': 'list',
          'aria-activedescendant': isOpen && typeof highlightedIndex === 'number' && highlightedIndex >= 0 ? _this.getItemId(highlightedIndex) : undefined,
          'aria-controls': isOpen ? _this.menuId : undefined,
          'aria-labelledby': rest && rest['aria-label'] ? undefined : _this.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: 'off',
          value: inputValue,
          id: _this.inputId
        }, eventHandlers, rest);
      };
      _this.inputHandleKeyDown = function (event) {
        var key = normalizeArrowKey(event);
        if (key && _this.inputKeyDownHandlers[key]) {
          _this.inputKeyDownHandlers[key].call(_this, event);
        }
      };
      _this.inputHandleChange = function (event) {
        _this.internalSetState({
          type: changeInput,
          isOpen: true,
          inputValue: event.target.value,
          highlightedIndex: _this.props.defaultHighlightedIndex
        });
      };
      _this.inputHandleBlur = function () {
        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not the body element
        _this.internalSetTimeout(function () {
          var _activeElement$datase;
          if (_this.isMouseDown || !_this.props.environment) {
            return;
          }
          var activeElement = _this.props.environment.document.activeElement;
          var downshiftButtonIsActive = (activeElement == null || (_activeElement$datase = activeElement.dataset) == null ? void 0 : _activeElement$datase.toggle) && _this._rootNode && _this._rootNode.contains(activeElement);
          if (!downshiftButtonIsActive) {
            _this.reset({
              type: blurInput
            });
          }
        });
      };
      //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ INPUT
      /////////////////////////////// MENU
      _this.menuRef = function (node) {
        _this._menuNode = node;
      };
      _this.getMenuProps = function (_temp5, _temp6) {
        var _extends3;
        var _ref5 = _temp5 === void 0 ? {} : _temp5,
          _ref5$refKey = _ref5.refKey,
          refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey,
          ref = _ref5.ref,
          props = _objectWithoutPropertiesLoose(_ref5, _excluded4$2);
        var _ref6 = _temp6 === void 0 ? {} : _temp6,
          _ref6$suppressRefErro = _ref6.suppressRefError,
          suppressRefError = _ref6$suppressRefErro === void 0 ? false : _ref6$suppressRefErro;
        _this.getMenuProps.called = true;
        _this.getMenuProps.refKey = refKey;
        _this.getMenuProps.suppressRefError = suppressRefError;
        return _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, _this.menuRef), _extends3.role = 'listbox', _extends3['aria-labelledby'] = props && props['aria-label'] ? undefined : _this.labelId, _extends3.id = _this.menuId, _extends3), props);
      };
      //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ MENU
      /////////////////////////////// ITEM
      _this.getItemProps = function (_temp7) {
        var _enabledEventHandlers;
        var _ref7 = _temp7 === void 0 ? {} : _temp7,
          onMouseMove = _ref7.onMouseMove,
          onMouseDown = _ref7.onMouseDown,
          onClick = _ref7.onClick;
          _ref7.onPress;
          var index = _ref7.index,
          _ref7$item = _ref7.item,
          item = _ref7$item === void 0 ? process.env.NODE_ENV === 'production' ? /* istanbul ignore next */undefined : requiredProp('getItemProps', 'item') : _ref7$item,
          rest = _objectWithoutPropertiesLoose(_ref7, _excluded5);
        if (index === undefined) {
          _this.items.push(item);
          index = _this.items.indexOf(item);
        } else {
          _this.items[index] = item;
        }
        var onSelectKey = 'onClick';
        var customClickHandler = onClick;
        var enabledEventHandlers = (_enabledEventHandlers = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: callAllEventHandlers(onMouseMove, function () {
            if (index === _this.getState().highlightedIndex) {
              return;
            }
            _this.setHighlightedIndex(index, {
              type: itemMouseEnter
            });

            // We never want to manually scroll when changing state based
            // on `onMouseMove` because we will be moving the element out
            // from under the user which is currently scrolling/moving the
            // cursor
            _this.avoidScrolling = true;
            _this.internalSetTimeout(function () {
              return _this.avoidScrolling = false;
            }, 250);
          }),
          onMouseDown: callAllEventHandlers(onMouseDown, function (event) {
            // This prevents the activeElement from being changed
            // to the item so it can remain with the current activeElement
            // which is a more common use case.
            event.preventDefault();
          })
        }, _enabledEventHandlers[onSelectKey] = callAllEventHandlers(customClickHandler, function () {
          _this.selectItemAtIndex(index, {
            type: clickItem
          });
        }), _enabledEventHandlers);

        // Passing down the onMouseDown handler to prevent redirect
        // of the activeElement if clicking on disabled items
        var eventHandlers = rest.disabled ? {
          onMouseDown: enabledEventHandlers.onMouseDown
        } : enabledEventHandlers;
        return _extends({
          id: _this.getItemId(index),
          role: 'option',
          'aria-selected': _this.getState().highlightedIndex === index
        }, eventHandlers, rest);
      };
      //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ ITEM
      _this.clearItems = function () {
        _this.items = [];
      };
      _this.reset = function (otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }
        otherStateToSet = pickState(otherStateToSet);
        _this.internalSetState(function (_ref8) {
          var selectedItem = _ref8.selectedItem;
          return _extends({
            isOpen: _this.props.defaultIsOpen,
            highlightedIndex: _this.props.defaultHighlightedIndex,
            inputValue: _this.props.itemToString(selectedItem)
          }, otherStateToSet);
        }, cb);
      };
      _this.toggleMenu = function (otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }
        otherStateToSet = pickState(otherStateToSet);
        _this.internalSetState(function (_ref9) {
          var isOpen = _ref9.isOpen;
          return _extends({
            isOpen: !isOpen
          }, isOpen && {
            highlightedIndex: _this.props.defaultHighlightedIndex
          }, otherStateToSet);
        }, function () {
          var _this$getState7 = _this.getState(),
            isOpen = _this$getState7.isOpen,
            highlightedIndex = _this$getState7.highlightedIndex;
          if (isOpen) {
            if (_this.getItemCount() > 0 && typeof highlightedIndex === 'number') {
              _this.setHighlightedIndex(highlightedIndex, otherStateToSet);
            }
          }
          cbToCb(cb)();
        });
      };
      _this.openMenu = function (cb) {
        _this.internalSetState({
          isOpen: true
        }, cb);
      };
      _this.closeMenu = function (cb) {
        _this.internalSetState({
          isOpen: false
        }, cb);
      };
      _this.updateStatus = debounce$1(function () {
        var _this$props;
        if (!((_this$props = _this.props) != null && (_this$props = _this$props.environment) != null && _this$props.document)) {
          return;
        }
        var state = _this.getState();
        var item = _this.items[state.highlightedIndex];
        var resultCount = _this.getItemCount();
        var status = _this.props.getA11yStatusMessage(_extends({
          itemToString: _this.props.itemToString,
          previousResultCount: _this.previousResultCount,
          resultCount: resultCount,
          highlightedItem: item
        }, state));
        _this.previousResultCount = resultCount;
        setStatus(status, _this.props.environment.document);
      }, 200);
      var _this$props2 = _this.props,
        defaultHighlightedIndex = _this$props2.defaultHighlightedIndex,
        _this$props2$initialH = _this$props2.initialHighlightedIndex,
        _highlightedIndex = _this$props2$initialH === void 0 ? defaultHighlightedIndex : _this$props2$initialH,
        defaultIsOpen = _this$props2.defaultIsOpen,
        _this$props2$initialI = _this$props2.initialIsOpen,
        _isOpen = _this$props2$initialI === void 0 ? defaultIsOpen : _this$props2$initialI,
        _this$props2$initialI2 = _this$props2.initialInputValue,
        _inputValue = _this$props2$initialI2 === void 0 ? '' : _this$props2$initialI2,
        _this$props2$initialS = _this$props2.initialSelectedItem,
        _selectedItem = _this$props2$initialS === void 0 ? null : _this$props2$initialS;
      var _state = _this.getState({
        highlightedIndex: _highlightedIndex,
        isOpen: _isOpen,
        inputValue: _inputValue,
        selectedItem: _selectedItem
      });
      if (_state.selectedItem != null && _this.props.initialInputValue === undefined) {
        _state.inputValue = _this.props.itemToString(_state.selectedItem);
      }
      _this.state = _state;
      return _this;
    }
    _inheritsLoose(Downshift, _Component);
    var _proto = Downshift.prototype;
    /**
     * Clear all running timeouts
     */
    _proto.internalClearTimeouts = function internalClearTimeouts() {
      this.timeoutIds.forEach(function (id) {
        clearTimeout(id);
      });
      this.timeoutIds = [];
    }

    /**
     * Gets the state based on internal state or props
     * If a state value is passed via props, then that
     * is the value given, otherwise it's retrieved from
     * stateToMerge
     *
     * @param {Object} stateToMerge defaults to this.state
     * @return {Object} the state
     */;
    _proto.getState = function getState$1(stateToMerge) {
      if (stateToMerge === void 0) {
        stateToMerge = this.state;
      }
      return getState(stateToMerge, this.props);
    };
    _proto.getItemCount = function getItemCount() {
      // things read better this way. They're in priority order:
      // 1. `this.itemCount`
      // 2. `this.props.itemCount`
      // 3. `this.items.length`
      var itemCount = this.items.length;
      if (this.itemCount != null) {
        itemCount = this.itemCount;
      } else if (this.props.itemCount !== undefined) {
        itemCount = this.props.itemCount;
      }
      return itemCount;
    };
    _proto.getItemNodeFromIndex = function getItemNodeFromIndex(index) {
      return this.props.environment ? this.props.environment.document.getElementById(this.getItemId(index)) : null;
    };
    _proto.scrollHighlightedItemIntoView = function scrollHighlightedItemIntoView() {
      /* istanbul ignore else (react-native) */
      {
        var node = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(node, this._menuNode);
      }
    };
    _proto.moveHighlightedIndex = function moveHighlightedIndex(amount, otherStateToSet) {
      var itemCount = this.getItemCount();
      var _this$getState8 = this.getState(),
        highlightedIndex = _this$getState8.highlightedIndex;
      if (itemCount > 0) {
        var nextHighlightedIndex = getHighlightedIndex(highlightedIndex, amount, {
          length: itemCount
        }, this.isItemDisabled, true);
        this.setHighlightedIndex(nextHighlightedIndex, otherStateToSet);
      }
    };
    _proto.getStateAndHelpers = function getStateAndHelpers() {
      var _this$getState9 = this.getState(),
        highlightedIndex = _this$getState9.highlightedIndex,
        inputValue = _this$getState9.inputValue,
        selectedItem = _this$getState9.selectedItem,
        isOpen = _this$getState9.isOpen;
      var itemToString = this.props.itemToString;
      var id = this.id;
      var getRootProps = this.getRootProps,
        getToggleButtonProps = this.getToggleButtonProps,
        getLabelProps = this.getLabelProps,
        getMenuProps = this.getMenuProps,
        getInputProps = this.getInputProps,
        getItemProps = this.getItemProps,
        openMenu = this.openMenu,
        closeMenu = this.closeMenu,
        toggleMenu = this.toggleMenu,
        selectItem = this.selectItem,
        selectItemAtIndex = this.selectItemAtIndex,
        selectHighlightedItem = this.selectHighlightedItem,
        setHighlightedIndex = this.setHighlightedIndex,
        clearSelection = this.clearSelection,
        clearItems = this.clearItems,
        reset = this.reset,
        setItemCount = this.setItemCount,
        unsetItemCount = this.unsetItemCount,
        setState = this.internalSetState;
      return {
        // prop getters
        getRootProps: getRootProps,
        getToggleButtonProps: getToggleButtonProps,
        getLabelProps: getLabelProps,
        getMenuProps: getMenuProps,
        getInputProps: getInputProps,
        getItemProps: getItemProps,
        // actions
        reset: reset,
        openMenu: openMenu,
        closeMenu: closeMenu,
        toggleMenu: toggleMenu,
        selectItem: selectItem,
        selectItemAtIndex: selectItemAtIndex,
        selectHighlightedItem: selectHighlightedItem,
        setHighlightedIndex: setHighlightedIndex,
        clearSelection: clearSelection,
        clearItems: clearItems,
        setItemCount: setItemCount,
        unsetItemCount: unsetItemCount,
        setState: setState,
        // props
        itemToString: itemToString,
        // derived
        id: id,
        // state
        highlightedIndex: highlightedIndex,
        inputValue: inputValue,
        isOpen: isOpen,
        selectedItem: selectedItem
      };
    };
    _proto.componentDidMount = function componentDidMount() {
      var _this4 = this;
      /* istanbul ignore if (react-native) */
      if (process.env.NODE_ENV !== 'production' && !false && this.getMenuProps.called && !this.getMenuProps.suppressRefError) {
        validateGetMenuPropsCalledCorrectly(this._menuNode, this.getMenuProps);
      }

      /* istanbul ignore if (react-native or SSR) */
      if (!this.props.environment) {
        this.cleanup = function () {
          _this4.internalClearTimeouts();
        };
      } else {
        // this.isMouseDown helps us track whether the mouse is currently held down.
        // This is useful when the user clicks on an item in the list, but holds the mouse
        // down long enough for the list to disappear (because the blur event fires on the input)
        // this.isMouseDown is used in the blur handler on the input to determine whether the blur event should
        // trigger hiding the menu.
        var onMouseDown = function onMouseDown() {
          _this4.isMouseDown = true;
        };
        var onMouseUp = function onMouseUp(event) {
          _this4.isMouseDown = false;
          // if the target element or the activeElement is within a downshift node
          // then we don't want to reset downshift
          var contextWithinDownshift = targetWithinDownshift(event.target, [_this4._rootNode, _this4._menuNode], _this4.props.environment);
          if (!contextWithinDownshift && _this4.getState().isOpen) {
            _this4.reset({
              type: mouseUp
            }, function () {
              return _this4.props.onOuterClick(_this4.getStateAndHelpers());
            });
          }
        };
        // Touching an element in iOS gives focus and hover states, but touching out of
        // the element will remove hover, and persist the focus state, resulting in the
        // blur event not being triggered.
        // this.isTouchMove helps us track whether the user is tapping or swiping on a touch screen.
        // If the user taps outside of Downshift, the component should be reset,
        // but not if the user is swiping
        var onTouchStart = function onTouchStart() {
          _this4.isTouchMove = false;
        };
        var onTouchMove = function onTouchMove() {
          _this4.isTouchMove = true;
        };
        var onTouchEnd = function onTouchEnd(event) {
          var contextWithinDownshift = targetWithinDownshift(event.target, [_this4._rootNode, _this4._menuNode], _this4.props.environment, false);
          if (!_this4.isTouchMove && !contextWithinDownshift && _this4.getState().isOpen) {
            _this4.reset({
              type: touchEnd
            }, function () {
              return _this4.props.onOuterClick(_this4.getStateAndHelpers());
            });
          }
        };
        var environment = this.props.environment;
        environment.addEventListener('mousedown', onMouseDown);
        environment.addEventListener('mouseup', onMouseUp);
        environment.addEventListener('touchstart', onTouchStart);
        environment.addEventListener('touchmove', onTouchMove);
        environment.addEventListener('touchend', onTouchEnd);
        this.cleanup = function () {
          _this4.internalClearTimeouts();
          _this4.updateStatus.cancel();
          environment.removeEventListener('mousedown', onMouseDown);
          environment.removeEventListener('mouseup', onMouseUp);
          environment.removeEventListener('touchstart', onTouchStart);
          environment.removeEventListener('touchmove', onTouchMove);
          environment.removeEventListener('touchend', onTouchEnd);
        };
      }
    };
    _proto.shouldScroll = function shouldScroll(prevState, prevProps) {
      var _ref10 = this.props.highlightedIndex === undefined ? this.getState() : this.props,
        currentHighlightedIndex = _ref10.highlightedIndex;
      var _ref11 = prevProps.highlightedIndex === undefined ? prevState : prevProps,
        prevHighlightedIndex = _ref11.highlightedIndex;
      var scrollWhenOpen = currentHighlightedIndex && this.getState().isOpen && !prevState.isOpen;
      var scrollWhenNavigating = currentHighlightedIndex !== prevHighlightedIndex;
      return scrollWhenOpen || scrollWhenNavigating;
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      if (process.env.NODE_ENV !== 'production') {
        validateControlledUnchanged(this.state, prevProps, this.props);
        /* istanbul ignore if (react-native) */
        if (this.getMenuProps.called && !this.getMenuProps.suppressRefError) {
          validateGetMenuPropsCalledCorrectly(this._menuNode, this.getMenuProps);
        }
      }
      if (isControlledProp(this.props, 'selectedItem') && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) {
        this.internalSetState({
          type: controlledPropUpdatedSelectedItem,
          inputValue: this.props.itemToString(this.props.selectedItem)
        });
      }
      if (!this.avoidScrolling && this.shouldScroll(prevState, prevProps)) {
        this.scrollHighlightedItemIntoView();
      }

      /* istanbul ignore else (react-native) */
      {
        this.updateStatus();
      }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
      this.cleanup(); // avoids memory leak
    };
    _proto.render = function render() {
      var children = unwrapArray$1(this.props.children, noop);
      // because the items are rerendered every time we call the children
      // we clear this out each render and it will be populated again as
      // getItemProps is called.
      this.clearItems();
      // we reset this so we know whether the user calls getRootProps during
      // this render. If they do then we don't need to do anything,
      // if they don't then we need to clone the element they return and
      // apply the props for them.
      this.getRootProps.called = false;
      this.getRootProps.refKey = undefined;
      this.getRootProps.suppressRefError = undefined;
      // we do something similar for getMenuProps
      this.getMenuProps.called = false;
      this.getMenuProps.refKey = undefined;
      this.getMenuProps.suppressRefError = undefined;
      // we do something similar for getLabelProps
      this.getLabelProps.called = false;
      // and something similar for getInputProps
      this.getInputProps.called = false;
      var element = unwrapArray$1(children(this.getStateAndHelpers()));
      if (!element) {
        return null;
      }
      if (this.getRootProps.called || this.props.suppressRefError) {
        if (process.env.NODE_ENV !== 'production' && !this.getRootProps.suppressRefError && !this.props.suppressRefError) {
          validateGetRootPropsCalledCorrectly(element, this.getRootProps);
        }
        return element;
      } else if (isDOMElement(element)) {
        // they didn't apply the root props, but we can clone
        // this and apply the props ourselves
        return /*#__PURE__*/cloneElement(element, this.getRootProps(getElementProps(element)));
      }

      /* istanbul ignore else */
      if (process.env.NODE_ENV !== 'production') {
        // they didn't apply the root props, but they need to
        // otherwise we can't query around the autocomplete

        throw new Error('downshift: If you return a non-DOM element, you must apply the getRootProps function');
      }

      /* istanbul ignore next */
      return undefined;
    };
    return Downshift;
  }(Component);
  Downshift.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: false,
    getA11yStatusMessage: getA11yStatusMessage,
    itemToString: function itemToString(i) {
      if (i == null) {
        return '';
      }
      if (process.env.NODE_ENV !== 'production' && isPlainObject(i) && !i.hasOwnProperty('toString')) {
        // eslint-disable-next-line no-console
        console.warn('downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.', 'The object that was passed:', i);
      }
      return String(i);
    },
    onStateChange: noop,
    onInputValueChange: noop,
    onUserAction: noop,
    onChange: noop,
    onSelect: noop,
    onOuterClick: noop,
    selectedItemChanged: function selectedItemChanged(prevItem, item) {
      return prevItem !== item;
    },
    environment: /* istanbul ignore next (ssr) */
    typeof window === 'undefined' || false ? undefined : window,
    stateReducer: function stateReducer(state, stateToSet) {
      return stateToSet;
    },
    suppressRefError: false,
    scrollIntoView: scrollIntoView
  };
  Downshift.stateChangeTypes = stateChangeTypes$3;
  return Downshift;
}();
process.env.NODE_ENV !== "production" ? Downshift.propTypes = {
  children: PropTypes.func,
  defaultHighlightedIndex: PropTypes.number,
  defaultIsOpen: PropTypes.bool,
  initialHighlightedIndex: PropTypes.number,
  initialSelectedItem: PropTypes.any,
  initialInputValue: PropTypes.string,
  initialIsOpen: PropTypes.bool,
  getA11yStatusMessage: PropTypes.func,
  itemToString: PropTypes.func,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  onStateChange: PropTypes.func,
  onInputValueChange: PropTypes.func,
  onUserAction: PropTypes.func,
  onOuterClick: PropTypes.func,
  selectedItemChanged: PropTypes.func,
  stateReducer: PropTypes.func,
  itemCount: PropTypes.number,
  id: PropTypes.string,
  environment: PropTypes.shape({
    addEventListener: PropTypes.func.isRequired,
    removeEventListener: PropTypes.func.isRequired,
    document: PropTypes.shape({
      createElement: PropTypes.func.isRequired,
      getElementById: PropTypes.func.isRequired,
      activeElement: PropTypes.any.isRequired,
      body: PropTypes.any.isRequired
    }).isRequired,
    Node: PropTypes.func.isRequired
  }),
  suppressRefError: PropTypes.bool,
  scrollIntoView: PropTypes.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: PropTypes.any,
  isOpen: PropTypes.bool,
  inputValue: PropTypes.string,
  highlightedIndex: PropTypes.number,
  labelId: PropTypes.string,
  inputId: PropTypes.string,
  menuId: PropTypes.string,
  getItemId: PropTypes.func
  /* eslint-enable react/no-unused-prop-types */
} : void 0;
var Downshift$1 = Downshift;
function validateGetMenuPropsCalledCorrectly(node, _ref12) {
  var refKey = _ref12.refKey;
  if (!node) {
    // eslint-disable-next-line no-console
    console.error("downshift: The ref prop \"" + refKey + "\" from getMenuProps was not applied correctly on your menu element.");
  }
}
function validateGetRootPropsCalledCorrectly(element, _ref13) {
  var refKey = _ref13.refKey;
  var refKeySpecified = refKey !== 'ref';
  var isComposite = !isDOMElement(element);
  if (isComposite && !refKeySpecified && !reactIsExports.isForwardRef(element)) {
    // eslint-disable-next-line no-console
    console.error('downshift: You returned a non-DOM element. You must specify a refKey in getRootProps');
  } else if (!isComposite && refKeySpecified) {
    // eslint-disable-next-line no-console
    console.error("downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified \"" + refKey + "\"");
  }
  if (!reactIsExports.isForwardRef(element) && !getElementProps(element)[refKey]) {
    // eslint-disable-next-line no-console
    console.error("downshift: You must apply the ref prop \"" + refKey + "\" from getRootProps onto your root element.");
  }
}

var dropdownDefaultStateValues = {
  highlightedIndex: -1,
  isOpen: false,
  selectedItem: null,
  inputValue: ''
};
function callOnChangeProps(action, state, newState) {
  var props = action.props,
    type = action.type;
  var changes = {};
  Object.keys(state).forEach(function (key) {
    invokeOnChangeHandler(key, action, state, newState);
    if (newState[key] !== state[key]) {
      changes[key] = newState[key];
    }
  });
  if (props.onStateChange && Object.keys(changes).length) {
    props.onStateChange(_extends({
      type: type
    }, changes));
  }
}
function invokeOnChangeHandler(key, action, state, newState) {
  var props = action.props,
    type = action.type;
  var handler = "on" + capitalizeString(key) + "Change";
  if (props[handler] && newState[key] !== undefined && newState[key] !== state[key]) {
    props[handler](_extends({
      type: type
    }, newState));
  }
}

/**
 * Default state reducer that returns the changes.
 *
 * @param {Object} s state.
 * @param {Object} a action with changes.
 * @returns {Object} changes.
 */
function stateReducer(s, a) {
  return a.changes;
}

/**
 * Debounced call for updating the a11y message.
 */
var updateA11yStatus = debounce$1(function (status, document) {
  setStatus(status, document);
}, 200);

// istanbul ignore next
var useIsomorphicLayoutEffect$1 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect : useEffect;

// istanbul ignore next
var useElementIds = 'useId' in React__default // Avoid conditional useId call
? function useElementIds(_ref) {
  var id = _ref.id,
    labelId = _ref.labelId,
    menuId = _ref.menuId,
    getItemId = _ref.getItemId,
    toggleButtonId = _ref.toggleButtonId,
    inputId = _ref.inputId;
  // Avoid conditional useId call
  var reactId = "downshift-" + React__default.useId();
  if (!id) {
    id = reactId;
  }
  var elementIdsRef = useRef({
    labelId: labelId || id + "-label",
    menuId: menuId || id + "-menu",
    getItemId: getItemId || function (index) {
      return id + "-item-" + index;
    },
    toggleButtonId: toggleButtonId || id + "-toggle-button",
    inputId: inputId || id + "-input"
  });
  return elementIdsRef.current;
} : function useElementIds(_ref2) {
  var _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? "downshift-" + generateId() : _ref2$id,
    labelId = _ref2.labelId,
    menuId = _ref2.menuId,
    getItemId = _ref2.getItemId,
    toggleButtonId = _ref2.toggleButtonId,
    inputId = _ref2.inputId;
  var elementIdsRef = useRef({
    labelId: labelId || id + "-label",
    menuId: menuId || id + "-menu",
    getItemId: getItemId || function (index) {
      return id + "-item-" + index;
    },
    toggleButtonId: toggleButtonId || id + "-toggle-button",
    inputId: inputId || id + "-input"
  });
  return elementIdsRef.current;
};
function getItemAndIndex(itemProp, indexProp, items, errorMessage) {
  var item, index;
  if (itemProp === undefined) {
    if (indexProp === undefined) {
      throw new Error(errorMessage);
    }
    item = items[indexProp];
    index = indexProp;
  } else {
    index = indexProp === undefined ? items.indexOf(itemProp) : indexProp;
    item = itemProp;
  }
  return [item, index];
}
function isAcceptedCharacterKey(key) {
  return /^\S{1}$/.test(key);
}
function capitalizeString(string) {
  return "" + string.slice(0, 1).toUpperCase() + string.slice(1);
}
function useLatestRef(val) {
  var ref = useRef(val);
  // technically this is not "concurrent mode safe" because we're manipulating
  // the value during render (so it's not idempotent). However, the places this
  // hook is used is to support memoizing callbacks which will be called
  // *during* render, so we need the latest values *during* render.
  // If not for this, then we'd probably want to use useLayoutEffect instead.
  ref.current = val;
  return ref;
}

/**
 * Computes the controlled state using a the previous state, props,
 * two reducers, one from downshift and an optional one from the user.
 * Also calls the onChange handlers for state values that have changed.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} props The hook props, also passed to createInitialState.
 * @param {Function} createInitialState Function that returns the initial state.
 * @param {Function} isStateEqual Function that checks if a previous state is equal to the next.
 * @returns {Array} An array with the state and an action dispatcher.
 */
function useEnhancedReducer(reducer, props, createInitialState, isStateEqual) {
  var prevStateRef = useRef();
  var actionRef = useRef();
  var enhancedReducer = useCallback(function (state, action) {
    actionRef.current = action;
    state = getState(state, action.props);
    var changes = reducer(state, action);
    var newState = action.props.stateReducer(state, _extends({}, action, {
      changes: changes
    }));
    return newState;
  }, [reducer]);
  var _useReducer = useReducer(enhancedReducer, props, createInitialState),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  var propsRef = useLatestRef(props);
  var dispatchWithProps = useCallback(function (action) {
    return dispatch(_extends({
      props: propsRef.current
    }, action));
  }, [propsRef]);
  var action = actionRef.current;
  useEffect(function () {
    var prevState = getState(prevStateRef.current, action == null ? void 0 : action.props);
    var shouldCallOnChangeProps = action && prevStateRef.current && !isStateEqual(prevState, state);
    if (shouldCallOnChangeProps) {
      callOnChangeProps(action, prevState, state);
    }
    prevStateRef.current = state;
  }, [state, action, isStateEqual]);
  return [state, dispatchWithProps];
}

/**
 * Wraps the useEnhancedReducer and applies the controlled prop values before
 * returning the new state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} props The hook props, also passed to createInitialState.
 * @param {Function} createInitialState Function that returns the initial state.
 * @param {Function} isStateEqual Function that checks if a previous state is equal to the next.
 * @returns {Array} An array with the state and an action dispatcher.
 */
function useControlledReducer$1(reducer, props, createInitialState, isStateEqual) {
  var _useEnhancedReducer = useEnhancedReducer(reducer, props, createInitialState, isStateEqual),
    state = _useEnhancedReducer[0],
    dispatch = _useEnhancedReducer[1];
  return [getState(state, props), dispatch];
}
var defaultProps$3 = {
  itemToString: function itemToString(item) {
    return item ? String(item) : '';
  },
  itemToKey: function itemToKey(item) {
    return item;
  },
  stateReducer: stateReducer,
  scrollIntoView: scrollIntoView,
  environment: /* istanbul ignore next (ssr) */
  typeof window === 'undefined' || false ? undefined : window
};
function getDefaultValue$1(props, propKey, defaultStateValues) {
  if (defaultStateValues === void 0) {
    defaultStateValues = dropdownDefaultStateValues;
  }
  var defaultValue = props["default" + capitalizeString(propKey)];
  if (defaultValue !== undefined) {
    return defaultValue;
  }
  return defaultStateValues[propKey];
}
function getInitialValue$1(props, propKey, defaultStateValues) {
  if (defaultStateValues === void 0) {
    defaultStateValues = dropdownDefaultStateValues;
  }
  var value = props[propKey];
  if (value !== undefined) {
    return value;
  }
  var initialValue = props["initial" + capitalizeString(propKey)];
  if (initialValue !== undefined) {
    return initialValue;
  }
  return getDefaultValue$1(props, propKey, defaultStateValues);
}
function getInitialState$2(props) {
  var selectedItem = getInitialValue$1(props, 'selectedItem');
  var isOpen = getInitialValue$1(props, 'isOpen');
  var highlightedIndex = getInitialHighlightedIndex(props);
  var inputValue = getInitialValue$1(props, 'inputValue');
  return {
    highlightedIndex: highlightedIndex < 0 && selectedItem && isOpen ? props.items.findIndex(function (item) {
      return props.itemToKey(item) === props.itemToKey(selectedItem);
    }) : highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}
function getHighlightedIndexOnOpen(props, state, offset) {
  var items = props.items,
    initialHighlightedIndex = props.initialHighlightedIndex,
    defaultHighlightedIndex = props.defaultHighlightedIndex,
    isItemDisabled = props.isItemDisabled,
    itemToKey = props.itemToKey;
  var selectedItem = state.selectedItem,
    highlightedIndex = state.highlightedIndex;
  if (items.length === 0) {
    return -1;
  }

  // initialHighlightedIndex will give value to highlightedIndex on initial state only.
  if (initialHighlightedIndex !== undefined && highlightedIndex === initialHighlightedIndex && !isItemDisabled(items[initialHighlightedIndex], initialHighlightedIndex)) {
    return initialHighlightedIndex;
  }
  if (defaultHighlightedIndex !== undefined && !isItemDisabled(items[defaultHighlightedIndex], defaultHighlightedIndex)) {
    return defaultHighlightedIndex;
  }
  if (selectedItem) {
    return items.findIndex(function (item) {
      return itemToKey(selectedItem) === itemToKey(item);
    });
  }
  if (offset < 0 && !isItemDisabled(items[items.length - 1], items.length - 1)) {
    return items.length - 1;
  }
  if (offset > 0 && !isItemDisabled(items[0], 0)) {
    return 0;
  }
  return -1;
}
/**
 * Tracks mouse and touch events, such as mouseDown, touchMove and touchEnd.
 *
 * @param {Object} environment The environment to add the event listeners to, for instance window.
 * @param {Array<HTMLElement>} downshiftElementRefs The refs for the element that should not trigger a blur action from mouseDown or touchEnd.
 * @param {Function} handleBlur The function that is called if mouseDown or touchEnd occured outside the downshiftElements.
 * @returns {Object} The mouse and touch events information, if any of are happening.
 */
function useMouseAndTouchTracker(environment, downshiftElementRefs, handleBlur) {
  var mouseAndTouchTrackersRef = useRef({
    isMouseDown: false,
    isTouchMove: false,
    isTouchEnd: false
  });
  useEffect(function () {
    if (!environment) {
      return noop;
    }
    var downshiftElements = downshiftElementRefs.map(function (ref) {
      return ref.current;
    });
    function onMouseDown() {
      mouseAndTouchTrackersRef.current.isTouchEnd = false; // reset this one.
      mouseAndTouchTrackersRef.current.isMouseDown = true;
    }
    function onMouseUp(event) {
      mouseAndTouchTrackersRef.current.isMouseDown = false;
      if (!targetWithinDownshift(event.target, downshiftElements, environment)) {
        handleBlur();
      }
    }
    function onTouchStart() {
      mouseAndTouchTrackersRef.current.isTouchEnd = false;
      mouseAndTouchTrackersRef.current.isTouchMove = false;
    }
    function onTouchMove() {
      mouseAndTouchTrackersRef.current.isTouchMove = true;
    }
    function onTouchEnd(event) {
      mouseAndTouchTrackersRef.current.isTouchEnd = true;
      if (!mouseAndTouchTrackersRef.current.isTouchMove && !targetWithinDownshift(event.target, downshiftElements, environment, false)) {
        handleBlur();
      }
    }
    environment.addEventListener('mousedown', onMouseDown);
    environment.addEventListener('mouseup', onMouseUp);
    environment.addEventListener('touchstart', onTouchStart);
    environment.addEventListener('touchmove', onTouchMove);
    environment.addEventListener('touchend', onTouchEnd);
    return function cleanup() {
      environment.removeEventListener('mousedown', onMouseDown);
      environment.removeEventListener('mouseup', onMouseUp);
      environment.removeEventListener('touchstart', onTouchStart);
      environment.removeEventListener('touchmove', onTouchMove);
      environment.removeEventListener('touchend', onTouchEnd);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- refs don't change
  }, [environment, handleBlur]);
  return mouseAndTouchTrackersRef.current;
}

/* istanbul ignore next */
// eslint-disable-next-line import/no-mutable-exports
var useGetterPropsCalledChecker = function useGetterPropsCalledChecker() {
  return noop;
};
/**
 * Custom hook that checks if getter props are called correctly.
 *
 * @param  {...any} propKeys Getter prop names to be handled.
 * @returns {Function} Setter function called inside getter props to set call information.
 */
/* istanbul ignore next */
if (process.env.NODE_ENV !== 'production') {
  useGetterPropsCalledChecker = function useGetterPropsCalledChecker() {
    var isInitialMountRef = useRef(true);
    for (var _len = arguments.length, propKeys = new Array(_len), _key = 0; _key < _len; _key++) {
      propKeys[_key] = arguments[_key];
    }
    var getterPropsCalledRef = useRef(propKeys.reduce(function (acc, propKey) {
      acc[propKey] = {};
      return acc;
    }, {}));
    useEffect(function () {
      Object.keys(getterPropsCalledRef.current).forEach(function (propKey) {
        var propCallInfo = getterPropsCalledRef.current[propKey];
        if (isInitialMountRef.current) {
          if (!Object.keys(propCallInfo).length) {
            // eslint-disable-next-line no-console
            console.error("downshift: You forgot to call the " + propKey + " getter function on your component / element.");
            return;
          }
        }
        var suppressRefError = propCallInfo.suppressRefError,
          refKey = propCallInfo.refKey,
          elementRef = propCallInfo.elementRef;
        if ((!elementRef || !elementRef.current) && !suppressRefError) {
          // eslint-disable-next-line no-console
          console.error("downshift: The ref prop \"" + refKey + "\" from " + propKey + " was not applied correctly on your element.");
        }
      });
      isInitialMountRef.current = false;
    });
    var setGetterPropCallInfo = useCallback(function (propKey, suppressRefError, refKey, elementRef) {
      getterPropsCalledRef.current[propKey] = {
        suppressRefError: suppressRefError,
        refKey: refKey,
        elementRef: elementRef
      };
    }, []);
    return setGetterPropCallInfo;
  };
}

/**
 * Adds an a11y aria live status message if getA11yStatusMessage is passed.
 * @param {(options: Object) => string} getA11yStatusMessage The function that builds the status message.
 * @param {Object} options The options to be passed to getA11yStatusMessage if called.
 * @param {Array<unknown>} dependencyArray The dependency array that triggers the status message setter via useEffect.
 * @param {{document: Document}} environment The environment object containing the document.
 */
function useA11yMessageStatus(getA11yStatusMessage, options, dependencyArray, environment) {
  if (environment === void 0) {
    environment = {};
  }
  var document = environment.document;
  var isInitialMount = useIsInitialMount();

  // Adds an a11y aria live status message if getA11yStatusMessage is passed.
  useEffect(function () {
    if (!getA11yStatusMessage || isInitialMount || false || !document) {
      return;
    }
    var status = getA11yStatusMessage(options);
    updateA11yStatus(status, document);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencyArray);

  // Cleanup the status message container.
  useEffect(function () {
    return function () {
      updateA11yStatus.cancel();
      cleanupStatusDiv(document);
    };
  }, [document]);
}
function useScrollIntoView(_ref3) {
  var highlightedIndex = _ref3.highlightedIndex,
    isOpen = _ref3.isOpen,
    itemRefs = _ref3.itemRefs,
    getItemNodeFromIndex = _ref3.getItemNodeFromIndex,
    menuElement = _ref3.menuElement,
    scrollIntoViewProp = _ref3.scrollIntoView;
  // used not to scroll on highlight by mouse.
  var shouldScrollRef = useRef(true);
  // Scroll on highlighted item if change comes from keyboard.
  useIsomorphicLayoutEffect$1(function () {
    if (highlightedIndex < 0 || !isOpen || !Object.keys(itemRefs.current).length) {
      return;
    }
    if (shouldScrollRef.current === false) {
      shouldScrollRef.current = true;
    } else {
      scrollIntoViewProp(getItemNodeFromIndex(highlightedIndex), menuElement);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [highlightedIndex]);
  return shouldScrollRef;
}

// eslint-disable-next-line import/no-mutable-exports
var useControlPropsValidator = noop;
/* istanbul ignore next */
if (process.env.NODE_ENV !== 'production') {
  useControlPropsValidator = function useControlPropsValidator(_ref4) {
    var props = _ref4.props,
      state = _ref4.state;
    // used for checking when props are moving from controlled to uncontrolled.
    var prevPropsRef = useRef(props);
    var isInitialMount = useIsInitialMount();
    useEffect(function () {
      if (isInitialMount) {
        return;
      }
      validateControlledUnchanged(state, prevPropsRef.current, props);
      prevPropsRef.current = props;
    }, [state, props, isInitialMount]);
  };
}

/**
 * Handles selection on Enter / Alt + ArrowUp. Closes the menu and resets the highlighted index, unless there is a highlighted.
 * In that case, selects the item and resets to defaults for open state and highlighted idex.
 * @param {Object} props The useCombobox props.
 * @param {number} highlightedIndex The index from the state.
 * @param {boolean} inputValue Also return the input value for state.
 * @returns The changes for the state.
 */
function getChangesOnSelection(props, highlightedIndex, inputValue) {
  var _props$items;
  if (inputValue === void 0) {
    inputValue = true;
  }
  var shouldSelect = ((_props$items = props.items) == null ? void 0 : _props$items.length) && highlightedIndex >= 0;
  return _extends({
    isOpen: false,
    highlightedIndex: -1
  }, shouldSelect && _extends({
    selectedItem: props.items[highlightedIndex],
    isOpen: getDefaultValue$1(props, 'isOpen'),
    highlightedIndex: getDefaultValue$1(props, 'highlightedIndex')
  }, inputValue && {
    inputValue: props.itemToString(props.items[highlightedIndex])
  }));
}

/**
 * Check if a state is equal for dropdowns, by comparing isOpen, inputValue, highlightedIndex and selected item.
 * Used by useSelect and useCombobox.
 *
 * @param {Object} prevState
 * @param {Object} newState
 * @returns {boolean} Wheather the states are deeply equal.
 */
function isDropdownsStateEqual(prevState, newState) {
  return prevState.isOpen === newState.isOpen && prevState.inputValue === newState.inputValue && prevState.highlightedIndex === newState.highlightedIndex && prevState.selectedItem === newState.selectedItem;
}

/**
 * Tracks if it's the first render.
 */
function useIsInitialMount() {
  var isInitialMountRef = React__default.useRef(true);
  React__default.useEffect(function () {
    isInitialMountRef.current = false;
    return function () {
      isInitialMountRef.current = true;
    };
  }, []);
  return isInitialMountRef.current;
}

/**
 * Returns the new highlightedIndex based on the defaultHighlightedIndex prop, if it's not disabled.
 *
 * @param {Object} props Props from useCombobox or useSelect.
 * @returns {number} The highlighted index.
 */
function getDefaultHighlightedIndex(props) {
  var highlightedIndex = getDefaultValue$1(props, 'highlightedIndex');
  if (highlightedIndex > -1 && props.isItemDisabled(props.items[highlightedIndex], highlightedIndex)) {
    return -1;
  }
  return highlightedIndex;
}

/**
 * Returns the new highlightedIndex based on the initialHighlightedIndex prop, if not disabled.
 *
 * @param {Object} props Props from useCombobox or useSelect.
 * @returns {number} The highlighted index.
 */
function getInitialHighlightedIndex(props) {
  var highlightedIndex = getInitialValue$1(props, 'highlightedIndex');
  if (highlightedIndex > -1 && props.isItemDisabled(props.items[highlightedIndex], highlightedIndex)) {
    return -1;
  }
  return highlightedIndex;
}

// Shared between all exports.
var commonPropTypes = {
  environment: PropTypes.shape({
    addEventListener: PropTypes.func.isRequired,
    removeEventListener: PropTypes.func.isRequired,
    document: PropTypes.shape({
      createElement: PropTypes.func.isRequired,
      getElementById: PropTypes.func.isRequired,
      activeElement: PropTypes.any.isRequired,
      body: PropTypes.any.isRequired
    }).isRequired,
    Node: PropTypes.func.isRequired
  }),
  itemToString: PropTypes.func,
  itemToKey: PropTypes.func,
  stateReducer: PropTypes.func
};

// Shared between useSelect, useCombobox, Downshift.
var commonDropdownPropTypes = _extends({}, commonPropTypes, {
  getA11yStatusMessage: PropTypes.func,
  highlightedIndex: PropTypes.number,
  defaultHighlightedIndex: PropTypes.number,
  initialHighlightedIndex: PropTypes.number,
  isOpen: PropTypes.bool,
  defaultIsOpen: PropTypes.bool,
  initialIsOpen: PropTypes.bool,
  selectedItem: PropTypes.any,
  initialSelectedItem: PropTypes.any,
  defaultSelectedItem: PropTypes.any,
  id: PropTypes.string,
  labelId: PropTypes.string,
  menuId: PropTypes.string,
  getItemId: PropTypes.func,
  toggleButtonId: PropTypes.string,
  onSelectedItemChange: PropTypes.func,
  onHighlightedIndexChange: PropTypes.func,
  onStateChange: PropTypes.func,
  onIsOpenChange: PropTypes.func,
  scrollIntoView: PropTypes.func
});

function downshiftCommonReducer(state, action, stateChangeTypes) {
  var type = action.type,
    props = action.props;
  var changes;
  switch (type) {
    case stateChangeTypes.ItemMouseMove:
      changes = {
        highlightedIndex: action.disabled ? -1 : action.index
      };
      break;
    case stateChangeTypes.MenuMouseLeave:
      changes = {
        highlightedIndex: -1
      };
      break;
    case stateChangeTypes.ToggleButtonClick:
    case stateChangeTypes.FunctionToggleMenu:
      changes = {
        isOpen: !state.isOpen,
        highlightedIndex: state.isOpen ? -1 : getHighlightedIndexOnOpen(props, state, 0)
      };
      break;
    case stateChangeTypes.FunctionOpenMenu:
      changes = {
        isOpen: true,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 0)
      };
      break;
    case stateChangeTypes.FunctionCloseMenu:
      changes = {
        isOpen: false
      };
      break;
    case stateChangeTypes.FunctionSetHighlightedIndex:
      changes = {
        highlightedIndex: props.isItemDisabled(props.items[action.highlightedIndex], action.highlightedIndex) ? -1 : action.highlightedIndex
      };
      break;
    case stateChangeTypes.FunctionSetInputValue:
      changes = {
        inputValue: action.inputValue
      };
      break;
    case stateChangeTypes.FunctionReset:
      changes = {
        highlightedIndex: getDefaultHighlightedIndex(props),
        isOpen: getDefaultValue$1(props, 'isOpen'),
        selectedItem: getDefaultValue$1(props, 'selectedItem'),
        inputValue: getDefaultValue$1(props, 'inputValue')
      };
      break;
    default:
      throw new Error('Reducer called without proper action type.');
  }
  return _extends({}, state, changes);
}
/* eslint-enable complexity */

function getItemIndexByCharacterKey(_a) {
    var keysSoFar = _a.keysSoFar, highlightedIndex = _a.highlightedIndex, items = _a.items, itemToString = _a.itemToString, isItemDisabled = _a.isItemDisabled;
    var lowerCasedKeysSoFar = keysSoFar.toLowerCase();
    for (var index = 0; index < items.length; index++) {
        // if we already have a search query in progress, we also consider the current highlighted item.
        var offsetIndex = (index + highlightedIndex + (keysSoFar.length < 2 ? 1 : 0)) % items.length;
        var item = items[offsetIndex];
        if (item !== undefined &&
            itemToString(item).toLowerCase().startsWith(lowerCasedKeysSoFar) &&
            !isItemDisabled(item, offsetIndex)) {
            return offsetIndex;
        }
    }
    return highlightedIndex;
}
var propTypes$2 = __assign(__assign({}, commonDropdownPropTypes), { items: PropTypes.array.isRequired, isItemDisabled: PropTypes.func });
var defaultProps$2 = __assign(__assign({}, defaultProps$3), { isItemDisabled: function () {
        return false;
    } });
// eslint-disable-next-line import/no-mutable-exports
var validatePropTypes$2 = noop;
/* istanbul ignore next */
if (process.env.NODE_ENV !== 'production') {
    validatePropTypes$2 = function (options, caller) {
        PropTypes.checkPropTypes(propTypes$2, options, 'prop', caller.name);
    };
}

var ToggleButtonClick$1 = process.env.NODE_ENV !== "production" ? '__togglebutton_click__' : 0;
var ToggleButtonKeyDownArrowDown = process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_arrow_down__' : 1;
var ToggleButtonKeyDownArrowUp = process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_arrow_up__' : 2;
var ToggleButtonKeyDownCharacter = process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_character__' : 3;
var ToggleButtonKeyDownEscape = process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_escape__' : 4;
var ToggleButtonKeyDownHome = process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_home__' : 5;
var ToggleButtonKeyDownEnd = process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_end__' : 6;
var ToggleButtonKeyDownEnter = process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_enter__' : 7;
var ToggleButtonKeyDownSpaceButton = process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_space_button__' : 8;
var ToggleButtonKeyDownPageUp = process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_page_up__' : 9;
var ToggleButtonKeyDownPageDown = process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_page_down__' : 10;
var ToggleButtonBlur = process.env.NODE_ENV !== "production" ? '__togglebutton_blur__' : 11;
var MenuMouseLeave$1 = process.env.NODE_ENV !== "production" ? '__menu_mouse_leave__' : 12;
var ItemMouseMove$1 = process.env.NODE_ENV !== "production" ? '__item_mouse_move__' : 13;
var ItemClick$1 = process.env.NODE_ENV !== "production" ? '__item_click__' : 14;
var FunctionToggleMenu$1 = process.env.NODE_ENV !== "production" ? '__function_toggle_menu__' : 15;
var FunctionOpenMenu$1 = process.env.NODE_ENV !== "production" ? '__function_open_menu__' : 16;
var FunctionCloseMenu$1 = process.env.NODE_ENV !== "production" ? '__function_close_menu__' : 17;
var FunctionSetHighlightedIndex$1 = process.env.NODE_ENV !== "production" ? '__function_set_highlighted_index__' : 18;
var FunctionSelectItem$1 = process.env.NODE_ENV !== "production" ? '__function_select_item__' : 19;
var FunctionSetInputValue$1 = process.env.NODE_ENV !== "production" ? '__function_set_input_value__' : 20;
var FunctionReset$2 = process.env.NODE_ENV !== "production" ? '__function_reset__' : 21;

var stateChangeTypes$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FunctionCloseMenu: FunctionCloseMenu$1,
  FunctionOpenMenu: FunctionOpenMenu$1,
  FunctionReset: FunctionReset$2,
  FunctionSelectItem: FunctionSelectItem$1,
  FunctionSetHighlightedIndex: FunctionSetHighlightedIndex$1,
  FunctionSetInputValue: FunctionSetInputValue$1,
  FunctionToggleMenu: FunctionToggleMenu$1,
  ItemClick: ItemClick$1,
  ItemMouseMove: ItemMouseMove$1,
  MenuMouseLeave: MenuMouseLeave$1,
  ToggleButtonBlur: ToggleButtonBlur,
  ToggleButtonClick: ToggleButtonClick$1,
  ToggleButtonKeyDownArrowDown: ToggleButtonKeyDownArrowDown,
  ToggleButtonKeyDownArrowUp: ToggleButtonKeyDownArrowUp,
  ToggleButtonKeyDownCharacter: ToggleButtonKeyDownCharacter,
  ToggleButtonKeyDownEnd: ToggleButtonKeyDownEnd,
  ToggleButtonKeyDownEnter: ToggleButtonKeyDownEnter,
  ToggleButtonKeyDownEscape: ToggleButtonKeyDownEscape,
  ToggleButtonKeyDownHome: ToggleButtonKeyDownHome,
  ToggleButtonKeyDownPageDown: ToggleButtonKeyDownPageDown,
  ToggleButtonKeyDownPageUp: ToggleButtonKeyDownPageUp,
  ToggleButtonKeyDownSpaceButton: ToggleButtonKeyDownSpaceButton
});

/* eslint-disable complexity */
function downshiftSelectReducer(state, action) {
  var _props$items;
  var type = action.type,
    props = action.props,
    altKey = action.altKey;
  var changes;
  switch (type) {
    case ItemClick$1:
      changes = {
        isOpen: getDefaultValue$1(props, 'isOpen'),
        highlightedIndex: getDefaultHighlightedIndex(props),
        selectedItem: props.items[action.index]
      };
      break;
    case ToggleButtonKeyDownCharacter:
      {
        var lowercasedKey = action.key;
        var inputValue = "" + state.inputValue + lowercasedKey;
        var prevHighlightedIndex = !state.isOpen && state.selectedItem ? props.items.findIndex(function (item) {
          return props.itemToKey(item) === props.itemToKey(state.selectedItem);
        }) : state.highlightedIndex;
        var highlightedIndex = getItemIndexByCharacterKey({
          keysSoFar: inputValue,
          highlightedIndex: prevHighlightedIndex,
          items: props.items,
          itemToString: props.itemToString,
          isItemDisabled: props.isItemDisabled
        });
        changes = {
          inputValue: inputValue,
          highlightedIndex: highlightedIndex,
          isOpen: true
        };
      }
      break;
    case ToggleButtonKeyDownArrowDown:
      {
        var _highlightedIndex = state.isOpen ? getHighlightedIndex(state.highlightedIndex, 1, props.items, props.isItemDisabled) : altKey && state.selectedItem == null ? -1 : getHighlightedIndexOnOpen(props, state, 1);
        changes = {
          highlightedIndex: _highlightedIndex,
          isOpen: true
        };
      }
      break;
    case ToggleButtonKeyDownArrowUp:
      if (state.isOpen && altKey) {
        changes = getChangesOnSelection(props, state.highlightedIndex, false);
      } else {
        var _highlightedIndex2 = state.isOpen ? getHighlightedIndex(state.highlightedIndex, -1, props.items, props.isItemDisabled) : getHighlightedIndexOnOpen(props, state, -1);
        changes = {
          highlightedIndex: _highlightedIndex2,
          isOpen: true
        };
      }
      break;
    // only triggered when menu is open.
    case ToggleButtonKeyDownEnter:
    case ToggleButtonKeyDownSpaceButton:
      changes = getChangesOnSelection(props, state.highlightedIndex, false);
      break;
    case ToggleButtonKeyDownHome:
      changes = {
        highlightedIndex: getNonDisabledIndex(0, false, props.items, props.isItemDisabled),
        isOpen: true
      };
      break;
    case ToggleButtonKeyDownEnd:
      changes = {
        highlightedIndex: getNonDisabledIndex(props.items.length - 1, true, props.items, props.isItemDisabled),
        isOpen: true
      };
      break;
    case ToggleButtonKeyDownPageUp:
      changes = {
        highlightedIndex: getHighlightedIndex(state.highlightedIndex, -10, props.items, props.isItemDisabled)
      };
      break;
    case ToggleButtonKeyDownPageDown:
      changes = {
        highlightedIndex: getHighlightedIndex(state.highlightedIndex, 10, props.items, props.isItemDisabled)
      };
      break;
    case ToggleButtonKeyDownEscape:
      changes = {
        isOpen: false,
        highlightedIndex: -1
      };
      break;
    case ToggleButtonBlur:
      changes = _extends({
        isOpen: false,
        highlightedIndex: -1
      }, state.highlightedIndex >= 0 && ((_props$items = props.items) == null ? void 0 : _props$items.length) && {
        selectedItem: props.items[state.highlightedIndex]
      });
      break;
    case FunctionSelectItem$1:
      changes = {
        selectedItem: action.selectedItem
      };
      break;
    default:
      return downshiftCommonReducer(state, action, stateChangeTypes$2);
  }
  return _extends({}, state, changes);
}
/* eslint-enable complexity */

var _excluded$2 = ["onClick"],
  _excluded2$2 = ["onMouseLeave", "refKey", "ref"],
  _excluded3$1 = ["onBlur", "onClick", "onPress", "onKeyDown", "refKey", "ref"],
  _excluded4$1 = ["item", "index", "onMouseMove", "onClick", "onMouseDown", "onPress", "refKey", "disabled", "ref"];
useSelect.stateChangeTypes = stateChangeTypes$2;
function useSelect(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }
  validatePropTypes$2(userProps, useSelect);
  // Props defaults and destructuring.
  var props = _extends({}, defaultProps$2, userProps);
  var scrollIntoView = props.scrollIntoView,
    environment = props.environment,
    getA11yStatusMessage = props.getA11yStatusMessage;
  // Initial state depending on controlled props.
  var _useControlledReducer = useControlledReducer$1(downshiftSelectReducer, props, getInitialState$2, isDropdownsStateEqual),
    state = _useControlledReducer[0],
    dispatch = _useControlledReducer[1];
  var isOpen = state.isOpen,
    highlightedIndex = state.highlightedIndex,
    selectedItem = state.selectedItem,
    inputValue = state.inputValue;
  // Element efs.
  var toggleButtonRef = useRef(null);
  var menuRef = useRef(null);
  var itemRefs = useRef({});
  // used to keep the inputValue clearTimeout object between renders.
  var clearTimeoutRef = useRef(null);
  // prevent id re-generation between renders.
  var elementIds = useElementIds(props);
  // utility callback to get item element.
  var latest = useLatestRef({
    state: state,
    props: props
  });

  // Some utils.
  var getItemNodeFromIndex = useCallback(function (index) {
    return itemRefs.current[elementIds.getItemId(index)];
  }, [elementIds]);

  // Effects.
  // Adds an a11y aria live status message if getA11yStatusMessage is passed.
  useA11yMessageStatus(getA11yStatusMessage, state, [isOpen, highlightedIndex, selectedItem, inputValue], environment);
  // Scroll on highlighted item if change comes from keyboard.
  var shouldScrollRef = useScrollIntoView({
    menuElement: menuRef.current,
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    itemRefs: itemRefs,
    scrollIntoView: scrollIntoView,
    getItemNodeFromIndex: getItemNodeFromIndex
  });
  // Sets cleanup for the keysSoFar callback, debounded after 500ms.
  useEffect(function () {
    // init the clean function here as we need access to dispatch.
    clearTimeoutRef.current = debounce$1(function (outerDispatch) {
      outerDispatch({
        type: FunctionSetInputValue$1,
        inputValue: ''
      });
    }, 500);

    // Cancel any pending debounced calls on mount
    return function () {
      clearTimeoutRef.current.cancel();
    };
  }, []);
  // Invokes the keysSoFar callback set up above.
  useEffect(function () {
    if (!inputValue) {
      return;
    }
    clearTimeoutRef.current(dispatch);
  }, [dispatch, inputValue]);
  useControlPropsValidator({
    props: props,
    state: state
  });
  // Focus the toggle button on first render if required.
  useEffect(function () {
    var focusOnOpen = getInitialValue$1(props, 'isOpen');
    if (focusOnOpen && toggleButtonRef.current) {
      toggleButtonRef.current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var mouseAndTouchTrackers = useMouseAndTouchTracker(environment, [toggleButtonRef, menuRef], useCallback(function handleBlur() {
    if (latest.current.state.isOpen) {
      dispatch({
        type: ToggleButtonBlur
      });
    }
  }, [dispatch, latest]));
  var setGetterPropCallInfo = useGetterPropsCalledChecker('getMenuProps', 'getToggleButtonProps');
  // Reset itemRefs on close.
  useEffect(function () {
    if (!isOpen) {
      itemRefs.current = {};
    }
  }, [isOpen]);

  // Event handler functions.
  var toggleButtonKeyDownHandlers = useMemo(function () {
    return {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        dispatch({
          type: ToggleButtonKeyDownArrowDown,
          altKey: event.altKey
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        dispatch({
          type: ToggleButtonKeyDownArrowUp,
          altKey: event.altKey
        });
      },
      Home: function Home(event) {
        event.preventDefault();
        dispatch({
          type: ToggleButtonKeyDownHome
        });
      },
      End: function End(event) {
        event.preventDefault();
        dispatch({
          type: ToggleButtonKeyDownEnd
        });
      },
      Escape: function Escape() {
        if (latest.current.state.isOpen) {
          dispatch({
            type: ToggleButtonKeyDownEscape
          });
        }
      },
      Enter: function Enter(event) {
        event.preventDefault();
        dispatch({
          type: latest.current.state.isOpen ? ToggleButtonKeyDownEnter : ToggleButtonClick$1
        });
      },
      PageUp: function PageUp(event) {
        if (latest.current.state.isOpen) {
          event.preventDefault();
          dispatch({
            type: ToggleButtonKeyDownPageUp
          });
        }
      },
      PageDown: function PageDown(event) {
        if (latest.current.state.isOpen) {
          event.preventDefault();
          dispatch({
            type: ToggleButtonKeyDownPageDown
          });
        }
      },
      ' ': function _(event) {
        event.preventDefault();
        var currentState = latest.current.state;
        if (!currentState.isOpen) {
          dispatch({
            type: ToggleButtonClick$1
          });
          return;
        }
        if (currentState.inputValue) {
          dispatch({
            type: ToggleButtonKeyDownCharacter,
            key: ' '
          });
        } else {
          dispatch({
            type: ToggleButtonKeyDownSpaceButton
          });
        }
      }
    };
  }, [dispatch, latest]);

  // Action functions.
  var toggleMenu = useCallback(function () {
    dispatch({
      type: FunctionToggleMenu$1
    });
  }, [dispatch]);
  var closeMenu = useCallback(function () {
    dispatch({
      type: FunctionCloseMenu$1
    });
  }, [dispatch]);
  var openMenu = useCallback(function () {
    dispatch({
      type: FunctionOpenMenu$1
    });
  }, [dispatch]);
  var setHighlightedIndex = useCallback(function (newHighlightedIndex) {
    dispatch({
      type: FunctionSetHighlightedIndex$1,
      highlightedIndex: newHighlightedIndex
    });
  }, [dispatch]);
  var selectItem = useCallback(function (newSelectedItem) {
    dispatch({
      type: FunctionSelectItem$1,
      selectedItem: newSelectedItem
    });
  }, [dispatch]);
  var reset = useCallback(function () {
    dispatch({
      type: FunctionReset$2
    });
  }, [dispatch]);
  var setInputValue = useCallback(function (newInputValue) {
    dispatch({
      type: FunctionSetInputValue$1,
      inputValue: newInputValue
    });
  }, [dispatch]);
  // Getter functions.
  var getLabelProps = useCallback(function (_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
      onClick = _ref.onClick,
      labelProps = _objectWithoutPropertiesLoose(_ref, _excluded$2);
    var labelHandleClick = function labelHandleClick() {
      var _toggleButtonRef$curr;
      (_toggleButtonRef$curr = toggleButtonRef.current) == null || _toggleButtonRef$curr.focus();
    };
    return _extends({
      id: elementIds.labelId,
      htmlFor: elementIds.toggleButtonId,
      onClick: callAllEventHandlers(onClick, labelHandleClick)
    }, labelProps);
  }, [elementIds]);
  var getMenuProps = useCallback(function (_temp2, _temp3) {
    var _extends2;
    var _ref2 = _temp2 === void 0 ? {} : _temp2,
      onMouseLeave = _ref2.onMouseLeave,
      _ref2$refKey = _ref2.refKey,
      refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey,
      ref = _ref2.ref,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2$2);
    var _ref3 = _temp3 === void 0 ? {} : _temp3,
      _ref3$suppressRefErro = _ref3.suppressRefError,
      suppressRefError = _ref3$suppressRefErro === void 0 ? false : _ref3$suppressRefErro;
    var menuHandleMouseLeave = function menuHandleMouseLeave() {
      dispatch({
        type: MenuMouseLeave$1
      });
    };
    setGetterPropCallInfo('getMenuProps', suppressRefError, refKey, menuRef);
    return _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (menuNode) {
      menuRef.current = menuNode;
    }), _extends2.id = elementIds.menuId, _extends2.role = 'listbox', _extends2['aria-labelledby'] = rest && rest['aria-label'] ? undefined : "" + elementIds.labelId, _extends2.onMouseLeave = callAllEventHandlers(onMouseLeave, menuHandleMouseLeave), _extends2), rest);
  }, [dispatch, setGetterPropCallInfo, elementIds]);
  var getToggleButtonProps = useCallback(function (_temp4, _temp5) {
    var _extends3;
    var _ref4 = _temp4 === void 0 ? {} : _temp4,
      onBlur = _ref4.onBlur,
      onClick = _ref4.onClick;
      _ref4.onPress;
      var onKeyDown = _ref4.onKeyDown,
      _ref4$refKey = _ref4.refKey,
      refKey = _ref4$refKey === void 0 ? 'ref' : _ref4$refKey,
      ref = _ref4.ref,
      rest = _objectWithoutPropertiesLoose(_ref4, _excluded3$1);
    var _ref5 = _temp5 === void 0 ? {} : _temp5,
      _ref5$suppressRefErro = _ref5.suppressRefError,
      suppressRefError = _ref5$suppressRefErro === void 0 ? false : _ref5$suppressRefErro;
    var latestState = latest.current.state;
    var toggleButtonHandleClick = function toggleButtonHandleClick() {
      dispatch({
        type: ToggleButtonClick$1
      });
    };
    var toggleButtonHandleBlur = function toggleButtonHandleBlur() {
      if (latestState.isOpen && !mouseAndTouchTrackers.isMouseDown) {
        dispatch({
          type: ToggleButtonBlur
        });
      }
    };
    var toggleButtonHandleKeyDown = function toggleButtonHandleKeyDown(event) {
      var key = normalizeArrowKey(event);
      if (key && toggleButtonKeyDownHandlers[key]) {
        toggleButtonKeyDownHandlers[key](event);
      } else if (isAcceptedCharacterKey(key)) {
        dispatch({
          type: ToggleButtonKeyDownCharacter,
          key: key
        });
      }
    };
    var toggleProps = _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (toggleButtonNode) {
      toggleButtonRef.current = toggleButtonNode;
    }), _extends3['aria-activedescendant'] = latestState.isOpen && latestState.highlightedIndex > -1 ? elementIds.getItemId(latestState.highlightedIndex) : '', _extends3['aria-controls'] = elementIds.menuId, _extends3['aria-expanded'] = latest.current.state.isOpen, _extends3['aria-haspopup'] = 'listbox', _extends3['aria-labelledby'] = rest && rest['aria-label'] ? undefined : "" + elementIds.labelId, _extends3.id = elementIds.toggleButtonId, _extends3.role = 'combobox', _extends3.tabIndex = 0, _extends3.onBlur = callAllEventHandlers(onBlur, toggleButtonHandleBlur), _extends3), rest);
    if (!rest.disabled) {
      /* istanbul ignore if (react-native) */
      {
        toggleProps.onClick = callAllEventHandlers(onClick, toggleButtonHandleClick);
        toggleProps.onKeyDown = callAllEventHandlers(onKeyDown, toggleButtonHandleKeyDown);
      }
    }
    setGetterPropCallInfo('getToggleButtonProps', suppressRefError, refKey, toggleButtonRef);
    return toggleProps;
  }, [dispatch, elementIds, latest, mouseAndTouchTrackers, setGetterPropCallInfo, toggleButtonKeyDownHandlers]);
  var getItemProps = useCallback(function (_temp6) {
    var _extends4;
    var _ref6 = _temp6 === void 0 ? {} : _temp6,
      itemProp = _ref6.item,
      indexProp = _ref6.index,
      onMouseMove = _ref6.onMouseMove,
      onClick = _ref6.onClick,
      onMouseDown = _ref6.onMouseDown;
      _ref6.onPress;
      var _ref6$refKey = _ref6.refKey,
      refKey = _ref6$refKey === void 0 ? 'ref' : _ref6$refKey,
      disabledProp = _ref6.disabled,
      ref = _ref6.ref,
      rest = _objectWithoutPropertiesLoose(_ref6, _excluded4$1);
    if (disabledProp !== undefined) {
      console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useSelect.');
    }
    var _latest$current = latest.current,
      latestState = _latest$current.state,
      latestProps = _latest$current.props;
    var _getItemAndIndex = getItemAndIndex(itemProp, indexProp, latestProps.items, 'Pass either item or index to getItemProps!'),
      item = _getItemAndIndex[0],
      index = _getItemAndIndex[1];
    var disabled = latestProps.isItemDisabled(item, index);
    var itemHandleMouseMove = function itemHandleMouseMove() {
      if (mouseAndTouchTrackers.isTouchEnd || index === latestState.highlightedIndex) {
        return;
      }
      shouldScrollRef.current = false;
      dispatch({
        type: ItemMouseMove$1,
        index: index,
        disabled: disabled
      });
    };
    var itemHandleClick = function itemHandleClick() {
      dispatch({
        type: ItemClick$1,
        index: index
      });
    };
    var itemHandleMouseDown = function itemHandleMouseDown(e) {
      return e.preventDefault();
    }; // keep focus on the toggle after item click select.

    var itemProps = _extends((_extends4 = {}, _extends4[refKey] = handleRefs(ref, function (itemNode) {
      if (itemNode) {
        itemRefs.current[elementIds.getItemId(index)] = itemNode;
      }
    }), _extends4['aria-disabled'] = disabled, _extends4['aria-selected'] = item === latestState.selectedItem, _extends4.id = elementIds.getItemId(index), _extends4.role = 'option', _extends4), rest);
    if (!disabled) {
      /* istanbul ignore next (react-native) */
      {
        itemProps.onClick = callAllEventHandlers(onClick, itemHandleClick);
      }
    }
    itemProps.onMouseMove = callAllEventHandlers(onMouseMove, itemHandleMouseMove);
    itemProps.onMouseDown = callAllEventHandlers(onMouseDown, itemHandleMouseDown);
    return itemProps;
  }, [latest, elementIds, mouseAndTouchTrackers, shouldScrollRef, dispatch]);
  return {
    // prop getters.
    getToggleButtonProps: getToggleButtonProps,
    getLabelProps: getLabelProps,
    getMenuProps: getMenuProps,
    getItemProps: getItemProps,
    // actions.
    toggleMenu: toggleMenu,
    openMenu: openMenu,
    closeMenu: closeMenu,
    setHighlightedIndex: setHighlightedIndex,
    selectItem: selectItem,
    reset: reset,
    setInputValue: setInputValue,
    // state.
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}

var InputKeyDownArrowDown = process.env.NODE_ENV !== "production" ? '__input_keydown_arrow_down__' : 0;
var InputKeyDownArrowUp = process.env.NODE_ENV !== "production" ? '__input_keydown_arrow_up__' : 1;
var InputKeyDownEscape = process.env.NODE_ENV !== "production" ? '__input_keydown_escape__' : 2;
var InputKeyDownHome = process.env.NODE_ENV !== "production" ? '__input_keydown_home__' : 3;
var InputKeyDownEnd = process.env.NODE_ENV !== "production" ? '__input_keydown_end__' : 4;
var InputKeyDownPageUp = process.env.NODE_ENV !== "production" ? '__input_keydown_page_up__' : 5;
var InputKeyDownPageDown = process.env.NODE_ENV !== "production" ? '__input_keydown_page_down__' : 6;
var InputKeyDownEnter = process.env.NODE_ENV !== "production" ? '__input_keydown_enter__' : 7;
var InputChange = process.env.NODE_ENV !== "production" ? '__input_change__' : 8;
var InputBlur = process.env.NODE_ENV !== "production" ? '__input_blur__' : 9;
var InputClick = process.env.NODE_ENV !== "production" ? '__input_click__' : 10;
var MenuMouseLeave = process.env.NODE_ENV !== "production" ? '__menu_mouse_leave__' : 11;
var ItemMouseMove = process.env.NODE_ENV !== "production" ? '__item_mouse_move__' : 12;
var ItemClick = process.env.NODE_ENV !== "production" ? '__item_click__' : 13;
var ToggleButtonClick = process.env.NODE_ENV !== "production" ? '__togglebutton_click__' : 14;
var FunctionToggleMenu = process.env.NODE_ENV !== "production" ? '__function_toggle_menu__' : 15;
var FunctionOpenMenu = process.env.NODE_ENV !== "production" ? '__function_open_menu__' : 16;
var FunctionCloseMenu = process.env.NODE_ENV !== "production" ? '__function_close_menu__' : 17;
var FunctionSetHighlightedIndex = process.env.NODE_ENV !== "production" ? '__function_set_highlighted_index__' : 18;
var FunctionSelectItem = process.env.NODE_ENV !== "production" ? '__function_select_item__' : 19;
var FunctionSetInputValue = process.env.NODE_ENV !== "production" ? '__function_set_input_value__' : 20;
var FunctionReset$1 = process.env.NODE_ENV !== "production" ? '__function_reset__' : 21;
var ControlledPropUpdatedSelectedItem = process.env.NODE_ENV !== "production" ? '__controlled_prop_updated_selected_item__' : 22;

var stateChangeTypes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ControlledPropUpdatedSelectedItem: ControlledPropUpdatedSelectedItem,
  FunctionCloseMenu: FunctionCloseMenu,
  FunctionOpenMenu: FunctionOpenMenu,
  FunctionReset: FunctionReset$1,
  FunctionSelectItem: FunctionSelectItem,
  FunctionSetHighlightedIndex: FunctionSetHighlightedIndex,
  FunctionSetInputValue: FunctionSetInputValue,
  FunctionToggleMenu: FunctionToggleMenu,
  InputBlur: InputBlur,
  InputChange: InputChange,
  InputClick: InputClick,
  InputKeyDownArrowDown: InputKeyDownArrowDown,
  InputKeyDownArrowUp: InputKeyDownArrowUp,
  InputKeyDownEnd: InputKeyDownEnd,
  InputKeyDownEnter: InputKeyDownEnter,
  InputKeyDownEscape: InputKeyDownEscape,
  InputKeyDownHome: InputKeyDownHome,
  InputKeyDownPageDown: InputKeyDownPageDown,
  InputKeyDownPageUp: InputKeyDownPageUp,
  ItemClick: ItemClick,
  ItemMouseMove: ItemMouseMove,
  MenuMouseLeave: MenuMouseLeave,
  ToggleButtonClick: ToggleButtonClick
});

function getInitialState$1(props) {
  var initialState = getInitialState$2(props);
  var selectedItem = initialState.selectedItem;
  var inputValue = initialState.inputValue;
  if (inputValue === '' && selectedItem && props.defaultInputValue === undefined && props.initialInputValue === undefined && props.inputValue === undefined) {
    inputValue = props.itemToString(selectedItem);
  }
  return _extends({}, initialState, {
    inputValue: inputValue
  });
}
var propTypes$1 = _extends({}, commonDropdownPropTypes, {
  items: PropTypes.array.isRequired,
  isItemDisabled: PropTypes.func,
  inputValue: PropTypes.string,
  defaultInputValue: PropTypes.string,
  initialInputValue: PropTypes.string,
  inputId: PropTypes.string,
  onInputValueChange: PropTypes.func
});

/**
 * The useCombobox version of useControlledReducer, which also
 * checks if the controlled prop selectedItem changed between
 * renders. If so, it will also update inputValue with its
 * string equivalent. It uses the common useEnhancedReducer to
 * compute the rest of the state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} props The hook props, also passed to createInitialState.
 * @param {Function} createInitialState Function that returns the initial state.
 * @param {Function} isStateEqual Function that checks if a previous state is equal to the next.
 * @returns {Array} An array with the state and an action dispatcher.
 */
function useControlledReducer(reducer, props, createInitialState, isStateEqual) {
  var previousSelectedItemRef = useRef();
  var _useEnhancedReducer = useEnhancedReducer(reducer, props, createInitialState, isStateEqual),
    state = _useEnhancedReducer[0],
    dispatch = _useEnhancedReducer[1];
  var isInitialMount = useIsInitialMount();
  useEffect(function () {
    if (!isControlledProp(props, 'selectedItem')) {
      return;
    }
    if (!isInitialMount // on first mount we already have the proper inputValue for a initial selected item.
    ) {
      var shouldCallDispatch = props.itemToKey(props.selectedItem) !== props.itemToKey(previousSelectedItemRef.current);
      if (shouldCallDispatch) {
        dispatch({
          type: ControlledPropUpdatedSelectedItem,
          inputValue: props.itemToString(props.selectedItem)
        });
      }
    }
    previousSelectedItemRef.current = state.selectedItem === previousSelectedItemRef.current ? props.selectedItem : state.selectedItem;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.selectedItem, props.selectedItem]);
  return [getState(state, props), dispatch];
}

// eslint-disable-next-line import/no-mutable-exports
var validatePropTypes$1 = noop;
/* istanbul ignore next */
if (process.env.NODE_ENV !== 'production') {
  validatePropTypes$1 = function validatePropTypes(options, caller) {
    PropTypes.checkPropTypes(propTypes$1, options, 'prop', caller.name);
  };
}
var defaultProps$1 = _extends({}, defaultProps$3, {
  isItemDisabled: function isItemDisabled() {
    return false;
  }
});

/* eslint-disable complexity */
function downshiftUseComboboxReducer(state, action) {
  var _props$items;
  var type = action.type,
    props = action.props,
    altKey = action.altKey;
  var changes;
  switch (type) {
    case ItemClick:
      changes = {
        isOpen: getDefaultValue$1(props, 'isOpen'),
        highlightedIndex: getDefaultHighlightedIndex(props),
        selectedItem: props.items[action.index],
        inputValue: props.itemToString(props.items[action.index])
      };
      break;
    case InputKeyDownArrowDown:
      if (state.isOpen) {
        changes = {
          highlightedIndex: getHighlightedIndex(state.highlightedIndex, 1, props.items, props.isItemDisabled, true)
        };
      } else {
        changes = {
          highlightedIndex: altKey && state.selectedItem == null ? -1 : getHighlightedIndexOnOpen(props, state, 1),
          isOpen: props.items.length >= 0
        };
      }
      break;
    case InputKeyDownArrowUp:
      if (state.isOpen) {
        if (altKey) {
          changes = getChangesOnSelection(props, state.highlightedIndex);
        } else {
          changes = {
            highlightedIndex: getHighlightedIndex(state.highlightedIndex, -1, props.items, props.isItemDisabled, true)
          };
        }
      } else {
        changes = {
          highlightedIndex: getHighlightedIndexOnOpen(props, state, -1),
          isOpen: props.items.length >= 0
        };
      }
      break;
    case InputKeyDownEnter:
      changes = getChangesOnSelection(props, state.highlightedIndex);
      break;
    case InputKeyDownEscape:
      changes = _extends({
        isOpen: false,
        highlightedIndex: -1
      }, !state.isOpen && {
        selectedItem: null,
        inputValue: ''
      });
      break;
    case InputKeyDownPageUp:
      changes = {
        highlightedIndex: getHighlightedIndex(state.highlightedIndex, -10, props.items, props.isItemDisabled, true)
      };
      break;
    case InputKeyDownPageDown:
      changes = {
        highlightedIndex: getHighlightedIndex(state.highlightedIndex, 10, props.items, props.isItemDisabled, true)
      };
      break;
    case InputKeyDownHome:
      changes = {
        highlightedIndex: getNonDisabledIndex(0, false, props.items, props.isItemDisabled)
      };
      break;
    case InputKeyDownEnd:
      changes = {
        highlightedIndex: getNonDisabledIndex(props.items.length - 1, true, props.items, props.isItemDisabled)
      };
      break;
    case InputBlur:
      changes = _extends({
        isOpen: false,
        highlightedIndex: -1
      }, state.highlightedIndex >= 0 && ((_props$items = props.items) == null ? void 0 : _props$items.length) && action.selectItem && {
        selectedItem: props.items[state.highlightedIndex],
        inputValue: props.itemToString(props.items[state.highlightedIndex])
      });
      break;
    case InputChange:
      changes = {
        isOpen: true,
        highlightedIndex: getDefaultHighlightedIndex(props),
        inputValue: action.inputValue
      };
      break;
    case InputClick:
      changes = {
        isOpen: !state.isOpen,
        highlightedIndex: state.isOpen ? -1 : getHighlightedIndexOnOpen(props, state, 0)
      };
      break;
    case FunctionSelectItem:
      changes = {
        selectedItem: action.selectedItem,
        inputValue: props.itemToString(action.selectedItem)
      };
      break;
    case ControlledPropUpdatedSelectedItem:
      changes = {
        inputValue: action.inputValue
      };
      break;
    default:
      return downshiftCommonReducer(state, action, stateChangeTypes$1);
  }
  return _extends({}, state, changes);
}
/* eslint-enable complexity */

var _excluded$1 = ["onMouseLeave", "refKey", "ref"],
  _excluded2$1 = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"],
  _excluded3 = ["onClick", "onPress", "refKey", "ref"],
  _excluded4 = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
useCombobox.stateChangeTypes = stateChangeTypes$1;
function useCombobox(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }
  validatePropTypes$1(userProps, useCombobox);
  // Props defaults and destructuring.
  var props = _extends({}, defaultProps$1, userProps);
  var items = props.items,
    scrollIntoView = props.scrollIntoView,
    environment = props.environment,
    getA11yStatusMessage = props.getA11yStatusMessage;
  // Initial state depending on controlled props.
  var _useControlledReducer = useControlledReducer(downshiftUseComboboxReducer, props, getInitialState$1, isDropdownsStateEqual),
    state = _useControlledReducer[0],
    dispatch = _useControlledReducer[1];
  var isOpen = state.isOpen,
    highlightedIndex = state.highlightedIndex,
    selectedItem = state.selectedItem,
    inputValue = state.inputValue;

  // Element refs.
  var menuRef = useRef(null);
  var itemRefs = useRef({});
  var inputRef = useRef(null);
  var toggleButtonRef = useRef(null);
  var isInitialMount = useIsInitialMount();

  // prevent id re-generation between renders.
  var elementIds = useElementIds(props);
  // used to keep track of how many items we had on previous cycle.
  var previousResultCountRef = useRef();
  // utility callback to get item element.
  var latest = useLatestRef({
    state: state,
    props: props
  });
  var getItemNodeFromIndex = useCallback(function (index) {
    return itemRefs.current[elementIds.getItemId(index)];
  }, [elementIds]);

  // Effects.
  // Adds an a11y aria live status message if getA11yStatusMessage is passed.
  useA11yMessageStatus(getA11yStatusMessage, state, [isOpen, highlightedIndex, selectedItem, inputValue], environment);
  // Scroll on highlighted item if change comes from keyboard.
  var shouldScrollRef = useScrollIntoView({
    menuElement: menuRef.current,
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    itemRefs: itemRefs,
    scrollIntoView: scrollIntoView,
    getItemNodeFromIndex: getItemNodeFromIndex
  });
  useControlPropsValidator({
    props: props,
    state: state
  });
  // Focus the input on first render if required.
  useEffect(function () {
    var focusOnOpen = getInitialValue$1(props, 'isOpen');
    if (focusOnOpen && inputRef.current) {
      inputRef.current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    if (!isInitialMount) {
      previousResultCountRef.current = items.length;
    }
  });
  var mouseAndTouchTrackers = useMouseAndTouchTracker(environment, [toggleButtonRef, menuRef, inputRef], useCallback(function handleBlur() {
    if (latest.current.state.isOpen) {
      dispatch({
        type: InputBlur,
        selectItem: false
      });
    }
  }, [dispatch, latest]));
  var setGetterPropCallInfo = useGetterPropsCalledChecker('getInputProps', 'getMenuProps');
  // Reset itemRefs on close.
  useEffect(function () {
    if (!isOpen) {
      itemRefs.current = {};
    }
  }, [isOpen]);
  // Reset itemRefs on close.
  useEffect(function () {
    var _inputRef$current;
    if (!isOpen || !(environment != null && environment.document) || !(inputRef != null && (_inputRef$current = inputRef.current) != null && _inputRef$current.focus)) {
      return;
    }
    if (environment.document.activeElement !== inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen, environment]);

  /* Event handler functions */
  var inputKeyDownHandlers = useMemo(function () {
    return {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        dispatch({
          type: InputKeyDownArrowDown,
          altKey: event.altKey
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        dispatch({
          type: InputKeyDownArrowUp,
          altKey: event.altKey
        });
      },
      Home: function Home(event) {
        if (!latest.current.state.isOpen) {
          return;
        }
        event.preventDefault();
        dispatch({
          type: InputKeyDownHome
        });
      },
      End: function End(event) {
        if (!latest.current.state.isOpen) {
          return;
        }
        event.preventDefault();
        dispatch({
          type: InputKeyDownEnd
        });
      },
      Escape: function Escape(event) {
        var latestState = latest.current.state;
        if (latestState.isOpen || latestState.inputValue || latestState.selectedItem || latestState.highlightedIndex > -1) {
          event.preventDefault();
          dispatch({
            type: InputKeyDownEscape
          });
        }
      },
      Enter: function Enter(event) {
        var latestState = latest.current.state;
        // if closed or no highlighted index, do nothing.
        if (!latestState.isOpen || event.which === 229 // if IME composing, wait for next Enter keydown event.
        ) {
          return;
        }
        event.preventDefault();
        dispatch({
          type: InputKeyDownEnter
        });
      },
      PageUp: function PageUp(event) {
        if (latest.current.state.isOpen) {
          event.preventDefault();
          dispatch({
            type: InputKeyDownPageUp
          });
        }
      },
      PageDown: function PageDown(event) {
        if (latest.current.state.isOpen) {
          event.preventDefault();
          dispatch({
            type: InputKeyDownPageDown
          });
        }
      }
    };
  }, [dispatch, latest]);

  // Getter props.
  var getLabelProps = useCallback(function (labelProps) {
    return _extends({
      id: elementIds.labelId,
      htmlFor: elementIds.inputId
    }, labelProps);
  }, [elementIds]);
  var getMenuProps = useCallback(function (_temp, _temp2) {
    var _extends2;
    var _ref = _temp === void 0 ? {} : _temp,
      onMouseLeave = _ref.onMouseLeave,
      _ref$refKey = _ref.refKey,
      refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
      ref = _ref.ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
    var _ref2 = _temp2 === void 0 ? {} : _temp2,
      _ref2$suppressRefErro = _ref2.suppressRefError,
      suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;
    setGetterPropCallInfo('getMenuProps', suppressRefError, refKey, menuRef);
    return _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (menuNode) {
      menuRef.current = menuNode;
    }), _extends2.id = elementIds.menuId, _extends2.role = 'listbox', _extends2['aria-labelledby'] = rest && rest['aria-label'] ? undefined : "" + elementIds.labelId, _extends2.onMouseLeave = callAllEventHandlers(onMouseLeave, function () {
      dispatch({
        type: MenuMouseLeave
      });
    }), _extends2), rest);
  }, [dispatch, setGetterPropCallInfo, elementIds]);
  var getItemProps = useCallback(function (_temp3) {
    var _extends3, _ref4;
    var _ref3 = _temp3 === void 0 ? {} : _temp3,
      itemProp = _ref3.item,
      indexProp = _ref3.index,
      _ref3$refKey = _ref3.refKey,
      refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
      ref = _ref3.ref,
      onMouseMove = _ref3.onMouseMove,
      onMouseDown = _ref3.onMouseDown,
      onClick = _ref3.onClick;
      _ref3.onPress;
      var disabledProp = _ref3.disabled,
      rest = _objectWithoutPropertiesLoose(_ref3, _excluded2$1);
    if (disabledProp !== undefined) {
      console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
    }
    var _latest$current = latest.current,
      latestProps = _latest$current.props,
      latestState = _latest$current.state;
    var _getItemAndIndex = getItemAndIndex(itemProp, indexProp, latestProps.items, 'Pass either item or index to getItemProps!'),
      item = _getItemAndIndex[0],
      index = _getItemAndIndex[1];
    var disabled = latestProps.isItemDisabled(item, index);
    var onSelectKey = 'onClick';
    var customClickHandler = onClick;
    var itemHandleMouseMove = function itemHandleMouseMove() {
      if (mouseAndTouchTrackers.isTouchEnd || index === latestState.highlightedIndex) {
        return;
      }
      shouldScrollRef.current = false;
      dispatch({
        type: ItemMouseMove,
        index: index,
        disabled: disabled
      });
    };
    var itemHandleClick = function itemHandleClick() {
      dispatch({
        type: ItemClick,
        index: index
      });
    };
    var itemHandleMouseDown = function itemHandleMouseDown(e) {
      return e.preventDefault();
    }; // keep focus on the input after item click select.

    return _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (itemNode) {
      if (itemNode) {
        itemRefs.current[elementIds.getItemId(index)] = itemNode;
      }
    }), _extends3['aria-disabled'] = disabled, _extends3['aria-selected'] = index === latestState.highlightedIndex, _extends3.id = elementIds.getItemId(index), _extends3.role = 'option', _extends3), !disabled && (_ref4 = {}, _ref4[onSelectKey] = callAllEventHandlers(customClickHandler, itemHandleClick), _ref4), {
      onMouseMove: callAllEventHandlers(onMouseMove, itemHandleMouseMove),
      onMouseDown: callAllEventHandlers(onMouseDown, itemHandleMouseDown)
    }, rest);
  }, [dispatch, elementIds, latest, mouseAndTouchTrackers, shouldScrollRef]);
  var getToggleButtonProps = useCallback(function (_temp4) {
    var _extends4;
    var _ref5 = _temp4 === void 0 ? {} : _temp4,
      onClick = _ref5.onClick;
      _ref5.onPress;
      var _ref5$refKey = _ref5.refKey,
      refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey,
      ref = _ref5.ref,
      rest = _objectWithoutPropertiesLoose(_ref5, _excluded3);
    var latestState = latest.current.state;
    var toggleButtonHandleClick = function toggleButtonHandleClick() {
      dispatch({
        type: ToggleButtonClick
      });
    };
    return _extends((_extends4 = {}, _extends4[refKey] = handleRefs(ref, function (toggleButtonNode) {
      toggleButtonRef.current = toggleButtonNode;
    }), _extends4['aria-controls'] = elementIds.menuId, _extends4['aria-expanded'] = latestState.isOpen, _extends4.id = elementIds.toggleButtonId, _extends4.tabIndex = -1, _extends4), !rest.disabled && _extends({}, {
      onClick: callAllEventHandlers(onClick, toggleButtonHandleClick)
    }), rest);
  }, [dispatch, latest, elementIds]);
  var getInputProps = useCallback(function (_temp5, _temp6) {
    var _extends5;
    var _ref6 = _temp5 === void 0 ? {} : _temp5,
      onKeyDown = _ref6.onKeyDown,
      onChange = _ref6.onChange,
      onInput = _ref6.onInput,
      onBlur = _ref6.onBlur;
      _ref6.onChangeText;
      var onClick = _ref6.onClick,
      _ref6$refKey = _ref6.refKey,
      refKey = _ref6$refKey === void 0 ? 'ref' : _ref6$refKey,
      ref = _ref6.ref,
      rest = _objectWithoutPropertiesLoose(_ref6, _excluded4);
    var _ref7 = _temp6 === void 0 ? {} : _temp6,
      _ref7$suppressRefErro = _ref7.suppressRefError,
      suppressRefError = _ref7$suppressRefErro === void 0 ? false : _ref7$suppressRefErro;
    setGetterPropCallInfo('getInputProps', suppressRefError, refKey, inputRef);
    var latestState = latest.current.state;
    var inputHandleKeyDown = function inputHandleKeyDown(event) {
      var key = normalizeArrowKey(event);
      if (key && inputKeyDownHandlers[key]) {
        inputKeyDownHandlers[key](event);
      }
    };
    var inputHandleChange = function inputHandleChange(event) {
      dispatch({
        type: InputChange,
        inputValue: event.target.value
      });
    };
    var inputHandleBlur = function inputHandleBlur(event) {
      /* istanbul ignore else */
      if (environment != null && environment.document && latestState.isOpen && !mouseAndTouchTrackers.isMouseDown) {
        var isBlurByTabChange = event.relatedTarget === null && environment.document.activeElement !== environment.document.body;
        dispatch({
          type: InputBlur,
          selectItem: !isBlurByTabChange
        });
      }
    };
    var inputHandleClick = function inputHandleClick() {
      dispatch({
        type: InputClick
      });
    };

    /* istanbul ignore next (preact) */
    var onChangeKey = 'onChange';
    var eventHandlers = {};
    if (!rest.disabled) {
      var _eventHandlers;
      eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, inputHandleBlur), _eventHandlers.onClick = callAllEventHandlers(onClick, inputHandleClick), _eventHandlers);
    }
    return _extends((_extends5 = {}, _extends5[refKey] = handleRefs(ref, function (inputNode) {
      inputRef.current = inputNode;
    }), _extends5['aria-activedescendant'] = latestState.isOpen && latestState.highlightedIndex > -1 ? elementIds.getItemId(latestState.highlightedIndex) : '', _extends5['aria-autocomplete'] = 'list', _extends5['aria-controls'] = elementIds.menuId, _extends5['aria-expanded'] = latestState.isOpen, _extends5['aria-labelledby'] = rest && rest['aria-label'] ? undefined : elementIds.labelId, _extends5.autoComplete = 'off', _extends5.id = elementIds.inputId, _extends5.role = 'combobox', _extends5.value = latestState.inputValue, _extends5), eventHandlers, rest);
  }, [dispatch, elementIds, environment, inputKeyDownHandlers, latest, mouseAndTouchTrackers, setGetterPropCallInfo]);

  // returns
  var toggleMenu = useCallback(function () {
    dispatch({
      type: FunctionToggleMenu
    });
  }, [dispatch]);
  var closeMenu = useCallback(function () {
    dispatch({
      type: FunctionCloseMenu
    });
  }, [dispatch]);
  var openMenu = useCallback(function () {
    dispatch({
      type: FunctionOpenMenu
    });
  }, [dispatch]);
  var setHighlightedIndex = useCallback(function (newHighlightedIndex) {
    dispatch({
      type: FunctionSetHighlightedIndex,
      highlightedIndex: newHighlightedIndex
    });
  }, [dispatch]);
  var selectItem = useCallback(function (newSelectedItem) {
    dispatch({
      type: FunctionSelectItem,
      selectedItem: newSelectedItem
    });
  }, [dispatch]);
  var setInputValue = useCallback(function (newInputValue) {
    dispatch({
      type: FunctionSetInputValue,
      inputValue: newInputValue
    });
  }, [dispatch]);
  var reset = useCallback(function () {
    dispatch({
      type: FunctionReset$1
    });
  }, [dispatch]);
  return {
    // prop getters.
    getItemProps: getItemProps,
    getLabelProps: getLabelProps,
    getMenuProps: getMenuProps,
    getInputProps: getInputProps,
    getToggleButtonProps: getToggleButtonProps,
    // actions.
    toggleMenu: toggleMenu,
    openMenu: openMenu,
    closeMenu: closeMenu,
    setHighlightedIndex: setHighlightedIndex,
    setInputValue: setInputValue,
    selectItem: selectItem,
    reset: reset,
    // state.
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}

var defaultStateValues = {
  activeIndex: -1,
  selectedItems: []
};

/**
 * Returns the initial value for a state key in the following order:
 * 1. controlled prop, 2. initial prop, 3. default prop, 4. default
 * value from Downshift.
 *
 * @param {Object} props Props passed to the hook.
 * @param {string} propKey Props key to generate the value for.
 * @returns {any} The initial value for that prop.
 */
function getInitialValue(props, propKey) {
  return getInitialValue$1(props, propKey, defaultStateValues);
}

/**
 * Returns the default value for a state key in the following order:
 * 1. controlled prop, 2. default prop, 3. default value from Downshift.
 *
 * @param {Object} props Props passed to the hook.
 * @param {string} propKey Props key to generate the value for.
 * @returns {any} The initial value for that prop.
 */
function getDefaultValue(props, propKey) {
  return getDefaultValue$1(props, propKey, defaultStateValues);
}

/**
 * Gets the initial state based on the provided props. It uses initial, default
 * and controlled props related to state in order to compute the initial value.
 *
 * @param {Object} props Props passed to the hook.
 * @returns {Object} The initial state.
 */
function getInitialState(props) {
  var activeIndex = getInitialValue(props, 'activeIndex');
  var selectedItems = getInitialValue(props, 'selectedItems');
  return {
    activeIndex: activeIndex,
    selectedItems: selectedItems
  };
}

/**
 * Returns true if dropdown keydown operation is permitted. Should not be
 * allowed on keydown with modifier keys (ctrl, alt, shift, meta), on
 * input element with text content that is either highlighted or selection
 * cursor is not at the starting position.
 *
 * @param {KeyboardEvent} event The event from keydown.
 * @returns {boolean} Whether the operation is allowed.
 */
function isKeyDownOperationPermitted(event) {
  if (event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) {
    return false;
  }
  var element = event.target;
  if (element instanceof HTMLInputElement &&
  // if element is a text input
  element.value !== '' && (
  // and we have text in it
  // and cursor is either not at the start or is currently highlighting text.
  element.selectionStart !== 0 || element.selectionEnd !== 0)) {
    return false;
  }
  return true;
}

/**
 * Check if a state is equal for taglist, by comparing active index and selected items.
 * Used by useSelect and useCombobox.
 *
 * @param {Object} prevState
 * @param {Object} newState
 * @returns {boolean} Wheather the states are deeply equal.
 */
function isStateEqual(prevState, newState) {
  return prevState.selectedItems === newState.selectedItems && prevState.activeIndex === newState.activeIndex;
}
var propTypes = {
  stateReducer: commonPropTypes.stateReducer,
  itemToKey: commonPropTypes.itemToKey,
  environment: commonPropTypes.environment,
  selectedItems: PropTypes.array,
  initialSelectedItems: PropTypes.array,
  defaultSelectedItems: PropTypes.array,
  getA11yStatusMessage: PropTypes.func,
  activeIndex: PropTypes.number,
  initialActiveIndex: PropTypes.number,
  defaultActiveIndex: PropTypes.number,
  onActiveIndexChange: PropTypes.func,
  onSelectedItemsChange: PropTypes.func,
  keyNavigationNext: PropTypes.string,
  keyNavigationPrevious: PropTypes.string
};
var defaultProps$4 = {
  itemToKey: defaultProps$3.itemToKey,
  stateReducer: defaultProps$3.stateReducer,
  environment: defaultProps$3.environment,
  keyNavigationNext: 'ArrowRight',
  keyNavigationPrevious: 'ArrowLeft'
};

// eslint-disable-next-line import/no-mutable-exports
var validatePropTypes = noop;
/* istanbul ignore next */
if (process.env.NODE_ENV !== 'production') {
  validatePropTypes = function validatePropTypes(options, caller) {
    PropTypes.checkPropTypes(propTypes, options, 'prop', caller.name);
  };
}

var SelectedItemClick = process.env.NODE_ENV !== "production" ? '__selected_item_click__' : 0;
var SelectedItemKeyDownDelete = process.env.NODE_ENV !== "production" ? '__selected_item_keydown_delete__' : 1;
var SelectedItemKeyDownBackspace = process.env.NODE_ENV !== "production" ? '__selected_item_keydown_backspace__' : 2;
var SelectedItemKeyDownNavigationNext = process.env.NODE_ENV !== "production" ? '__selected_item_keydown_navigation_next__' : 3;
var SelectedItemKeyDownNavigationPrevious = process.env.NODE_ENV !== "production" ? '__selected_item_keydown_navigation_previous__' : 4;
var DropdownKeyDownNavigationPrevious = process.env.NODE_ENV !== "production" ? '__dropdown_keydown_navigation_previous__' : 5;
var DropdownKeyDownBackspace = process.env.NODE_ENV !== "production" ? '__dropdown_keydown_backspace__' : 6;
var DropdownClick = process.env.NODE_ENV !== "production" ? '__dropdown_click__' : 7;
var FunctionAddSelectedItem = process.env.NODE_ENV !== "production" ? '__function_add_selected_item__' : 8;
var FunctionRemoveSelectedItem = process.env.NODE_ENV !== "production" ? '__function_remove_selected_item__' : 9;
var FunctionSetSelectedItems = process.env.NODE_ENV !== "production" ? '__function_set_selected_items__' : 10;
var FunctionSetActiveIndex = process.env.NODE_ENV !== "production" ? '__function_set_active_index__' : 11;
var FunctionReset = process.env.NODE_ENV !== "production" ? '__function_reset__' : 12;

var stateChangeTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DropdownClick: DropdownClick,
  DropdownKeyDownBackspace: DropdownKeyDownBackspace,
  DropdownKeyDownNavigationPrevious: DropdownKeyDownNavigationPrevious,
  FunctionAddSelectedItem: FunctionAddSelectedItem,
  FunctionRemoveSelectedItem: FunctionRemoveSelectedItem,
  FunctionReset: FunctionReset,
  FunctionSetActiveIndex: FunctionSetActiveIndex,
  FunctionSetSelectedItems: FunctionSetSelectedItems,
  SelectedItemClick: SelectedItemClick,
  SelectedItemKeyDownBackspace: SelectedItemKeyDownBackspace,
  SelectedItemKeyDownDelete: SelectedItemKeyDownDelete,
  SelectedItemKeyDownNavigationNext: SelectedItemKeyDownNavigationNext,
  SelectedItemKeyDownNavigationPrevious: SelectedItemKeyDownNavigationPrevious
});

/* eslint-disable complexity */
function downshiftMultipleSelectionReducer(state, action) {
  var type = action.type,
    index = action.index,
    props = action.props,
    selectedItem = action.selectedItem;
  var activeIndex = state.activeIndex,
    selectedItems = state.selectedItems;
  var changes;
  switch (type) {
    case SelectedItemClick:
      changes = {
        activeIndex: index
      };
      break;
    case SelectedItemKeyDownNavigationPrevious:
      changes = {
        activeIndex: activeIndex - 1 < 0 ? 0 : activeIndex - 1
      };
      break;
    case SelectedItemKeyDownNavigationNext:
      changes = {
        activeIndex: activeIndex + 1 >= selectedItems.length ? -1 : activeIndex + 1
      };
      break;
    case SelectedItemKeyDownBackspace:
    case SelectedItemKeyDownDelete:
      {
        if (activeIndex < 0) {
          break;
        }
        var newActiveIndex = activeIndex;
        if (selectedItems.length === 1) {
          newActiveIndex = -1;
        } else if (activeIndex === selectedItems.length - 1) {
          newActiveIndex = selectedItems.length - 2;
        }
        changes = _extends({
          selectedItems: [].concat(selectedItems.slice(0, activeIndex), selectedItems.slice(activeIndex + 1))
        }, {
          activeIndex: newActiveIndex
        });
        break;
      }
    case DropdownKeyDownNavigationPrevious:
      changes = {
        activeIndex: selectedItems.length - 1
      };
      break;
    case DropdownKeyDownBackspace:
      changes = {
        selectedItems: selectedItems.slice(0, selectedItems.length - 1)
      };
      break;
    case FunctionAddSelectedItem:
      changes = {
        selectedItems: [].concat(selectedItems, [selectedItem])
      };
      break;
    case DropdownClick:
      changes = {
        activeIndex: -1
      };
      break;
    case FunctionRemoveSelectedItem:
      {
        var _newActiveIndex = activeIndex;
        var selectedItemIndex = selectedItems.findIndex(function (item) {
          return props.itemToKey(item) === props.itemToKey(selectedItem);
        });
        if (selectedItemIndex < 0) {
          break;
        }
        if (selectedItems.length === 1) {
          _newActiveIndex = -1;
        } else if (selectedItemIndex === selectedItems.length - 1) {
          _newActiveIndex = selectedItems.length - 2;
        }
        changes = {
          selectedItems: [].concat(selectedItems.slice(0, selectedItemIndex), selectedItems.slice(selectedItemIndex + 1)),
          activeIndex: _newActiveIndex
        };
        break;
      }
    case FunctionSetSelectedItems:
      {
        var newSelectedItems = action.selectedItems;
        changes = {
          selectedItems: newSelectedItems
        };
        break;
      }
    case FunctionSetActiveIndex:
      {
        var _newActiveIndex2 = action.activeIndex;
        changes = {
          activeIndex: _newActiveIndex2
        };
        break;
      }
    case FunctionReset:
      changes = {
        activeIndex: getDefaultValue(props, 'activeIndex'),
        selectedItems: getDefaultValue(props, 'selectedItems')
      };
      break;
    default:
      throw new Error('Reducer called without proper action type.');
  }
  return _extends({}, state, changes);
}

var _excluded = ["refKey", "ref", "onClick", "onKeyDown", "selectedItem", "index"],
  _excluded2 = ["refKey", "ref", "onKeyDown", "onClick", "preventKeyAction"];
useMultipleSelection.stateChangeTypes = stateChangeTypes;
function useMultipleSelection(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }
  validatePropTypes(userProps, useMultipleSelection);
  // Props defaults and destructuring.
  var props = _extends({}, defaultProps$4, userProps);
  var getA11yStatusMessage = props.getA11yStatusMessage,
    environment = props.environment,
    keyNavigationNext = props.keyNavigationNext,
    keyNavigationPrevious = props.keyNavigationPrevious;

  // Reducer init.
  var _useControlledReducer = useControlledReducer$1(downshiftMultipleSelectionReducer, props, getInitialState, isStateEqual),
    state = _useControlledReducer[0],
    dispatch = _useControlledReducer[1];
  var activeIndex = state.activeIndex,
    selectedItems = state.selectedItems;

  // Refs.
  var isInitialMount = useIsInitialMount();
  var dropdownRef = useRef(null);
  var selectedItemRefs = useRef();
  selectedItemRefs.current = [];
  var latest = useLatestRef({
    state: state,
    props: props
  });

  // Effects.
  // Adds an a11y aria live status message if getA11yStatusMessage is passed.
  useA11yMessageStatus(getA11yStatusMessage, state, [activeIndex, selectedItems], environment);
  // Sets focus on active item.
  useEffect(function () {
    if (isInitialMount) {
      return;
    }
    if (activeIndex === -1 && dropdownRef.current) {
      dropdownRef.current.focus();
    } else if (selectedItemRefs.current[activeIndex]) {
      selectedItemRefs.current[activeIndex].focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeIndex]);
  useControlPropsValidator({
    props: props,
    state: state
  });
  var setGetterPropCallInfo = useGetterPropsCalledChecker('getDropdownProps');

  // Event handler functions.
  var selectedItemKeyDownHandlers = useMemo(function () {
    var _ref;
    return _ref = {}, _ref[keyNavigationPrevious] = function () {
      dispatch({
        type: SelectedItemKeyDownNavigationPrevious
      });
    }, _ref[keyNavigationNext] = function () {
      dispatch({
        type: SelectedItemKeyDownNavigationNext
      });
    }, _ref.Delete = function Delete() {
      dispatch({
        type: SelectedItemKeyDownDelete
      });
    }, _ref.Backspace = function Backspace() {
      dispatch({
        type: SelectedItemKeyDownBackspace
      });
    }, _ref;
  }, [dispatch, keyNavigationNext, keyNavigationPrevious]);
  var dropdownKeyDownHandlers = useMemo(function () {
    var _ref2;
    return _ref2 = {}, _ref2[keyNavigationPrevious] = function (event) {
      if (isKeyDownOperationPermitted(event)) {
        dispatch({
          type: DropdownKeyDownNavigationPrevious
        });
      }
    }, _ref2.Backspace = function Backspace(event) {
      if (isKeyDownOperationPermitted(event)) {
        dispatch({
          type: DropdownKeyDownBackspace
        });
      }
    }, _ref2;
  }, [dispatch, keyNavigationPrevious]);

  // Getter props.
  var getSelectedItemProps = useCallback(function (_temp) {
    var _extends2;
    var _ref3 = _temp === void 0 ? {} : _temp,
      _ref3$refKey = _ref3.refKey,
      refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
      ref = _ref3.ref,
      onClick = _ref3.onClick,
      onKeyDown = _ref3.onKeyDown,
      selectedItemProp = _ref3.selectedItem,
      indexProp = _ref3.index,
      rest = _objectWithoutPropertiesLoose(_ref3, _excluded);
    var latestState = latest.current.state;
    var _getItemAndIndex = getItemAndIndex(selectedItemProp, indexProp, latestState.selectedItems, 'Pass either item or index to getSelectedItemProps!'),
      index = _getItemAndIndex[1];
    var isFocusable = index > -1 && index === latestState.activeIndex;
    var selectedItemHandleClick = function selectedItemHandleClick() {
      dispatch({
        type: SelectedItemClick,
        index: index
      });
    };
    var selectedItemHandleKeyDown = function selectedItemHandleKeyDown(event) {
      var key = normalizeArrowKey(event);
      if (key && selectedItemKeyDownHandlers[key]) {
        selectedItemKeyDownHandlers[key](event);
      }
    };
    return _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (selectedItemNode) {
      if (selectedItemNode) {
        selectedItemRefs.current.push(selectedItemNode);
      }
    }), _extends2.tabIndex = isFocusable ? 0 : -1, _extends2.onClick = callAllEventHandlers(onClick, selectedItemHandleClick), _extends2.onKeyDown = callAllEventHandlers(onKeyDown, selectedItemHandleKeyDown), _extends2), rest);
  }, [dispatch, latest, selectedItemKeyDownHandlers]);
  var getDropdownProps = useCallback(function (_temp2, _temp3) {
    var _extends3;
    var _ref4 = _temp2 === void 0 ? {} : _temp2,
      _ref4$refKey = _ref4.refKey,
      refKey = _ref4$refKey === void 0 ? 'ref' : _ref4$refKey,
      ref = _ref4.ref,
      onKeyDown = _ref4.onKeyDown,
      onClick = _ref4.onClick,
      _ref4$preventKeyActio = _ref4.preventKeyAction,
      preventKeyAction = _ref4$preventKeyActio === void 0 ? false : _ref4$preventKeyActio,
      rest = _objectWithoutPropertiesLoose(_ref4, _excluded2);
    var _ref5 = _temp3 === void 0 ? {} : _temp3,
      _ref5$suppressRefErro = _ref5.suppressRefError,
      suppressRefError = _ref5$suppressRefErro === void 0 ? false : _ref5$suppressRefErro;
    setGetterPropCallInfo('getDropdownProps', suppressRefError, refKey, dropdownRef);
    var dropdownHandleKeyDown = function dropdownHandleKeyDown(event) {
      var key = normalizeArrowKey(event);
      if (key && dropdownKeyDownHandlers[key]) {
        dropdownKeyDownHandlers[key](event);
      }
    };
    var dropdownHandleClick = function dropdownHandleClick() {
      dispatch({
        type: DropdownClick
      });
    };
    return _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (dropdownNode) {
      if (dropdownNode) {
        dropdownRef.current = dropdownNode;
      }
    }), _extends3), !preventKeyAction && {
      onKeyDown: callAllEventHandlers(onKeyDown, dropdownHandleKeyDown),
      onClick: callAllEventHandlers(onClick, dropdownHandleClick)
    }, rest);
  }, [dispatch, dropdownKeyDownHandlers, setGetterPropCallInfo]);

  // returns
  var addSelectedItem = useCallback(function (selectedItem) {
    dispatch({
      type: FunctionAddSelectedItem,
      selectedItem: selectedItem
    });
  }, [dispatch]);
  var removeSelectedItem = useCallback(function (selectedItem) {
    dispatch({
      type: FunctionRemoveSelectedItem,
      selectedItem: selectedItem
    });
  }, [dispatch]);
  var setSelectedItems = useCallback(function (newSelectedItems) {
    dispatch({
      type: FunctionSetSelectedItems,
      selectedItems: newSelectedItems
    });
  }, [dispatch]);
  var setActiveIndex = useCallback(function (newActiveIndex) {
    dispatch({
      type: FunctionSetActiveIndex,
      activeIndex: newActiveIndex
    });
  }, [dispatch]);
  var reset = useCallback(function () {
    dispatch({
      type: FunctionReset
    });
  }, [dispatch]);
  return {
    getSelectedItemProps: getSelectedItemProps,
    getDropdownProps: getDropdownProps,
    addSelectedItem: addSelectedItem,
    removeSelectedItem: removeSelectedItem,
    setSelectedItems: setSelectedItems,
    setActiveIndex: setActiveIndex,
    reset: reset,
    selectedItems: selectedItems,
    activeIndex: activeIndex
  };
}

/**
 * Uses CSS media queries to determine specific conditions, primary use case
 * is to determine if a viewport meets specific conditions, but can be used
 * for any media query
 *
 * @example
 * ```
 * const isScreenSizeSmall = useMatchMedia(`(min-width: ${HuiBreakpointProps.Sm}px) and (max-width: ${HuiBreakpointProps.Md - 1}px)`);
 * ```
 *
 * @param query - CSS media query
 * @returns
 */
const useMatchMedia = (query) => {
    const [matches, setMatches] = useState();
    useEffect(() => {
        var _a;
        const matchMediaQuery = window.matchMedia(query);
        if (matchMediaQuery) {
            const onChange = (evt) => {
                setMatches(evt.matches);
            };
            (_a = matchMediaQuery.addEventListener) === null || _a === void 0 ? void 0 : _a.call(matchMediaQuery, 'change', onChange);
            setMatches(matchMediaQuery.matches);
            return () => {
                var _a;
                (_a = matchMediaQuery.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(matchMediaQuery, 'change', onChange);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return matches;
};

const useDropdownMenuPosition = ({ menuId, isOpen, listOverflowHeight }) => {
    const [isDropdownFullHeight, setFullHeight] = useState(false);
    const [isDropdownFullWidth, setFullWidth] = useState(false);
    const [isDropdownOutsideRight, setOutsideRight] = useState(false);
    const [isDropdownOutsideBottom, setOutsideBottom] = useState(false);
    const [dropdownStyles, setDropdownStyles] = useState({});
    const [overlayStyles, setOverlayStyles] = useState({});
    const [scroll, setScroll] = useState({ x: 0, y: 0 });
    const oneHundredVH = useVH(100);
    const isScreenSizeSmall = useMatchMedia(`(min-width: ${HuiBreakpointProps.Sm}px) and (max-width: ${HuiBreakpointProps.Md - 1}px)`);
    listOverflowHeight = listOverflowHeight || window.innerHeight * 0.9;
    const beforeMenuOpen = () => {
        setScroll({ x: window.scrollX, y: window.scrollY });
    };
    useEffect(() => {
        if (isOpen) {
            const list = document.getElementById(menuId);
            const testBoundaries = (el) => {
                const listBounds = el.getBoundingClientRect();
                const isTall = listOverflowHeight <= el.offsetHeight;
                return {
                    isOutsideBottom: listOverflowHeight > el.offsetHeight && listBounds.y + listBounds.height > window.innerHeight,
                    isOutsideRight: listBounds.x + listBounds.width > window.innerWidth,
                    isTall,
                    isWide: window.innerWidth <= listBounds.width || (isTall && isScreenSizeSmall),
                };
            };
            const setBoundaries = (el, preserveTrue = false) => {
                // preserveTrue is for secondary calculations, ex first round menu displays off the bottom, so isOutsideBottom
                // is true for the second round, but due to rendering above the bottom after the first pass it will test false
                // on the second pass so the styles keeping it on screen would be removed unless we preserved the true value
                const { isOutsideBottom, isOutsideRight, isTall, isWide } = testBoundaries(el);
                setFullHeight(preserveTrue ? isDropdownFullHeight || isTall : isTall);
                setFullWidth(preserveTrue ? isDropdownFullWidth || isWide : isWide);
                setOutsideBottom(preserveTrue ? isDropdownOutsideBottom || isOutsideBottom : isOutsideBottom);
                setOutsideRight(preserveTrue ? isDropdownOutsideRight || isOutsideRight : isOutsideRight);
                setNoScrollOnBody(el && (isDropdownFullWidth || isDropdownFullHeight || isDropdownOutsideBottom));
                setNoScrollOnDialog(el && (isDropdownFullWidth || isDropdownFullHeight || isDropdownOutsideBottom));
            };
            setBoundaries(list);
            if (isDropdownFullHeight || isDropdownOutsideBottom) {
                setTimeout(() => {
                    // On small screens the list will already have displayed at full width by the time code execution reaches here
                    // but on larger screens it will just be full height with width to fit-content. The list is now
                    // removed from the confines of its relative position to the fixed position space which means the list
                    // can possibly extend off the right side of the screen, check for that, bring it back if necessary
                    setBoundaries(list, true);
                }, 0);
            }
        }
        else {
            setNoScrollOnBody(false);
            setNoScrollOnDialog(false);
            setFullHeight(false);
            setFullWidth(false);
            setOutsideBottom(false);
            setOutsideRight(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDropdownFullHeight, isDropdownOutsideBottom, isOpen]);
    useEffect(() => {
        const spacingUnit = '1rem';
        const zIndex = 10;
        const overlayStyle = {
            position: 'relative',
            width: '100%',
            zIndex,
        };
        const dropdownStyle = {
            overflowX: 'hidden',
            overflowY: isOpen ? 'auto' : 'hidden',
            position: 'absolute',
            width: '100%',
            zIndex,
        };
        if (isDropdownOutsideRight) {
            overlayStyle['right'] = 0;
            dropdownStyle['left'] = 'unset';
            dropdownStyle['right'] = isDropdownFullWidth || isDropdownFullHeight || isDropdownOutsideBottom ? spacingUnit : 0;
        }
        if (isDropdownOutsideBottom) {
            overlayStyle['bottom'] = 0;
            overlayStyle.position = 'fixed';
            dropdownStyle['bottom'] = spacingUnit;
            dropdownStyle['top'] = 'unset';
            dropdownStyle['width'] = 'fit-content';
        }
        if (isDropdownFullHeight) {
            overlayStyle['height'] = `${oneHundredVH}px`;
            overlayStyle['left'] = 'unset';
            overlayStyle.position = 'fixed';
            overlayStyle['top'] = '0';
            overlayStyle.width = 'unset';
            dropdownStyle['maxHeight'] = `calc(${oneHundredVH}px - (${spacingUnit} * 2))`;
            dropdownStyle['top'] = spacingUnit;
            dropdownStyle['width'] = 'fit-content';
        }
        if (isDropdownFullWidth) {
            overlayStyle['left'] = 0;
            dropdownStyle['left'] = spacingUnit;
            dropdownStyle['maxWidth'] = `calc(100vw - (${spacingUnit} * 2))`;
            dropdownStyle['width'] = `calc(100vw - (${spacingUnit} * 2))`;
        }
        setOverlayStyles(overlayStyle);
        setDropdownStyles(dropdownStyle);
        if (isOpen) {
            // if content displays outside of the viewport it can cause the page to scroll
            // in the beforeMenuOpen function the consumer of this hook will cause the
            // scroll position to be saved before the menu is opened, then when this is hit
            // it puts the page back to where it was so when the dropdown is closed the
            // page is where they left it
            window.scrollTo(scroll.x, scroll.y);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDropdownFullHeight, isDropdownFullWidth, isDropdownOutsideBottom, isDropdownOutsideRight]);
    return {
        beforeMenuOpen,
        dropdownStyles,
        isDropdownFullHeight,
        isDropdownFullWidth,
        isDropdownOutsideBottom,
        isDropdownOutsideRight,
        overlayStyles,
    };
};

const HuiSelectOption = (props) => {
    return React__default.createElement("option", { value: props.value }, props.children);
};

// Downshift documentation https://github.com/downshift-js/downshift/tree/master/src/hooks/useSelect
const defaultProps = {
    ariaDescribedBy: '',
    canDeselect: false,
    className: '',
    testId: 'select',
};
const HuiSelect = (props) => {
    var _a;
    const { size: contextSize } = useContext(InternalFormContext);
    const isMounted = useRef(false);
    const preventWatchTriggerWithOldValue = useRef('');
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    props = { ...defaultProps, ...props };
    const { autoComplete, canDeselect, children, className, disabled, helperText, initialText, label, labelIsHidden, name, onChange, readOnly, required, size, testId, value, validate, } = props;
    const selectSize = size || contextSize || HuiFormSizeProps.Normal;
    let { errors, register } = props;
    const items = [];
    const labelsMap = {};
    const testIdMap = {};
    const valuesMap = {};
    const deselectText = initialText || ' ';
    if (canDeselect) {
        items.push(deselectText);
        labelsMap[deselectText] = '';
        testIdMap[deselectText] = 'deselect-option';
        valuesMap[''] = deselectText;
    }
    React__default.Children.map(children, (child) => {
        const mappedLabel = child.props.children;
        const mappedValue = child.props.value || mappedLabel;
        items.push(mappedLabel);
        labelsMap[mappedLabel] = mappedValue;
        testIdMap[mappedLabel] = child.props.testId || 'select-option';
        valuesMap[mappedValue] = mappedLabel;
    });
    const { errors: contextErrors, register: contextRegister, setValue, trigger, watch } = useFormContext() || {};
    if (!register && contextRegister) {
        register = contextRegister;
    }
    if (!errors && contextErrors) {
        errors = contextErrors;
    }
    const hasError = Boolean(errors === null || errors === void 0 ? void 0 : errors[name]);
    const errorMessage = (_a = errors === null || errors === void 0 ? void 0 : errors[name]) === null || _a === void 0 ? void 0 : _a.message;
    const onSelectedItemChange = async (item) => {
        if (onChange) {
            onChange(labelsMap[item.selectedItem]);
        }
        if (trigger) {
            setTimeout(async () => {
                // if validation is set up this will cause it to re-check validation status
                await trigger(name);
            }, 0);
        }
    };
    const iconSize = selectSize === HuiFormSizeProps.Normal ? '2rem' : '1.75rem';
    const caretOpenIcon = (React__default.createElement(HuiInputIcon, { className: "hui-pointer-events-none", icon: HuiIconCaretUp, iconClassName: "hui-text-gray-50", iconSize: iconSize, inputSize: selectSize, placement: HuiInputIconPlacementProps.End }));
    const caretClosedIcon = (React__default.createElement(HuiInputIcon, { className: "hui-pointer-events-none", icon: HuiIconCaretDown, iconClassName: "hui-text-gray-50", iconSize: iconSize, inputSize: selectSize, placement: HuiInputIconPlacementProps.End }));
    function downshiftStateReducer(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _state, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    actionAndChanges) {
        const { type, changes } = actionAndChanges;
        switch (type) {
            case useSelect.stateChangeTypes.ToggleButtonKeyDownEnter:
            case useSelect.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
            case useSelect.stateChangeTypes.ToggleButtonClick:
            case useSelect.stateChangeTypes.ItemClick:
            case useSelect.stateChangeTypes.ToggleButtonKeyDownCharacter:
                if (disabled) {
                    return {
                        ...changes,
                        isOpen: false,
                    };
                }
        }
        return changes;
    }
    const { closeMenu, isOpen, getItemProps, getLabelProps, getMenuProps, getToggleButtonProps, highlightedIndex, selectItem, selectedItem, } = useSelect({
        items,
        onSelectedItemChange,
        stateReducer: downshiftStateReducer,
    });
    const watchValue = watch === null || watch === void 0 ? void 0 : watch(name);
    useEffect(() => {
        // not thrilled with this hack, but when using setValue or reset this useEffect is triggered once for the
        // new value, and subsequently for the old value, which results in an infinite loop. it doesn't seem
        // to matter if watch is used in the client code or not, nor if defaultValues exist on the form
        if (preventWatchTriggerWithOldValue.current !== watchValue) {
            // watchValue or selectedItem needs to be truthy, if neither are then it can result in loops and
            // other unexpected results
            if (isMounted.current && (watchValue || selectedItem)) {
                // watchValue comes from RHF, selectItem is downshift, this transfers the value change
                // from RHF to downshift as soon as RHF sets a new value in cases of defaultValues, reset, or setValue
                selectItem(valuesMap[watchValue]);
            }
        }
        setTimeout(() => {
            preventWatchTriggerWithOldValue.current = watchValue;
        }, 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watchValue]);
    useEffect(() => {
        if (selectedItem !== null) {
            // when something is selected in downshift selectedItem is updated so the value in
            // RHF needs to be updated with setValue
            let inputValue = selectedItem && labelsMap[selectedItem];
            if (inputValue === null || inputValue === undefined) {
                inputValue = value || '';
            }
            setValue === null || setValue === void 0 ? void 0 : setValue(name, inputValue, { shouldDirty: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedItem]);
    useEffect(() => {
        if (value !== undefined) {
            selectItem(valuesMap[value]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    const menuProps = getMenuProps();
    const menuId = `${menuProps.id}-list-container`;
    const { beforeMenuOpen, dropdownStyles, overlayStyles } = useDropdownMenuPosition({
        isOpen,
        menuId,
    });
    const { onClick: toggleButtonOnClick, tabIndex, ...toggleButtonProps } = getToggleButtonProps();
    const helperTextId = helperText ? `${toggleButtonProps.id}-helper-text` : '';
    const errorTextId = hasError ? `${toggleButtonProps.id}-error-text` : '';
    const { 'aria-labelledby': menuLabelledBy, role: menuRole, ...menuContainerProps } = menuProps;
    return (React__default.createElement("div", { className: className },
        React__default.createElement(HuiLabel, { ...getLabelProps(), isHidden: labelIsHidden, readOnly: readOnly, testId: `${testId}-label` }, label),
        React__default.createElement(HuiFieldHelperText, { id: helperTextId, testId: `${testId}-helper-text` }, helperText),
        React__default.createElement("div", { className: "hui-select-container" },
            React__default.createElement("div", { className: "hui-position-relative" },
                React__default.createElement("div", { "aria-describedby": `${helperTextId} ${errorTextId}`, "aria-disabled": disabled, className: `hui-select-button hui-input hui-ellipsis hui-padding-right-48 
              ${hasError ? 'hui-field-has-error' : ''} ${disabled ? 'hui-select-button-disabled' : ''}
              ${selectSize === HuiFormSizeProps.Compact ? 'hui-input-compact hui-select-button-compact' : ''}
            `, "data-testid": testId, onClick: (evt) => {
                        beforeMenuOpen();
                        toggleButtonOnClick(evt);
                    }, tabIndex: disabled ? -1 : tabIndex, ...toggleButtonProps }, selectedItem || valuesMap[value] || value || initialText || ' '),
                isOpen ? caretOpenIcon : caretClosedIcon),
            React__default.createElement("div", { onClick: closeMenu, style: overlayStyles },
                React__default.createElement("div", { className: `hui-select-list-container ${isOpen ? 'hui-select-is-open' : 'hui-visually-hidden'}`, style: dropdownStyles, ...menuContainerProps },
                    React__default.createElement("ul", { "aria-hidden": !isOpen, "aria-invalid": hasError, "aria-labelledby": menuLabelledBy, "aria-required": Boolean(required), className: "hui-select-list", "data-testid": `select-list-${testId}`, id: menuId, role: menuRole }, items.map((item, index) => {
                        if (!selectedItem && item === deselectText) {
                            return null;
                        }
                        return (React__default.createElement("li", { className: `
                      hui-select-option hui-ellipsis 
                      ${index === highlightedIndex ? 'hui-select-option-highlighted' : ''}
                      ${item === selectedItem ? 'hui-select-option-selected' : ''}
                      ${size === HuiFormSizeProps.Compact ? 'hui-select-option-compact' : ''}
                    `, "data-testid": testIdMap[item], key: `${item}-${index}`, ...getItemProps({ index, item }) }, item));
                    }))))),
        React__default.createElement(HuiFieldError, { errorMessage: errorMessage, hasError: hasError, id: errorTextId, testId: `${testId}-error-message` }),
        React__default.createElement("input", { "aria-hidden": true, autoComplete: autoComplete, className: "hui-visually-hidden", "data-testid": `select-input-${testId}`, name: name, onChange: (evt) => {
                // browser autocomplete triggers this
                selectItem(valuesMap[evt.target.value]);
            }, onFocus: () => {
                var _a;
                // react-hook-form gives this element focus when there is an error, but
                // it really needs to go to the button so keyboard input can toggle open
                // the dropdown again
                (_a = document.getElementById(toggleButtonProps.id)) === null || _a === void 0 ? void 0 : _a.focus();
            }, ref: register && register({ required, validate }), 
            // Safari has a bug where it won't autofill a form element if it has a tabindex of -1, is readonly, or disabled.
            // Tabindex needs to be -1 to prevent focus from ever reaching it via keyboard. As soon as this input receives
            // focus programatically, it redirects focus to the button launcher because that redirect is required for proper
            // error focusing. If it did receive focus via keyboard it will result in a loop where it appears focus cannot
            // get past the select
            tabIndex: -1, type: "text", value: labelsMap[selectedItem] || '' })));
};

var HuiTextAreaAlignProps;
(function (HuiTextAreaAlignProps) {
    HuiTextAreaAlignProps["Center"] = "hui-text-align-center";
    HuiTextAreaAlignProps["Left"] = "hui-text-align-left";
    HuiTextAreaAlignProps["Right"] = "hui-text-align-right";
})(HuiTextAreaAlignProps || (HuiTextAreaAlignProps = {}));
const HuiTextArea = ({ ariaDescribedBy = '', autoComplete = 'off', className = '', cols = 20, count = false, countLabel, disabled, errors, format = (v) => v, helperText, id, label, labelIsHidden = false, maxLength, minLength, name: elementName, onChange, pattern, placeholder, register, required, rows = 4, size, spellCheck = true, textAlign = HuiTextAreaAlignProps.Left, testId = 'textarea', validate, value, ...otherProps }) => {
    var _a;
    const { size: contextSize } = useContext(InternalFormContext);
    const [charCount, setCharCount] = useState((value === null || value === void 0 ? void 0 : value.length) || 0);
    if (!id) {
        id = uniqueId();
    }
    let textareaErrors = errors;
    let textareaRegister = register;
    let textareaValue = value;
    const textareaSize = size || contextSize || HuiFormSizeProps.Normal;
    if (textareaValue) {
        const initialValue = format(textareaValue);
        if (!(initialValue instanceof RangeError)) {
            textareaValue = `${initialValue}`;
        }
    }
    const { clearErrors, errors: contextErrors, register: contextRegister, setError, setValue, trigger, } = useFormContext() || {};
    if (!textareaRegister && contextRegister) {
        textareaRegister = contextRegister;
    }
    if (!errors && contextErrors) {
        textareaErrors = contextErrors;
    }
    const internalOnChange = (evt) => {
        var _a;
        if (onChange) {
            onChange(evt);
        }
        const formattedValue = format(evt.target.value);
        setCharCount(((_a = evt.target.value) === null || _a === void 0 ? void 0 : _a.length) || 0);
        if (formattedValue instanceof RangeError) {
            setError === null || setError === void 0 ? void 0 : setError(elementName, {
                message: formattedValue.message,
                type: 'manual',
            });
            return;
        }
        setValue === null || setValue === void 0 ? void 0 : setValue(elementName, formattedValue);
        clearErrors === null || clearErrors === void 0 ? void 0 : clearErrors(elementName);
        triggerValidation();
    };
    useEffect(() => {
        if (value) {
            triggerValidation();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const triggerValidation = () => {
        if (minLength || maxLength) {
            trigger === null || trigger === void 0 ? void 0 : trigger(elementName);
        }
    };
    const hasError = Boolean(textareaErrors === null || textareaErrors === void 0 ? void 0 : textareaErrors[elementName]);
    const errorMessage = (_a = textareaErrors === null || textareaErrors === void 0 ? void 0 : textareaErrors[elementName]) === null || _a === void 0 ? void 0 : _a.message;
    const helperTextId = helperText ? `${id}-helper-text` : '';
    const errorTextId = hasError ? `${id}-error-text` : '';
    const countTextId = count ? `${id}-count-text` : '';
    const maxLengthValue = ((maxLength === null || maxLength === void 0 ? void 0 : maxLength.value) || maxLength);
    const minLengthValue = ((minLength === null || minLength === void 0 ? void 0 : minLength.value) || minLength);
    return (React__default.createElement("div", { className: className },
        React__default.createElement(HuiLabel, { htmlFor: id, isHidden: labelIsHidden, testId: `${testId}-label` }, label),
        React__default.createElement(HuiFieldHelperText, { id: helperTextId, testId: `${testId}-helper-text` }, helperText),
        React__default.createElement("div", { className: "hui-position-relative hui-textarea-container" },
            React__default.createElement("textarea", { "aria-describedby": `${helperTextId} ${errorTextId} ${countTextId} ${ariaDescribedBy}`, "aria-invalid": hasError, "aria-required": Boolean(required), autoComplete: autoComplete, className: `
            hui-textarea
            ${textareaSize === HuiFormSizeProps.Compact ? 'hui-textarea-compact' : ''}
            ${hasError ? 'hui-field-has-error' : ''}
            ${textAlign}
          `, cols: cols, "data-testid": testId, defaultValue: textareaValue, disabled: disabled, id: id, name: elementName, onChange: internalOnChange, placeholder: disabled ? null : placeholder, ref: textareaRegister && textareaRegister({ maxLength, minLength, pattern, required, validate }), rows: rows, spellCheck: spellCheck, ...otherProps })),
        React__default.createElement("div", { className: "hui-flex" },
            React__default.createElement(HuiFieldError, { className: "hui-flex-1", errorMessage: errorMessage, hasError: hasError, id: errorTextId, testId: `${testId}-error-message` }),
            count && (React__default.createElement("div", { className: "hui-flex-1 hui-text-align-right hui-text-sm hui-margin-top-8", "data-testid": `${testId}-count`, id: countTextId },
                countLabel,
                ' ',
                React__default.createElement("span", { className: `${(maxLengthValue && charCount && charCount > maxLengthValue) ||
                        (minLengthValue && charCount && charCount < minLengthValue)
                        ? 'hui-text-error hui-font-weight-700'
                        : ''}` }, charCount),
                maxLengthValue >= 0 && `/${maxLengthValue}`)))));
};

/**
 * The `HuiContext` allows definition of several parameters once per application. This
 * is particularly useful for passing in labels which need to be localized at the
 * application level, ex. Datepicker labels, close button labels, notification count
 * labels, etc... It can also be used for any application state that HUI needs to know
 * about in order to function properly.
 */
const HuiContext = React__default.createContext({});

/**
 * A heading component for HUI. It will translate the `level` into all the regular css classes used for that
 * particular heading level.
 *
 * For `h1`'s it will add special functionality for reading the `h1` when the SPA is navigated to new pages.
 * This will focus the `h1` for Assistive Technologies so the new page name is announced.
 *
 * NOTE: heading levels are meant to be semantic. Do not apply a level because it gives you the correct
 * style. Always apply `level`'s in descending, sequential order. If a particular `level` does not match the
 * styling, apply a `layout` that does.
 *
 * If the pre-configured `layout`'s do not match your design (this is not typical), consult with the designer
 * to confirm the design is correct. If the design is correct then use `className` to apply different css
 * classes which are appropriate.
 */
const HuiHeading = ({ children, className = '', layout, level, testId = 'heading', ...otherProps }) => {
    var _a;
    const heading = `h${level}`;
    const ref = useRef();
    const { isInitialPageLoad } = useContext(HuiContext);
    useEffect(() => {
        // for screen readers and keyboard users when a page is navigated in a spa, the h1 should be
        // focused to both announce the new "page" they are on and to reset focus to an expected place
        if (level === 1 && ref.current && !isInitialPageLoad) {
            if (!document.getElementById('reauth')) {
                ref.current.focus();
            }
        }
    }, []);
    const defaultClassNames = {
        h1: 'page',
        h2: 'paper',
        h3: 'section',
        h4: 'subsection',
    };
    const internalClassNames = {
        page: 'hui-heading-page hui-padding-top-24 hui-margin-top-16:md hui-margin-bottom-32 hui-padding-left-8 hui-padding-left-32:md',
        paper: 'hui-heading-paper',
        section: 'hui-heading-section',
        subsection: 'hui-heading-subsection',
    };
    const internalClassName = (_a = internalClassNames[layout !== null && layout !== void 0 ? layout : defaultClassNames[heading]]) !== null && _a !== void 0 ? _a : '';
    const HeadingWithLevel = (headingProps) => React__default.createElement(heading, { ...headingProps, ref }, children);
    return (React__default.createElement(HeadingWithLevel, { className: `${internalClassName} ${className}`, "data-testid": testId, ...(level === 1 && { id: 'pageTitle', tabIndex: -1 }), ...otherProps }, children));
};

var HuiInfoBoxType;
(function (HuiInfoBoxType) {
    HuiInfoBoxType[HuiInfoBoxType["Basic"] = 0] = "Basic";
    HuiInfoBoxType[HuiInfoBoxType["Caution"] = 1] = "Caution";
    HuiInfoBoxType[HuiInfoBoxType["Error"] = 2] = "Error";
    HuiInfoBoxType[HuiInfoBoxType["Information"] = 3] = "Information";
    HuiInfoBoxType[HuiInfoBoxType["Success"] = 4] = "Success";
})(HuiInfoBoxType || (HuiInfoBoxType = {}));
const HuiInfoBox = ({ className = '', closeButton, closeButtonLabel, icon, message, testId = 'cmp-infobox', title, type = HuiInfoBoxType.Basic, verticalCenter = false, ...otherProps }) => {
    const [isVisible, setVisible] = useState(true);
    const id = useRef(uniqueId()).current;
    let ariaLive = 'polite';
    let iconClasses = '';
    let infoBoxClasses = '';
    switch (type) {
        case HuiInfoBoxType.Basic:
            ariaLive = 'off';
            iconClasses = 'hui-text-gray-100';
            infoBoxClasses = 'hui-background-gray-100';
            break;
        case HuiInfoBoxType.Caution:
            iconClasses = 'hui-text-caution';
            infoBoxClasses = 'hui-background-legend-yellow-100';
            break;
        case HuiInfoBoxType.Error:
            ariaLive = 'assertive';
            iconClasses = 'hui-text-error';
            infoBoxClasses = 'hui-background-badge-pink';
            break;
        case HuiInfoBoxType.Information:
            iconClasses = 'hui-text-information';
            infoBoxClasses = 'hui-background-legend-blue-100';
            break;
        case HuiInfoBoxType.Success:
            iconClasses = 'hui-text-success';
            infoBoxClasses = 'hui-background-legend-green-100';
            break;
    }
    if (!isVisible) {
        return null;
    }
    return (React__default.createElement("div", { "aria-live": ariaLive, className: `hui-flex hui-border-radius-10 hui-padding-12 hui-padding-24:md ${verticalCenter && 'hui-flex-align-center'} ${infoBoxClasses} ${className}`, "data-testid": testId, id: id, ...otherProps },
        icon && (React__default.createElement(HuiIcon, { className: `hui-margin-right-8 ${iconClasses}`, icon: icon, size: "1.8rem", style: verticalCenter ? {} : { marginTop: '2px' }, testId: `${testId}-icon` })),
        React__default.createElement("div", { className: "hui-flex-1" },
            title && (React__default.createElement("div", { className: `hui-text-gray-10 hui-text-lg:scale hui-font-weight-700 ${message && 'hui-margin-bottom-8'}`, "data-testid": `${testId}-title` }, title)),
            React__default.createElement("div", { className: "hui-text-gray-10 hui-text-compact", "data-testid": `${testId}-message` }, message)),
        closeButton && (React__default.createElement("div", { style: verticalCenter ? { display: 'inherit' } : { position: 'relative', top: '-7px' } },
            React__default.createElement("button", { "aria-describedby": id, "aria-label": closeButtonLabel, className: "hui-icon-button", "data-testid": `${testId}-close-button`, onClick: () => setVisible(false), type: "button" },
                React__default.createElement(HuiIcon, { icon: HuiIconCross, testId: `${testId}-close-icon` }))))));
};

/**
 * Typically pairs with async paginated tables. Will dim the content wrapped with this component and
 * show a `HuiLoader` when the `loading` prop is true.
 *
 * @param HuiLoaderOverlayProps - {@link HuiLoaderOverlayProps}
 * @returns Wrapped children with a loading overlay
 */
const HuiLoaderOverlay = ({ children, className, label, loading, testId = 'loader-overlay', ...otherProps }) => {
    return (React__default.createElement("div", { "aria-busy": loading, "aria-label": label, "aria-live": "polite", className: `hui-position-relative ${className}`, "data-testid": testId, ...otherProps },
        children,
        loading && (React__default.createElement("div", { "aria-live": "polite", className: "hui-loader-overlay", "data-testid": `${testId}-visible` },
            React__default.createElement(HuiLoader, { className: "hui-loader-overlay-loader", testId: `${testId}-loader` })))));
};

/**
 * Fires a callback when any area outside of a defined node is clicked
 *
 * @example
 * ```
 * JS:
 * const closeOpenMenu = () => {
 *   if (isOpen) {
 *     closeMenu();
 *   }
 * };
 * const containerRef = useRef(null);
 * useClickOutside(containerRef, closeOpenMenu);
 *
 * JSX:
 * <div>
 *   <div ref={containerRef}>Menu</div>
 *   <p>Click on this and the menu will close</p>
 * </div>
 * ```
 *
 * @param ref - React ref that is assigned to the node that should not trigger the callback if it is clicked
 * @param callback - function that is called when anything that is not contained by the ref is clicked on
 * @param isActive - state which will turn this functionality on or off
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useClickOutside = (ref, callback, isActive = true) => {
    const handleClick = (event) => {
        var _a;
        if (isActive && ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) === false) {
            callback();
        }
    };
    useEffect(() => {
        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, []);
};

/**
 * Returns the element bounds of a specified element, including height, width, scroll height and width,
 * and if the element is overflowing its container. It updates according to the specified conditions.
 *
 * @example
 * ```
 * const { height: menuHeight } = useGetBoundingRects({
 *   conditions: () => !!selectedItem || isOpen,
 *   delay: 0,
 *   dependencies: [selectedItem, isOpen],
 *   elementId: menuId,
 * });
 * ```
 *
 * @param config - the configuration options {@link GetBoundingRectProps}
 */
const useGetBoundingRects = ({ conditions, delay, dependencies, elementId }) => {
    const [boundingRects, setBoundingRects] = useState();
    const getElementBounds = () => {
        const element = document.getElementById(elementId);
        if (element) {
            const { bottom, height, left, right, top, width, x, y } = element.getBoundingClientRect();
            const { clientHeight, clientWidth, scrollHeight, scrollWidth } = element;
            setBoundingRects({
                bottom,
                clientHeight,
                clientWidth,
                height,
                left,
                right,
                scrollHeight,
                scrollWidth,
                top,
                width,
                x,
                y,
            });
        }
    };
    useEffect(() => {
        if (conditions()) {
            if (delay === undefined) {
                getElementBounds();
            }
            else {
                setTimeout(getElementBounds, delay);
            }
        }
    }, dependencies);
    return (boundingRects || {
        bottom: 0,
        clientHeight: 0,
        clientWidth: 0,
        height: 0,
        left: 0,
        right: 0,
        scrollHeight: 0,
        scrollWidth: 0,
        top: 0,
        width: 0,
        x: 0,
        y: 0,
    });
};

const HuiMenuList = ({ closeOpenMenu, getItemProps, highlightedIndex, isActionLayout, isInlineLayout, inlineLayoutMenuItemClasses, isOpen, isNavLayout, isSmScreen, isMenuLayout, menuActiveDescendant, menuClassName, menuId, menuItems, menuLabelledBy, menuRole, refsMap, selectedItem, testId = 'menu', }) => {
    return (React__default.createElement("ul", { "aria-activedescendant": menuActiveDescendant, "aria-hidden": !isOpen, "aria-labelledby": menuLabelledBy, className: `hui-menu-list ${isMenuLayout && !isSmScreen ? 'hui-menu-list-tab-panel-menu' : ''} ${menuClassName}`, "data-testid": `${testId}-menu-list`, id: menuId, role: menuRole }, menuItems.map((menuItem, index) => {
        var _a;
        const optionProps = getItemProps({
            index,
            item: menuItem.item.props.id,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onChange: () => { },
            ref: refsMap[menuItem.id],
        });
        if (isNavLayout &&
            Children.toArray(menuItem.item.props.children).some((child) => {
                return child.type === 'a';
            })) {
            // The nav layout is composed of links which handle clicks on their own
            // in some cases the default onClick handler will cause links to fire twice
            // we just want the menu to close and let the link handle itself
            // the children are filtered to include a because a submenu could be present
            // which toggles visibility of its children and should have the default
            // click handler
            optionProps.onClick = closeOpenMenu;
        }
        let highlightedIndexClass = 'hui-menu-item-highlighted-left-border';
        let selectedIndexClass = 'hui-menu-item-selected-left-border';
        let layoutSpecificClasses = '';
        if (isInlineLayout) {
            layoutSpecificClasses = `hui-menu-item-inline hui-padding-right-8 ${inlineLayoutMenuItemClasses}`;
        }
        else if (isActionLayout) {
            highlightedIndexClass = 'hui-menu-item-highlighted-background-color';
            selectedIndexClass = '';
            layoutSpecificClasses = 'hui-menu-item-action';
        }
        else if (isMenuLayout) {
            highlightedIndexClass = 'hui-menu-item-highlighted-background-color';
            selectedIndexClass = 'hui-menu-item-selected-background-color';
            layoutSpecificClasses = 'hui-menu-item-tab-panel-menu';
        }
        return (React__default.createElement(React__default.Fragment, { key: `${menuItem.id}` },
            isInlineLayout && index === 0 && React__default.createElement("li", { className: "hui-menu-inline-top", role: "presentation" }),
            menuItem.item.props.topBorder && React__default.createElement("li", { className: "hui-menu-item-border-top", role: "presentation" }),
            React__default.createElement("li", { className: `hui-menu-item
                ${layoutSpecificClasses}
                ${index === highlightedIndex ? highlightedIndexClass : ''}
                ${menuItem.id === selectedItem ? selectedIndexClass : ''}
              `, "data-testid": `${(_a = menuItem.item.props.testId) !== null && _a !== void 0 ? _a : 'menu'}-list-item`, ...optionProps, "aria-selected": menuItem.id === selectedItem, role: "menuitem" }, menuItem.item),
            isInlineLayout && index === menuItems.length - 1 && (React__default.createElement("li", { className: "hui-menu-inline-bottom", role: "presentation" }))));
    })));
};

var HuiMenuAlignProps;
(function (HuiMenuAlignProps) {
    HuiMenuAlignProps[HuiMenuAlignProps["Left"] = 0] = "Left";
    HuiMenuAlignProps[HuiMenuAlignProps["Right"] = 1] = "Right";
})(HuiMenuAlignProps || (HuiMenuAlignProps = {}));
var HuiMenuLayoutProps;
(function (HuiMenuLayoutProps) {
    /**
     * Use for one-off actions in a dropdown menu with an outline button as the launcher
     */
    HuiMenuLayoutProps[HuiMenuLayoutProps["ActionMenu"] = 0] = "ActionMenu";
    /**
     * Use for switching between content within the same section on a page, appears without a border
     */
    HuiMenuLayoutProps[HuiMenuLayoutProps["Inline"] = 1] = "Inline";
    /**
     * Use for page navigation, primarily the top right menu
     */
    HuiMenuLayoutProps[HuiMenuLayoutProps["Nav"] = 2] = "Nav";
    /**
     * Used in conjunction with a HuiStepper, this internal only layout is used for rendering a stepper in a Sm viewport
     */
    HuiMenuLayoutProps[HuiMenuLayoutProps["ProgressMenu"] = 3] = "ProgressMenu";
    /**
     * Used in conjunction with HuiTabPanels, this internal only layout is used for rendering nav tabs in a Sm viewport
     */
    HuiMenuLayoutProps[HuiMenuLayoutProps["TabPanelMenu"] = 4] = "TabPanelMenu";
})(HuiMenuLayoutProps || (HuiMenuLayoutProps = {}));

// Downshift documentation https://github.com/downshift-js/downshift/tree/master/src/hooks/useSelect
/**
 * Use to display an inline menu or for a global navigation menu.
 *
 * Each menu is comprised of a `HuiMenu` and any number of `HuiMenuItem` children.
 *
 * NOTE: many props are conditional on the type of `layout` prop used, refer to {@link HuiMenuProps}.
 *
 * @remarks
 * [API/Demos](https://hui.inside.humaninterest.com/?path=/docs/components-huimenu--documentation)
 *
 * {@link HuiMenuProps}
 *
 * @returns HuiMenu component
 *
 * @example
 * See the API/Demo links for example usage
 */
const HuiMenu = ({ align = HuiMenuAlignProps.Left, caretClassName = '', children, closeLabel, disabled = false, hideCaret, label, launcher, launcherContainerClassName = '', layout = HuiMenuLayoutProps.Inline, menuClassName = '', mobileLayout, onClose, rootClassName = '', selectedIndex = 0, testId = 'menu', ...otherProps }) => {
    var _a, _b, _c;
    const matchingBreakpoint = useMatchingBreakpoint();
    const isSmScreen = matchingBreakpoint === HuiBreakpointProps.Sm;
    const launcherId = useRef(uniqueId()).current;
    const isActionLayout = layout === HuiMenuLayoutProps.ActionMenu;
    const isInlineLayout = layout === HuiMenuLayoutProps.Inline;
    const isNavLayout = layout === HuiMenuLayoutProps.Nav;
    const isMenuLayout = layout === HuiMenuLayoutProps.TabPanelMenu || layout === HuiMenuLayoutProps.ProgressMenu;
    const isTabPanelMenuInDialog = isSmScreen && isMenuLayout;
    const internalCaretClassName = `hui-pointer-events-none hui-flex-justify-end ${isInlineLayout ? 'hui-margin-right-4' : ''} ${disabled ? 'hui-text-gray-70' : ''} ${caretClassName}`;
    const caretOpenIcon = React__default.createElement(HuiIcon, { className: internalCaretClassName, icon: HuiIconCaretUp });
    const caretClosedIcon = React__default.createElement(HuiIcon, { className: internalCaretClassName, icon: HuiIconCaretDown });
    const useMobileLayout = mobileLayout !== undefined ? mobileLayout : isSmScreen;
    const refsMap = {};
    const idMap = {};
    const allItemsWithId = React__default.Children.map(children, (item, index) => {
        const id = `el-${launcherId}-${index}`;
        if (item) {
            idMap[id] = item;
            // eslint-disable-next-line react-hooks/rules-of-hooks
            refsMap[id] = useRef(id);
        }
        return { id, item };
    });
    const menuItems = allItemsWithId.filter(({ item }) => item && !item.props.hidden);
    const items = menuItems.map(({ id }) => {
        return id;
    });
    const itemToString = (item) => {
        if (!item) {
            return '';
        }
        return item.id || item;
    };
    const onIsOpenChange = (changes) => {
        if (!changes.isOpen && onClose) {
            onClose();
        }
    };
    const onSelectedItemChange = async (item) => {
        var _a, _b;
        if (!item.selectedItem) {
            return null;
        }
        const id = item.selectedItem;
        const { onSelect } = (_a = idMap[id]) === null || _a === void 0 ? void 0 : _a.props;
        if (onSelect) {
            await onSelect();
        }
        else {
            // if the enter key is pressed while a menu option is focused and there is a link
            // inside the menu item the event won't reach it so have to manually trigger
            // unless dropshift allows for optional event propagation in the future
            const link = (_b = refsMap[id].current.getElementsByTagName('a')) === null || _b === void 0 ? void 0 : _b[0];
            if (link && link.href !== window.location.href) {
                link.click();
            }
        }
        if (isNavLayout) {
            selectItem(null);
        }
    };
    function downshiftStateReducer(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    state, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    actionAndChanges) {
        var _a;
        const { type, changes } = actionAndChanges;
        const selectedItemProps = (_a = idMap[changes.selectedItem]) === null || _a === void 0 ? void 0 : _a.props;
        switch (type) {
            case useSelect.stateChangeTypes.ToggleButtonBlur:
                // this is operating in a dialog, the user should be able to
                // hide this on their own
                if (isTabPanelMenuInDialog) {
                    return {
                        ...changes,
                        isOpen: true,
                        selectedItem,
                    };
                }
                break;
            case useSelect.stateChangeTypes.ToggleButtonKeyDownEnter:
            case useSelect.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
            case useSelect.stateChangeTypes.ItemClick:
            case useSelect.stateChangeTypes.ToggleButtonClick:
                if ((selectedItemProps === null || selectedItemProps === void 0 ? void 0 : selectedItemProps.closeMenuOnClick) === false) {
                    // For scenarios where a sub-menu is implemented, keep the menu open on click
                    if (changes.selectedItem === state.selectedItem) {
                        // Since the currently selected item is open and it is clicked again, downshift
                        // won't refire the onSelectedItemChange event, so have to do it manually
                        selectedItemProps === null || selectedItemProps === void 0 ? void 0 : selectedItemProps.onSelect();
                    }
                    return {
                        ...changes,
                        highlightedIndex: isNavLayout && !isOpen ? null : state.highlightedIndex,
                        isOpen: true,
                    };
                }
                if (isActionLayout && isOpen) {
                    selectedItemProps === null || selectedItemProps === void 0 ? void 0 : selectedItemProps.onSelect();
                    return { ...changes, highlightedIndex: null, selectedItem: null };
                }
                break;
            // handles circular navigation in Up direction
            case useSelect.stateChangeTypes.ToggleButtonKeyDownArrowDown:
                if (state.highlightedIndex === items.length - 1) {
                    return { ...changes, highlightedIndex: state.highlightedIndex };
                }
                else {
                    return changes;
                }
            // handles circular navigation in Down direction
            case useSelect.stateChangeTypes.ToggleButtonKeyDownArrowUp:
                if (state.highlightedIndex === 0) {
                    return { ...changes, highlightedIndex: state.highlightedIndex };
                }
                else {
                    return changes;
                }
        }
        return changes;
    }
    let initialSelectedItem = (_a = menuItems.find((menuItem) => { var _a; return (_a = menuItem === null || menuItem === void 0 ? void 0 : menuItem.item) === null || _a === void 0 ? void 0 : _a.props.selected; })) === null || _a === void 0 ? void 0 : _a.id;
    if (!initialSelectedItem && (isInlineLayout || isMenuLayout)) {
        // pre-select the first (or manually selected) item only if the menu does not have a launcher
        initialSelectedItem = (_b = menuItems[selectedIndex]) === null || _b === void 0 ? void 0 : _b.id;
    }
    const { closeMenu, isOpen, getItemProps, getLabelProps, getMenuProps, getToggleButtonProps, highlightedIndex, selectItem, selectedItem, } = useSelect({
        initialSelectedItem,
        itemToString,
        items,
        onIsOpenChange,
        onSelectedItemChange,
        stateReducer: downshiftStateReducer,
    });
    useEffect(() => {
        var _a;
        if (selectedIndex >= 0 && (isInlineLayout || isMenuLayout)) {
            selectItem((_a = menuItems[selectedIndex]) === null || _a === void 0 ? void 0 : _a.id);
        }
    }, [selectedIndex]);
    const closeOpenMenu = () => {
        if (isOpen) {
            closeMenu();
        }
    };
    const containerRef = useRef(null);
    useClickOutside(containerRef, closeOpenMenu, isTabPanelMenuInDialog ? false : isOpen);
    const menuProps = getMenuProps();
    const menuId = `${menuProps.id}-list-container`;
    const { 'aria-activedescendant': menuActiveDescendant, onClick: toggleButtonOnClick, ...toggleButtonProps } = getToggleButtonProps();
    delete toggleButtonProps['aria-labelledby'];
    const oneHundredVH = useVH(100);
    const { height: launcherHeight } = useGetBoundingRects({
        conditions: () => isOpen,
        dependencies: [isOpen],
        elementId: `${toggleButtonProps.id}-parent`,
    });
    const { height: menuHeight } = useGetBoundingRects({
        conditions: () => !!selectedItem || isOpen,
        delay: 0,
        dependencies: [selectedItem, isOpen],
        elementId: menuId,
    });
    const { beforeMenuOpen, isDropdownFullHeight, isDropdownOutsideBottom, isDropdownOutsideRight, dropdownStyles, overlayStyles, } = useDropdownMenuPosition({
        isOpen: isOpen && !isTabPanelMenuInDialog,
        listOverflowHeight: isNavLayout ? window.innerHeight - launcherHeight : undefined,
        menuId: menuProps.id,
    });
    const { 'aria-labelledby': menuLabelledBy, ...menuContainerProps } = menuProps;
    // override the default listbox role provided by downshift
    const menuRole = 'menu';
    const inlineDropdownStyles = {};
    const navDropdownStyles = {};
    if (isInlineLayout && !isDropdownFullHeight && !isDropdownOutsideBottom && !isDropdownOutsideRight) {
        inlineDropdownStyles['top'] = `-${launcherHeight}px`;
    }
    else if (isNavLayout && useMobileLayout) {
        navDropdownStyles['top'] = `0px`;
        navDropdownStyles['height'] = `calc(${oneHundredVH}px - ${launcherHeight}px`;
    }
    else if (isNavLayout && !useMobileLayout) {
        navDropdownStyles['maxHeight'] = `calc(${oneHundredVH}px - ${launcherHeight}px`;
    }
    if (!useMobileLayout) {
        if (isMenuLayout) {
            navDropdownStyles['--bottomBorderRadius'] = '4px';
        }
        else {
            // opening a sub-menu could make a flyout style menu overflow when opened, in that case, no border radius
            navDropdownStyles['--bottomBorderRadius'] = menuHeight === window.innerHeight - launcherHeight ? '0' : '14px';
        }
    }
    const inlineLayoutMenuItemClasses = 'hui-text-compact hui-font-weight-semi-bold hui-text-gray-10 hui-padding-vertical-12 hui-padding-left-16';
    const labelProps = getLabelProps();
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: rootClassName, ref: containerRef, ...otherProps },
            React__default.createElement("div", { className: "hui-visually-hidden", ...labelProps }, label),
            React__default.createElement("div", { className: `${isNavLayout ? 'hui-menu-list-container-nav-layout' : ''}
          ` },
                React__default.createElement("div", { className: `hui-position-relative
            ${isNavLayout ? 'hui-flex hui-flex-justify-end' : ''}
            ${launcherContainerClassName}
          `, id: `${toggleButtonProps.id}-parent` },
                    React__default.createElement("div", { "aria-controls": menuId, "aria-describedby": launcherId, "aria-labelledby": labelProps.id, className: `
              hui-menu-launcher hui-flex hui-flex-align-center hui-ellipsis
              ${isActionLayout ? 'hui-menu-launcher-action-menu' : ''}
              ${isInlineLayout ? 'hui-width-full hui-text-align-left' : ''}
              ${isMenuLayout ? 'hui-menu-launcher-tab-panel-menu' : ''}
              ${disabled ? 'hui-menu-action-disabled' : ''}
            `, ...toggleButtonProps, ...(disabled && { 'aria-disabled': true, tabIndex: -1 }), "aria-haspopup": "true", "data-testid": testId, onClick: (evt) => {
                            if (disabled) {
                                return;
                            }
                            beforeMenuOpen();
                            if (isNavLayout) {
                                // if the page is scrolled slightly and the nav menu is clickable, and the menu is full
                                // screen height (either on mobile, or a scrollable menu), then there will be a white
                                // gap at the bottom if the page is not scrolled up all the way up, unfortunately
                                // safari plays by different rules than the rest, so that's why there are two scrollTo's
                                // one fires before the click is triggered, and one fires after the click is triggered
                                window.scrollTo(0, 0);
                                setTimeout(() => {
                                    window.scrollTo(0, 0);
                                }, 10);
                            }
                            toggleButtonOnClick(evt);
                        }, role: "button" },
                        React__default.createElement("div", { className: `hui-menu-launcher-content hui-flex-1 ${isInlineLayout ? inlineLayoutMenuItemClasses : ''}`, id: launcherId }, launcher || idMap[selectedItem]),
                        !hideCaret && (React__default.createElement("span", { className: `${isMenuLayout ? 'hui-text-primary-teal' : 'hui-text-gray-50'}` }, isOpen ? caretOpenIcon : caretClosedIcon)))),
                !isTabPanelMenuInDialog && (React__default.createElement("div", { className: `hui-menu-list-container-overlay
            ${isNavLayout && !useMobileLayout && !isDropdownFullHeight
                        ? 'hui-menu-list-nav-layout-large-screen-overlay'
                        : ''}
          `, style: isInlineLayout ? overlayStyles : null },
                    React__default.createElement("div", { className: `hui-menu-list-container
                ${isOpen ? 'hui-menu-list-container-is-open' : 'hui-visually-hidden'}
                ${align === HuiMenuAlignProps.Left
                            ? 'hui-menu-container-list-container-left'
                            : 'hui-menu-container-list-container-right'}
                ${isNavLayout || isMenuLayout
                            ? 'hui-menu-list-nav-layout'
                            : 'hui-menu-list-inline-layout hui-width-fit-content'}
                ${(isNavLayout || isMenuLayout) && !useMobileLayout && !isDropdownFullHeight
                            ? 'hui-menu-list-nav-layout-large-screen'
                            : ''}
                ${isActionLayout ? 'hui-menu-container-list-container-action-menu' : ''}
                ${isMenuLayout ? 'hui-menu-list-container-tab-panel-menu' : ''}
              `, style: isInlineLayout ? { ...dropdownStyles, ...inlineDropdownStyles } : navDropdownStyles, ...menuContainerProps, role: undefined },
                        React__default.createElement(HuiMenuList, { closeOpenMenu: closeOpenMenu, getItemProps: getItemProps, highlightedIndex: highlightedIndex, inlineLayoutMenuItemClasses: inlineLayoutMenuItemClasses, isActionLayout: isActionLayout, isInlineLayout: isInlineLayout, isMenuLayout: isMenuLayout, isNavLayout: isNavLayout, isOpen: isOpen, isSmScreen: isSmScreen, menuActiveDescendant: menuActiveDescendant, menuClassName: menuClassName, menuId: menuId, menuItems: menuItems, menuLabelledBy: menuLabelledBy, menuRole: menuRole, refsMap: refsMap, selectedItem: selectedItem, testId: testId })))))),
        isTabPanelMenuInDialog && (React__default.createElement(HuiDialog, { backgroundClose: true, className: "hui-menu-dialog", focusEl: (_c = refsMap[selectedItem]) === null || _c === void 0 ? void 0 : _c.current.id, layout: HuiDialogLayoutProps.MenuDialog, onClose: closeOpenMenu, testId: `${testId}-dialog`, visible: isOpen },
            React__default.createElement(HuiDialogHeader, { className: "hui-menu-dialog-header" }, label),
            React__default.createElement(HuiDialogBody, { className: "hui-menu-dialog-body" },
                React__default.createElement("div", { ...getMenuProps(), style: { overflowY: 'auto' } },
                    React__default.createElement(HuiMenuList, { closeOpenMenu: closeOpenMenu, getItemProps: getItemProps, highlightedIndex: highlightedIndex, inlineLayoutMenuItemClasses: inlineLayoutMenuItemClasses, isActionLayout: isActionLayout, isInlineLayout: isInlineLayout, isMenuLayout: isMenuLayout, isNavLayout: isNavLayout, isOpen: isOpen, isSmScreen: isSmScreen, menuActiveDescendant: menuActiveDescendant, menuClassName: menuClassName, menuId: menuId, menuItems: menuItems, menuLabelledBy: menuLabelledBy, menuRole: menuRole, refsMap: refsMap, selectedItem: selectedItem, testId: testId }))),
            React__default.createElement(HuiDialogFooter, { className: "hui-menu-dialog-footer" },
                React__default.createElement(HuiButton, { layout: HuiButtonLayoutProps.Outline, onClick: closeOpenMenu, testId: `${testId}-close` }, closeLabel))))));
};

/**
 * Used in conjunction with a `HuiMenu`, this is an individual menu item. When
 * used for a `Nav` layout, the content of it can be a button or a link. Otherwise
 * this take a text string.
 *
 * @remarks
 * [API/Demos](https://hui.inside.humaninterest.com/?path=/docs/components-huimenu--documentation)
 *
 * {@link HuiMenuItemProps}
 *
 * @returns HuiMenuItem component
 *
 * @example
 * See the API/Demo links for example usage
 */
const HuiMenuItem = ({ ariaExpanded, ariaLabel, children, className = '', 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
closeMenuOnClick, hidden = false, label = '', testId = 'menu-item', 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
topBorder, ...otherProps }) => {
    const aria = { 'aria-hidden': hidden };
    if (ariaExpanded !== undefined) {
        aria['aria-expanded'] = ariaExpanded;
    }
    if (ariaLabel !== undefined) {
        aria['aria-label'] = ariaLabel;
    }
    return (React__default.createElement("div", { ...aria, className: `hui-ellipsis ${className}`, "data-testid": testId, ...otherProps }, children || label));
};

/**
 * Will typically be used to paginate tables with `ReactTable`. For async data fetching, pair
 * this with `HuiLoaderOverlay` to indicate when there is async activity happening to the user
 * so they know their data is being fetched
 *
 * @param HuiPaginationProps - {@link HuiPaginationProps}
 * @returns Pagination Component
 */
const HuiPagination = ({ className = '', labels, onChange, page = 0, pageCount, slots = 7, testId = 'pagination', ...otherProps }) => {
    const id = useRef(uniqueId()).current;
    const [currentPage, setCurrentPage] = useState(page);
    const matchingBreakpoint = useMatchingBreakpoint();
    const isSmScreen = matchingBreakpoint === HuiBreakpointProps.Sm;
    useEffect(() => {
        if (onChange) {
            onChange(currentPage);
        }
    }, [currentPage]);
    const currentPageNumberForDisplay = currentPage + 1;
    const slotsInUse = isSmScreen ? 5 : slots;
    const midSlot = Math.ceil(slotsInUse / 2);
    const numberOfSlots = Math.min(slotsInUse, pageCount);
    const slotsArray = Array(numberOfSlots).fill(null);
    const ellipsis = '...';
    const formatSlotLabel = (slotValue) => {
        if (slotValue === ellipsis) {
            return '';
        }
        else if (slotValue === pageCount && pageCount !== 1) {
            return labels.lastPageFormatter(slotValue);
        }
        else if (slotValue === currentPageNumberForDisplay) {
            return labels.currentPageFormatter(slotValue);
        }
        return labels.pageFormatter(slotValue);
    };
    const lowerEllipsisActive = currentPageNumberForDisplay >= midSlot && pageCount > slotsInUse;
    const upperEllipsisActive = pageCount > slotsInUse && currentPageNumberForDisplay <= pageCount - midSlot;
    const getArrowButton = ({ direction, hideAtStep, icon, label, stepButtonTestId, }) => {
        return (React__default.createElement("div", { className: `hui-flex hui-flex-all-centered ${!isSmScreen ? 'hui-pagination-arrow-button-container' : ''}` },
            React__default.createElement("button", { "aria-hidden": currentPageNumberForDisplay === hideAtStep, ...(isSmScreen ? { 'aria-label': label } : {}), className: `hui-button-reset hui-pagination-button hui-pagination-arrow-button ${currentPageNumberForDisplay === hideAtStep ? 'hui-visibility-hidden' : ''}`, "data-testid": stepButtonTestId, onClick: () => {
                    setCurrentPage(currentPage + direction);
                }, type: "button" },
                React__default.createElement("div", { className: `hui-flex hui-flex-align-center hui-flex-justify-end hui-column-gap-8 ${direction === -1 ? 'hui-flex-row-reverse' : ''}` },
                    !isSmScreen && React__default.createElement("div", null, label),
                    React__default.createElement("div", null,
                        React__default.createElement(HuiIcon, { icon: icon }))))));
    };
    if (!pageCount) {
        return null;
    }
    return (React__default.createElement("nav", { "aria-label": labels.navigation, className: `hui-flex ${className}`, "data-testid": testId, ...otherProps },
        getArrowButton({
            direction: -1,
            hideAtStep: 1,
            icon: HuiIconArrowLeft,
            label: labels.previous,
            stepButtonTestId: `${testId}-previous`,
        }),
        React__default.createElement("div", { className: "hui-flex-1" },
            React__default.createElement("div", { className: "hui-flex hui-flex-all-centered" },
                React__default.createElement("ul", { className: "hui-pagination-slots hui-flex" }, slotsArray.map((_slot, index) => {
                    const slotNumber = index + 1;
                    let slotValue = slotNumber;
                    const upperSlotNumber = pageCount + slotNumber - numberOfSlots;
                    switch (slotNumber) {
                        case 1:
                            break;
                        case 2:
                            if (lowerEllipsisActive) {
                                slotValue = ellipsis;
                            }
                            break;
                        case slotsInUse - 1:
                            if (upperEllipsisActive) {
                                slotValue = ellipsis;
                            }
                            else {
                                slotValue = upperSlotNumber;
                            }
                            break;
                        case slotsInUse:
                            slotValue = pageCount;
                            break;
                        default:
                            if (lowerEllipsisActive && upperEllipsisActive) {
                                slotValue = currentPageNumberForDisplay + slotNumber - midSlot;
                            }
                            else if (!upperEllipsisActive) {
                                slotValue = upperSlotNumber;
                            }
                            break;
                    }
                    return (React__default.createElement("li", { className: "hui-pagination-slot hui-margin-4", key: `${id}-${index}` },
                        React__default.createElement("button", { "aria-label": formatSlotLabel(slotValue), className: `hui-button-reset hui-pagination-button ${currentPageNumberForDisplay === slotValue ? 'hui-pagination-slot-current ' : ''} hui-pagination-slot-button`, ...(slotValue === currentPageNumberForDisplay ? { 'aria-current': 'page' } : {}), "data-testid": `${testId}-${slotNumber}-${slotValue === ellipsis ? 'ellipsis' : slotValue}`, disabled: slotValue === ellipsis, onClick: () => {
                                if (slotValue !== ellipsis) {
                                    setCurrentPage(Number(slotValue) - 1);
                                }
                            }, type: "button" }, slotValue)));
                })))),
        getArrowButton({
            direction: 1,
            hideAtStep: pageCount,
            icon: HuiIconArrowRight,
            label: labels.next,
            stepButtonTestId: `${testId}-next`,
        })));
};

var HuiPaperLayout;
(function (HuiPaperLayout) {
    HuiPaperLayout["Large"] = "large";
    HuiPaperLayout["Card"] = "card";
})(HuiPaperLayout || (HuiPaperLayout = {}));
function HuiPaper({ className = '', layout, children, ...otherProps }) {
    return (React__default.createElement("div", { className: `hui-paper ${layout === HuiPaperLayout.Large ? 'hui-paper-large' : ''} ${layout === HuiPaperLayout.Card ? 'hui-paper-card' : ''} ${className}`, ...otherProps }, children));
}

var HuiStepperTypeProps;
(function (HuiStepperTypeProps) {
    HuiStepperTypeProps[HuiStepperTypeProps["Link"] = 0] = "Link";
    HuiStepperTypeProps[HuiStepperTypeProps["Numeric"] = 1] = "Numeric";
})(HuiStepperTypeProps || (HuiStepperTypeProps = {}));
var HuiStepperLayoutProps;
(function (HuiStepperLayoutProps) {
    HuiStepperLayoutProps[HuiStepperLayoutProps["Horizontal"] = 0] = "Horizontal";
    HuiStepperLayoutProps[HuiStepperLayoutProps["Vertical"] = 1] = "Vertical";
})(HuiStepperLayoutProps || (HuiStepperLayoutProps = {}));
var HuiStepperLinkStepState;
(function (HuiStepperLinkStepState) {
    HuiStepperLinkStepState[HuiStepperLinkStepState["Active"] = 0] = "Active";
    HuiStepperLinkStepState[HuiStepperLinkStepState["Complete"] = 1] = "Complete";
    HuiStepperLinkStepState[HuiStepperLinkStepState["Disabled"] = 2] = "Disabled";
})(HuiStepperLinkStepState || (HuiStepperLinkStepState = {}));

const HuiStepperLinkContext = React__default.createContext({});
const HuiStepperLink = ({ className = '', children, current, layout: layoutProp, max, stepperLabelMaker, testId = 'cmp-stepper-link', ...otherProps }) => {
    const layoutForBreakpoint = useLayoutFromMatchingBreakpoint(layoutProp, HuiStepperLayoutProps.Horizontal);
    const stepperId = useRef(uniqueId()).current;
    const layoutClassName = layoutForBreakpoint === HuiStepperLayoutProps.Horizontal ? 'hui-flex-row' : 'hui-flex-column';
    const context = {
        current,
        layout: layoutForBreakpoint,
        testId,
    };
    return (React__default.createElement(HuiStepperLinkContext.Provider, { value: context },
        React__default.createElement("div", { className: className },
            React__default.createElement("div", { "aria-label": stepperLabelMaker(current + 1, current + 1, max + 1), "aria-live": "polite", "aria-valuemax": max + 2, "aria-valuemin": 1, "aria-valuenow": current + 1, "aria-valuetext": stepperLabelMaker(current + 1, current + 1, max + 1), className: `hui-visually-hidden`, "data-testid": testId, id: stepperId, role: "progressbar", ...otherProps }),
            React__default.createElement("nav", { "aria-labelledby": stepperId, className: `hui-stepper-link hui-flex ${layoutClassName}`, "data-testid": `${testId}-nav` }, children))));
};

function steps(current, max, label) {
    const result = [];
    if (label) {
        result.push(current);
    }
    else {
        while (result.length < max) {
            result.push(result.length + 1);
        }
    }
    return result;
}
const HuiStepperNumeric = ({ className = '', current, max, label, stepperLabelMaker, testId = 'cmp-stepper', ...otherProps }) => {
    const labelId = label && uniqueId();
    if (label) {
        otherProps['aria-labelledby'] = labelId;
    }
    return (React__default.createElement("div", { className: className },
        React__default.createElement("div", { "aria-label": stepperLabelMaker(current, current, max), "aria-live": "polite", "aria-valuemax": max + 1, "aria-valuemin": 1, "aria-valuenow": current, "aria-valuetext": stepperLabelMaker(current, current, max), className: "hui-stepper hui-flex-align-center hui-flex-space-between hui-border-radius-full hui-padding-vertical-8 hui-padding-vertical-12:md hui-padding-horizontal-12 hui-padding-horizontal-16:md", "data-testid": testId, role: "progressbar", ...otherProps },
            steps(current, max, label).map((step) => {
                return (React__default.createElement(React__default.Fragment, { key: step },
                    React__default.createElement("div", { className: "hui-stepper-step-container hui-flex hui-flex-align-center hui-flex-justify-center", "data-testid": `${testId}-${step}` },
                        React__default.createElement("div", { className: `
                  hui-stepper-step
                  hui-flex hui-flex-align-center hui-flex-justify-center
                  hui-border-radius-full
                  hui-font-weight-bold

                  ${step <= current ? 'hui-background-white' : 'hui-stepper-step-after-current'}
                  ${step === current ? 'hui-stepper-step-current' : 'hui-stepper-step-not-current'}
                ` },
                            React__default.createElement("div", { className: `
                    hui-stepper-step-text
                    ${step !== current ? 'hui-display-none' : ''}
                  ` }, step))),
                    step !== max && !label && (React__default.createElement("div", { className: `
                  hui-stepper-step-separator
                  ${step < current
                            ? 'hui-stepper-step-separator-before-current hui-background-white'
                            : 'hui-stepper-step-separator-current-or-after'}
                ` }))));
            }),
            label && (React__default.createElement("div", { className: "hui-stepper-label hui-text-white hui-font-weight-bold", "data-testid": `${testId}-label`, id: labelId }, label)))));
};

/**
 * HuiStepper supports two types, a numerical visual only stepper, and an interactive navigation based stepper
 * The props used depend on the `HuiStepperTypeProps` assigned.
 *
 * @remarks
 * [API/Demo Link](https://hui.inside.humaninterest.com/?path=/docs/components-huistepper-link--default)
 *
 * [API/Demo Numeric](https://hui.inside.humaninterest.com/?path=/docs/components-huistepper--default)
 *
 * {@link HuiStepperProps}
 *
 * @returns HuiStepper component
 *
 * @example
 * See the API/Demo links for example usage
 */
const HuiStepper = ({ children, type, ...otherProps }) => {
    if (type === HuiStepperTypeProps.Link) {
        return React__default.createElement(HuiStepperLink, { ...otherProps }, children);
    }
    return React__default.createElement(HuiStepperNumeric, { ...otherProps });
};

/**
 * HuiStepperLinkStep renders an individual button or div for a HuiStepper Link type component.
 * All props except for `onClick` are required. If `onClick` is provided, the step will render
 * as a button instead of a div, and the `onClick` is assigned to the button `onClick` handler.
 *
 * {@link HuiStepperLinkStepProps}
 *
 * @returns HuiStepperLinkStep component
 *
 * @example
 * ```
 * <HuiStepperLinkStep
 *    index={index}
 *    isActive={index === isActive}
 *    isCompleted={completed[index]}
 *    isDisabled={disabled[index]}
 *    key={`key-${index}`}
 *    {...((completed[index] || !disabled[index]) && index !== isActive
 *      ? {
 *          onClick: () => {
 *            setIsActive(index);
 *          },
 *        }
 *      : {})}
 *  >
 *    {step}
 *  </HuiStepperLinkStep>
 * ```
 */
const HuiStepperLinkStep = ({ children, className = '', index, isActive, isCompleted, isDisabled, onClick, ...otherProps }) => {
    const { layout, testId } = useContext(HuiStepperLinkContext);
    const baseCssClasses = 'hui-flex hui-flex-1 hui-flex-align-start hui-stepper-link-step';
    const layoutClassName = layout === HuiStepperLayoutProps.Horizontal ? 'hui-flex-column' : 'hui-flex-row';
    let barClasses = `hui-flex-align-self-stretch ${layout === HuiStepperLayoutProps.Horizontal
        ? 'hui-stepper-link-step-bar-horizontal hui-margin-bottom-8'
        : 'hui-stepper-link-step-bar-vertical hui-margin-right-8'}`;
    let labelClasses = `hui-stepper-link-step-label hui-width-full ${layout === HuiStepperLayoutProps.Horizontal ? ' ' : 'hui-padding-vertical-8'}`;
    if (isActive) {
        barClasses = `hui-stepper-link-step-bar-active ${barClasses}`;
        labelClasses = `hui-stepper-link-step-label-active ${labelClasses}`;
    }
    else if (isCompleted) {
        barClasses = `hui-stepper-link-step-bar-complete ${barClasses}`;
        labelClasses = `hui-stepper-link-step-label-complete ${labelClasses}`;
    }
    else if (isDisabled) {
        barClasses = `hui-stepper-link-step-bar-disabled ${barClasses}`;
        labelClasses = `hui-stepper-link-step-label-disabled ${labelClasses}`;
    }
    else {
        barClasses = `hui-stepper-link-step-bar-in-progress ${barClasses}`;
        labelClasses = `hui-stepper-link-step-label-in-progress ${labelClasses}`;
    }
    if (onClick) {
        return (React__default.createElement("button", { "aria-current": isActive, className: `${baseCssClasses} ${layoutClassName} hui-text-button ${className}`, "data-testid": `${testId}-step-${index}`, disabled: isDisabled, onClick: onClick, type: "button", ...otherProps },
            React__default.createElement("div", { "aria-hidden": "true", className: barClasses }),
            React__default.createElement("div", { className: labelClasses }, children)));
    }
    return (React__default.createElement("div", { "aria-current": isActive, "aria-disabled": isDisabled, className: `${baseCssClasses} ${layoutClassName} ${className}`, "data-testid": `${testId}-step-${index}`, ...otherProps },
        React__default.createElement("div", { "aria-hidden": "true", className: barClasses }),
        React__default.createElement("div", { className: labelClasses }, children)));
};

var HuiTabPanelLayoutProps;
(function (HuiTabPanelLayoutProps) {
    HuiTabPanelLayoutProps[HuiTabPanelLayoutProps["Menu"] = 0] = "Menu";
    HuiTabPanelLayoutProps[HuiTabPanelLayoutProps["Tabs"] = 1] = "Tabs";
})(HuiTabPanelLayoutProps || (HuiTabPanelLayoutProps = {}));

const TabPanelContainerContext = React__default.createContext({});
/**
 * Tab panels acts as a form of secondary navigation and are commonly used with child routers. It
 * will automatically switch layouts from tabs to a dropdown menu depending on the screen width
 * and the width of the tabs. In viewports matching `Sm` it will display a menu in a dialog anchored
 * to the bottom of the screen.
 *
 * `HuiTabPanelContainer` is the outermost component in the tab panel system which wraps a `HuiNavTabs`
 * group, composed of individual `HuiNavTab`'s, and individual `HuiTabPanel`'s which contain the page
 * content for each tab.
 *
 * Note: succinctness of the tab labels should be prioritized as the number of tabs increases for
 * the most discoverable experience of content.
 *
 * @remarks
 * [API/Demo](https://hui.inside.humaninterest.com/?path=/docs/components-huitabpanel--documentation)
 *
 * {@link HuiTabPanelContainerContextProps}
 *
 * @returns HuiTabPanel component
 *
 * @example
 * See the API/Demo links for example usage
 */
const HuiTabPanelContainer = ({ activeTab, children, closeLabel, lazy = true, notificationLabel, testId = 'tab-panel-container', ...otherProps }) => {
    const [activeIndex, setActiveIndex] = useState();
    const [focusIndex, setFocusIndex] = useState();
    const [indexMap, setIndexMap] = useState();
    const [layout, setLayout] = useState();
    const [tabWidthValues, setTabWidthValues] = useState();
    const tabWidths = useRef({});
    const refs = useRef([]);
    useEffect(() => {
        if (indexMap) {
            const mappedActiveTab = indexMap[activeTab];
            if (typeof mappedActiveTab === 'number') {
                setActiveIndex(mappedActiveTab);
                setFocusIndex(mappedActiveTab);
            }
        }
    }, [activeTab, indexMap]);
    const context = {
        activeIndex,
        closeLabel,
        focusIndex,
        handleTabClick: (evt, index, onClick) => {
            setActiveIndex(index);
            setFocusIndex(index);
            if (onClick) {
                onClick(evt);
            }
        },
        id: useRef(uniqueId()).current,
        indexMap,
        layout,
        lazy,
        notificationLabel,
        refs,
        setActiveIndex,
        setFocusIndex,
        setIndexMap,
        setLayout,
        setTabWidthValues,
        tabWidthValues,
        tabWidths,
    };
    return (React__default.createElement(TabPanelContainerContext.Provider, { value: context },
        React__default.createElement("div", { "data-testid": testId, ...otherProps }, children)));
};

/**
 * This creates a tab intended only for use as part of a HuiTabPanelContainer.
 *
 * @remarks
 * [API/Demo](https://hui.inside.humaninterest.com/?path=/docs/components-huitabpanel--documentation)
 *
 * {@link HuiNavTabProps}
 *
 * @returns HuiNavTab component
 *
 * @example
 * See the API/Demo links for example usage
 */
const HuiNavTab = ({ children, className, notificationCount, onClick, tabId, testId = 'nav-tab', ...otherProps }) => {
    const { activeIndex, focusIndex, handleTabClick, id, indexMap, layout, notificationLabel, refs, setTabWidthValues, tabWidths, } = useContext(TabPanelContainerContext);
    const index = indexMap === null || indexMap === void 0 ? void 0 : indexMap[tabId];
    const isActive = activeIndex !== undefined && activeIndex === index;
    const isFocused = focusIndex === index;
    const isTabLayout = layout === HuiTabPanelLayoutProps.Tabs;
    const buttonActiveClassName = isActive ? 'hui-tab-button-active' : '';
    const tabContainerId = useRef(`${uniqueId()}-${index}`).current;
    const tabRef = useRef();
    useEffect(() => {
        const tabEl = document.getElementById(tabContainerId);
        // using a setInterval because in more complex UI's the widths of the tabs may not
        // be available at that point and we need an accurate width for a proper experience
        const interval = setInterval(() => {
            if (tabEl.clientWidth) {
                tabWidths.current[tabContainerId] = tabEl.clientWidth;
                refs.current.push(tabRef);
                setTabWidthValues(Object.values(tabWidths.current));
                clearInterval(interval);
            }
        }, 30);
    }, []);
    return (React__default.createElement("div", { className: `hui-tab ${className || ''}`, id: tabContainerId, role: "presentation", ...otherProps },
        React__default.createElement("button", { "aria-controls": `${id}-panel-${index}`, "aria-label": notificationLabel(children, notificationCount), "aria-selected": isActive, className: `hui-tab-button ${buttonActiveClassName}`, "data-testid": testId, id: `${id}-tab-${index}`, onClick: (evt) => handleTabClick(evt, index, onClick), ref: tabRef, role: "tab", tabIndex: isFocused && isTabLayout ? 0 : -1, type: "button" },
            React__default.createElement("span", { className: "hui-tab-label" }, children)),
        notificationCount && (React__default.createElement("div", { "aria-hidden": "true" },
            React__default.createElement("div", { className: "hui-tab-notification" }, notificationCount)))));
};

/**
 * This creates a group of tabs intended only for use as part of a HuiTabPanelContainer.
 *
 * @remarks
 * [API/Demo](https://hui.inside.humaninterest.com/?path=/docs/components-huitabpanel--documentation)
 *
 * {@link HuiNavTabsProps}
 *
 * @returns HuiNavTabs component
 *
 * @example
 * See the API/Demo links for example usage
 */
const HuiNavTabs = ({ children, className = '', label, testId = 'nav-tabs', ...otherProps }) => {
    const { activeIndex, closeLabel, handleTabClick, focusIndex, layout, refs, setFocusIndex, setIndexMap, setLayout, tabWidthValues, } = useContext(TabPanelContainerContext);
    const [tabsContainerWidth, setTabsContainerWidth] = useState();
    const tabsContainerId = useRef(uniqueId()).current;
    const tabCount = React__default.Children.toArray(children).filter((reactChild) => {
        if (isValidElement(reactChild)) {
            // conditionally included tabs need to be filtered out of the count
            return Boolean(reactChild);
        }
        return false;
    }).length;
    const windowSize = useWindowSize();
    const { clientWidth } = useGetBoundingRects({
        conditions: () => true,
        dependencies: [tabWidthValues, windowSize],
        elementId: tabsContainerId,
    });
    useEffect(() => {
        const indexMap = {};
        React__default.Children.forEach(children, (reactChild, index) => {
            if (isValidElement(reactChild)) {
                indexMap[reactChild.props.tabId] = index;
            }
        });
        setIndexMap(indexMap);
    }, []);
    useEffect(() => {
        if (tabWidthValues && tabCount === tabWidthValues.length) {
            setTabsContainerWidth(tabWidthValues.reduce((partialSum, tabWidth) => partialSum + tabWidth, 0) + tabWidthValues.length * 24 + 10);
        }
    }, [tabCount, tabWidthValues === null || tabWidthValues === void 0 ? void 0 : tabWidthValues.length]);
    useEffect(() => {
        var _a, _b, _c;
        if (clientWidth && tabsContainerWidth) {
            const newLayout = clientWidth <= tabsContainerWidth ? HuiTabPanelLayoutProps.Menu : HuiTabPanelLayoutProps.Tabs;
            if (layout !== newLayout) {
                if (((_b = (_a = refs.current[focusIndex]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.id) === ((_c = document.activeElement) === null || _c === void 0 ? void 0 : _c.id)) {
                    // if layouts switch and the current focus is on a nav tab, the element is hidden
                    // so we want to blur it
                    document.activeElement.blur();
                }
                setLayout(newLayout);
            }
        }
    }, [clientWidth, tabsContainerWidth]);
    const handleNextTab = (nextTabIndex) => {
        const tabCount = refs.current.length;
        let tabToFocus = nextTabIndex;
        if (nextTabIndex >= tabCount) {
            tabToFocus = 0;
        }
        else if (nextTabIndex < 0) {
            tabToFocus = tabCount - 1;
        }
        setFocusIndex(tabToFocus);
        refs.current[tabToFocus].current.focus();
    };
    const handleKeyPress = (event) => {
        if (event.key === 'ArrowLeft') {
            const nextTabIndex = focusIndex - 1;
            handleNextTab(nextTabIndex);
        }
        if (event.key === 'ArrowRight') {
            const nextTabIndex = focusIndex + 1;
            handleNextTab(nextTabIndex);
        }
    };
    return (React__default.createElement("div", { "data-testid": testId, id: tabsContainerId },
        React__default.createElement("div", { "aria-label": label, className: `hui-tabs ${tabsContainerWidth ? '' : 'hui-tabs-loading'} ${layout === HuiTabPanelLayoutProps.Menu ? 'hui-visually-hidden' : ''} ${className}`, "data-testid": `${testId}-wrapper`, onKeyDown: handleKeyPress, role: 'tablist', ...otherProps }, children),
        layout === HuiTabPanelLayoutProps.Menu && (React__default.createElement(HuiMenu, { "aria-hidden": true, closeLabel: closeLabel, label: label, layout: HuiMenuLayoutProps.TabPanelMenu, selectedIndex: activeIndex, testId: `${testId}-menu` }, React__default.Children.map(children, (child, index) => {
            if (!child) {
                return null;
            }
            const { props } = child;
            return (React__default.createElement(HuiMenuItem, { className: "hui-nav-tab-menu-item", onSelect: () => handleTabClick(undefined, index, props.onClick), testId: `${props.testId}-menu` },
                React__default.createElement("div", null, props.children),
                props.notificationCount && (React__default.createElement("div", { className: "hui-flex-align-self-center" },
                    React__default.createElement("div", { className: "hui-tab-notification" }, props.notificationCount)))));
        })))));
};

/**
 * This creates a tab panel intended only for use as part of a HuiTabPanelContainer.
 *
 * @remarks
 * [API/Demo](https://hui.inside.humaninterest.com/?path=/docs/components-huitabpanel--documentation)
 *
 * {@link HuiTabPanelProps}
 *
 * @returns HuiTabPanel component
 *
 * @example
 * See the API/Demo links for example usage
 */
const HuiTabPanel = ({ children, className, panelId, testId = 'tab-panel', ...otherProps }) => {
    const { activeIndex, id, indexMap, lazy } = useContext(TabPanelContainerContext);
    const index = indexMap === null || indexMap === void 0 ? void 0 : indexMap[panelId];
    const isPanelActive = activeIndex !== undefined && index === activeIndex;
    const alreadyActivated = useRef(false);
    useEffect(() => {
        if (isPanelActive) {
            alreadyActivated.current = true;
        }
    }, [isPanelActive]);
    return (React__default.createElement("div", { "aria-hidden": !isPanelActive, "aria-labelledby": `${id}-tab-${index}`, className: `${isPanelActive ? '' : 'hui-visually-hidden'} ${className || ''}`, "data-testid": testId, hidden: !isPanelActive, id: `${id}-panel-${index}`, role: "tabpanel", ...otherProps }, (isPanelActive || alreadyActivated.current || !lazy) && children));
};

var HuiTableLayoutProps;
(function (HuiTableLayoutProps) {
    HuiTableLayoutProps[HuiTableLayoutProps["Narrow"] = 0] = "Narrow";
    HuiTableLayoutProps[HuiTableLayoutProps["Wide"] = 1] = "Wide";
})(HuiTableLayoutProps || (HuiTableLayoutProps = {}));
var HuiTableCellTypeProps;
(function (HuiTableCellTypeProps) {
    HuiTableCellTypeProps["Td"] = "td";
    HuiTableCellTypeProps["Th"] = "th";
})(HuiTableCellTypeProps || (HuiTableCellTypeProps = {}));
const HuiTableContext = React__default.createContext({});
const HuiTable = ({ children, className = '', layout, testId, ...otherProps }) => {
    const breakpoint = useMatchingBreakpoint();
    const tableLayout = useLayoutFromMatchingBreakpoint(layout, HuiTableLayoutProps.Wide);
    const [columnHeaders, setColumnHeaders] = useState();
    const id = useRef(uniqueId());
    const context = {
        breakpoint,
        columnHeaders,
        id: id.current,
        layout: tableLayout,
        setColumnHeaders,
    };
    return (React__default.createElement(HuiTableContext.Provider, { value: context },
        React__default.createElement("table", { className: `hui-table ${className}`, "data-testid": testId, ...otherProps }, children)));
};

const HuiTableRow = ({ children, className = '', ...otherProps }) => {
    return (React__default.createElement("tr", { className: `hui-table-row ${className}`, ...otherProps }, children));
};

const HuiTableBody = ({ children, ...props }) => {
    const context = useContext(HuiTableContext);
    if (context.layout === HuiTableLayoutProps.Narrow) {
        return (React__default.createElement("tbody", { ...props }, React__default.Children.map(children, (tableRow, tableRowIndex) => {
            return React__default.Children.map(context.columnHeaders, (columnHeader, columnIndex) => {
                var _a, _b;
                if (!tableRow) {
                    return null;
                }
                let valueColumn = tableRow.props.children[columnIndex];
                if (((_a = columnHeader.props.hiddenAtBreakpoints) === null || _a === void 0 ? void 0 : _a.indexOf(context.breakpoint)) >= 0) {
                    valueColumn = React__default.cloneElement(valueColumn, {
                        colSpan: 2,
                    });
                }
                else if (((_b = valueColumn === null || valueColumn === void 0 ? void 0 : valueColumn.props.hiddenAtBreakpoints) === null || _b === void 0 ? void 0 : _b.indexOf(context.breakpoint)) >= 0) {
                    columnHeader = React__default.cloneElement(columnHeader, { colSpan: 2 });
                }
                const { className = '', ...tableRowProps } = tableRow.props;
                return (React__default.createElement(HuiTableRow, { className: `${columnIndex === 0 ? 'hui-table-row-group-start' : ''} ${className}`, key: `${context.id}-${tableRowIndex}-${columnIndex}`, ...tableRowProps },
                    columnHeader,
                    valueColumn));
            });
        })));
    }
    return React__default.createElement("tbody", { ...props }, children);
};

const HuiTableCell = ({ children, className = '', hiddenAtBreakpoints, narrowLayoutClassName = '', wideLayoutClassName = '', type = HuiTableCellTypeProps.Td, ...otherProps }) => {
    const context = useContext(HuiTableContext);
    if ((hiddenAtBreakpoints === null || hiddenAtBreakpoints === void 0 ? void 0 : hiddenAtBreakpoints.indexOf(context.breakpoint)) >= 0) {
        return null;
    }
    className = `
    hui-table-cell 
    ${className}
    ${context.layout === HuiTableLayoutProps.Narrow ? narrowLayoutClassName : wideLayoutClassName}
  `;
    return React__default.createElement(`${type}`, { className, ...otherProps }, children);
};

const HuiTableFoot = ({ children, ...otherProps }) => {
    const trChildren = React__default.Children.map(children.props.children, (child) => {
        return React__default.cloneElement(child, {
            type: HuiTableCellTypeProps.Th,
        });
    });
    return React__default.createElement("tfoot", { ...otherProps }, React__default.cloneElement(children, { children: trChildren }));
};

const HuiTableHead = ({ children, ...otherProps }) => {
    const context = useContext(HuiTableContext);
    const trChildren = React__default.Children.map(children.props.children, (child) => {
        return React__default.cloneElement(child, {
            type: HuiTableCellTypeProps.Th,
        });
    });
    useEffect(() => {
        context.setColumnHeaders(trChildren);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [children]);
    if (context.layout === HuiTableLayoutProps.Narrow) {
        return null;
    }
    return React__default.createElement("thead", { ...otherProps }, React__default.cloneElement(children, { children: trChildren }));
};

var HuiToastLevel;
(function (HuiToastLevel) {
    HuiToastLevel[HuiToastLevel["Error"] = 0] = "Error";
    HuiToastLevel[HuiToastLevel["Info"] = 1] = "Info";
    HuiToastLevel[HuiToastLevel["Success"] = 2] = "Success";
    HuiToastLevel[HuiToastLevel["Warning"] = 3] = "Warning";
})(HuiToastLevel || (HuiToastLevel = {}));

const ToastContext = createContext(null);
const useToast = () => {
    return useContext(ToastContext);
};

const HuiToast = ({ autoDismiss = true, dismissButtonAriaLabel, duration = 5000, isDismissable = true, testId = 'btn-toast-close', toastContent, toastId, toastLevel = HuiToastLevel.Success, ...props }) => {
    const { removeToast } = useToast();
    useEffect(() => {
        if (autoDismiss) {
            const timer = setTimeout(() => removeToast({ toastId }), duration);
            return () => clearTimeout(timer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [toastId, removeToast]);
    return (React__default.createElement("div", { className: `hui-toast ${{
            [HuiToastLevel.Error]: 'hui-toast-error',
            [HuiToastLevel.Info]: 'hui-toast-info',
            [HuiToastLevel.Success]: 'hui-toast-success',
            [HuiToastLevel.Warning]: 'hui-toast-warning',
        }[toastLevel]}`, role: "alert", ...props },
        React__default.createElement("div", { className: "hui-toast-content" }, toastContent),
        isDismissable && (React__default.createElement("button", { "aria-label": dismissButtonAriaLabel, className: `hui-icon-button hui-toast-close-button ${{
                [HuiToastLevel.Error]: 'hui-toast-close-button-error',
                [HuiToastLevel.Info]: 'hui-toast-close-button-info',
                [HuiToastLevel.Success]: 'hui-toast-close-button-success',
                [HuiToastLevel.Warning]: 'hui-toast-close-button-warning',
            }[toastLevel]}`, "data-testid": `${testId}-close`, onClick: () => removeToast({ toastId }), type: "button" },
            React__default.createElement(HuiIcon, { icon: HuiIconCross })))));
};

const HuiToastContainer = ({ children, ...props }) => {
    return ReactDOM.createPortal(React__default.createElement("div", { className: "hui-toast-container", ...props }, children), document.body);
};

const HuiToastProvider = ({ dismissButtonAriaLabel, testId, children }) => {
    const [toasts, setToasts] = useState([]);
    const [currentToast, setCurrentToast] = useState();
    const [currentToastId, setCurrentToastId] = useState();
    useEffect(() => {
        var _a;
        setCurrentToast(toasts[0]);
        setCurrentToastId((_a = toasts[0]) === null || _a === void 0 ? void 0 : _a.toastId);
    }, [toasts]);
    const toastContext = {
        addToast(params) {
            const toastId = uniqueId();
            setToasts((toastsToSet) => [...toastsToSet, { dismissButtonAriaLabel, toastId, ...params }]);
            return { toastId };
        },
        currentToastId,
        removeAllToasts: () => {
            if (toasts.length) {
                return setToasts([]);
            }
        },
        removeToast({ toastId }) {
            return setToasts((toastsToSet) => toastsToSet.filter((t) => t.toastId !== toastId));
        },
        removeToastsByLevel(toastLevel) {
            if (toasts.length) {
                return setToasts((toastsToSet) => toastsToSet.filter((t) => t.toastLevel !== toastLevel));
            }
        },
    };
    return (React__default.createElement(ToastContext.Provider, { value: toastContext },
        React__default.createElement(HuiToastContainer, { "data-testid": testId }, currentToast && React__default.createElement(HuiToast, { testId: testId, ...currentToast })),
        children));
};

var ManagerReferenceNodeContext = React.createContext();
var ManagerReferenceNodeSetterContext = React.createContext();
function Manager(_ref) {
  var children = _ref.children;

  var _React$useState = React.useState(null),
      referenceNode = _React$useState[0],
      setReferenceNode = _React$useState[1];

  React.useEffect(function () {
    return function () {
      setReferenceNode(null);
    };
  }, [setReferenceNode]);
  return /*#__PURE__*/React.createElement(ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /*#__PURE__*/React.createElement(ManagerReferenceNodeSetterContext.Provider, {
    value: setReferenceNode
  }, children));
}

/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

/*:: import type { Window } from '../types'; */

/*:: declare function getWindow(node: Node | Window): Window; */
function getWindow(node) {
  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

/*:: declare function isElement(node: mixed): boolean %checks(node instanceof
  Element); */

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
/*:: declare function isHTMLElement(node: mixed): boolean %checks(node instanceof
  HTMLElement); */


function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
/*:: declare function isShadowRoot(node: mixed): boolean %checks(node instanceof
  ShadowRoot); */


function isShadowRoot(node) {
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

// Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.
function getLayoutRect(element) {
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: element.offsetWidth,
    height: element.offsetHeight
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || // DOM Element detected
    // $FlowFixMe[incompatible-return]: need a better way to handle this...
    element.host || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  var offsetParent = element.offsetParent;

  if (offsetParent) {
    var html = getDocumentElement(offsetParent);

    if (getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static' && getComputedStyle$1(html).position !== 'static') {
      return html;
    }
  }

  return offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var currentNode = getParentNode(element);

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.

    if (css.transform !== 'none' || css.perspective !== 'none' || css.willChange && css.willChange !== 'auto') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static') {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min, value, max) {
  return Math.max(min, Math.min(value, max));
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign(Object.assign({}, getFreshSideObject()), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = state.modifiersData[name + "#persistent"].padding;
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element,
      _options$padding = options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (process.env.NODE_ENV !== "production") {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
  state.modifiersData[name + "#persistent"] = {
    padding: mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements))
  };
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: Math.round(x * dpr) / dpr || 0,
    y: Math.round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets;

  var _ref3 = roundOffsets ? roundOffsetsByDPR(offsets) : offsets,
      _ref3$x = _ref3.x,
      x = _ref3$x === void 0 ? 0 : _ref3$x,
      _ref3$y = _ref3.y,
      y = _ref3$y === void 0 ? 0 : _ref3$y;

  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

    /*:: offsetParent = (offsetParent: Element); */


    if (placement === top) {
      sideY = bottom;
      y -= offsetParent.clientHeight - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left) {
      sideX = right;
      x -= offsetParent.clientWidth - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign(Object.assign({}, commonStyles), {}, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) < 2 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign(Object.assign({}, commonStyles), {}, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref4) {
  var state = _ref4.state,
      options = _ref4.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (process.env.NODE_ENV !== "production") {
    var transitionProperty = getComputedStyle$1(state.elements.popper).transitionProperty || '';

    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign(Object.assign({}, state.styles.popper), mapToStyles(Object.assign(Object.assign({}, commonStyles), {}, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign(Object.assign({}, state.styles.arrow), mapToStyles(Object.assign(Object.assign({}, commonStyles), {}, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign(Object.assign({}, state.attributes.popper), {}, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getBoundingClientRect(element) {
  var rect = element.getBoundingClientRect();
  return {
    width: rect.width,
    height: rect.height,
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    left: rect.left,
    x: rect.left,
    y: rect.top
  };
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = element.ownerDocument.body;
  var width = Math.max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = Math.max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += Math.max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = getNodeName(scrollParent) === 'body';
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign(Object.assign({}, rect), {}, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isHTMLElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = Math.max(rect.top, accRect.top);
    accRect.right = Math.min(rect.right, accRect.right);
    accRect.bottom = Math.min(rect.bottom, accRect.bottom);
    accRect.left = Math.max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function getVariation(placement) {
  return placement.split('-')[1];
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var referenceElement = state.elements.reference;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(referenceElement);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign(Object.assign({}, popperRect), popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

/*:: type OverflowsMap = { [ComputedPlacement]: number }; */

/*;; type OverflowsMap = { [key in ComputedPlacement]: number }; */
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;

    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign(Object.assign({}, state.attributes.popper), {}, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign(Object.assign({}, rects), {}, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign(Object.assign({}, state.rects), {}, {
    placement: state.placement
  })) : tetherOffset;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = popperOffsets[mainAxis] + overflow[mainSide];
    var max = popperOffsets[mainAxis] - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - tetherOffsetValue : minLen - arrowLen - arrowPaddingMin - tetherOffsetValue;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + tetherOffsetValue : maxLen + arrowLen + arrowPaddingMax + tetherOffsetValue;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = state.modifiersData.offset ? state.modifiersData.offset[state.placement][mainAxis] : 0;
    var tetherMin = popperOffsets[mainAxis] + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = popperOffsets[mainAxis] + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? Math.min(min, tetherMin) : min, offset, tether ? Math.max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var _preventedOffset = within(_min, _offset, _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

// Composite means it takes into account transforms as well as layout.

function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement);
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    Object.keys(modifier).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }

        case 'phase':
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'effect':
          if (typeof modifier.effect !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'requires':
          if (!Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign(Object.assign(Object.assign({}, existing), current), {}, {
      options: Object.assign(Object.assign({}, existing.options), current.options),
      data: Object.assign(Object.assign({}, existing.data), current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign(Object.assign({}, DEFAULT_OPTIONS), defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(options) {
        cleanupModifierEffects();
        state.options = Object.assign(Object.assign(Object.assign({}, defaultOptions), state.options), options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (process.env.NODE_ENV !== "production") {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }

          var _getComputedStyle = getComputedStyle$1(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer


          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (process.env.NODE_ENV !== "production") {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (process.env.NODE_ENV !== "production") {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper$2 = /*#__PURE__*/popperGenerator(); // eslint-disable-next-line import/no-unused-modules

var defaultModifiers$1 = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1];
var createPopper$1 = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers$1
}); // eslint-disable-next-line import/no-unused-modules

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var isEqual = /*@__PURE__*/getDefaultExportFromCjs(reactFastCompare);

var EMPTY_MODIFIERS$1 = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = React.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS$1
  };

  var _React$useState = React.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = React.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        setState({
          styles: fromEntries(elements.map(function (element) {
            return [element, state.styles[element] || {}];
          })),
          attributes: fromEntries(elements.map(function (element) {
            return [element, state.attributes[element]];
          }))
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = React.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (isEqual(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

var NOOP = function NOOP() {
  return void 0;
};

var NOOP_PROMISE = function NOOP_PROMISE() {
  return Promise.resolve(null);
};

var EMPTY_MODIFIERS = [];
function Popper(_ref) {
  var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers,
      referenceElement = _ref.referenceElement,
      onFirstUpdate = _ref.onFirstUpdate,
      innerRef = _ref.innerRef,
      children = _ref.children;
  var referenceNode = React.useContext(ManagerReferenceNodeContext);

  var _React$useState = React.useState(null),
      popperElement = _React$useState[0],
      setPopperElement = _React$useState[1];

  var _React$useState2 = React.useState(null),
      arrowElement = _React$useState2[0],
      setArrowElement = _React$useState2[1];

  React.useEffect(function () {
    setRef(innerRef, popperElement);
  }, [innerRef, popperElement]);
  var options = React.useMemo(function () {
    return {
      placement: placement,
      strategy: strategy,
      onFirstUpdate: onFirstUpdate,
      modifiers: [].concat(modifiers, [{
        name: 'arrow',
        enabled: arrowElement != null,
        options: {
          element: arrowElement
        }
      }])
    };
  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);

  var _usePopper = usePopper(referenceElement || referenceNode, popperElement, options),
      state = _usePopper.state,
      styles = _usePopper.styles,
      forceUpdate = _usePopper.forceUpdate,
      update = _usePopper.update;

  var childrenProps = React.useMemo(function () {
    return {
      ref: setPopperElement,
      style: styles.popper,
      placement: state ? state.placement : placement,
      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: styles.arrow,
        ref: setArrowElement
      },
      forceUpdate: forceUpdate || NOOP,
      update: update || NOOP_PROMISE
    };
  }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
  return unwrapArray(children)(childrenProps);
}

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;

var warning$1 = /*@__PURE__*/getDefaultExportFromCjs(warning_1);

function Reference(_ref) {
  var children = _ref.children,
      innerRef = _ref.innerRef;
  var setReferenceNode = React.useContext(ManagerReferenceNodeSetterContext);
  var refHandler = React.useCallback(function (node) {
    setRef(innerRef, node);
    safeInvoke(setReferenceNode, node);
  }, [innerRef, setReferenceNode]); // ran on unmount

  React.useEffect(function () {
    return function () {
      return setRef(innerRef, null);
    };
  });
  React.useEffect(function () {
    warning$1(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
  }, [setReferenceNode]);
  return unwrapArray(children)({
    ref: refHandler
  });
}

// Public components
 // Public types

const HuiTooltipDefault = ({ badge, children, className = '', icon, iconSize = '1.5rem', label, onClick, testId = 'cmp-tooltip', ...otherProps }) => {
    const id = useRef(uniqueId());
    const tooltipLauncherRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);
    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
        placement: 'auto',
    });
    useClickOutside(tooltipLauncherRef, () => setIsOpen(false));
    const launcher = (icon && icon) || (badge && badge) || React__default.createElement(HuiIcon, { icon: HuiIconInfoCircle, size: iconSize });
    return (React__default.createElement("span", { ref: tooltipLauncherRef },
        React__default.createElement("button", { "aria-describedby": id.current, "aria-label": label, className: `hui-icon-button ${className} ${isOpen ? 'hui-icon-button-focus' : ''}`, "data-testid": testId, onClick: (evt) => {
                if (onClick) {
                    onClick(evt);
                }
                setIsOpen(!isOpen);
            }, ref: setReferenceElement, type: "button", ...otherProps }, launcher),
        React__default.createElement("div", { className: `hui-tooltip-default-container ${isOpen ? '' : 'hui-visually-hidden'}`, id: id.current, ref: setPopperElement, role: "tooltip", style: styles.popper, tabIndex: -1, ...attributes.popper },
            React__default.createElement("div", { className: "hui-tooltip-default" }, children))));
};

const HuiTooltipDialog = ({ badge, className = '', children, closeButtonLabel, icon, iconSize = '1.5rem', label, onClick, testId = 'cmp-tooltip', ...otherProps }) => {
    const [isOpen, setIsOpen] = useState(false);
    const matchingBreakpoint = useMatchingBreakpoint();
    const id = useRef(uniqueId()).current;
    const childrenMap = {};
    React__default.Children.toArray(children).forEach((reactChild) => {
        if (isValidElement(reactChild)) {
            childrenMap[reactChild.type.__TYPE] = reactChild;
        }
    });
    const launcher = (icon && icon) || (badge && badge) || React__default.createElement(HuiIcon, { icon: HuiIconInfoCircle, size: iconSize });
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("button", { "aria-describedby": isOpen ? id : null, "aria-label": label, className: `hui-icon-button ${className}`, "data-testid": testId, onClick: (evt) => {
                if (onClick) {
                    onClick(evt);
                }
                setIsOpen(!isOpen);
            }, type: "button", ...otherProps }, launcher),
        isOpen && (React__default.createElement(HuiDialog, { autoFocus: false, hasCloseButton: true, id: id, onClose: () => setIsOpen(false), ...(testId ? { testId: `${testId}-dialog` } : {}) },
            childrenMap.HuiTooltipTitle && React__default.createElement(HuiDialogHeader, null, childrenMap.HuiTooltipTitle),
            childrenMap.HuiTooltipContent && React__default.createElement(HuiDialogBody, null, childrenMap.HuiTooltipContent),
            matchingBreakpoint !== HuiBreakpointProps.Sm && (React__default.createElement(HuiDialogFooter, null,
                React__default.createElement(HuiButton, { onClick: () => setIsOpen(false), testId: `${testId}-close-button` }, closeButtonLabel)))))));
};

/**
 * @param badge - (optional) provide a HuiBadge for the launcher
 * @param icon - (optional) provide a custom HuiIcon for the launcher
 * @param iconSize - (optional) custom size the launcher icon, use rem
 * @param label - the label which is used for screenreaders
 * @param testId - (optional) an id to use with e2e test frameworks
 *
 * To launch the tooltip into a dialog instead of a popover, use the following parameters
 * @param closeButtonLabel - the label which is applied to the close dialog and used by screenreaders
 * @param useDialog - set to true if you want the tooltip to open in a dialog
 *
 * @returns HuiTooltip
 */
const HuiTooltip = ({ useDialog = false, ...otherProps }) => {
    const matchingBreakpoint = useMatchingBreakpoint();
    return useDialog || matchingBreakpoint === HuiBreakpointProps.Sm ? (React__default.createElement(HuiTooltipDialog, { ...otherProps })) : (React__default.createElement(HuiTooltipDefault, { ...otherProps }));
};

const HuiTooltipContent = ({ className = '', children, ...props }) => (React__default.createElement("div", { className: `hui-tooltip-content hui-text-compact hui-font-weight-medium ${className}`, ...props }, children));
HuiTooltipContent.__TYPE = 'HuiTooltipContent';

const HuiTooltipTitle = ({ className = '', children, ...props }) => (React__default.createElement("div", { className: `hui-tooltip-title hui-text-lg hui-font-weight-bold ${className}`, ...props }, children));
HuiTooltipTitle.__TYPE = 'HuiTooltipTitle';

export { n$1 as ChainDate, ExpandablePanelContext, HuiBadge, HuiBadgeType, HuiBreakpointProps, HuiButton, HuiButtonLayoutProps, HuiButtonSizeProps, HuiButtonWidthProps, HuiChecked, HuiCheckedButtonLayoutProps, HuiCheckedLayoutProps, HuiCheckedOption, HuiCheckedSelectionTypeProps, HuiContext, HuiDatepicker, HuiDialog, HuiDialogBody, HuiDialogFooter, HuiDialogHeader, HuiDialogLayoutProps, HuiDialogSizeProps, HuiDivider, HuiExpandablePanel, HuiExpandablePanelBottomClose, HuiExpandablePanelCaretPosition, HuiExpandablePanelContent, HuiExpandablePanelContext, HuiExpandablePanelSummary, HuiFieldError, HuiFieldErrorLayoutProps, HuiFieldHelperText, HuiFlag, HuiFlagType, HuiForm, HuiFormContext, HuiFormSizeProps, HuiFormValidationProps, HuiHeading, HuiIcon, HuiIconAddUser, HuiIconArrowLeft, HuiIconArrowRight, HuiIconArrowUpRight, HuiIconBriefcase, HuiIconCalendar, HuiIconCaretDown, HuiIconCaretLeft, HuiIconCaretRight, HuiIconCaretUp, HuiIconChat, HuiIconCheck, HuiIconCheckCircle, HuiIconCheckCircleSolid, HuiIconCheckboxChecked, HuiIconCheckboxUnchecked, HuiIconCircle, HuiIconClock, HuiIconCross, HuiIconCrossCircle, HuiIconCrossCircleSolid, HuiIconDollar, HuiIconDotsGrid, HuiIconDownload, HuiIconExclamationCircle, HuiIconExclamationCircleSolid, HuiIconExternalLink, HuiIconFilter, HuiIconFlagCircle, HuiIconGraduationCap, HuiIconHeart, HuiIconHome, HuiIconInfoCircle, HuiIconInfoCircleSolid, HuiIconMask, HuiIconMedicBox, HuiIconPadlockOpen, HuiIconPaperStamp, HuiIconPercent, HuiIconPieChart, HuiIconPlus, HuiIconQuestionCircle, HuiIconQuestionCircleSolid, HuiIconRadioChecked, HuiIconRadioUnchecked, HuiIconReveal, HuiIconSearch, HuiIconShieldCheckMark, HuiIconSort, HuiIconStar, HuiIconStarCircle, HuiIconSwitch, HuiIconTags, HuiIconTextFileWithImageDoc, HuiIconThumbsUp, HuiIconTicket, HuiIconTwoArrowsCircle, HuiIconUpload, HuiIconUserProfile, HuiIconUsersGroup, HuiInfoBox, HuiInfoBoxType, HuiInput, HuiInputIcon, HuiInputIconPlacementProps, HuiInputTextAlignProps, HuiLabel, HuiLabelTypeProps, HuiLoader, HuiLoaderLayout, HuiLoaderOverlay, HuiLoaderSize, HuiMenu, HuiMenuAlignProps, HuiMenuItem, HuiMenuLayoutProps, HuiNavTab, HuiNavTabs, HuiPagination, HuiPaper, HuiPaperLayout, HuiPassword, HuiRowCheckbox, HuiSelect, HuiSelectOption, HuiStepper, HuiStepperLayoutProps, HuiStepperLink, HuiStepperLinkContext, HuiStepperLinkStep, HuiStepperLinkStepState, HuiStepperNumeric, HuiStepperTypeProps, HuiTabPanel, HuiTabPanelContainer, HuiTabPanelLayoutProps, HuiTable, HuiTableBody, HuiTableCell, HuiTableCellTypeProps, HuiTableContext, HuiTableFoot, HuiTableHead, HuiTableLayoutProps, HuiTableRow, HuiTextArea, HuiTextAreaAlignProps, HuiToast, HuiToastContainer, HuiToastLevel, HuiToastProvider, HuiTooltip, HuiTooltipContent, HuiTooltipTitle, InternalFormContext, ModalContext, TabPanelContainerContext, r$1 as TimePeriod, y as isDateValid, scrollSmoothlyTo, setNoScrollOnBody, setNoScrollOnDialog, uniqueId, useClickOutside, useDropdownMenuPosition, useGetBoundingRects, useLayoutFromMatchingBreakpoint, useMatchMedia, useMatchingBreakpoint, useToast, useVH, useWindowSize };
//# sourceMappingURL=hui.min.esm.js.map
